import React from "react";

const SoldOutsvg = ({ fill,  }) => {
  return (
    <>
      <svg
    style={{height : 900, width : 800,}}
        id="Layer_1"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 4138.28 2350.41"
      >
        <defs>
          <style>
            {`
    .cls-1 {
      fill: #000;
    }

    .cls-1, .cls-2, .cls-3 {
      stroke-width: 0;
    }

    .cls-2 {
      fill: #c2000b;
    }

    .cls-4 {
      filter: url(#luminosity-noclip);
    }

    .cls-3 {
      fill: #fff;
    }

    .cls-5 {
      mask: url(#mask);
    }
  `}
          </style>
          <filter
            id="luminosity-noclip"
            x="-907.56"
            y="-997.98"
            width="5953.4"
            height="4346.38"
            color-interpolation-filters="sRGB"
            filterUnits="userSpaceOnUse"
          >
            <feFlood flood-color="#fff" result="bg" />
            <feBlend in="SourceGraphic" in2="bg" />
          </filter>
          <mask
            id="mask"
            x="-907.56"
            y="-997.98"
            width="5953.4"
            height="4346.38"
            maskUnits="userSpaceOnUse"
          >
            <g class="cls-4">
              <g>
                <path
                  class="cls-1"
                  d="M126.24,893.89c.07-.28.08-.55.13-.82l-24.27,7.92c3.77.39,7.54.79,11.31,1.16,5.03-1.29,9.58-3.63,12.84-8.26Z"
                />
                <path
                  class="cls-1"
                  d="M604.7,736.93c4.22,7.74,9.82,14.67,17.26,19.55-.47-4.22-.9-8.41-1.33-12.61-4.61-1.76-7.35-5.16-9.61-9.01l-6.33,2.06Z"
                />
                <path
                  class="cls-1"
                  d="M645.12,723.74c3.79,2.77,7.73,5.39,11.1,8.66,3.43,5.16,4.82,11.37,7.69,16.85,4.54,3.26,9.06,7.11,12.79,11.54-2.46,1.09-5.71,2.55-7.54,3.36.97,1.23,2.99,3.7,4,4.95,3.18-.85,3.6-4.27,4.5-7.1,3.33,4.22,5.91,8.93,7.08,14.14,4.23,2.65,9.13,3.98,13.79,5.79,3.16,5.96,6.52,11.85,9.91,17.71,2.84-.77,5.47-1.92,7.93-3.45,3.1,3.45,6.4,7.12,10.53,1.87l-.27,3.48c3.39.3,6.7.64,9.96.95-.14-.83-.42-2.42-.55-3.22-2.04.53-6.11,1.56-8.13,2.08.97-2.17,2.96-6.48,3.93-8.65-6.47-4.68-4.76-13.03-6.4-19.83-7.94,1.11-12.2-6.07-19.26-7.53-3.6,6.99,8.12,6.66,12.11,9.09,8.5.72,4.92,10.73,5.59,16.29-1.82.39-4.83,1.03-7.42,1.58-8.43-4.6-9.19-16.35-17.29-21.39-8.87-5.04-9.02-18.06-19.53-21.22-3.76-12.79-15.1-20-23.38-29.59l-11.14,3.64Z"
                />
                <path
                  class="cls-1"
                  d="M1588.71,415.72l-7.55,2.47c.78,2.65,1.62,5.28,2.57,7.88,2.73-.99,8.19-3.01,10.93-4-1.08-3.16-3.3-5.03-5.94-6.34Z"
                />
                <path
                  class="cls-1"
                  d="M201.72,877.26c3.93-1.35,7.6-3.19,11.04-5.52.18-9.44-16.22-2.1-11.04,5.52Z"
                />
                <path
                  class="cls-1"
                  d="M1931.11,308.84c.85,8.06,3.94,16.09,11.15,20.46-1.29-7.88-4.07-15.98-11.15-20.46Z"
                />
                <path
                  class="cls-1"
                  d="M1310.01,519.35c-4.14,1.62-1.43,8.6,2.7,7.45,4.52-1.41,1.58-8.95-2.7-7.45Z"
                />
                <path
                  class="cls-1"
                  d="M249.79,875.01c5.73,1.39,11.38,3.24,16.75,5.79,3.81,2.82,5.5-3.24,6.88-5.5-1.99-.12-5.98-.4-7.97-.52.89-3.75,2.63-7.68.53-11.37-1.33,1.78-3.98,5.3-5.29,7.07-4.23-7.49-8.78,1.22-10.89,4.53Z"
                />
                <path
                  class="cls-1"
                  d="M1714.91,396.25c5.44.41,10.42-1.55,14.6-5-5.05-7.63-13.96-2.91-14.6,5Z"
                />
                <path
                  class="cls-1"
                  d="M1658.15,418.44c1.47,1.1,4.38,3.31,5.84,4.41,16.2-6.6,31.36-15.45,47.21-22.81-.51-1.35-1.52-4.04-2.03-5.39-16.37,6.39-31.6,15.43-48.04,21.6-1.13-1.08-3.45-3.24-4.61-4.34-6.43,1.73-12.69,4.38-16.5,10.09,6.45,2.97,12.48-.28,18.13-3.57Z"
                />
                <path
                  class="cls-1"
                  d="M201.79,904.56c-1.95-3.9-8.23-.61-8.24,2.96,1.52,4.45,9.19,1.27,8.24-2.96Z"
                />
                <path
                  class="cls-1"
                  d="M1048.91,625.25c-2.54,2.41-4.16,8.05-.9,10.51,6.89,1.75,7.82-11.36.9-10.51Z"
                />
                <path
                  class="cls-1"
                  d="M2098.41,336.14c.63-.36,1.36-.74,2.12-1.14-1.22-.92-2.46-1.82-3.67-2.75-1.37-.32-2.75-.63-4.13-.94.14-.48.33-1.15.53-1.84-.5-.39-1-.79-1.51-1.19l-4.31,3.11c2.16.24,4.35.46,6.59.74-3.86,4.02-5.54,9.27-7.78,14.17.32.36.63.73.95,1.09,2.77-4.63,6.51-8.59,11.2-11.25Z"
                />
                <path
                  class="cls-1"
                  d="M2599.01,116.23c-.63,1.78-1.88,5.35-2.51,7.14,3.38,4,7.9,1.47,11.73-1.16-.92-1.24-1.76-2.54-2.54-3.88-2.23-.7-4.47-1.41-6.68-2.1Z"
                />
                <path
                  class="cls-1"
                  d="M233.42,891.91c-3.15,4.76-1.22,10.38-.71,15.53,5.65-3.9,4-10.62.71-15.53Z"
                />
                <path
                  class="cls-1"
                  d="M246.94,901.92c5.01-4.32,13.04-3.62,16.83-9.39-5.23-4.68-13.04-1.86-19.41-2.71.18,4.14-.83,8.88,2.57,12.1Z"
                />
                <path
                  class="cls-1"
                  d="M2042.11,315.76c-.39-5.01-7.62-4.91-9.54-1.12-4.23,7.53,10.12,8.56,9.54,1.12Z"
                />
                <path
                  class="cls-1"
                  d="M554.04,801.11c3.68,3.34,6,2.95,7.01-1.18-3.68-3.34-6-2.95-7.01,1.18Z"
                />
                <path
                  class="cls-1"
                  d="M49.12,989.62c-.2-4.54-2.24-5.62-6.07-3.26.11,4.57,2.15,5.65,6.07,3.26Z"
                />
                <path
                  class="cls-1"
                  d="M399.04,870.29c-2.12,5.87,7.75,7.15,9.09,1.91,1.99-5.86-7.62-6.96-9.09-1.91Z"
                />
                <path
                  class="cls-1"
                  d="M2653.56,147.13c-6-2.51-11.36-6.07-16.8-9.44,1.39,9.09,8.85,11.16,16.8,9.44Z"
                />
                <path
                  class="cls-1"
                  d="M2662.28,142.54c-6.69,4.23-4.9,10.84-1.94,16.6,2.06-5.21,4.2-10.92,1.94-16.6Z"
                />
                <path
                  class="cls-1"
                  d="M193.3,985.45c1.67-.95,5.06-2.83,6.74-3.75,2.23-5.74,5.21-11.21,10.4-14.79,2.16-3.46,4.3-6.92,6.55-10.31-.54-1.24-1.6-3.68-2.13-4.88-4.5,6.31-11.61,7.89-19,7.92,5.16,8.1,7.26,20.49-2.57,25.81Z"
                />
                <path
                  class="cls-1"
                  d="M3249.55-33.77c.45,2.31,1.37,6.88,1.81,9.16-1.67,5.69-3.19,11.43-4.85,17.08,2.1,1.13,4.26,2.17,6.46,2.94-.4.22-.79.4-1.17.55,1.07,1.94,3.26,5.86,4.36,7.79,2.13-1.43,5.96-2.42,8.33-4.12-1.56-.56-3.12-1.11-4.68-1.67-.94-.48-1.85-.98-2.75-1.5,3.26.51,6.61.21,9.99-1.51-1.74-7.7-5.7-15.82-1.89-23.62,2.65-5.17,2.66-11.93-3.19-14.92-6.23-.15-8.98,5.86-12.42,9.84Z"
                />
                <path
                  class="cls-1"
                  d="M3056.8,25.65c-5.9,1.09-10.97,3.68-13.97,9,4.77.6,9.47-.13,14.05-1.66-.03-1.84-.05-5.5-.08-7.34Z"
                />
                <path
                  class="cls-1"
                  d="M3149.56,6.13c-2.01,5.9,7.48,6.97,8.88,1.77,2.52-6.07-7.73-6.99-8.88-1.77Z"
                />
                <path
                  class="cls-1"
                  d="M2025.72,392.41c3.41-.68,7.3-1.11,10.54-2.73-.8-2.36-2.43-7.04-3.27-9.39-2.77,3.86-5.26,7.87-7.27,12.12Z"
                />
                <path
                  class="cls-1"
                  d="M3152.24,20.62c-.19-5.42-2.47-6.76-6.85-3.98.06,5.43,2.34,6.76,6.85,3.98Z"
                />
                <path
                  class="cls-1"
                  d="M50.84,1033.23c2.45,10.7,18.57,14.14,26.14,6.46-2.76-5.79-6.5-10.95-11.82-14.59-1.1,1.27-3.29,3.73-4.36,4.99-3.2.81-8.68-1.06-9.96,3.15Z"
                />
                <path
                  class="cls-1"
                  d="M2061.58,372.3c-1.59,2.84-7.87,8.32-2.03,10.78,4.2-.33,7.31-3.46,10.65-5.79-2.87-1.69-5.74-3.37-8.62-4.98Z"
                />
                <path
                  class="cls-1"
                  d="M565.59,904.97c-5.64-4.81-11.76-2.35-15.89,3,5.53,5.19,11.48,1.6,15.89-3Z"
                />
                <path
                  class="cls-1"
                  d="M2734.65,192.36c-2.97,1.33-3.13,4.98-1.77,7.76,1.44.89,2.79,1.91,4.08,3,4.58-1.16,2.7-11.34-2.3-10.77Z"
                />
                <path
                  class="cls-1"
                  d="M36.32,1086.04c1.46,7.56,7.79,1.02,10.9-1.31-3.84-2.38-7.79-1.62-10.9,1.31Z"
                />
                <path
                  class="cls-1"
                  d="M478.97,939.95c1.13,4.7,1.48,9.57.95,14.31,5.29-2.69,3.73-10.5-.95-14.31Z"
                />
                <path
                  class="cls-1"
                  d="M2513.34,292.26c4.11-1.51,2.03-9.44-2.47-7.67-3.75,1.8-1.86,8.91,2.47,7.67Z"
                />
                <path
                  class="cls-1"
                  d="M2186.9,402.29c-4.1,1.74-4.59,4.46-1.49,8.12,4.67-.82,9.95-3.92,9.46-9.44-2.9-.33-5.55.1-7.97,1.32Z"
                />
                <path
                  class="cls-1"
                  d="M3435.07,9c2.78-4.14-3.92-12.33-7.16-6.5-2.48,4.04,3.59,11.4,7.16,6.5Z"
                />
                <path
                  class="cls-1"
                  d="M1693.49,591.08c9.16.98,5.66-8.5.98-11.82-1.4.86-4.21,2.55-5.61,3.41,1.16,2.11,3.47,6.3,4.63,8.41Z"
                />
                <path
                  class="cls-1"
                  d="M3368.89,44.76c2.78.37,7.63,4.13,9.56.24,3.75-5.09,2.55-11.86-1.14-16.57-7.51,1.61-6.81,10.56-8.42,16.33Z"
                />
                <path
                  class="cls-1"
                  d="M655.61,927.11c-.31-5.07-2.76-5.99-7.26-2.77.25,5.2,2.67,6.12,7.26,2.77Z"
                />
                <path
                  class="cls-1"
                  d="M1763.23,563.04c-4.91-.01-9.64.86-13.76,3.55,1.04,1.54,3.12,4.63,4.17,6.17,4.74-1.55,7.85-5.18,9.6-9.72Z"
                />
                <path
                  class="cls-1"
                  d="M503.26,974.66c.29,4.71,2.33,5.8,6.1,3.25-.34-4.66-2.38-5.74-6.1-3.25Z"
                />
                <path
                  class="cls-1"
                  d="M1391.51,683.37c-.23,4.75,1.57,5.84,5.41,3.28.25-4.79-1.55-5.88-5.41-3.28Z"
                />
                <path
                  class="cls-1"
                  d="M1711.36,581.14c-2.07-5.11-9.89-.64-8.27,3.91,2.22,4.42,9.57.37,8.27-3.91Z"
                />
                <path
                  class="cls-1"
                  d="M2645.62,283.03c2.87-3.96-3.58-9.52-6.62-5.24-3.24,4.08,3.55,9.93,6.62,5.24Z"
                />
                <path
                  class="cls-1"
                  d="M490.2,981.31c-2.75,1.67-5.44,10.31.03,9.37,5.34-1.44,8.11-14.92-.03-9.37Z"
                />
                <path
                  class="cls-1"
                  d="M3195.16,115.35c-.9,4.16-3.7,9.68.44,13.1,3.29,3.8,8.02.17,12.13-.23-.1-5.24-2.67-11.9,2.96-15.35,7.47-5.23,7.08-14.98,2.7-22.19-7.96,6.6-14.53,15-18.23,24.67Z"
                />
                <path
                  class="cls-1"
                  d="M3153.18,135.24c2.91,4.6,8.18-.48,11.86-1.45-.6-1.95-1.81-5.86-2.41-7.79.67-2.57,2.02-7.72,2.69-10.29-2.48-.9-4.91-1.86-7.28-2.83-3.99,6.41-11.76,15.17-4.87,22.36Z"
                />
                <path
                  class="cls-1"
                  d="M1667.78,611.17c4.21-2.45-.12-8.6-3.81-5.38-4.99,2.33-.16,9.3,3.81,5.38Z"
                />
                <path
                  class="cls-1"
                  d="M2628.72,300.15c4.46-1.99,11.18-2.51,11.03-8.84-4.74,0-9.43-.15-14.08.23.88,2.91,1.88,5.77,3.05,8.62Z"
                />
                <path
                  class="cls-1"
                  d="M1457.93,686.12c8.42-1.6-3.95-15.38-6.78-6.56-3.68,4.39,2.83,9.9,6.78,6.56Z"
                />
                <path
                  class="cls-1"
                  d="M2457.14,389.57c-3.16-1.96-6.36-3.84-9.59-5.58-2.38-4.2-4.6-8.42-6.85-12.65-2.01.57-5.38,1.53-8.27,2.36-.98,2.42-2.1,4.79-3.34,7.1,7.73,6.72,17.77,11.08,28.05,8.77Z"
                />
                <path
                  class="cls-1"
                  d="M2656.26,292.03c-.37-4.62-2.4-5.5-6.09-2.69.39,4.58,2.42,5.46,6.09,2.69Z"
                />
                <path
                  class="cls-1"
                  d="M3122.21,152.81c3.98.45,6.9-7.09,1.72-7.29-4.22-.57-7.32,7.23-1.72,7.29Z"
                />
                <path
                  class="cls-1"
                  d="M486.64,1042.17c-.5-1.52-1.47-4.5-1.99-6.01,2.53-2.24,5.06-4.48,7.59-6.71,1.98-4.14,4.19-8.16,6.33-12.22,3.16.72,6.35,1.42,9.54,2.13-3.66-5.33-5.46-17.04-14.34-13.03,3.21,7.76-5.99,13.05-1.86,20.57-4.28,2.14-8.5,4.35-12.69,6.63,2.45,2.86,4.91,5.76,7.42,8.64Z"
                />
                <path
                  class="cls-1"
                  d="M671.86,949.1c-1.81.73-5.4,2.2-7.2,2.96-4.17,12.15,11.98,3.95,7.2-2.96Z"
                />
                <path
                  class="cls-1"
                  d="M3170.42,162.31c11.68-1.49,16.67-14.01,26.73-18.91-.89-2.43-2.64-7.27-3.54-9.7-9.79,7.4-23.5,14.5-23.2,28.61Z"
                />
                <path
                  class="cls-1"
                  d="M2859.46,264.56c6.38-3.12-.03-11.52-5.14-7.5-5.69,3.07.14,11.45,5.14,7.5Z"
                />
                <path
                  class="cls-1"
                  d="M507.08,1042.39c6.8,5.38,14.02,10.31,22.09,13.73-.97-11.11-3.26-23.37,2.95-33.5-1.71-.62-5.11-1.86-6.83-2.48.17,1.15.52,3.46.7,4.61-6.44.35-12.83.46-19.24.36.86,5.74.46,11.51.33,17.27Z"
                />
                <path
                  class="cls-1"
                  d="M2465.25,386.42c-7.93,1.75.1,11.03,4.46,12.12,1.14-3.4,1.84-15.46-4.46-12.12Z"
                />
                <path
                  class="cls-1"
                  d="M1072.43,848.36c.17,4.65,2.14,5.82,5.97,3.56-.15-4.79-2.12-5.96-5.97-3.56Z"
                />
                <path
                  class="cls-1"
                  d="M2027.2,536.06c-3.36,6.27-5.75,13.07-7.55,19.91,1.22,6.32,4.59,12.01,7.03,17.94,8.76,1.61,16.96-.76,24.87-4.55,3.8,1.11,7.64,2.11,11.47,3.14l-5.81-17.78c-1.46-4.47-1.97-8.94-1.76-13.27-.79-2.55-1.97-4.95-3.89-7.04-2.31.85-6.92,2.59-9.26,3.46-4.63-1.51-11.02-7.29-15.11-1.79Z"
                />
                <path
                  class="cls-1"
                  d="M2211.8,483.22c-1.01,3.75-2.33,7.42-3.94,10.97.11.23.16.45.29.68,6.21-1.46,6.32-7.21,6.53-12.42-1.07.14-2.01.42-2.88.76Z"
                />
                <path
                  class="cls-1"
                  d="M1450.23,741.95c3.11-3.67,2.37-5.71-2.24-6.13-3,3.57-2.26,5.65,2.24,6.13Z"
                />
                <path
                  class="cls-1"
                  d="M1208.28,829.67c.22-5.41-5.86-6.52-9.89-4.97-2.71,6.73,5.85,10.29,9.89,4.97Z"
                />
                <path
                  class="cls-1"
                  d="M2494.05,411.1c-2.37-3.26-4.79-6.44-7.24-9.6-2.53,2.74-6.22,8.85-1.08,11.31,2.97,1.89,5.69-.58,8.32-1.71Z"
                />
                <path
                  class="cls-1"
                  d="M571.48,1075.82c1-5.67,2.17-11.36,2.39-17.18,2.22-1.13,4.51-2.25,6.81-3.33l.85,7.25c5.46-.47,14.79-3.28,11.16-10.8-2.46-7.43-10.8-2.39-16.02-2.03,1.39-9.03-9.71-9.17-15.51-11.17-7.13,13.05.93,27.76,10.32,37.27Z"
                />
                <path
                  class="cls-1"
                  d="M1369.13,776.35c1.78,13.7,24.01,15.16,30.59,4.84-5.36-3.86-11.83-3.8-17.88-2.06-4.27-1.03-8.5-1.93-12.71-2.78Z"
                />
                <path
                  class="cls-1"
                  d="M1191.26,846.95c-2.53,3.78,3.39,10.79,6.66,6.09,2.41-3.74-3.34-10.34-6.66-6.09Z"
                />
                <path
                  class="cls-1"
                  d="M602.84,1072.44c.16,6.37,2.45,13.99-2.72,19.07-5.92,6.47-11.81,14.38-8.12,23.63-2.63,2.14-5.25,4.3-7.85,6.43,6.2,11.26,4.81,24.01,8.38,35.85,5.42-8.42,11.94-16.03,18.43-23.66-2.35-4.01-4.38-8.15-6.05-12.45,2.56-7.01,4.55-15.26,10.57-20.01.75.87,1.53,1.69,2.31,2.47.59,1.19,1.77,3.56,2.36,4.74-8.67,3.5-4.03,14.12-6.09,21.18,2.29-.21,6.86-.62,9.15-.8,5.06-8.91,11.02-17.51,19.91-22.94,5.23-3.02,7.75-9.12,7.97-14.91-3.69-2.02-7.53-3.83-11.1-6.29-.71,2.65-1.48,5.26-2.33,7.89-3.31,4.68-6.47,9.44-10.08,13.91-2.4-.66-4.81-1.35-7.28-2.13.37-4.11-.47-7.92-1.96-11.52-.09-3.25-.08-6.49,1.09-9.51,4.12-5.82,8.88-11.2,13.62-16.55,2.92.29,8.78.93,11.66,1.23,2.82-1.88,4.6-5.82,7.64-7.32,2.15,3,4.22,6.05,6.11,9.22-2.35.73-7.01,2.12-9.32,2.84,2.79.84,5.56.97,8.3.42,1.45,4.13,5.19,5.1,8.94,5.75-1.04-1.24-3.15-3.68-4.21-4.88.32-2.93.45-6.03-1.19-8.69,1.1-2.02,1.39-4.05,1.18-6.06,2.47-.46,4.38-1.59,4.03-4.89-.28-5.89,1.87-13.22-3.7-17.31-2.4-2.71-1.66-6.82-2.56-10.12-14.88,1.56-25.16,12.21-35.19,22.04-5.56.58-10.61-5.15-15.94-4.92-1.64-1.76-4.43-2.46-6.21-.18-1.5,2.08-.49,4.54,1.26,5.91,2.37,6.11,4.79,12.2,6.96,18.4-2.02,1.03-5.97,3.13-7.96,4.14Z"
                />
                <path
                  class="cls-1"
                  d="M1369.93,795.69c-2.91,4.18,3.95,11.28,7.51,6.52,2.57-4.27-3.9-11.23-7.51-6.52Z"
                />
                <path
                  class="cls-1"
                  d="M1937.84,611.18c-.12,5.18,2.22,6.17,7.01,2.95,0-5.07-2.35-6.06-7.01-2.95Z"
                />
                <path
                  class="cls-1"
                  d="M2705.86,377.15c2.18-1.86,4.47-3.71,6.78-5.58,4.11,2.59,8.41,5.05,12.95,7.03.73-3.04,1.56-6.06,2.43-9.08-.3-.1-.61-.2-.91-.31-1.44.9-3.29,2.06-4.34,2.71-1.27-2.07-2.5-4.14-3.74-6.22-1.66-.84-3.28-1.76-4.86-2.73-4.62.4-9.23.6-13.83.67,1.8,4.49,3.67,8.99,5.51,13.49Z"
                />
                <path
                  class="cls-1"
                  d="M1130.55,883.38c-7.36-1.23-20.47,1.44-17.75,11.21,7.77.12,15.06-3.6,17.75-11.21Z"
                />
                <path
                  class="cls-1"
                  d="M1108.29,893.67c-5.3-.89-12.3-.09-13.15,6.38,5.21,6.6,11.54-.91,13.15-6.38Z"
                />
                <path
                  class="cls-1"
                  d="M1098.43,909.29c2.24-5.2-6.49-6.89-7.94-2.18-2.51,5.39,6.45,7,7.94,2.18Z"
                />
                <path
                  class="cls-1"
                  d="M104.8,1238.39c-.45,3.65-.75,7.31-.24,10.99,1.88-2.26,3.74-4.62,5.38-7.1-1.83-1.14-3.55-2.44-5.13-3.89Z"
                />
                <path
                  class="cls-1"
                  d="M685.62,1061.18c7.54-3.47,15.46-4.34,23.69-3.83-6.19-5.17-13.82-8.77-22.04-6.45-2.91-3.35-6.03-6.54-10.5-7.56-.01,6.56,1.49,16.29,8.85,17.85Z"
                />
                <path
                  class="cls-1"
                  d="M1042.44,926.93c-2.92,4.15,4.1,9.59,7.1,5.18,2.61-4.05-4.15-9.3-7.1-5.18Z"
                />
                <path
                  class="cls-1"
                  d="M2740.3,383.49c.5-5.37-3.87-7.44-7.99-9.33-.83,2.09-2.53,6.27-3.37,8.33,3.42,1.3,7.99,5.02,11.35,1Z"
                />
                <path
                  class="cls-1"
                  d="M2413.06,483.76c1.42,4.24,5.7,6.54,8.6,9.76,3.45-4.56,7.91-7.99,12.82-10.98-5.82-7.31-15.87-5.27-21.42,1.21Z"
                />
                <path
                  class="cls-1"
                  d="M2810.47,363.88c.02-5.08-4.78-5.9-8.44-4.03-.88.69-2.69,2.06-3.6,2.76-.26,7.65,8.49,4.69,12.05,1.28Z"
                />
                <path
                  class="cls-1"
                  d="M774.71,1025.28c.04,1.67.17,4.95.2,6.59,6.13-.28,10.88-2.91,12.68-8.95-.69-.03-1.37-.05-2.06-.06,2.78-1.32,4.68-4.49.54-7.75-1.45.51-4.3,1.54-5.75,2.05-1.32,3.33-.68,5.17.69,5.93-2.2.3-4.33.93-6.3,2.19Z"
                />
                <path
                  class="cls-1"
                  d="M768.34,1043.02c-1.98-4.33-4.43-8.33-7.41-12-6.96,3.48-13.8,7.16-20.35,11.28,1.06,1,3.27,3,4.36,3.99,7.59-2.38,15.33-4.1,23.4-3.27Z"
                />
                <path
                  class="cls-1"
                  d="M2795.28,377.26s0,0,0,0c-.13.92-.06,1.95.33,3.14,5.11,6.8,13.61,4.1,19.39-.01-2.05-4.21-4.17-8.45-6.29-12.67-3.65,2.62-10.86,3.87-12.93,7.92.91-3.5.56-7-3.34-9.2-3.54,1.96-5.52,5.45-7.41,8.93,3.48.36,6.9,1,10.25,1.89Z"
                />
                <path
                  class="cls-1"
                  d="M715.16,1053.42c-3.95,8.92,9.17,6.89,11.45.67-1.86-4.57-9.24-5.35-11.45-.67Z"
                />
                <path
                  class="cls-1"
                  d="M2018.39,638.6c7.64,1.47,11.75-6.22,12.46-12.6-3.41-1.38-6.51-1-9.3,1.05-2.88,2.82-7.81,8.2-3.15,11.55Z"
                />
                <path
                  class="cls-1"
                  d="M836.6,1022.72c5.14-.2,9.83-2.23,13.99-5.14-4.23-8.03-14.69-3.2-13.99,5.14Z"
                />
                <path
                  class="cls-1"
                  d="M1847.76,696.76c2.87-3.36,1.94-8.16,2.89-12.14-2.09.62-4.14,1.34-6.17,2.11-3.2,2.38-6.98,4.36-11.43,5.82-.55.18-1.08.29-1.63.44-.49.28-.99.54-1.47.83,5.73,1.79,11.69,3.38,17.8,2.93Z"
                />
                <path
                  class="cls-1"
                  d="M212.02,1228.89c-.36-5.43-2.67-6.63-6.94-3.65.26,5.43,2.58,6.66,6.94,3.65Z"
                />
                <path
                  class="cls-1"
                  d="M817.47,1032.5c.2,5.65,2.43,6.94,6.7,3.83-.31-5.48-2.54-6.77-6.7-3.83Z"
                />
                <path
                  class="cls-1"
                  d="M3042.22,307.19c-4.36,1.69-1,8.36,3.02,7.28,4.71-1.44,1.09-8.83-3.02-7.28Z"
                />
                <path
                  class="cls-1"
                  d="M2011.9,655.48c2.74,7.78,12.53-2.61,18.15-2.36-1.8-1.4-5.44-4.21-7.24-5.6l-.42,6.53c-4.3-1.32-13.53-8.19-10.49,1.44Z"
                />
                <path
                  class="cls-1"
                  d="M2067.89,639.82c1.35-.76,2.73-1.38,4.14-1.96-.44-1.95-.67-3.89-.79-5.81-5.34,2.49-12.25.06-16.61,4.74,3.54,3.32,8.67,6.78,13.26,3.03Z"
                />
                <path
                  class="cls-1"
                  d="M236.81,1245.4c-2.18-.9-9.72-8.26-10.27-1.79-1.59,4.49,3.13,6.91,5.59,9.71,1.59-2.64,3.13-5.26,4.68-7.91Z"
                />
                <path
                  class="cls-1"
                  d="M575.51,1145.03c.27,5.56,2.54,6.87,6.88,3.97-.37-5.46-2.66-6.8-6.88-3.97Z"
                />
                <path
                  class="cls-1"
                  d="M214.02,1273.82c-3.14-2.61-6.47-8.07-11.17-4.66,1.97,3.46,3.53,7.12,4.65,10.95,2.14-2.11,4.31-4.2,6.52-6.3Z"
                />
                <path
                  class="cls-1"
                  d="M232.53,1269.45c1.69-7.17-9.5-9.03-12.6-3.69,1.21,5.05,8.77,7.93,12.6,3.69Z"
                />
                <path
                  class="cls-1"
                  d="M1394.42,898.52c.75-4.08,1.49-8.22,2.2-12.31-4.41,1.64-8.78,3.37-13.05,5.34,2.83,3.41,6.58,5.75,10.85,6.98Z"
                />
                <path
                  class="cls-1"
                  d="M3571.9,190.93c-1.56,1.82-4.61,5.44-6.14,7.25-1.59-4.56-2.98-9.14-4.25-13.74-2.86-.41-5.51-.82-8.23-1.31,2.16,2.49,6.45,7.41,8.6,9.87-.6,0-1.21,0-1.81.01,1.31,2.34,2.41,4.79,3.27,7.34,3.17-1.8,6.31-3.66,9.46-5.51-.22-.97-.69-2.93-.9-3.91Z"
                />
                <path
                  class="cls-1"
                  d="M3947.08,56.9c-1.99-4.66-10.55-1.73-8.68,3.17,2.16,3.93,9.91,1.54,8.68-3.17Z"
                />
                <path
                  class="cls-1"
                  d="M2937.62,389.1c-2.84,4.39,4.54,9.07,7.44,4.77,2.54-4.26-4.7-8.85-7.44-4.77Z"
                />
                <path
                  class="cls-1"
                  d="M3964.95,57.99c-.06-5.63-2.17-6.85-6.37-3.67-.04,5.63,2.07,6.85,6.37,3.67Z"
                />
                <path
                  class="cls-1"
                  d="M3216.63,307.27c3.16-3.49,2.58-5.68-1.76-6.52-3.27,3.49-2.69,5.65,1.76,6.52Z"
                />
                <path
                  class="cls-1"
                  d="M3992.12,58.33c-.16-5.23-2.55-6.26-7.16-3.08.12,5.1,2.51,6.14,7.16,3.08Z"
                />
                <path
                  class="cls-1"
                  d="M243.63,1295.95c-5.42-3.54-10.26-7.84-15.38-11.79-.28,13.24,8.94,24.31,13.43,36.29,1.32-8.1,1.74-16.3,1.95-24.5Z"
                />
                <path
                  class="cls-1"
                  d="M3158.68,336.1c7.28.99,8.17,4.83,4.35,10.24,1.45-.91,4.31-2.75,5.75-3.69-.79-.99-2.37-3.03-3.14-4.05,1.63-1.4,4.86-4.17,6.48-5.58-4.31-5.69-11.67-3.42-13.45,3.08Z"
                />
                <path
                  class="cls-1"
                  d="M1393.3,923.93c2.76-4.1-4.18-9.19-7.18-5.22-2.88,4.17,4.11,9.41,7.18,5.22Z"
                />
                <path
                  class="cls-1"
                  d="M2066.47,695.28c-.56,1.16-1.68,3.51-2.23,4.7,5.14,10.09,13.25-9.57,2.23-4.7Z"
                />
                <path
                  class="cls-1"
                  d="M3098.6,360.99c.18.52.37,1.04.55,1.56,3.09.45,6.18.92,9.29,1.4,1.46-1.52,2.21-3.52,1.4-6.49-3.87,1.13-7.51,2.32-11.25,3.54Z"
                />
                <path
                  class="cls-1"
                  d="M3130.83,347.78c-1.38,4.62,5.88,5.14,7.41,1.58,2.4-5.02-6.4-6.01-7.41-1.58Z"
                />
                <path
                  class="cls-1"
                  d="M3219.46,325.3c.11-.54.16-1.04.17-1.49,3.51-1.22,7.75-3.75,10.31-4.45-.31.94-.62,1.88-.91,2.81,3.15-.96,6.38-1.98,9.68-2.99-3.34-3.11-5.69-6.92-6.61-11.39-1.33-.17-3.96-.49-5.28-.63,1.22,1.69,3.71,5.08,4.97,6.78-.5,1.39-.99,2.79-1.45,4.19-.49-9.4-11.57-1.87-16.46,1.02-.06.32-.1.62-.13.91-1.95.43-3.98,1.44-5.4,2.7-1.04,8.88,6.69,6.19,11.11,2.52Z"
                />
                <path
                  class="cls-1"
                  d="M1934.3,750.69c-.89,2.41-2.67,7.26-3.6,9.68,4.79,3.85,10.58,4.31,15.89,1.1-1.78-5.97-6.91-8.8-12.29-10.78Z"
                />
                <path
                  class="cls-1"
                  d="M752.95,1151.27c5.66,1.48,5.22-7.59,10.01-9.08-.34-.73-1.01-2.16-1.32-2.9-2.43,4.59-7.17,5.53-11.97,5.96.83,1.51,2.45,4.51,3.28,6.02Z"
                />
                <path
                  class="cls-1"
                  d="M571.3,1204.11c-.87,6,.8,11.4,5.96,14.96,4.66-6.12,1.92-13.67-5.96-14.96Z"
                />
                <path
                  class="cls-1"
                  d="M803.49,1131.55c-.13,5.69,1.98,6.88,6.24,3.58.04-5.66-2.04-6.86-6.24-3.58Z"
                />
                <path
                  class="cls-1"
                  d="M170.2,1346.24c.25-5.53-1.92-6.7-6.44-3.58-.19,5.41,1.95,6.59,6.44,3.58Z"
                />
                <path
                  class="cls-1"
                  d="M449.69,1262c0-3.16,2.82-5.36,4.33-7.94-3.7,2.15-7.56,4.02-11.58,5.39.73.6,2.18,1.74,2.92,2.34,1.57,4.09-.1,7.33-4.93,9.71,4.83.91,9.74,1.63,14.72,1.45,1.64-4.97-2.87-7.67-5.46-10.96Z"
                />
                <path
                  class="cls-1"
                  d="M492.06,1251.83c.23-4.14-.26-8.32-3.05-11.61-1.3,3.42-2.65,6.81-3.92,10.22,2.31.49,4.64.94,6.97,1.39Z"
                />
                <path
                  class="cls-1"
                  d="M2825.73,526.8c-1.83.87-5.53,2.61-7.4,3.49-.2,1.85-.69,5.5-.89,7.35,5.24-.94,12.83-2.41,11.66-9.89,11.32-3.02,15.28-15.61,25.7-20.12,9.43-11.38,16.32-25.06,28.12-34.32,2.27-5.31,1.33-10.65-1.47-15.62-1.24,4.34-2.09,8.75-2.93,13.16-10.96-.22-17.11,9.89-16.63,19.78-6.82,3.5-13.95,6.37-21.02,9.25-.16,1.57-.52,4.68-.7,6.21-7.88,4.59-16.08,10.36-14.45,20.72Z"
                />
                <path
                  class="cls-1"
                  d="M2903.31,458.11c-5.07-4.63-11.7-4.85-13.98,2.68,3.69,6.46,10.2.27,13.98-2.68Z"
                />
                <path
                  class="cls-1"
                  d="M3300.81,337.25c-6.82-4.75-20.15,1.92-17.07,10.13,7.11-.37,13.3-4.24,18.9-8.42-.02-.02-.04-.03-.05-.05-.62-.53-1.2-1.09-1.78-1.65Z"
                />
                <path
                  class="cls-1"
                  d="M399.29,1294.48c7.96-.85,13.15-8.63,21.29-8.29l-1.01-2.69c-5.03,1.47-9.35-1.35-13.67-3.27,7.09,7.7-3.23,9.05-6.61,14.26Z"
                />
                <path
                  class="cls-1"
                  d="M772.68,1168.16c-2.93,1.22-6.58,6.21-2.98,8.67,5.3,2.74,9.55-9.27,2.98-8.67Z"
                />
                <path
                  class="cls-1"
                  d="M142.48,1412.92c1.34-.48,2.64-.94,3.53-1.24.57-4.86,1.24-9.68,1.99-14.5,1.77-.55,5.31-1.66,7.08-2.21-1.11-4.54-.23-12.33-6.79-11.83.75,8.89-4.69,15.85-8.03,23.57.41.95.8,1.9,1.12,2.89.36,1.11.74,2.22,1.1,3.33Z"
                />
                <path
                  class="cls-1"
                  d="M768.5,1180.99c-6.96,4.93-15.05,7.74-23.16,10.18.82,1.38,2.47,4.17,3.3,5.58-5.4,2.5-10.74,5.29-14.51,10.12l-1.13-6.05c-1.2,5.6-2.24,11.25-2.93,16.96,7.6-6.48,13.76-14.68,23.22-18.67,1.76-9.01,14.17-9.73,15.23-18.11Z"
                />
                <path
                  class="cls-1"
                  d="M402.81,1313.6c.14-4.01.04-8.01-.25-11.99-4.31,1.31-8.47,3-12.41,5.13,1.1,6.06,8.18,5.09,12.66,6.86Z"
                />
                <path
                  class="cls-1"
                  d="M597.6,1294.35c11.89-11.04,6.81-28.47,12.9-41.93-4.45-4.87-8.84-9.79-13.17-14.79.7,19.44.45,39.79-8.66,57.48,2.22-.19,6.7-.57,8.93-.76Z"
                />
                <path
                  class="cls-1"
                  d="M2693.86,558.28c4.84,3.6,11.17,6,17.05,3.21-4.91-2.06-13.72-10.62-17.05-3.21Z"
                />
                <path
                  class="cls-1"
                  d="M3650.42,245.5c1.44.71,4.3,2.16,5.71,2.87,2.34-1.27,4.74-2.56,7.18-3.86-.03-1.54-.11-4.67-.14-6.21-5.31.62-9.84,2.71-12.75,7.19Z"
                />
                <path
                  class="cls-1"
                  d="M806.13,1172.5c2.71,4.8,2.9,14.04,10.78,12.11-1.68-5.77-3.1-12.8-10.78-12.11Z"
                />
                <path
                  class="cls-1"
                  d="M2621.31,582.97c-2.99,3.4,2.59,9.58,5.45,4.95,2.48-3.33-2.63-9.19-5.45-4.95Z"
                />
                <path
                  class="cls-1"
                  d="M424.02,1321.44c.23.81.39,1.77.57,2.76,2.97-1.98,5.9-4.02,8.8-6.11-.03-1.02-.06-2.04-.03-3.03,1.72-.53,4.68-1.48,7.02-2.22.79-.61,1.56-1.24,2.34-1.86.83-5.42-5.23-6.24-8.57-1.76-.77-.62-2.26-1.88-3.01-2.51.69,1.09,2.1,3.25,2.8,4.36-3.76,2.91-9.56,4.8-9.93,10.37Z"
                />
                <path
                  class="cls-1"
                  d="M2793.9,535.24c-.55,1.19-1.65,3.5-2.18,4.64,5.54,9.76,13.28-9.78,2.18-4.64Z"
                />
                <path
                  class="cls-1"
                  d="M3304.86,377.79c-.13-5.64-2.24-6.87-6.36-3.74,0,5.75,2.11,6.98,6.36,3.74Z"
                />
                <path
                  class="cls-1"
                  d="M2314.77,705.25c-1.5-7.88-10.52-2.78-13.29,1.31,3.54,5.4,10.33,3.95,13.29-1.31Z"
                />
                <path
                  class="cls-1"
                  d="M2245.46,735.34c-8.69-2.94-13.05,9.44-18.47,14.47,7.41-1.61,25.19-3.45,18.47-14.47Z"
                />
                <path
                  class="cls-1"
                  d="M2340.47,700.46c.22,5.41,2.57,6.62,7,3.73-.31-5.38-2.64-6.64-7-3.73Z"
                />
                <path
                  class="cls-1"
                  d="M3255.04,411.83c.14.36.29.71.43,1.07.34.91.64,1.82.94,2.73,2.86,1.32,6.04,2.13,9.05,2.6,2.74-2.11,10.82-2.89,7.32-7.97-5.24-2.81-10.98-4.15-16.8-4.52-.13,2.07-.47,4.09-.93,6.09Z"
                />
                <path
                  class="cls-1"
                  d="M2367.05,701.57c.61,6.82,6.94,3.65,11.45,3.25.21-2.02.63-6.09.85-8.11-4.51.5-9.22,1.2-12.3,4.85Z"
                />
                <path
                  class="cls-1"
                  d="M4020.54,163.61c-.02-5.41-2.26-6.52-6.72-3.29-.02,5.28,2.22,6.4,6.72,3.29Z"
                />
                <path
                  class="cls-1"
                  d="M77.75,1468.95c-3.73-8.53-16.63-3.58-11.91,4.9,4.37-.42,8.11-2.85,11.91-4.9Z"
                />
                <path
                  class="cls-1"
                  d="M2441.79,708.23c5.38,4.33,11.2.85,15.43-3.39-3.11-1.4-6.24-2.74-9.31-4.02-1.52,1.84-4.6,5.57-6.12,7.41Z"
                />
                <path
                  class="cls-1"
                  d="M2699.64,625.84c-2.09-7.85-14.73-4.03-12.39,3.34,4.5,3.17,8.44-1.65,12.39-3.34Z"
                />
                <path
                  class="cls-1"
                  d="M767.15,1258.84c1.07,1,3.17,3.03,4.24,4.03,2.12-1.23,6.35-3.72,8.47-4.95-1.53-2.02-3.03-4.02-4.49-6.03-2.07,3.13-4.84,5.45-8.22,6.95Z"
                />
                <path
                  class="cls-1"
                  d="M761.73,1275.6c-.86-2.44-2.57-7.36-3.45-9.83-2.5,2.63-4.94,5.24-7.41,7.9-7.2,1.74-19.81,8.21-16.75,17.06,4.55-6.26,11.02-10.22,17.66-13.97,3.37,2.7,6.66.31,9.94-1.16Z"
                />
                <path
                  class="cls-1"
                  d="M762.94,1268.69c3.84,3.62,6.38,2.76,7.6-2.58-3.8-3.5-6.34-2.64-7.6,2.58Z"
                />
                <path
                  class="cls-1"
                  d="M2459.22,716.42c-6.48,3.02-14.67,5.33-16.78,13.07,7.3-1.84,14.87-5.02,16.78-13.07Z"
                />
                <path
                  class="cls-1"
                  d="M711.57,1306.29c2.76,1.68,5.18,3.65,7.28,5.84.09-.02.17-.04.26-.07.29.73.66,1.45,1.1,2.17,1.47-.95,4.4-2.78,5.88-3.7l1.81,3.48.97-.62c-.43-1.45-.86-2.91-1.28-4.38.51-.33,1.01-.68,1.45-1.1.42-6.53,1.04-13.08,1.61-19.58-3.39,2.53-6.51,5.4-9.31,8.58,0-.16-.01-.32-.02-.46-.21.39-.41.78-.61,1.17-1.07,1.26-2.1,2.57-3.06,3.92-2.55-1.12-5.11-2.27-7.6-3.4-1.22,3.26-.39,5.95,1.5,8.14Z"
                />
                <path
                  class="cls-1"
                  d="M751.49,1289.63c-4.95.17-10.6-.34-13.78,4.43,1.37,10.07,13.34,2.37,13.78-4.43Z"
                />
                <path
                  class="cls-1"
                  d="M791.46,1271.01c-1.3,4.26-2.56,8.53-3.34,12.92,4.31-.3,9-.95,12.09-4.35,1.73-5.91-4.69-7.48-8.75-8.57Z"
                />
                <path
                  class="cls-1"
                  d="M3073.76,528.83c-1.32,1.51-2.54,3.02-3.74,4.51.76,1,2.27,2.92,3.06,3.91,2.16-.6,6.44-1.8,8.59-2.4-3.17-1.38-5.81-3.38-7.92-6.02Z"
                />
                <path
                  class="cls-1"
                  d="M3997.14,235.28c4.18-1.4,2.06-9.34-2.35-7.81-3.87,1.73-1.98,8.75,2.35,7.81Z"
                />
                <path
                  class="cls-1"
                  d="M1223.55,1146.57c2.63-5.63-6.77-6.93-7.76-1.74-2.05,5.34,6.41,6.35,7.76,1.74Z"
                />
                <path
                  class="cls-1"
                  d="M-5.88,1561.73c1.84,2.76,3.77,5.46,5.69,8.16.94-8.44-.43-19.32-7.54-24.73,1.33,5.41,1.84,11,1.85,16.57Z"
                />
                <path
                  class="cls-1"
                  d="M1427.64,1087.06c1.76-.39,3.52-.69,5.27-.93,2.05-3.25,3.92-6.61,4.54-10.49-4.68,2.03-9.12,4.39-13.43,7.04,1.2,1.46,2.42,2.92,3.63,4.38Z"
                />
                <path
                  class="cls-1"
                  d="M3054.19,551.99c-1.17,4.55.53,6.55,4.99,6.03.96-4.58-.73-6.55-4.99-6.03Z"
                />
                <path
                  class="cls-1"
                  d="M3072.36,565.32c-5,2.91-10.03,5.83-15.53,7.52,5.29-3.78,10.16-8.02,8.29-15.48-8.94,2.38-10.06,13.27-19.24,15.09-5.37-3.68-10.85-7.2-16.34-10.68-2.67,2.76-5.35,5.5-8.09,8.21-.24.58-.51,1.16-.75,1.74.96,1.81,2.89,5.45,3.81,7.26-.69,1.4-2.11,4.15-2.83,5.53,1.62,1.81,3.29,3.62,4.96,5.44,1.58.44,3.16.89,4.74,1.34,5.66-4.02,1.38-13.37,9.53-15.85-.64,1.75-1.91,5.26-2.58,7.03,5.26,7.46,13.88,4.21,19.01-1.5,1.58.42,4.81,1.25,6.39,1.65,2.62-5.87,5.59-11.61,8.64-17.31Z"
                />
                <path
                  class="cls-1"
                  d="M3086.36,561.56c1.7,1.19,5.08,3.62,6.75,4.82,2.24-2.82,3.24-5.93,3.03-9.36-5.27-1.31-10.71-.77-15.99-1.1-.45,1.39-1.36,4.18-1.82,5.54,2.64.05,5.29.05,8.03.1Z"
                />
                <path
                  class="cls-1"
                  d="M1227.96,1169.77c2.04-5.61-7.26-7.92-8.75-2.49-2.28,5.68,7.19,7.91,8.75,2.49Z"
                />
                <path
                  class="cls-1"
                  d="M613.67,1389.92c1.64-.74,4.98-2.16,6.63-2.87-.05,4.69-1.62,13.17,6.05,10.5-.52-1.71-1.51-5.15-2.01-6.87,11.98,5.8,9.55-8.93,12.43-15.99-8.13,1.88-15.13-3.2-17.37-10.9-5.16,2.32-10.28,4.67-15.46,6.9,4.86,5.71,11.27,10.74,9.74,19.24ZM619.16,1380.39c3.69-2.58,5.74-1.57,6.13,3.01-3.81,2.65-5.85,1.64-6.13-3.01Z"
                />
                <path
                  class="cls-1"
                  d="M1560.4,1059.37c-5.19,2.84.47,9.46,4.58,5.8,5.49-2.84-.56-9.97-4.58-5.8Z"
                />
                <path
                  class="cls-1"
                  d="M3291.87,503.28c-1.18-4.22-7.69-5.52-10.57-2.53-1.65,5.45,10.23,9.1,10.57,2.53Z"
                />
                <path
                  class="cls-1"
                  d="M2.65,1594.98c3.93-3.4.28-9.34-1.71-12.85-4.26,1.26-5,13.93,1.71,12.85Z"
                />
                <path
                  class="cls-1"
                  d="M3916.16,330.72c12.47-7.83,21.63-20.64,24.92-35.06-.99.05-2.94.15-3.91.17-7.63,12.14-18.25,22.76-31.81,27.96,3.54,2.31,7.19,4.61,10.8,6.93Z"
                />
                <path
                  class="cls-1"
                  d="M3692.64,397.06c-.38-4.75-.71-9.48-1.38-14.21-5.53-1.69-14.71,4.16-9.63,10.44,1,6.06,6.65,4.52,11.01,3.77Z"
                />
                <path
                  class="cls-1"
                  d="M62.09,1579.25c-3.19,4.03,3.78,9.72,6.88,5.42,2.5-3.98-3.67-9.59-6.88-5.42Z"
                />
                <path
                  class="cls-1"
                  d="M588.4,1406.84c-.45,4.92,1.2,5.83,4.92,2.73.44-5.05-1.21-5.96-4.92-2.73Z"
                />
                <path
                  class="cls-1"
                  d="M2869,693.95c3.93-3.15-.72-10,3.16-12.1-1.57.01-3.15-.03-4.72-.13.47,4.07,1,8.14,1.57,12.23Z"
                />
                <path
                  class="cls-1"
                  d="M3118.96,595.22c-1.49,4.49,0,6.25,4.41,5.28,1.37-4.45-.11-6.22-4.41-5.28Z"
                />
                <path
                  class="cls-1"
                  d="M3669.8,417.09c-3.44-4.66-12.91.52-9.33,5.7,3.49,4,11.73-.63,9.33-5.7Z"
                />
                <path
                  class="cls-1"
                  d="M2544.65,805.55c1.38.02,4.16.09,5.55.11-.45-.96-1.35-2.89-1.79-3.85.34-4.62-.65-9.2-2.51-13.36-.99.89-3.01,2.63-3.99,3.52.84,4.53,1.75,9.08,2.76,13.59Z"
                />
                <path
                  class="cls-1"
                  d="M608.27,1434.13c-4.24-5.57-11.09-5.05-17.18-4.95,3.72,6.05,10.65,7.28,17.18,4.95Z"
                />
                <path
                  class="cls-1"
                  d="M2947.01,762.1c.45-1.09,1.34-3.3,1.8-4.38-1.79-.63-5.34-1.85-7.12-2.45-4.21-8.27-13.08-10.42-21.51-11.63-8.42-3.97-12.79-14.99-23.71-12.7-2.61-6.98-9.42-9.6-15.83-11.94l4.26-4.45c-1.91,1.36-3.77,2.78-5.55,4.2-5.86-.67-10.78-3.01-15.31-6.03l4.39,13.45c6.83,2.49,13.69,4.96,18.34,11.07,1.97-.68,5.91-2.07,7.87-2.77,5.63,14.16,24.54,7.72,31.6,19.87,5.11,5.76,13.93,5.2,20.79,7.77Z"
                />
                <path
                  class="cls-1"
                  d="M534.22,1451.01c-5.27,2.49-9.04,6.81-11.6,11.92,8.72,5.39,14.78-4.25,11.6-11.92Z"
                />
                <path
                  class="cls-1"
                  d="M726.98,1390.64c-5.46,2.83-11.27,5.53-14.22,11.23,6.13-.89,12.28-1.82,18.54-1.08-1.14-3.49-2.62-6.91-4.32-10.15Z"
                />
                <path
                  class="cls-1"
                  d="M502.18,1476.13c4.01,1.38,8.07,2.78,12.14,4.14-.66-1.8-1.95-5.45-2.6-7.25,5.86-.37,10.94-2.33,12.13-8.67-9.26-1.48-15.45,6.42-21.67,11.78Z"
                />
                <path
                  class="cls-1"
                  d="M1362.7,1197.73c.57.62,1.19,1.21,1.8,1.78,1.85-3.7,3.42-7.54,4.95-11.4-3.2.61-6.36,1.3-9.25,2.75-.06.28-.06.55-.08.82.92,1.94,1.78,3.93,2.55,5.97,0,.02.02.05.03.08Z"
                />
                <path
                  class="cls-1"
                  d="M1202.4,1251.36c-5.58,1.96-10.81-.57-16.05-1.99-1.13,5.71,6.19,6.52,9.49,9.61-.27,1.97-.73,5.89-1,7.86,8.31,2.29,11.48-9.63,7.55-15.47Z"
                />
                <path
                  class="cls-1"
                  d="M1219,1243.52c2.39-5.65-7.36-7.82-8.82-2.5-2.4,5.72,7.01,7.56,8.82,2.5Z"
                />
                <path
                  class="cls-1"
                  d="M1544.1,1145.06c2.2-3.88,4.02-7.87,6.17-11.79-7.18-3.27-9.81,7.13-6.17,11.79Z"
                />
                <path
                  class="cls-1"
                  d="M2538.04,813.08c-.05-5.5-2.19-6.51-6.53-3.01-.03,5.46,2.11,6.47,6.53,3.01Z"
                />
                <path
                  class="cls-1"
                  d="M500.59,1478.06c-2.44.86-7.31,2.62-9.75,3.49l-2.4-.46c.53,1.1,1.6,3.35,2.16,4.44-2,.05-5.97.13-7.97.18-.03,1.25-.11,3.77-.14,5.02-7.38-1.69-11.71,5-17.05,8.42,3.27.34,6.49.64,9.8.97,4.39-6.54,11.59-9.9,17.32-15,4.37-1.23,8.6,1.33,12.89,2.01-1.63-3.03-3.26-6.06-4.84-9.07Z"
                />
                <path
                  class="cls-1"
                  d="M739.47,1409.53c4.69.35,8.78-1.72,11.16-5.76.88-4.32-3.7-6.19-7.06-6.3-3.43,2.87-6.5,7.57-4.1,12.06Z"
                />
                <path
                  class="cls-1"
                  d="M604.33,1455.96c2.02-3.69-3.47-10.53-6.55-5.66-2.78,3.93,3.57,10.83,6.55,5.66Z"
                />
                <path
                  class="cls-1"
                  d="M2261.29,915.86c4.36-.55,4.55-8.61-.59-7.07-4.47.52-4.64,8.64.59,7.07Z"
                />
                <path
                  class="cls-1"
                  d="M4107.76,316.21c2.43-.19,7.25-.55,9.66-.77-1.51-4.31-2.89-8.74-5.2-12.72-5.44,1.77-6.79,8.87-4.47,13.49Z"
                />
                <path
                  class="cls-1"
                  d="M404.09,1537.39c-8.3,3.83-14.95,10.1-22.46,15.11-.46.59-.92,1.18-1.38,1.76-.56,1.95-1.05,3.91-1.42,5.93,3.8-1.24,7.58-2.41,11.42-3.53-.57-1.53-1.72-4.55-2.32-6.07,2.72-.32,8.14-.91,10.83-1.22,1.17-3,2.33-6.04,3.51-9.01,1.96-1.01,5.83-3.05,7.75-4.07,2.11.79,6.33,2.4,8.44,3.19-.58-2.2-1.75-6.59-2.33-8.79,5.98-.84,9.61,2.68,12.27,7.62-.04-4.66-.59-9.32-.97-13.9,2.78.6,5.6,1.2,8.43,1.82-.28-1.49-.86-4.49-1.18-5.97,5.42-3.18,18.28-1.77,15.1-11.11,4.66-2.6,9.23-5.7,14.83-5.85-.63-1-1.83-3.03-2.43-4.05-.89.66-2.71,1.99-3.6,2.66-20.16,3.22-32.75,21.68-51.3,28.91-.81,1.64-2.4,4.92-3.17,6.55Z"
                />
                <path
                  class="cls-1"
                  d="M714.13,1425.63c-3.34,9.63,9.97,9.75,15.7,12.56,3.61-1.51,7.18-3.12,10.74-4.78,3.12-5.59,3.27-12.33,4.66-18.46-10.84-2.51-27.49-2.35-31.1,10.69Z"
                />
                <path
                  class="cls-1"
                  d="M2.94,1655.59c-.82,1.31-2.4,3.98-3.19,5.28-2.19.71-6.55,2.07-8.74,2.78,4.48,7.85,8.95,17.55,18.29,20.52-1.91-5.23-3.84-10.41-5.76-15.6,2.56,1.55,7.68,4.69,10.25,6.27,4.27-10.91-10.2-9.61-10.85-19.25Z"
                />
                <path
                  class="cls-1"
                  d="M3386.45,561.01c4.45-2.53-1.27-8.53-4.84-6.39-4.24,2.56,1.38,7.92,4.84,6.39Z"
                />
                <path
                  class="cls-1"
                  d="M758.92,1423.21c-5.75,2.58-1.32,12.43,4.31,9.08,5.95-.93,1.3-13.84-4.31-9.08Z"
                />
                <path
                  class="cls-1"
                  d="M2515.68,854.26c.07-4.63-1.81-5.56-5.6-2.74-.19,4.67,1.69,5.6,5.6,2.74Z"
                />
                <path
                  class="cls-1"
                  d="M3784.95,445.08c1.36-4.78-6.48-10.99-8.73-4.61-2.15,4.94,5.88,8.43,8.73,4.61Z"
                />
                <path
                  class="cls-1"
                  d="M2185.01,968.62c-4.11-3.94-9.33-.89-13.77.36,1.31,3.91,1.08,9.29,5.4,11.48,6.49,1.34,12.92-5.73,8.37-11.84Z"
                />
                <path
                  class="cls-1"
                  d="M3343.2,625.62c-3.37-2.39-6.86-4.54-10.59-6.14-2.29,1.3-4.82,2.42-7.62,3.34-.62.2-1.22.33-1.83.5.27.67.56,1.34.82,2.02-1.28-.42-2.48-.85-3.73-1.28-1.72.35-3.39.56-5.03.68.24,3.84.78,7.67,2.11,11.31.85-2.43,2.56-7.29,3.42-9.72,2.11,1.53,4.27,3.11,6.47,4.68,4.95-2.56,9.99-4.3,15.19-.72-1.35,1.31-4.03,3.94-5.38,5.25,1.58.42,4.77,1.23,6.35,1.63-.44-4.02,1.22-6.35,4.92-6.95,2.35,2.97,4.56,6.14,6.82,9.27-2.72.82-8.14,2.46-10.86,3.28,1.66,1.58,4.98,4.76,6.64,6.34,3.06,6.9-5.62,19.14,6.32,19.25,8.79-11.76,5.56-26.97,2.01-40.22-.35-.38-.69-.77-1.03-1.16-.14,2.66-.33,6.1-.44,8.03-4.64-3.6-8.62-8.18-14.55-9.37Z"
                />
                <path
                  class="cls-1"
                  d="M723.47,1453.3c-1.34-1.44-4.04-4.33-5.39-5.8-2.51.95-7.57,2.87-10.09,3.8,1.04,3.19,2.11,6.37,3.21,9.54,4.56-1.69,8.85-4,12.26-7.53Z"
                />
                <path
                  class="cls-1"
                  d="M987.49,1371.29c-3.23-6.81-11.26-4.02-17.11-4.94-.08,9.54,12.8,14.71,17.11,4.94Z"
                />
                <path
                  class="cls-1"
                  d="M1000.87,1363.56c-6.98-4.38-14,.17-11.32,8.17,5.75.81,9.18-3.5,11.32-8.17Z"
                />
                <path
                  class="cls-1"
                  d="M38.14,1736.99c11.98-.78,23.01-7.67,34.16-11.59-1.95-.41-5.87-1.21-7.81-1.58,1.48-1.66,4.41-4.93,5.88-6.59-10.91,2.09-20.96,6.81-30.08,13.02.03-6.26.88-12.51,1.55-18.7-8.34-2.39-16.99-3.86-24.64-8.13,5.02-3.79,10.25-4.96,15.63-3.49,1.14-1.65,2.29-3.27,3.49-4.87,3.98-.89,6.5-3.36,6.47-7.56-4.87,1.76-9.7,4.07-15.01,2.92-1.56,1.38-4.76,4.17-6.32,5.56.55-8.62-7.65-8.19-13.75-9.16,1.52,11.57,9.48,20.4,15.7,29.77,1.69.86,5.12,2.6,6.82,3.49.39,2.23.78,4.45,1.22,6.73,1.83,1.88,4.1,3.65,5.38,5.9-1.78,1.32-3.52,2.68-5.22,4.1,2.09.29,4.14.33,6.17.22,0,.06,0,.12-.01.19.1-.06.23-.13.36-.21Z"
                />
                <path
                  class="cls-1"
                  d="M1008.16,1364.47c.24-4.72-1.57-5.74-5.48-3.09-.32,4.68,1.49,5.7,5.48,3.09Z"
                />
                <path
                  class="cls-1"
                  d="M743.13,1457.81c-2.2,3.24,3.53,12.46,5.15,5.58.85-2.76-2.79-11.83-5.15-5.58Z"
                />
                <path
                  class="cls-1"
                  d="M751.02,1454.6c-2.09,4.21.84,11.73,6.25,11,4.91-2.98-1.59-14.04-6.25-11Z"
                />
                <path
                  class="cls-1"
                  d="M780.95,1447.95c-3.6,2.25-7.13,4.51-10.57,6.95-2.73-.96-5.35-1.98-8.07-2.78-.13,1.96-.47,5.87-.6,7.83,5.96-.16,11.94-.4,17.88-1.13.43-3.63.89-7.25,1.36-10.86Z"
                />
                <path
                  class="cls-1"
                  d="M1095.54,1442.07c-14.31-3.57-21.41-18.83-35.71-22.7-14.12-3.93-24.94-14.31-38.53-19.29-8.36-3.15-14.83-10.22-23.84-11.75-3.8-3.5-5.92-15.68-12.39-10.34-.63,4.14.44,8.76,4.01,11.36,9.04,8.24,18.78,15.72,28.89,22.6,1.1,1.42,3.37,4.24,4.5,5.66,8.07,3.21,17.39,4.27,24.06,10.37,6.01,5.84,15.08,6.77,20.7,13.17,5.13,5.62,12.82,4.56,19.05,1.61-1.42,8.73-.85,17.59-.7,26.38,5.84-7.76,12.6-16.69,9.95-27.08Z"
                />
                <path
                  class="cls-1"
                  d="M3616.76,522.04c-3.82,1.78-1.6,8.69,2.56,7.63,4.28-1.5,1.88-9.39-2.56-7.63Z"
                />
                <path
                  class="cls-1"
                  d="M738.62,1473.97c-.31-1.78-.95-5.37-1.26-7.15-6.39,3.29-15.48,3.98-17.25,12.45-6.12,3.07-12.18,3.27-16.35-2.93,0,.02,0,.03,0,.05-1.95-3.44-3.98-6.87-6.06-10.27-5.13,3.12-10.23,6.23-15.54,9.24,4.5,3.27,9.7,2.75,14.73,1.68-.69,1.64-1.26,3.3-1.71,4.99-.94.6-1.99,1.65-3.13,3.31.37,1.66,1.13,5.01,1.53,6.66,2.69.44,4.47-.55,5.48-2.08.56-.07,1.1-.16,1.65-.24-.04.17-.09.34-.13.5,4.29-1.37,8.61-2.67,12.95-3.89,2.14,1.62,4.52,2.73,7.16,3.31-1.96-2.39-3.93-4.73-5.92-7.01,4.1-1.74,8.24-3.5,12.35-5.31,3.81-1.11,7.65-2.2,11.49-3.31ZM696.98,1476l6.64,1.03c-.58,3.09-1.26,6.17-2.03,9.24-1.47-3.44-2.99-6.87-4.61-10.27Z"
                />
                <path
                  class="cls-1"
                  d="M3345.77,616.58c.08,4.58,2.05,5.55,5.91,2.88-.11-4.67-2.07-5.61-5.91-2.88Z"
                />
                <path
                  class="cls-1"
                  d="M682.46,1491.5c-2.18,1.15-4.32,2.32-6.46,3.49.77,2.47,2.3,7.45,3.07,9.92,3.57-2.65,7.17-5.33,10.72-8.04-2.46-1.78-4.91-3.61-7.33-5.37Z"
                />
                <path
                  class="cls-1"
                  d="M3264.71,647.01c.09,5.52,2.27,6.65,6.56,3.41-.15-5.6-2.33-6.73-6.56-3.41Z"
                />
                <path
                  class="cls-1"
                  d="M3537.96,569.47c-4.02,6.32-9.04,11.76-16.7,13.32l1.24-5.98c-2.34-.18-7.01-.57-9.35-.75l6.66-2.58c-.71-.84-2.18-2.55-2.92-3.38-2.35,1.74-4.66,3.44-6.96,5.13-.94,5.75-2.38,11.67-.68,17.47,4.45-2.02,9-3.95,13.61-5.79l-1-3.07c2.88-1.17,8.61-3.48,11.49-4.66.71,1.75,2.06,5.28,2.74,7.07,2.81-4.28,4.08-9.84,8.52-12.93-2.3-1.27-4.5-2.56-6.64-3.85Z"
                />
                <path
                  class="cls-1"
                  d="M395.39,1606.31c2.29-3.81-3.63-9.98-6.81-5.81-2.57,3.86,3.66,10.81,6.81,5.81Z"
                />
                <path
                  class="cls-1"
                  d="M2984.91,751.24c-4.8,1.47-7.42,6.93-12.83,6.51-13.61-.8-21.31,16.8-17.83,27.87,3.23-3.48,4.78-11.41,11-10.38,3.61.23,7.26.42,10.99.51,4.56-7.34,18.08-15.55,8.67-24.51Z"
                />
                <path
                  class="cls-1"
                  d="M3264.33,672.21c-3.69,1.67-7.2,3.49-10.59,5.44-3.08,12.6,11.86,1.1,17.87,1.09-1.87,4.37-9.2,7.04-7.51,12.3,3.54,2,7.49,3.27,11.37,4.76,2.76-7.09,8.07-12.05,15.32-14.45.39-10.85,1.02-22.52,7.26-31.82-8.17,4.62-17.78,7.72-22.78,16.21-5.68-2.58-9.7,1.08-10.93,6.46Z"
                />
                <path
                  class="cls-1"
                  d="M3252.06,667.98c1.77,3.89,4.16,3.99,7.15.29-1.87-3.96-4.22-4.07-7.15-.29Z"
                />
                <path
                  class="cls-1"
                  d="M3838.88,485.9c-.43,3.2,2.42,5.46,3.79,8.11,1.91-4.45,8.48-7.91,6.95-13.3-4.03.31-8.94,1.24-10.74,5.19Z"
                />
                <path
                  class="cls-1"
                  d="M3517.37,593.23c3.68,3.34,6.05,2.36,7.16-2.98-3.45-1.7-5.85-.71-7.16,2.98Z"
                />
                <path
                  class="cls-1"
                  d="M386.6,1632.51c-1.5-5.02-2.95-10.06-4.59-14.97-3.43,5.66-2.02,13.47,1.26,18.99.81-1.01,2.48-3,3.33-4.01Z"
                />
                <path
                  class="cls-1"
                  d="M3517.83,611.71c1.78-4.95,3.67-9.87,5.71-14.74l-5.72,3.68c-.72-2.22-2.15-6.69-2.89-8.94-1.84,1.78-5.5,5.29-7.34,7.07-.58,1.73-1.65,5.24-2.2,6.97,1.95,4.64,4.01,9.31,6.02,14-1.73-6.63-2.54-13.46-.12-20.03,1.9,4.08,4.12,8.1,6.53,11.98Z"
                />
                <path
                  class="cls-1"
                  d="M1676.87,1212.68c-1.54-4.91-6.49-11.73-11.51-5.72.6,5.75,6.93,6.31,11.51,5.72Z"
                />
                <path
                  class="cls-1"
                  d="M4139.56,405.09c-.26-5.53-2.51-6.78-6.73-3.72.18,5.49,2.43,6.74,6.73,3.72Z"
                />
                <path
                  class="cls-1"
                  d="M60.08,1737.65c3.03,2.17,6.25,4.11,9.57,5.85-.2-1.48-.53-3.86-.84-6.07-.74-1.02-1.45-2.06-2.12-3.12-2.15,1.08-5.01,2.52-6.62,3.34Z"
                />
                <path
                  class="cls-1"
                  d="M1279.87,1354c-1.37-4.09-3.1-8.06-4.69-12.01-3.71,1.61-7.03,4.01-9.22,7.48,4.22,1.92,8.84,7.6,13.92,4.53Z"
                />
                <path
                  class="cls-1"
                  d="M1337.15,1320.34c2.11,3.68,4.58,3.62,7.36-.22-2.18-3.79-4.65-3.73-7.36.22Z"
                />
                <path
                  class="cls-1"
                  d="M1764.27,1180.25c-3.05,4.15,3.55,10.77,7.01,6.02,3.6-4.3-3.6-11.53-7.01-6.02Z"
                />
                <path
                  class="cls-1"
                  d="M406.91,1629.54c-1.87-4.4-8.88-2.48-10.56,1.13-.67,6.2,11.43,4.64,10.56-1.13Z"
                />
                <path
                  class="cls-1"
                  d="M59.5,1760.49c-1.5,2.91-2.97,5.84-4.43,8.77,2.05,4.11,4.08,8.18,6.29,12.27,5.76.04,9.18,3.52,10.86,8.96,3.26-7.72-1.88-14.82-3.82-22.11,3.41-2.83,4.04-6.46,1.91-10.94-2.18.74-6.52,2.26-8.69,3.04-2.57-3.87-5.26-7.56-8.34-11.03-1,2.51-5.55,5.64-3.08,8.27,2.34.68,6.97,2.09,9.31,2.78Z"
                />
                <path
                  class="cls-1"
                  d="M789.11,1525.89c-.21-1.27-.63-3.89-.85-5.17-2.35-1.75-4.69-3.45-6.99-5.15-3.21,4.98-6.09,10.09,3.73,7.32-.82,1.61-2.46,4.84-3.28,6.42.51,5.28,2.45,12.14,9.05,11.23,1.67-6.73-13.06-10.66-1.66-14.65Z"
                />
                <path
                  class="cls-1"
                  d="M3503.93,628.36s.06-.02.09-.03l-.05-.16c-.01.06-.03.13-.04.19Z"
                />
                <path
                  class="cls-1"
                  d="M3507.12,646.67c-1.42,3.29-2.62,6.6-3.86,9.9,2.46.11,7.33.33,9.79.44,1.48-4.75.19-9.61-.67-14.3-3.55-1.6-7.02-3.19-10.46-4.75.51-2.37,1.49-7.08,2.01-9.59-3.97,1.17-7.39,3.6-9.63,8.08,3.98,3.64,6.87,9.32,12.82,10.24Z"
                />
                <path
                  class="cls-1"
                  d="M3509.66,630.57c1.38.02,4.13.1,5.5.16.09-.77.27-2.27.35-3.04-4-.43-7.96-.38-11.49.64l1.8,5.92c.95-.91,2.9-2.76,3.84-3.67Z"
                />
                <path
                  class="cls-1"
                  d="M3533.96,630.85c-3.39-.3-6.72-.6-10-.87,1.86,3.12,3.75,6.24,5.77,9.34,1.4-2.81,2.8-5.62,4.23-8.47Z"
                />
                <path
                  class="cls-1"
                  d="M3302.79,728.15s.12.03.17.04c1.74-.03,3.47-.06,5.21-.08-1.18-3.13-2.34-6.27-3.39-9.42-4.23-1.85-8.33-3.9-12.61-5.36-2.55,1.97-4.11,7.09-7.62,3.13-3.03,2.37-6.69,2.69-10.28,2.79,3.44,2.1,6.62,4.43,10.01,6.78.95-1.92,2.77-5.81,3.72-7.77,3.19,2.81,5.4,6.3,6.95,10.13,2.6-.07,5.2-.14,7.79-.19.02-.02.03-.03.05-.05Z"
                />
                <path
                  class="cls-1"
                  d="M3545.1,635.44c-.49-5.32-2.9-6.52-7.23-3.62.36,5.33,2.77,6.53,7.23,3.62Z"
                />
                <path
                  class="cls-1"
                  d="M1571.51,1275.98c-8.07,2.06-15.75,5.41-22.39,10.4.98,2.6,2.9,7.76,3.88,10.33,10.81-.97,21.72-8.43,18.51-20.73Z"
                />
                <path
                  class="cls-1"
                  d="M2212.63,1076.31c-.19-5.52-2.39-6.71-6.63-3.52.09,5.52,2.28,6.68,6.63,3.52Z"
                />
                <path
                  class="cls-1"
                  d="M1113.96,1440.93c-2.49,4.11,4.25,9.2,7.24,5.1,2.77-4.27-4.35-9.41-7.24-5.1Z"
                />
                <path
                  class="cls-1"
                  d="M1488.5,1341.09c-2.84-6.13-8.84-3.4-13.81-2.55-5.12-2.8-10.28-5.65-14.59-9.59.46,4.69-1.46,11.8,2.63,14.84,8.62-.26,17.97,2.44,25.77-2.7Z"
                />
                <path
                  class="cls-1"
                  d="M3893.21,548.84c2.72-4.22-3.74-11.76-7.24-6.41-3.1,4.1,3.71,11.06,7.24,6.41Z"
                />
                <path
                  class="cls-1"
                  d="M71.42,1793.81c4.13,6.99,10.23,12.39,15.59,18.41,2.72-4.12,5.57-8.17,8.76-11.97-1.09-1.59-3.26-4.75-4.33-6.35-6.14,4.86-13.11-3.28-20.03-.08Z"
                />
                <path
                  class="cls-1"
                  d="M805.58,1573.16c-1.84.03-5.48.11-7.28.16l-3.15-3.07,4.67-3.41-.28-1.49c-1.42.4-4.26,1.26-5.7,1.69-.13-2.35-.39-7.07-.53-9.44-1.01.5-3.11,1.49-4.13,1.99l3.77,3.71c-3.08,2.42-6.13,4.79-9.17,7.23,1.09,1.19,3.26,3.61,4.34,4.84.38-2.34,1.14-7,1.53-9.31,4.64,5.14,7.67,11.45,11.02,17.48-9.85-5.36-9.67,4.67-10.33,11.1,2.09,2.18,4.21,4.34,6.34,6.54-.17-3-.47-9.06-.65-12.09,3.56,6.07,6.3,12.6,9.53,18.91l-5.55,1.11c4.06,2.84,3.58,8.28,7.65,11.08-10,5.41-2.93,20.48,2.69,25.95.43,3.05.85,6.11,1.29,9.19-.76,3.54-1.48,7.1-2.2,10.67-2.15-.81-6.42-2.48-8.57-3.29,2.18,3.79,5.84,6.16,9.64,8.21,1.5,3.58,4.11,7.13,2.82,11.32,3.71,1.58,8.7,7.61,10.45-1.26-.98-4.78-2.37-9.5-3.43-14.26,1.83,1.32,3.96.62,6.37-2.12-1.89-3.06-4.23-3.41-7.01-1.02-.72-3.94-1.12-7.92-.76-12.01,1.19.47,3.35,1.3,4.97,1.93-.9-.88-1.76-1.81-2.57-2.77-1.41.41-2.76.8-3.71,1.07-.17-2.12-.15-4.24-.05-6.35-5.81-9.72-7.71-21.9-4.55-32.66-.71-3.02-1.07-6.13-1.09-9.24-1.83-5.02-4.26-9.78-7.89-14.04,3.44-4.82,1.31-10.92,1.53-16.33Z"
                />
                <path
                  class="cls-1"
                  d="M3483.51,697.6c-1.04.51-3.06,1.54-4.1,2.08,1.91.08,5.77.27,7.68.35.48-7.28,9.39-5.52,14.24-8.08,1.59-1.73,4.79-5.19,6.38-6.92-4.63-3.57-8.67.95-12.02,3.96,1.59-8.01-3.16-10.8-10.02-11.12,1.32,1.69,3.98,5.09,5.3,6.77-7.41,1.08-9.14,6.71-7.47,12.96Z"
                />
                <path
                  class="cls-1"
                  d="M3839.74,564.66c2.77.45,5.53.92,8.3,1.34.8.12,1.56.33,2.33.51.05-.38.04-.79-.07-1.24-3.48-2.02-7.38-1.69-11.11-1.59.17.33.37.65.55.98Z"
                />
                <path
                  class="cls-1"
                  d="M3908.88,551.35c-1.96-4.97-5.92-10.51-11.21-5.52-3.67,8.12,6.57,8.91,11.21,5.52Z"
                />
                <path
                  class="cls-1"
                  d="M1067.13,1471.71c-1.56,4.58,5.62,5.59,7.26,1.97,2.43-4.83-6.07-6.45-7.26-1.97Z"
                />
                <path
                  class="cls-1"
                  d="M1976.75,1189.55c-.02-.05-.04-.12-.06-.17-2.53-1.93-4.78-4.21-6.75-6.73,1.54,5.7,4.03,11.11,6.74,16.36,2.01-3.01.87-6.3.07-9.47Z"
                />
                <path
                  class="cls-1"
                  d="M2223.53,1099.61c.43,1.41,1.22,4.24,1.64,5.65,3.92,2.22,10.55-2.5,7.42-6.93-3.34-2.41-6.36-1.99-9.06,1.28Z"
                />
                <path
                  class="cls-1"
                  d="M2723.28,945.29c3.03-3.68,2.33-5.84-2.13-6.53-3.02,3.61-2.31,5.8,2.13,6.53Z"
                />
                <path
                  class="cls-1"
                  d="M1083.53,1475.94c.22,5.41,2.5,6.61,6.88,3.67-.31-5.48-2.6-6.72-6.88-3.67Z"
                />
                <path
                  class="cls-1"
                  d="M671.47,2347.99c-6.98-4.38-14,.17-11.32,8.17,5.74.81,9.18-3.5,11.32-8.17Z"
                />
                <path
                  class="cls-1"
                  d="M673.28,2345.82c-.32,4.68,1.49,5.7,5.48,3.09.24-4.72-1.57-5.74-5.48-3.09Z"
                />
                <path
                  class="cls-1"
                  d="M2167.57,1126.82c-1.77.6-3.5,1.24-5.22,1.92-1.28,2.24-2.73,4.46-4.3,6.67.78,1.84,2.18,3.61,2.94,5.33,3.48-2.01,7.03-4.01,10.56-6.07-1.01-1.96-2.99-5.88-3.97-7.85Z"
                />
                <path
                  class="cls-1"
                  d="M109.03,1846.51c4.68,1.26,9.38,2.58,14.11,3.9-.82-3.87-1.57-7.69-2.44-11.5-1.12,1.61-3.44,4.82-4.6,6.41-2.82-3.48-6.04-6.46-9.32-9.5,1.83-1.2,3.68-2.41,5.52-3.58,2.53-.29,7.59-.83,10.12-1.12-.02,1.79-.05,5.4-.07,7.21.96-1.59,2.84-4.69,3.78-6.24-7.07-3.84-14.03-7.86-21.17-11.51-.43,1.65-1.27,4.95-1.72,6.58-5.01,2.98-4.74-3.29-1.88-5.97-1.52-5.18-2.01-11.31-8.06-12.86-2.01,1.36-6.04,4.06-8.02,5.41.93,2.86,2.81,8.6,3.75,11.48l5.55-.4c-1.13.44-3.36,1.33-4.5,1.77,4.46,11.18,11.36,20.8,19.03,29.99l3.95-.99c-1.01-2.26-3.03-6.81-4.04-9.07Z"
                />
                <path
                  class="cls-1"
                  d="M3473.99,749.48c4.71,3.49,8.13,7.95,10.4,12.9,6.38.15,12.79,2.53,19.03,4.38-.06-2.13-.14-6.41-.19-8.51,5.07.4,15.11.48,12.92-7.38-1.54,1.04-4.65,3.06-6.2,4.07-4-8.64-.04-17.94,1.91-26.57-1.92,4.22-4.49,8.19-7.36,11.75-.5-2.05-1.58-6.17-2.12-8.25l-4.76-1.4c.61-1.64,1.83-4.9,2.44-6.54-5.41,2.47-8.39,7.14-6.42,13.49-11.59-3.78-6.56-21.02,3.5-22.32,1.01,1.75,3.06,5.25,4.1,7,.62-2.93,1.32-5.84,2.08-8.78.74-1.55,2.22-4.62,2.96-6.18l9.75-3.18c-4.09-1.52-8.06-3.49-9.03-8.21l-1.32.06c.8,1.62,2.39,4.86,3.22,6.48-6.16,8.94-9.8-.67-12.85-5.49-3.36,2.27-6.68,4.57-9.97,6.85-1.6,10.03,2.44,23.24-6.51,30.19,3.7,1.75,7.26,3.51,11.09,5.35-1.74,1.68-5.19,5.02-6.92,6.7,3.71,2.42,6.73,7.65,11.89,7.18l1.53-1.61c1.8-.76,5.35-2.25,7.12-3-3.89,4.06-8.02,7.86-11.94,11.83-.03-1.64-.11-4.87-.14-6.51-2.48,1.05-7.46,3.21-9.94,4.25.28-5.74-4.01-7.23-8.27-8.56Z"
                />
                <path
                  class="cls-1"
                  d="M2809.95,930.61c-2.6,3.98,3.42,11.49,7.11,6.65,2.86-4.13-3.63-12.06-7.11-6.65Z"
                />
                <path
                  class="cls-1"
                  d="M3531.76,706.82c-.37-5.26-2.67-5.92-6.88-2.02.18,5.29,2.48,5.95,6.88,2.02Z"
                />
                <path
                  class="cls-1"
                  d="M1787.06,1272.11c-3.63,4.44-6.79,9.58-5.14,15.56,4.21-4.4,9.52-9.03,5.14-15.56Z"
                />
                <path
                  class="cls-1"
                  d="M1999.65,1232.02c-2.94-5.7-6.78-11.7-13.57-12.75,1.77,1.91,3.57,3.84,5.41,5.76-1.94,6.52,2.94,12.08,8.16,6.98Z"
                />
                <path
                  class="cls-1"
                  d="M2818.37,952c-2.93,4.22,4.23,9.55,7.16,5.06,2.39-4.11-4.24-9.17-7.16-5.06Z"
                />
                <path
                  class="cls-1"
                  d="M2227.79,1155.3c1.51-7.22-6.46-9.19-11.24-5.2,1.73,4.58,6.6,7.05,11.24,5.2Z"
                />
                <path
                  class="cls-1"
                  d="M1016.8,1758.06c6.75-2.27,11.04,2.41,13.36,8.18,5.85-5.04-2.4-10.24-7.22-11.19.26-1.67.56-3.34.87-4.96-4.15-6.54-5.16-14.89-11.49-19.95,5.42-12.43-11.02-13.78-15.6-22.14,2.02-.39,6.08-1.14,8.1-1.54-3.52-2.65-6.99-5.25-10.43-7.86-2.3-9.63-5.1-19.34-10.47-27.74-1.9-.05-5.73-.15-7.62-.17.62-1.18,1.81-3.52,2.44-4.66-5.81-17.4-14.09-34.19-23.9-49.64-2.29.61-6.89,1.85-9.18,2.46.14-3.81,1.89-8.52-2.95-10.06-7.25-8.42-8.58-20.09-12.16-30.25-.69.86-1.42,1.69-2.13,2.53-1.11,3.65-2.78,7.06-5.09,10.04,1.52,3.42,3.09,6.84,5.17,9.98,2.76,3,9.35,1.99,8.47,7.82,3.52,16.66,15.68,29.71,20.07,46.05,5.62,6,11.1,12.28,15.12,19.54,6.86,16.38,17.86,30.61,28.78,44.49-.67,1.36-1.99,4.11-2.65,5.47,6.79,8.35,13.25,17,20.02,25.39-.82-.28-1.95-.26-3.42.06-1.37,4.45.11,6.22,4.41,5.28.48-1.44.65-2.6.51-3.48.57.7,1.13,1.41,1.71,2.11-1.17,1.05-3.54,3.17-4.74,4.23Z"
                />
                <path
                  class="cls-1"
                  d="M1763.72,1318.62c2.41-4.89,4.62-9.84,6.71-14.86-3.22,2.29-6.43,4.62-9.55,6.98.71,1.96,2.13,5.89,2.84,7.88Z"
                />
                <path
                  class="cls-1"
                  d="M889.68,1628.63c.76-3.37,1.22-6.78,1.59-10.21-.74.55-1.48,1.1-2.22,1.64.04.79.1,1.59.27,2.43-.93-.18-1.73-.46-2.45-.79-.64.48-1.28.96-1.92,1.45-1.46-2.03-4.14-3.07-6.06-.65-2.75,3.62,2.73,9.93,5.94,6.54-.03.69-.07,1.37-.14,2.05,1.88-.12,3.62-.71,4.98-2.47Z"
                />
                <path
                  class="cls-1"
                  d="M1317.7,1465.58c.13-5.46-1.99-6.41-6.44-2.84-.09,5.51,2.07,6.45,6.44,2.84Z"
                />
                <path
                  class="cls-1"
                  d="M1998.54,1246.74c-1.39,8.62,20.25,6.73,4.39,10.57.88,1.36,2.61,4.09,3.48,5.42,1.88-3.71,3.71-7.46,5.58-11.23-1.99-4.13-3.55-8.39-4.65-12.8-5.32,1.1-15.72.12-8.8,8.05Z"
                />
                <path
                  class="cls-1"
                  d="M1758.74,1330.15c-.19-5.32-2.48-6.35-6.83-3.11.1,5.35,2.39,6.38,6.83,3.11Z"
                />
                <path
                  class="cls-1"
                  d="M777.76,1650.51c-3.66,2.57-7.18,5.3-10.49,8.33,5.44,3.07,17.01-1.75,10.49-8.33Z"
                />
                <path
                  class="cls-1"
                  d="M975.87,1596.73c-.28,5.43,1.88,6.48,6.53,3.11.15-5.4-2-6.44-6.53-3.11Z"
                />
                <path
                  class="cls-1"
                  d="M151.82,1911.5c-1.57-5.74-3.12-11.52-4.46-17.27,3.07-.9,6.16-1.71,9.31-2.47-12.14-4.04-24.57-7.61-36.03-13.38,7.2,8.27,13.79,17.75,24.73,21.37-1.6-.15-4.75-.43-6.31-.59,1.44,4.71,3.62,9.54,3.17,14.66,3.19-.74,6.4-1.52,9.59-2.32Z"
                />
                <path
                  class="cls-1"
                  d="M908.12,1624.69c1.86,5.48,4.36,10.78,8.74,14.73-.92-6.12-.28-14.77-8.74-14.73Z"
                />
                <path
                  class="cls-1"
                  d="M3526.92,795.27c-5.14-4.29-7.41-10.4-9.01-16.7l.55,4.06c-4.46,1.59-8.89,3.04-13.26,4.6,1.39,1.57,4.15,4.69,5.51,6.27l.16-7.95c6.43,3.42,6.66,11.34-2.15,11.53.93.77,2.76,2.39,3.69,3.17,3.42.6,6.88,1.22,10.4,1.88l-1.95-5.98c1.55-.12,4.47-.32,6.17-.45-.03-.14-.07-.27-.11-.41Z"
                />
                <path
                  class="cls-1"
                  d="M1534.37,1441.25c7.25-1.16,2.45-7.62,1.73-11.99-2.17,1.08-6.57,3.25-8.77,4.34,1.91,2.87,2.54,7.98,7.04,7.65Z"
                />
                <path
                  class="cls-1"
                  d="M2066.24,1264.44c4.26,6.47,11.52,4.2,17.85,2.88.15-3.61.33-7.2.51-10.79-4.43.64-8.61.5-12.47-.35-2.61,1.96-4.69,4.64-5.88,8.26Z"
                />
                <path
                  class="cls-1"
                  d="M2051.95,1264.63c.1,2.25.3,6.79.4,9.05l-5.62-.22c1.04,3.29,5.45,6.29,3.93,9.98-.36,3.01-5.55,10.69,1.89,9.3,2.15-5.24,3.96-10.64,5.91-15.98,2.31-1.06,6.89-3.19,9.16-4.27-5.2-2.74-10.42-5.34-15.67-7.86Z"
                />
                <path
                  class="cls-1"
                  d="M4148.43,588.99c-.8-1.82-2.44-5.42-3.24-7.25-4.65,8.51-17.2,8.37-24.38,14.68,1.4.89,4.13,2.65,5.52,3.51-.49,1.27-1.5,3.75-2,4.99,2.47-2.22,4.95-4.51,7.47-6.77,6.14-1.67,10.01-11.87,16.64-9.16Z"
                />
                <path
                  class="cls-1"
                  d="M2091.09,1255.11c-.21,5.01-.75,10.16,1.4,14.9,1.02-.9,3.08-2.72,4.14-3.6-1.36-1.61-4.04-4.76-5.4-6.34,4.34-1.32,8.74-2.68,13.12-4.08-4.43-.5-8.9-.69-13.26-.88Z"
                />
                <path
                  class="cls-1"
                  d="M2758.13,1041.78c-1.78-5.87-8.85-.94-8.88,3.27-2.52,4.52.46,8.62,3.36,12.05,2.28-4.85,5.68-9.79,5.52-15.32Z"
                />
                <path
                  class="cls-1"
                  d="M127.09,1899.68c-3.78,1.7-1.99,8.95,2.34,7.78,4.07-1.53,2.15-9.37-2.34-7.78Z"
                />
                <path
                  class="cls-1"
                  d="M3396.44,857.89c1.46-8.32-4.99-9.76-10.15-13.05,1.7,3.84,3.31,7.7,4.82,11.58,2.01.55,3.99,1.1,5.33,1.48Z"
                />
                <path
                  class="cls-1"
                  d="M3443.84,828.47c-2.9,3.28-6.36,5.91-9.75,8.59-1.06-3.49-5.48-6.3-7.89-2.36-1.55,2.42.06,5.66,2.34,7.08-.14.13-.29.26-.42.39,2.62,9.57,16.46.07,11.75-7.16,8.81-2.88,18.48-5.06,25.03-12.2,3.59.71,7.31,2.42,11.12,1.21-4.06-2.76-8.18-5.42-12.05-8.35-3.35,1.2-7.01,1.88-10.96,1.94-3.42,3.1-5.95,7.55-9.15,10.86Z"
                />
                <path
                  class="cls-1"
                  d="M2240.93,1216.96c-1.89,5.53,7.2,7.63,9.21,2.78,1.91-5.47-7.6-8.04-9.21-2.78Z"
                />
                <path
                  class="cls-1"
                  d="M2349.56,1181.2c-4.48,2.97.26,11.01,5.09,8.69,4.17-2.98-.35-11.38-5.09-8.69Z"
                />
                <path
                  class="cls-1"
                  d="M2743.62,1056.1c-6.75,4.15-14.4,7.79-18.24,15.06,7.61-1.51,14.8-4.5,21.87-7.78-.9-1.82-2.72-5.46-3.62-7.29Z"
                />
                <path
                  class="cls-1"
                  d="M822.05,1686.4c-4.21.4-8.43.84-12.62,1.3.49,5.4,4.27,8.92,8.07,12.36l9.56-3.12c-.89-3.6-4.42-7.1-5.01-10.53Z"
                />
                <path
                  class="cls-1"
                  d="M3982.93,668.33c.16-7.45-7.87-7.21-12.9-9.34,2.53,4.75,3.39,9.98,3.86,15.31,3.01-1.79,6.27-3.56,9.04-5.98Z"
                />
                <path
                  class="cls-1"
                  d="M4015.67,645.77c-3.59-.28-9.82,3.58-7.74,7.6,3.72,1.1,9.31-3.71,7.74-7.6Z"
                />
                <path
                  class="cls-1"
                  d="M1930.36,1345.76c.91-.27,1.82-.66,2.72-1.25,4.26,1,8.31.34,12.17-1.96-4.03-3.21-9.08-2.66-14-2.88-.3,2.03-.59,4.06-.89,6.09Z"
                />
                <path
                  class="cls-1"
                  d="M3942.43,674.62c1.91,3.68,4.44,3.63,7.58-.15-2.08-3.69-4.59-3.65-7.58.15Z"
                />
                <path
                  class="cls-1"
                  d="M3995.5,670.58c2.92-3.1,5.69-6.26,8.64-9.48-3.78-1.29-7.51-2.52-11.19-3.71.03,4.53,1.22,8.88,2.56,13.18Z"
                />
                <path
                  class="cls-1"
                  d="M2177.4,1274.41c-1-.97-1.95-2-2.84-3.08-.12.06-.25.12-.37.18-5.57.44-10.87-2.2-16.27-2.99-5.06,1.59-10.16,2.95-15.2,4.19-2.19,1.11-4.35,2.18-6.52,3.26.93.07,1.87.13,2.81.29,4.46,0,8.69,1.05,12.71,3.06,8.47-2.2,16.86-5.01,25.68-4.92Z"
                />
                <path
                  class="cls-1"
                  d="M2261.19,1251.45c-7.72-3.28-16.75-1.21-23.54,3.4-.23,1.32-.52,2.62-.89,3.9,7.33-2.48,14.78-4.59,22.14-.64,1.05-2.13,1.81-4.35,2.29-6.67Z"
                />
                <path
                  class="cls-1"
                  d="M4023.6,678.61c-2.07-5.11-.58-10.03,3.64-13.36,6.16-.16,12.45-.06,18.67-.88-4.5-4.11-9.17-8.33-9.93-14.77,0,1.75-.04,5.22-.04,6.97l-4.07,1.93c-.39-1.39-1.18-4.12-1.56-5.51-1.02,1.41-3.04,4.18-4.03,5.58-14.78,4.46-20.18,19.43-28.15,30.94-6.29,2.86-11.64,7.06-16.52,11.78l1.51,1.12c-3.91,3.66-7.58,7.48-11.11,11.39,5.83,8.38,11.63-4.54,15.97-8.64,3-2.22,6.45-4.33,8.25-7.87,5.98-9.79,15.86-16.3,23.2-25.02,1.05,1.57,3.13,4.76,4.18,6.33Z"
                />
                <path
                  class="cls-1"
                  d="M1622.76,1449.97c1.51-4.63.12-6.53-4.14-5.67-1.53,4.57-.14,6.47,4.14,5.67Z"
                />
                <path
                  class="cls-1"
                  d="M4007.72,665.98c7.97,2.47,3.18-9.81-.85-2.31l.85,2.31Z"
                />
                <path
                  class="cls-1"
                  d="M932.32,1681.53c-3.08-3.16-6.07-6.35-9.14-9.45l3.4,9.08c-3-1.27-5.97-2.52-8.94-3.81-2.3,3.24-4.65,6.46-7.08,9.61,1.76.03,5.31.11,7.1.13,4.03-3.6,9.1-5.89,14.66-5.56Z"
                />
                <path
                  class="cls-1"
                  d="M2723.58,1096.15c2.36-1.01,7.09-2.99,9.45-3.99.04-1.53.16-4.56.23-6.09-6.11-.09-14.02,2.26-9.68,10.09Z"
                />
                <path
                  class="cls-1"
                  d="M902.25,1692.8c-2.01.32-6.02.92-8.04,1.21-.09-2.12-.28-6.33-.37-8.45-6.96-.52-6.55,6.71-7.15,11.14,3.92-.64,7.9-1.03,11.92-1.17,5.41-.72,10.77-1.6,16.08-3.16-4.17-1.66-8.43-1.42-12.43.43Z"
                />
                <path
                  class="cls-1"
                  d="M2019.47,1328.24c6.15-2.78.6-10.82-4.37-6.81-5.67,2.62-.41,10.39,4.37,6.81Z"
                />
                <path
                  class="cls-1"
                  d="M3441.39,873.37c.69-1.64,1.26-3.3,1.71-4.99.94-.6,1.99-1.65,3.13-3.31-.37-1.66-1.13-5.01-1.53-6.66-2.69-.44-4.47.55-5.48,2.08-.56.07-1.1.16-1.65.24.04-.17.09-.34.13-.5-4.29,1.37-8.61,2.67-12.95,3.89-2.14-1.62-4.52-2.73-7.16-3.31,1.96,2.39,3.93,4.73,5.92,7.01-4.1,1.74-8.24,3.5-12.35,5.31-3.81,1.11-7.65,2.2-11.49,3.31.31,1.78.95,5.37,1.26,7.15,6.39-3.29,15.48-3.98,17.25-12.45,6.12-3.07,12.18-3.27,16.35,2.93,0-.02,0-.03,0-.05,1.95,3.44,3.98,6.87,6.06,10.27,5.13-3.12,10.23-6.23,15.54-9.24-4.5-3.27-9.7-2.75-14.73-1.68ZM3434.65,873.38c.58-3.09,1.26-6.17,2.03-9.24,1.47,3.44,2.99,6.87,4.61,10.27l-6.64-1.03Z"
                />
                <path
                  class="cls-1"
                  d="M154.26,1934.54c-.14,5.86,1.92,7.21,6.14,4.08.07-5.77-1.99-7.12-6.14-4.08Z"
                />
                <path
                  class="cls-1"
                  d="M2620.71,1135.75c-2.21.22-6.61.65-8.83.86-5.98-7.93-5.69,6.87-7.65,10.53-6.32-.93-12.56-2.02-18.78-3.25.51,2.23.98,4.46,1.42,6.7,3.09,1.49,6.07,3.2,8.92,5.13,5.51-.31,11.04-.56,16.52-1.84,5.23-4.46,6.6-11.8,8.4-18.14Z"
                />
                <path
                  class="cls-1"
                  d="M2287.71,1249.69c-2.05,3.7,4.23,8.64,7.04,5.1,1.19-3.55-4.21-8.58-7.04-5.1Z"
                />
                <path
                  class="cls-1"
                  d="M3537.29,850.16c-2.08.05-4.26.1-5.65.13-.23-1.64-.73-4.91-.99-6.53l-5.68,1.85c.6,4.51,1.65,8.97,3.08,13.35.42-.14.86-.26,1.31-.37,2.37-3.11,5.04-5.91,7.94-8.44Z"
                />
                <path
                  class="cls-1"
                  d="M4025.58,682.61c.68,1.76,1.99,5.27,2.66,7.03,5.25-4.1,10.55-8.25,15.07-13.25-6.05,1.84-11.84,4.2-17.73,6.23Z"
                />
                <path
                  class="cls-1"
                  d="M3476.6,887.32c1.44-2.18,2.91-4.38,4.42-6.55-4.6-4.82-9.11-9.7-13.81-14.38-.9,2.18-1.78,4.34-2.58,6.52l5.71-1.16c.85,5.6,3.59,10.59,6.26,15.57Z"
                />
                <path
                  class="cls-1"
                  d="M4094.19,673.66c3.52-.34,7.06-.93,10.67-1.8-.11-3.02-.12-6.04-.04-9.09-2,.05-6,.14-8,.19-1.11,3.49-4.03,6.9-2.62,10.71Z"
                />
                <path
                  class="cls-1"
                  d="M3676.03,814.92c-.9-2-2.02-4.37-2.83-6.11-4.1-3.65-9.45-5.4-14.55-1.59,2.02,4.12,7.34,3.45,11.06,4.96-1.37,1.46-4.13,4.34-5.5,5.8-.93-1.21-2.74-3.64-3.67-4.85-1.77,2.29-3.47,4.6-5.11,6.91.47,2.87.97,5.77,1.51,8.65-2.41-1.2-7.26-3.61-9.68-4.84.76,2.01,2.26,5.99,3,7.96,4.56.39,9.75,5.05,13.91,1.01-1.35-1.24-4.09-3.67-5.44-4.92,4.19-2.11,8.77-4.34,6.37-10.04,3.46-.4,7.02-.78,10.57-1.19.08-.59.24-1.16.35-1.75Z"
                />
                <path
                  class="cls-1"
                  d="M872.39,1797.57c-8.11-8.88-10.49-20.57-14.84-31.32l-10.23,3.34c1.15,4.49,1.72,9.49,5.4,12.22,9.98,3.4,8.78,16.8,18.52,21.32,1.42,3.94,3.16,7.71,5.2,11.41,1.74,2.66,5.26,7.97,7,10.62-7.82-1.31-14.63-5.48-21.61-8.95-.68,6.27,4.68,9.3,9.2,12.02,3.77-.49,7.48.68,11.16,1.54l-2.87-4.47c1.87.06,5.67.17,7.54.23-2.36-4.24-3.07-9.08-3.8-13.79-4.15-4.16-10.84-7.35-10.67-14.16Z"
                />
                <path
                  class="cls-1"
                  d="M2193.09,1324.23c-2.83-2.26-6.06-3.93-10.25-4.28-.34,1.21-.95,3.46-1.34,4.87,3.98-.72,7.74-.75,11.28-.26.09-.11.2-.22.3-.33Z"
                />
                <path
                  class="cls-1"
                  d="M2300.71,1293.21c-2.17,1.08-4.31,2.15-6.42,3.2-3.98-.95-7.81-1.69-11.75-2.32,3.1,3.02,6.29,5.98,9.51,8.96,4.72.54,9.46,1.08,14.22,1.64-.2,1.54-.59,4.66-.8,6.21,6.39,5.04,7.86,13.06,2.97,19.7.84,1.12,1.83,2.22,2.84,3.33.53.08,1.05.15,1.58.23,20.21,2.96,32.94,25.94,28.84,44.81-.96,4.44-2.67,8.39-4.9,11.89,1.57,1.16,3.11,2.38,4.55,3.68-.26,9.8,7.54,17.34,11.21,25.99-1.21,1.74-3.64,5.22-4.85,6.96.21,4.34.35,8.79-2.19,12.55l-2.57-5.31c.06,3.68.02,7.36-.12,11.06,4-4.94,9.68-7.63,15.36-10.29,2.14,5.32,4.5,10.6,6.92,15.86,5.57-5.79-.17-13.89-1.18-20.39-3.96-9.77-2.59-20.6-6.4-30.42,4.96,3.46,12.07,2.68,14-3.96-10.55,3.51-14.74-6.85-21.81-11.74.45-1.59,1.35-4.81,1.81-6.41-.63-2.15-1.93-6.43-2.56-8.57-2.07-1.71-4-3.5-5.79-5.37,2.45-6.61,2.43-15.62-6.14-17.16.51-8.23-7.53-12.06-12.24-17.42-7.74-5.81-8.77-17.4-18.51-20.78l5.59-2.33c-1.86-4.47-3.65-8.93-5.5-13.36-.81-5.25-1.76-10.45-2.81-15.62-6.56,3.28-4.81,9.77-2.85,15.35Z"
                />
                <path
                  class="cls-1"
                  d="M171.67,1986.74c3.25-3.65,2.66-5.74-1.81-6.27-3.24,3.58-2.62,5.66,1.81,6.27Z"
                />
                <path
                  class="cls-1"
                  d="M641.62,1836.73c.09,4.51.2,9.02.36,13.53,4.02,1.61,8.1,3.2,12.17,4.84-.8-8.9,2.63-16.67,6.13-24.45l-18.66,6.09Z"
                />
                <path
                  class="cls-1"
                  d="M2857.36,1110.87c5.83,2.73,12.28,4.87,16.14-1.94-5.83-2.94-13.11-5.97-16.14,1.94Z"
                />
                <path
                  class="cls-1"
                  d="M3495.11,917.98c2.98,4.64,5,10.32,9.41,13.87.06-.34.11-.67.17-1.01-3.01-5.42-4.37-11.49-5.84-17.45-2.58-5.01-7.01-8.8-10.33-13.2,2.12,5.66,4.31,11.23,6.61,16.87-2.18.11-6.6.27-8.79.35,1.43,1.28,4.29,3.88,5.72,5.16l3.04-4.59Z"
                />
                <path
                  class="cls-1"
                  d="M3446.56,923.31c-4.43-3.7-11.15-3.79-12.93,2.51,1.84,8.21,9.69,1.07,12.93-2.51Z"
                />
                <path
                  class="cls-1"
                  d="M3455.8,914.75c-.66,3.74,4.64,8.77,8.16,5.94.92-3.76-5.01-8.25-8.16-5.94Z"
                />
                <path
                  class="cls-1"
                  d="M1923.9,1425.02c5.78,1.04,10.64-10.56,2.24-7.25-3.17.39-8.14,7.09-2.24,7.25Z"
                />
                <path
                  class="cls-1"
                  d="M2109.22,1360.59c-4.48,1.53-2.98,9.81,2.05,8.54,4.79-1.29,3.11-10.26-2.05-8.54Z"
                />
                <path
                  class="cls-1"
                  d="M3452.21,923.11c-.23,4.95,1.58,5.97,5.38,3.09.18-5-1.63-6.02-5.38-3.09Z"
                />
                <path
                  class="cls-1"
                  d="M2004.71,1408.46c2.7-2.33,5.47-4.68,8.26-7.03-4.07-1.36-8.09-2.74-12.06-4.1.94,2.78,2.83,8.35,3.8,11.13Z"
                />
                <path
                  class="cls-1"
                  d="M2979.02,1082.99c0,5.14,2.35,6.16,7.02,2.98-.05-5.19-2.43-6.2-7.02-2.98Z"
                />
                <path
                  class="cls-1"
                  d="M3464.42,921.89c-1.53,4.06-2.74,8.19-3.94,12.34,3.55,1.09,6.77,5.08,10.86,4.76.53-6.42,1.36-15.3-6.93-17.1Z"
                />
                <path
                  class="cls-1"
                  d="M3935.79,778.24c.83,1.35,2.37,3.83,3.39,5.47.58-1.49,1.22-2.97,1.89-4.42-.18-.04-.36-.06-.54-.11.5-2.08,1.49-6.24,1.99-8.31-3.13,1.93-5.36,4.37-6.74,7.37Z"
                />
                <path
                  class="cls-1"
                  d="M436.28,1920.43c-5.27,2.7-.18,10.28,4.45,6.75,6.41-2.7.58-10.98-4.45-6.75Z"
                />
                <path
                  class="cls-1"
                  d="M2013.03,1432.19c4.61-5.84,9.09-11.91,10.66-19.34-1.92-.21-5.76-.64-7.67-.86-2.47,2.93-4.99,5.83-7.42,8.78l4.73,5.95c-2.53-.75-5.03-1.52-7.5-2.29,1.11-3.19,3.3-9.55,4.41-12.74-6.8,1.61-19.66,11.96-8.12,17.98-12.12,8.11-24.55,15.9-35.48,25.69,4.92.59,9.84,1.21,14.76,1.84,2.4-3.64,4.8-7.29,7.19-10.95,2.23,1.39,4.42,2.83,6.63,4.36,5.19-7.17,9.02-15.11,8.6-24.22,1.51,1.32,4.55,3.96,6.06,5.28,1.68,5.67-5.95,10.41-.66,16.32,3.56-4.66,7.77-9.97,3.82-15.8Z"
                />
                <path
                  class="cls-1"
                  d="M570.95,1897.71c5.7,3.65,8.56-4.88,10.82-8.44-4.78-1.36-17.23,1.89-10.82,8.44Z"
                />
                <path
                  class="cls-1"
                  d="M3463.24,951.34c-2.71-1.1-5.34-2.16-7.94-3.22-1.91,1.26-5.79,3.77-7.73,5.05,5.28,2.48,10.55.29,15.67-1.82Z"
                />
                <path
                  class="cls-1"
                  d="M3469.99,944.4c-5.5-2.14-4.55,6.86-1.36,8.61,5.77,2.65,6.13-7.48,1.36-8.61Z"
                />
                <path
                  class="cls-1"
                  d="M283.89,1985.74c-1.59,4.28,5.96,9.08,7.82,3.87,1.57-4.45-5.85-9.18-7.82-3.87Z"
                />
                <path
                  class="cls-1"
                  d="M43.91,2157.89c-3.14,1.09-9.39,3.27-12.5,4.35-2.2-6.64,6-7.37,8.46-11.97-2.46-7.74-7.92-14.89-5.92-23.38.48-2.25.23-4.35-.41-6.36,7.86-2.79,2.04-13.33-3.05-11.8,5.19-2.52,3.18-9.5-2.89-10.25-.49-1.29-1.44-3.8-1.89-5.06l-.03,3.81c-4.76,1.59-7.11,5.92-9.46,10.05-1.86-1.68-3.72-3.36-5.56-4.98,3.17-2.55,6.39-5.04,9.64-7.45-2.16-5.28-4.6-10.4-7.19-15.43-1.5.66-4.46,1.99-5.96,2.65.28,4.98-4.49,7.45-7.47,10.57,2.48,6.89,3.71,14.15,3.22,21.5,12.63,7.61,19.45,24.47,16.94,38.81,3.88.98,7.81,1.99,11.72,2.96-1.34,1.55-3.97,4.62-5.28,6.16,1.4.89,4.23,2.65,5.66,3.53-4,5.78-7.89,11.65-11.63,17.61,5.71,8.73,7.76,18.41,5.68,28.63,4.01,4.77,10.7,4.27,16.28,5.58.82-19.93-4.58-39.98,1.64-59.53ZM29.87,2108.98c-.61.31-1.2.82-1.74,1.55-.19-.33-.38-.66-.57-.99.88-.1,1.63-.31,2.31-.57Z"
                />
                <path
                  class="cls-1"
                  d="M2632.65,1227.85c.18-4.8-1.66-5.91-5.46-3.33-.23,4.75,1.61,5.86,5.46,3.33Z"
                />
                <path
                  class="cls-1"
                  d="M665.92,1891.35c.57-.93,1.66-2.83,2.2-3.78-1.52-6.19-1.97-12.53-1.85-18.86-2.39,7.5-8.81,16.36-.34,22.63Z"
                />
                <path
                  class="cls-1"
                  d="M495.05,1932.71c.41-4.81-1.33-5.82-5.24-3.06-.48,4.7,1.3,5.73,5.24,3.06Z"
                />
                <path
                  class="cls-1"
                  d="M2329.33,1328.78l-.42,2.62c4.72,7.16,7.4-6.68.42-2.62Z"
                />
                <path
                  class="cls-1"
                  d="M295.31,2009.1c1.34-5.18-1.12-9.08-5.31-11.85-1.7,5.29.85,9.2,5.31,11.85Z"
                />
                <path
                  class="cls-1"
                  d="M569.04,1912.66c-.2-4.54-2.22-5.66-6.07-3.36.09,4.61,2.14,5.72,6.07,3.36Z"
                />
                <path
                  class="cls-1"
                  d="M599.79,1897.81c-4.63,2.59.68,8.99,4.32,5.31,4.13-2.79-.81-8.54-4.32-5.31Z"
                />
                <path
                  class="cls-1"
                  d="M780.47,1845.93c-.31-5.28-2.72-6.27-7.19-2.97.36,5.13,2.74,6.13,7.19,2.97Z"
                />
                <path
                  class="cls-1"
                  d="M3501.38,953.24c-1.15-.13-2.32-.05-3.5.41-3.46,4.2-1.43,9.01,2.21,12.13.37-4.19.79-8.37,1.28-12.54Z"
                />
                <path
                  class="cls-1"
                  d="M626.35,1905.85c-.16-2.34-.31-4.67-.4-7-.97.12-2.87.37-3.8.5-.86,3.14-2.62,9.39-3.47,12.53l-1.5-7.58c-1.05.38-3.15,1.06-4.21,1.41,7.56,6.27.4,12.54-3.73,18.23,2.63,1.06,5.27,2.14,7.92,3.26-4.21,3.79-9.83-2.2-14.08,1.87-6.86,1.84.52,9.71,1.11,13.59,16.23-1.47,16.74-20.09,28.52-27.66-1.68-3.39-3.78-6.43-6.35-9.15Z"
                />
                <path
                  class="cls-1"
                  d="M3462.01,986.27c-.86-4.69-1.73-9.42-2.18-14.18-4.16,3.54-8.23,7.12-12.45,10.45,2.43,2.4,4.81,4.85,7.36,7.31,2.36-1.21,4.76-2.4,7.27-3.58Z"
                />
                <path
                  class="cls-1"
                  d="M841.25,1832.54c-.19,1.37-.54,4.11-.71,5.44,7.93,7.29,9.33-14.47.71-5.44Z"
                />
                <path
                  class="cls-1"
                  d="M2043.14,1440.41c-4.77,1.46-9.33,3.35-13.06,6.65,3.2,2.28,6.45,4.62,9.68,6.99-.4-1.11-1.19-3.34-1.62-4.45,2.4-2.63,4.16-5.69,5-9.19Z"
                />
                <path
                  class="cls-1"
                  d="M1649.62,1612.97c4.31-2.35,8.55-4.81,12.84-7.22.58-3.68,1.23-7.36,1.92-11.01-.04-2.17-.1-6.59-.14-8.76l-5.86,6.05c1.69-6.37,3.12-12.78,4.26-19.27-2.33-.55-4.6-1.12-6.86-1.66-1.04,14.32-5.23,28.26-9.09,42.06-.83,5.18-1.62,10.38-1.82,15.65,6.87-2.85,6.48-9.71,4.75-15.84Z"
                />
                <path
                  class="cls-1"
                  d="M2028.83,1464.14c.17.03.35.05.53.08,3.21-2.05,6.44-4.14,9.7-6.24-4.69-2-9.71-2.88-14.63-3.73,1.09,2.46,3.23,7.25,4.4,9.89Z"
                />
                <path
                  class="cls-1"
                  d="M899.96,1837.55c.71-6.79-5.76-7.87-10.76-9.29.63,4.4,2.76,7.84,6.38,10.39,1.99,4.76,5.76,8.47,9.76,11.67,3.68-5.61-1.88-9.17-5.38-12.77Z"
                />
                <path
                  class="cls-1"
                  d="M3457.97,1007.15c-3.03.08-6.03.15-9.01.22,0,1.41-.08,4.19-.1,5.58.7,2.76,1.44,5.55,2.21,8.32,3.02-.85,6.11-1.66,9.28-2.46-.93-3.87-1.72-7.74-2.39-11.66Z"
                />
                <path
                  class="cls-1"
                  d="M2361.07,1365.68c-1.47,4.55-2.88,9.11-4.05,13.76,8.25-1.18,7.98-7.98,4.05-13.76Z"
                />
                <path
                  class="cls-1"
                  d="M1697.21,1594.11c3.2-4-3.59-10.09-6.76-5.66-2.51,3.84,3.39,9.55,6.76,5.66Z"
                />
                <path
                  class="cls-1"
                  d="M3473.78,1009.79c.24-4.72-1.6-5.73-5.49-3.02-.33,4.65,1.51,5.66,5.49,3.02Z"
                />
                <path
                  class="cls-1"
                  d="M565.59,1972.94c10,1.71,11.62-8.16,7.2-14.72-8.66-1.41-16.78,9.04-7.2,14.72Z"
                />
                <path
                  class="cls-1"
                  d="M3810.49,905.36c-1.11,4.03-2.62,7.95-4.82,11.49,3.41.39,6.87.83,10.36,1.25-.43-2.1-.74-4.21-.94-6.33-2.89-.87-5.04-2.47-4.6-6.41Z"
                />
                <path
                  class="cls-1"
                  d="M608.06,1962.07c-2.51.35-7.47,1.1-9.98,1.44-3.42-.9-6.79-1.75-10.21-2.55.82,9.62,5.09,18.27,11.72,25.29,2.29-4.61,1.95-9.78,1.81-14.74,3.19-2.49,6.53-5.02,6.67-9.44Z"
                />
                <path
                  class="cls-1"
                  d="M556.4,1984.21c.29-5.4-1.86-6.42-6.4-3.02-.35,5.42,1.77,6.45,6.4,3.02Z"
                />
                <path
                  class="cls-1"
                  d="M1636.35,1634.01c-5.56-1.68-11.36-2.27-17.09-2.12,4.5,5.22,11.59,8.22,17.09,2.12Z"
                />
                <path
                  class="cls-1"
                  d="M1561.02,1657.09c-1.54,4.64,5.99,5.68,7.45,1.8,1.82-4.73-6.25-6.06-7.45-1.8Z"
                />
                <path
                  class="cls-1"
                  d="M589.17,2004.07c-4.5-2.97-9.1-5.74-13.29-9.11-.07-4.75.37-9.47.27-14.21-3.97,3.58-6.3,8.51-7.44,13.66,1.81,6.06,4.24,11.96,6.49,17.92-3.18,8.4-6.82,16.68-7.96,25.66,2.35-.73,7.12-2.19,9.47-2.92,5.9-9.52,8.62-20.56,12.47-31Z"
                />
                <path
                  class="cls-1"
                  d="M545.27,2002.64c-1.33.87-3.92,2.62-5.24,3.52,1.1,2.23,3.24,6.74,4.35,9,9.57,1.72,4.95-9.14.89-12.52Z"
                />
                <path
                  class="cls-1"
                  d="M3318.57,1191.28c.42-.91,1.15-2.47,1.73-3.73-1.88-.17-3.75-.37-5.58-.68-6.06-1.04-11.57-2.96-16.64-5.46.42,2.62.95,5.94,1.24,7.85-1.75.2-5.22.59-6.97.8,2.16,1.98,4.35,3.96,6.65,5.96-2.89-11.63,13.59-7.29,19.56-4.74Z"
                />
                <path
                  class="cls-1"
                  d="M1275.31,1775.93c3.76-4.76-4.4-9.76-7.42-4.91-4.13,4.74,4.32,9.75,7.42,4.91Z"
                />
                <path
                  class="cls-1"
                  d="M3976.39,893.65c.31.19.6.39.92.58-.34.22-.69.35-1.03.52-.19,1.5-.43,3-.79,4.48,3.16,1.04,6.37,2.11,9.38,3.42-.37,2.68-.8,5.37-1.28,8.02l-2.26-8.77c-10.75,8.68,3.57,12.18,4.89,20.02,3.66-1.87,7.4-3.69,11.21-5.51.42,1.81,1.22,5.48,1.62,7.34,6.8-.07,13.78,2.56,20.5.1,1.33,2.63,2.69,5.24,4.15,7.89,3.11-2.32,6.07-4.87,8.93-7.65,4.25,4.36,8.28,9.8,9.51,15.85l-2.65.43c.71.94,2.07,2.85,2.79,3.8-.31.16-.6.22-.91.33,1,.2,2,.38,3.01.64,1.68-1.05,3.31-2.16,4.76-3.55l-5.03-.58c-.32-4.88,4.71-8.75,5.85-13.35-5.59-2.17-10.7-5.27-13.93-10.57,2.08-.41,6.21-1.25,8.3-1.67-4.03-7.39-9.13,1.57-13.25,3.79-.06-1.43-.14-4.26-.21-5.68-1.76-.44-5.34-1.32-7.1-1.78-9.52-10.74-4.81,1.13-4.97,5.59-1.71-5.56-3.91-10.96-6.2-16.23-1.55.71-4.65,2.12-6.18,2.79-11.07-2.34-21.37-6.84-29.86-14.26.02,1.34-.04,2.67-.17,4.02Z"
                />
                <path
                  class="cls-1"
                  d="M4059.98,943.68c1.41,1.86,4.21,5.58,5.62,7.44l2.68-5.08c3.03,1.46,6.13,2.91,9.31,4.32.94,1.04,2.83,3.11,3.74,4.16,1.68-3.61,3.36-7.21,5.11-10.81-1.49.28-4.5.83-5.99,1.11l-2.68.03c2.5-1.62,7.52-4.87,10.03-6.54-10.44,4.05-15.94-6.5-25.41-7-4.07-1.01-8.36-2.11-12.41-3.67.23,2.67.72,7.95.99,10.59,1.23-.67,3.73-2.06,4.99-2.74,1.01,2.06,3.01,6.14,4.01,8.17Z"
                />
                <path
                  class="cls-1"
                  d="M421.52,2054.16c.19-5.51-1.96-6.72-6.51-3.66-.15,5.4,2.02,6.6,6.51,3.66Z"
                />
                <path
                  class="cls-1"
                  d="M65.3,2184.39c-4.58-1.06-8.41,2.34-12.19,4.25,3.53,3.92,8.36,3.05,12.88,2.38-.13-2.24-.38-4.45-.69-6.63Z"
                />
                <path
                  class="cls-1"
                  d="M262.78,2135.07c-2.55-3.31-4.86-6.84-6.86-10.6-.71.61-1.41,1.25-2.09,1.91,2.2,3.04,4.42,6.12,6.63,9.2.84-.08,1.6-.27,2.32-.5Z"
                />
                <path
                  class="cls-1"
                  d="M3425.88,1087.51c3.43,2.78,7.12,5.44,10.82,8.03,1.13-3.63,2.38-7.23,3.61-10.86-1.05.71-3.16,2.07-4.21,2.75-2.55.02-7.68.05-10.23.08Z"
                />
                <path
                  class="cls-1"
                  d="M3966.85,916.58c-.29.35-.6.68-.9,1.02,1.01,4.72,1.78,9.5,2.71,14.28,1.72-7.18,4.17-14.2,5.74-21.44-2.6,2.01-5.1,4.07-7.55,6.14Z"
                />
                <path
                  class="cls-1"
                  d="M547.72,2034.75c-10.03,3.14-20.39,7.56-26.63,16.46,9.26-3.86,25.49-3.68,26.63-16.46Z"
                />
                <path
                  class="cls-1"
                  d="M4101.95,874.05c-5.4,5.29-19.72,5.7-16.69,15.7,1.08-2.14,3.17-6.45,4.22-8.6,5.65,8.34,14.31.81,12.47-7.1Z"
                />
                <path
                  class="cls-1"
                  d="M4111.76,874.44c.12,4.6,2.14,5.72,6,3.35-.27-4.65-2.29-5.77-6-3.35Z"
                />
                <path
                  class="cls-1"
                  d="M1245.42,1815.13c-2.6,7.78,12.18,4.66,11.22-1.34-2.47-4.27-9.22-2.4-11.22,1.34Z"
                />
                <path
                  class="cls-1"
                  d="M67.42,2201.91c-1.97,5.38,6.87,6.33,8.14,1.68,2.19-5.45-6.88-6.36-8.14-1.68Z"
                />
                <path
                  class="cls-1"
                  d="M560.58,2039.35c-3.66,8.56-6.8,17.48-7.72,26.82,3.29,5.45,9.35,2.19,13.69.44-1.39-9.09,2.63-20.79-5.97-27.26Z"
                />
                <path
                  class="cls-1"
                  d="M1261,1818.28c5.53-3.15,12.06-5.38,16.43-10.31-5.23,3.86-19.37.51-16.43,10.31Z"
                />
                <path
                  class="cls-1"
                  d="M31.54,2219.68c-2.81,4.58-4.58,9.66-6.38,14.75,1.69,4.76,3.39,9.55,5.11,14.33,4.1-2.38,11.82-2.21,11.5-8.63,1.29-6.24-7.26-6.7-10.9-9.39,2.29-1.62,6.87-4.9,9.17-6.52-2.83-1.56-5.67-3.06-8.51-4.55Z"
                />
                <path
                  class="cls-1"
                  d="M524.04,2085.88c1.64,1.19,3.17,2.52,4.6,3.96.63.22,1.31.41,2.08.55-.5-4.11-1.22-8.17-1.96-12.17,2-3.24,11.15-4.88,7.92-10.01-1.12-7.03-10.1-7.97-13.47-2.23.88,6.03-1.82,14.6.82,19.91Z"
                />
                <path
                  class="cls-1"
                  d="M772.11,1982.81c-2.9,3.47,2.87,9.31,5.67,4.91,2.42-3.41-2.82-8.96-5.67-4.91Z"
                />
                <path
                  class="cls-1"
                  d="M2311.62,1489.96c3.92.77,7.72-7.26,2.14-6.95-3.93-.3-8.39,7.04-2.14,6.95Z"
                />
                <path
                  class="cls-1"
                  d="M2415.95,1480.87c-7.5,13.47-15.77,26.46-24.25,39.28-2.7,3.97-7.9,4.83-11.74,7.09,2.14-3.42,4.49-6.74,6.93-9.96-3.18-10.05-4.49-20.55-7.66-30.57-4.71-7-12.45-11.47-20.61-13,.13,1,.36,3.04.49,4.08,2.17-.04,6.54-.15,8.71-.19-.98,15.21,10.35,27.48,9.85,42.33-6.53,3.91-13.25,7.63-20.67,9.2.81,1.86,1.47,3.78,2.01,5.74,2.04.46,4.33.36,6.91-.38-1.62,1.69-3.3,3.47-4.39,5.26-1.44-.96-3.29-1.03-4.51.88-1.9,3.04,1.98,7.58,4.9,5.9.63.63,1.47,1.25,2.58,1.84,2.91-4.18,5.85-8.33,8.84-12.47,4.95,3.22,3.79,6.87-.64,10.09-.9,2.48-1.74,4.97-2.5,7.47,5.6-2.2,11.25-4.45,17.04-6.4-1.23-4.07-2.49-8.13-3.67-12.18,4.04-5.76,9.72-8.72,15.95-3.76-.7-2.06-2.08-6.18-2.79-8.23,6.81-2.93,9.91-10.43,15.99-14.46-.36-1.3-1.05-3.93-1.4-5.22,6.14-6.21,9.96-14.18,4.65-22.32Z"
                />
                <path
                  class="cls-1"
                  d="M3220.55,1193.43c-4.19,1.47-1.67,8.58,2.5,7.45,4.6-1.37,1.83-8.9-2.5-7.45Z"
                />
                <path
                  class="cls-1"
                  d="M401.13,2140.21c3.58-4.8,5.2-10.54,6.74-16.22-1.07-2.54-3.24-7.65-4.31-10.22-8.46,6.42-9.31,18.43-2.43,26.44Z"
                />
                <path
                  class="cls-1"
                  d="M138.9,2204.73c.26,5.43,2.52,6.71,6.81,3.86-.21-5.58-2.47-6.86-6.81-3.86Z"
                />
                <path
                  class="cls-1"
                  d="M555.67,2085.26c.38-6.04-3.51-14.65-10.47-10.23-10.39,4.43,4.78,12.99,10.47,10.23Z"
                />
                <path
                  class="cls-1"
                  d="M2903,1318.56c-.15-3.14-1.85-5.25-4.98-6.31-4.63-1.82-9.13,5.8-3.71,7.7,3.23,1.03,6.1.56,8.69-1.39Z"
                />
                <path
                  class="cls-1"
                  d="M2733.51,1381.32c1.93-1.87,2.05-3.72,1.3-5.47-.95-1.21-1.87-2.46-2.75-3.73-1.14-1.15-2.38-2.21-3.36-3.15-3.02,8.45-10.9,12.74-17.81,17.51,6.9,7.03,16.19-1.28,22.62-5.16Z"
                />
                <path
                  class="cls-1"
                  d="M2952.13,1296.98c-8.73,2.92-18.82,5.27-24.24,13.36,9.12-1.3,21.31-2.89,24.24-13.36Z"
                />
                <path
                  class="cls-1"
                  d="M3191.43,1225.95c2.88-3.73,2.12-5.87-2.37-6.45-2.87,3.66-2.07,5.82,2.37,6.45Z"
                />
                <path
                  class="cls-1"
                  d="M3264.56,1193.35c-3.87,3.79-11.17,11.51-5.69,16.65,5.51-2.91,5.9-11.07,5.69-16.65Z"
                />
                <path
                  class="cls-1"
                  d="M4099.4,953.44c3.71,6.32,8.28,11.68,16.34,11.04,1.73-.06,5.26-.17,7.02-.21.41-1.21,1.23-3.66,1.63-4.9l-4.26,1.79c-2.39-.83-7.23-2.48-9.65-3.3.08-2.01.23-5.99.31-8-1.94-1.21-3.77-2.4-5.54-3.57l3.54,7.75c-5.8-1.1-9.29-4.57-10.39-10.42,4.85-2.86,6.48-7.96,4.76-13.22,3.42,3.49,6.98,6.97,10.67,10.33l-2-3.95c2.96-1.23,5.16-3.23,6.64-6.03-6.47-1.28-15.54-9.08-19.45.57-3.25-2.44-6.45-5.02-9.58-7.43,2.25,5.15,4.91,10.6,10.08,13.48-1.86,5.62-4.43,11.26-10.75,12.79-1.49,3.42-2.86,6.86-4.13,10.34.12.04.23.08.34.12,5.26-1.24,11.58-1.4,14.41-7.17Z"
                />
                <path
                  class="cls-1"
                  d="M38.71,2250.18c-8.54,6.59-7.67,17.19-2.01,25.36-1.73,4.06-4.49,9.83,2.52,10.1-.64-11.76,8.39-25.36-.52-35.46Z"
                />
                <path
                  class="cls-1"
                  d="M1592.34,1744.98c-4.25,1.92-1.55,9.58,2.95,8.92,4.79-1.8,1.93-10.35-2.95-8.92Z"
                />
                <path
                  class="cls-1"
                  d="M2694.88,1397.69c4.64-.91,10.95-.45,13.1-5.79-1.25-3.93-3.72-7.29-5.91-10.68-4.05,4.68-5.75,10.62-7.2,16.47Z"
                />
                <path
                  class="cls-1"
                  d="M880.49,1983.46c-5.6,2.6-.99,10.57,3.98,6.84,6.33-2.34,1.18-11.01-3.98-6.84Z"
                />
                <path
                  class="cls-1"
                  d="M61.46,2265.61c7.16,1.56,6.35-12.26-.27-10.8-4.14,1.95-4.29,9.2.27,10.8Z"
                />
                <path
                  class="cls-1"
                  d="M3841.92,1026.66c-1.77,5.28,6.64,6.13,8.32,1.92,2.24-5.4-7.05-6.67-8.32-1.92Z"
                />
                <path
                  class="cls-1"
                  d="M12.94,2289.04c2.75-4.66,6.58-6.92,11.43-6.79-.42,1.82-1.21,5.47-1.62,7.29,2.49-.11,5.24.31,7.06-1.87-2.04-2.86-4.1-5.65-6.22-8.35-3.94,2.76-9.81,4.14-10.64,9.73Z"
                />
                <path
                  class="cls-1"
                  d="M2750.81,1395.3c-2.35,0-7.07-.04-9.44-.08-1.29,3.25-2.53,6.47-3.69,9.71-.9.41-1.79.83-2.68,1.24,2.24.48,4.47.98,6.7,1.49.47-.64.96-1.25,1.37-1.97,3.34-2.84,7.17-5.63,7.73-10.39Z"
                />
                <path
                  class="cls-1"
                  d="M4136.2,957.56c-.4-2.26-1.13-6.76-1.5-9.02l-5.54,2.18c-.41-1.98-1.27-5.94-1.72-7.94-2.25,1.98-4.24,4.11-5.93,6.44,3.88,4.28,9.34,6.36,14.69,8.35Z"
                />
                <path
                  class="cls-1"
                  d="M3784.79,1064.1c-.21-5.38-2.47-6.42-6.78-3.16.05,5.4,2.3,6.44,6.78,3.16Z"
                />
                <path
                  class="cls-1"
                  d="M1612.94,1785.55c3.19,1.65,6.38,3.36,9.55,5.15,2.13-2.01,4.39-3.95,6.54-6-4.45-.77-8.89-1.4-13.31-1.94.24-6.06-.92-12.51-8.7-11.01,1.74,4.91,4.56,9.34,8.33,12.95l-2.41.85Z"
                />
                <path
                  class="cls-1"
                  d="M914.21,2002.94c-.16,5.5,1.97,6.75,6.35,3.81.14-5.66-1.99-6.91-6.35-3.81Z"
                />
                <path
                  class="cls-1"
                  d="M2336.52,1601.73c-.21-1.01-.43-2.02-.63-3.03,2.58-6.21.86-12.41-.97-18.48-3.38,1.05-6.63,1.61-9.74,1.78,4.28,6.11,6.25,13.22,8.4,20.26.98-.18,1.96-.35,2.94-.53Z"
                />
                <path
                  class="cls-1"
                  d="M3877.07,1036.94c-3.56,5.36,1.22,10.22,3.24,15.08,4.9-1.06,7.66-4.95,10.04-9.09-4.14-2.58-7.94-7.63-13.28-5.98Z"
                />
                <path
                  class="cls-1"
                  d="M43.76,2301.5c-2.75-3.57-3.97-11.04-9.96-8.48-1.9,4.49-3,9.25-3.96,14.03,4.91-1.13,9.54-3.11,13.92-5.55Z"
                />
                <path
                  class="cls-1"
                  d="M3931.27,1019.98c9.27,5.55,7.85,17.87,11.66,26.75-1.42.39-4.26,1.16-5.69,1.52,1.26,3.66,2.56,7.33,3.93,11.02-6.29-.43-9.55,4.09-12.6,8.65,5.84-4.66,12.71-7.21,19.58-10.05-1.16-3.45-3.65-5.63-7.47-6.5,8.77,1.54,7.06-7.21,8.91-12.05-7.72-5.01-9.65-16.28-18.31-19.33Z"
                />
                <path
                  class="cls-1"
                  d="M3243.23,1249.72c-2.62,4.12,3.91,11.26,7.38,6.33,2.67-4.27-4.03-11.73-7.38-6.33Z"
                />
                <path
                  class="cls-1"
                  d="M4138.64,969.23c1.69-6.57-10.75-13.26-6.65-2.67-4.42-.37-8.41,1.08-12.24,2.85,10.61,2.25,21.28,4.3,31.92,6.41-4.49-2.8-6.48-10.74-13.02-6.59Z"
                />
                <path
                  class="cls-1"
                  d="M3293.87,1249c.71.38,1.42.77,2.1,1.19,3.97-.95,7.94-1.93,11.93-3.03l1.04,7.29c2.92-5.36,5.8-10.77,8.74-16.16-4.26.25-9.61-1.53-11.78,3.34-3.84,8.01-10.96.08-15.78-2.41l4.63-2.92-3.34-.15c-1.95,2.69-3.9,5.34-5.8,7.98-4.02-6.35-4.1-2.89-5.07,1.1,2.54.16,4.97.6,7.28,1.29.12-.57.2-1.14.32-1.71,3.33-.45,5.25.94,5.73,4.19Z"
                />
                <path
                  class="cls-1"
                  d="M1612.84,1797.28c-3.96-9.67-13.78-1.02-19.71,1.73,5.13,8.81,13.16,1.18,19.71-1.73Z"
                />
                <path
                  class="cls-1"
                  d="M2449.68,1534.77l-5.87.03c1.25-1.01,3.71-3.06,4.96-4.07-.7-2.06-2.13-6.13-2.87-8.17-1.11,4.63-2.43,9.23-3.62,13.82,3.71,1.68,7.57,3.01,11.49,4.32-1.02-1.48-3.06-4.44-4.09-5.93Z"
                />
                <path
                  class="cls-1"
                  d="M1575.05,1814.26c-.13,5.46,2.08,6.78,6.56,4.04.14-5.46-2.06-6.82-6.56-4.04Z"
                />
                <path
                  class="cls-1"
                  d="M2453.66,1527.29c-5.17,1.79-.52,9.62,3.83,8.63,4.66-2.3.6-9.61-3.83-8.63Z"
                />
                <path
                  class="cls-1"
                  d="M176.96,2276.44c.11,4.67,2.05,5.75,5.79,3.22-.1-4.74-2.04-5.82-5.79-3.22Z"
                />
                <path
                  class="cls-1"
                  d="M330.48,2227.04c-3.06,3.92,3.49,10.49,6.44,5.43,2.41-3.85-3.34-10.24-6.44-5.43Z"
                />
                <path
                  class="cls-1"
                  d="M1570.27,1822.37c-10.86,5.23-21.96,9.86-32.79,15.07-4.28,2.64-11.27,3.98-10.37,10.85,11.08-4.15,22.36-7.9,33.22-12.73,4.93-2.62,12.14-6.38,9.94-13.2Z"
                />
                <path
                  class="cls-1"
                  d="M2377.73,1576.14c2.44-3.45-2.97-9.08-5.81-4.93-2.64,3.45,3.07,9.18,5.81,4.93Z"
                />
                <path
                  class="cls-1"
                  d="M1508.37,1858.48c.64,5.37,3,6.52,7.12,3.39-.66-5.53-3.05-6.67-7.12-3.39Z"
                />
                <path
                  class="cls-1"
                  d="M2821.01,1432.01c-3.2,4.2,3.99,9.15,7.08,5.02,2.98-4.16-4.17-9.06-7.08-5.02Z"
                />
                <path
                  class="cls-1"
                  d="M312.4,2265.24c4.38-2.03,3.53-9.05-.41-11.03-6.67-.98-6.7,12.94.41,11.03Z"
                />
                <path
                  class="cls-1"
                  d="M685.68,2134.99c.65-4.82-1.11-5.76-5.23-2.83-.53,4.64,1.22,5.59,5.23,2.83Z"
                />
                <path
                  class="cls-1"
                  d="M3952.59,1064.72c1.94,4.81,4.07,9.59,6.44,14.27,1.58-4.01,3.05-8.05,4.65-12.11-3.78-.78-7.42-1.51-11.09-2.16Z"
                />
                <path
                  class="cls-1"
                  d="M472.11,2251.26c1.81.08,5.4.29,7.21.37-3.17-12.39,2.67-24.14,9.12-34.75-5.21-.05-10.33-.7-15.28-1.92-2.08,2.09-3.65,4.62-4.29,7.87-1.89,5.32,2.11,10.07,3.7,14.93-1.83,4.39-1.78,8.95-.47,13.5Z"
                />
                <path
                  class="cls-1"
                  d="M2351.74,1594.14c-2.63-3.64-9.27-2.86-11.4.9-1.53,7.26,12.87,5.75,11.4-.9Z"
                />
                <path
                  class="cls-1"
                  d="M3940.94,1074.64c-.01,5.32,2.25,6.49,6.8,3.53-.11-5.38-2.37-6.55-6.8-3.53Z"
                />
                <path
                  class="cls-1"
                  d="M3925.44,1084.41c-3.34,1.29-4.93,3.53-4.77,6.7,2.27,4.17,7.28.38,9.57-1.88,4.45-3.37-1.38-8.15-4.8-4.82Z"
                />
                <path
                  class="cls-1"
                  d="M113.1,2331.24c-4.92,3.05,1.1,9.15,4.97,5.74,5.53-3.05-1.03-9.85-4.97-5.74Z"
                />
                <path
                  class="cls-1"
                  d="M2405.68,1588.93c.12.04.23.11.35.16,3.49-.81,6.93-1.7,10.34-2.65-2.85-2.89-8.1-2.03-10.68,2.49Z"
                />
                <path
                  class="cls-1"
                  d="M1952.8,1746.92c7.02,0,10.39-5.14,10.72-11.63-8.19-3.58-10.31,5.48-10.72,11.63Z"
                />
                <path
                  class="cls-1"
                  d="M2798.43,1470.65c-1.21-.93-2.42-1.85-3.63-2.77-1.48,2.92-3.32,5.68-5.51,8.19.15.1.32.22.45.31,2.84-1.9,5.78-3.8,8.69-5.73Z"
                />
                <path
                  class="cls-1"
                  d="M2957.75,1415.95c.05-4.69-1.83-5.82-5.66-3.43-.13,4.75,1.72,5.89,5.66,3.43Z"
                />
                <path
                  class="cls-1"
                  d="M428.66,2241.54c5.15,8.67,13.24.39,19.75-2.01-4.53-10.05-13.25-.85-19.75,2.01Z"
                />
                <path
                  class="cls-1"
                  d="M466.1,2237.69c2.36-3.39-2.87-9.01-5.69-4.97-2.73,3.48,2.93,9.5,5.69,4.97Z"
                />
                <path
                  class="cls-1"
                  d="M1026.83,2054.86c6.44-2.51.7-11.45-4.39-6.87-4.96,2.73-.16,10.1,4.39,6.87Z"
                />
                <path
                  class="cls-1"
                  d="M3476.67,1253.42c-.31-5.48-2.52-6.57-6.67-3.34.15,5.6,2.36,6.72,6.67,3.34Z"
                />
                <path
                  class="cls-1"
                  d="M3958.5,1095.9c-.44,5.56,1.6,6.64,6.15,3.2.46-5.6-1.6-6.64-6.15-3.2Z"
                />
                <path
                  class="cls-1"
                  d="M3475.32,1266.06c1.43-4.47.02-6.33-4.23-5.54-1.6,4.56-.19,6.42,4.23,5.54Z"
                />
                <path
                  class="cls-1"
                  d="M420.75,2257.57c-1.23,3.26-1.46,6.78-1.65,10.34,4.11.7,8.14,1.76,12.02,3.19,2.22-5.18,4.8-10.23,5.67-15.67-4.42-5.41-11.03.81-16.04,2.14Z"
                />
                <path
                  class="cls-1"
                  d="M3897.13,1123.93c-3.74,3.27-3.27,5.23,1.47,5.94,3.6-3.29,3.11-5.29-1.47-5.94Z"
                />
                <path
                  class="cls-1"
                  d="M3277.6,1328.96c-3.53,1.35-3.81,7.26-1.34,9.78,1.24-.44,3.76-1.36,4.99-1.8.39-3.55-.82-6.22-3.65-7.99Z"
                />
                <path
                  class="cls-1"
                  d="M3402.69,1287.72c-1.71,5.16,1.94,13.45,8.34,9.98,1.11-5.04-2.39-12.16-8.34-9.98Z"
                />
                <path
                  class="cls-1"
                  d="M720.1,2175.75c3.26-4.53-4.07-10.81-7.32-5.64-3.56,4.42,4.05,10.34,7.32,5.64Z"
                />
                <path
                  class="cls-1"
                  d="M468.03,2259.68c-5.53-.58-11.03-.13-15.5,3.58,1.35,3.73,2.67,7.36,4.12,11.06,4.95-3.9,8.34-9.25,11.39-14.64Z"
                />
                <path
                  class="cls-1"
                  d="M3242.67,1357.47c-1.46,9.75-2.74,19.62-5.52,29.13,3.15-2.2,6.24-4.36,9.61-6.4.14-7.81.78-16.05-4.09-22.73Z"
                />
                <path
                  class="cls-1"
                  d="M454.71,2281.78c-.33-4.83-4.92-13.52-9.92-7.32-.24,1.14-.09,2.37.24,3.57,2.24,1.45,4.4,3.03,6.47,4.72.76,0,1.52.02,2.28.02.31-.28.62-.61.92-.99Z"
                />
                <path
                  class="cls-1"
                  d="M1777.47,1859.55c-1.99-9.5-11.76-15.22-20.98-14.23,4.92,7.34,12.28,12.39,20.98,14.23Z"
                />
                <path
                  class="cls-1"
                  d="M3964.81,1133.14c.17.22.36.45.53.67-1.11.24-2.3,1.28-3.57,3.15,1.95,3.58,4.23,3.5,6.9-.18.57.33,1.15.65,1.72,1,1.15-4.92.28-9.9-1.43-14.67-1.36,3.34-2.9,6.66-4.15,10.03Z"
                />
                <path
                  class="cls-1"
                  d="M3255.95,1356.05c-1.31,4.33-2.43,8.73-3.52,13.11,4.22,1.48,8.73,2.86,11.18,7.07,8.33-4.33,10.57-12.63,10.73-21.39-3.78,5.1-8.45,9.11-14.49,11.12-.97-2.47-2.93-7.45-3.91-9.92Z"
                />
                <path
                  class="cls-1"
                  d="M3856.35,1164.37c-4.92,3.56,3.44,12.9,7.35,7.48,3.33-4.52-3-10.22-7.35-7.48Z"
                />
                <path
                  class="cls-1"
                  d="M1302.36,2006.97c-1.85,4.94,6.53,7.14,8.14,2.49,2.07-5.18-6.6-7.36-8.14-2.49Z"
                />
                <path
                  class="cls-1"
                  d="M2906.01,1484.5c-3.52,3.13-2.96,5.14,1.67,6.04,3.48-3.25,2.95-5.27-1.67-6.04Z"
                />
                <path
                  class="cls-1"
                  d="M1806.69,1851.35c.03,1.64.05,4.89.08,6.53-3.39,3.42-6.96,6.68-9.97,10.45,2.91,4.6,5.62,9.39,5.45,15.06,2.39.02,7.2.14,9.61.19-.95-2.81-2.85-8.41-3.83-11.22,1.89,1.67,5.64,5.02,7.51,6.73,9.85-2.37,13.06-13.54,11.55-22.39-2.65-2.46-5.33-4.88-7.98-7.24-4.2.63-8.32,1.27-12.42,1.9Z"
                />
                <path
                  class="cls-1"
                  d="M3262.71,1390.24c-.51-2.34-1.01-4.69-1.52-7.02-3.29,3.09-6.28,6.52-9.24,9.91.18.36.4.78.62,1.23l6.17-2.97c1.32-.49,2.64-.86,3.97-1.15Z"
                />
                <path
                  class="cls-1"
                  d="M1355.93,2028.98c4.7-1.37,1.4-8.79-2.76-7.43-4.33,1.55-1.27,8.38,2.76,7.43Z"
                />
                <path
                  class="cls-1"
                  d="M3531.84,1313.36c-6.26,3.89-2.31,10.03,2.65,12.85,3.06-3.59,4.42-10.25,10.52-9.79v-.68c-4.47.05-11.08,4.12-13.17-2.39Z"
                />
                <path
                  class="cls-1"
                  d="M3219.98,1423.6c-.19,1.98-.6,5.88-.78,7.82,3.69.71,7.46,1.43,11.31,2.12-2-5.6-3.86-11.21-5.54-16.88-1.7,2.3-3.36,4.63-4.99,6.94Z"
                />
                <path
                  class="cls-1"
                  d="M3496.35,1335.33c-1.6-2.03-3.17-4.04-4.65-6.01-2.11,1.97-4.13,3.94-6.13,5.93,1.59,2.51,3.31,5,5.12,7.44,1.86-2.42,3.75-4.89,5.66-7.36Z"
                />
                <path
                  class="cls-1"
                  d="M3368.86,1384.68c5.97-2.42.45-10.77-4.24-6.82-5.41,2.98-.88,11.21,4.24,6.82Z"
                />
                <path
                  class="cls-1"
                  d="M1806.11,1895.3c5.19-.48,6.47-2.95,3.89-7.45-5.19.38-6.49,2.86-3.89,7.45Z"
                />
                <path
                  class="cls-1"
                  d="M2780.19,1581.68c-.18-4.68-2.1-5.7-5.82-3.11.02,4.7,1.97,5.71,5.82,3.11Z"
                />
                <path
                  class="cls-1"
                  d="M1354.43,2048.49c-.27-4.75-2.3-5.8-6.03-3.14.22,4.6,2.25,5.65,6.03,3.14Z"
                />
                <path
                  class="cls-1"
                  d="M3504.54,1351.75l-6.54.96,3.09-6.08c-1.21-.31-3.62-.9-4.82-1.18.61,5.78-1.92,11.01-4.8,15.78.69,2.42,1.45,4.83,2.24,7.23,1.89-1.37,3.76-2.75,5.62-4.15-.56-1-1.18-1.98-1.94-2.86,5.68-.11,8.31-4.5,7.15-9.7Z"
                />
                <path
                  class="cls-1"
                  d="M1796.63,1907.74c-3.58,4.26,3.82,11.59,7.11,5.92,2.82-4.25-3.77-10.84-7.11-5.92Z"
                />
                <path
                  class="cls-1"
                  d="M1865.83,1885.06c-3.01,3.74,3.43,8.26,6.08,4.3,2.74-3.75-3.46-8.22-6.08-4.3Z"
                />
                <path
                  class="cls-1"
                  d="M1333.72,2076.19c5.93,1.19,11.91,2.2,17.94,2.95,1.49-5.12,1.18-10.3-1.33-14.99-5.41,1.87-10.8,3.89-16.07,6.05-.15,1.49-.38,4.49-.53,5.99Z"
                />
                <path
                  class="cls-1"
                  d="M3365.15,1410.6c7.28,2.23,14.59-.5,10.89-9.17-3.93,2.69-9.21,4.12-10.89,9.17Z"
                />
                <path
                  class="cls-1"
                  d="M1375.47,2085.96c.86-1.89,2.56-5.64,3.4-7.5-3.43-3.08-7.39-4.71-11.86-4.83,1.08-3.18,2.19-6.36,3.32-9.49-1.96-.13-5.91-.39-7.87-.52-8.51,2.98-.71,10.79,2.56,14.73l-2.5,1.82c4.27,1.97,8.6,3.88,12.95,5.79Z"
                />
                <path
                  class="cls-1"
                  d="M2327.6,1754.86c-.3-5.45-2.65-6.67-7.02-3.59.29,5.32,2.63,6.5,7.02,3.59Z"
                />
                <path
                  class="cls-1"
                  d="M1384.39,2067.25c.74,2.68,2.29,8.06,3.04,10.74,10.93.23,5.97-15.9-3.04-10.74Z"
                />
                <path
                  class="cls-1"
                  d="M3367.97,1457.84c2.37,1.18,7.09,3.5,9.45,4.65,3.7-1.64,7.52-3.33,11.29-5.06,2.49,2.38,5.51,3.58,9.06,3.56-.89-2.1-2.6-6.31-3.45-8.42-6.93-1.67-16.77.84-17.67-8.92,3.88-2.54,7.76-5.16,11.65-7.77,1.28.22,3.85.66,5.14.91-.05-4.99-.52-9.95-.96-14.88l-2.4.78c7.28,11.07-9.27,6.09-12.05,14.46.77-7.21-1.14-14.42-9-16.05.92,1.28,2.76,3.84,3.68,5.09-1.82,4.09.76,7.99,1.97,11.8l-11.86-1.21,5.17,3.59,5.48-.21c.22,4.27.48,8.58.78,12.89-1.55,1.21-4.7,3.62-6.26,4.8Z"
                />
                <path
                  class="cls-1"
                  d="M4131.04,1173.83c.14,5.47,2.36,6.62,6.73,3.42-.31-5.48-2.57-6.62-6.73-3.42Z"
                />
                <path
                  class="cls-1"
                  d="M2508.96,1743.26c-.22-5.81-2.35-7.1-6.42-3.82.13,5.64,2.28,6.89,6.42,3.82Z"
                />
                <path
                  class="cls-1"
                  d="M3514.37,1445.63c6.18,5.64,13.6-2.32,14.4-9.87-2.25,1.59-4.5,3.18-6.78,4.74.6.34,1.23.65,1.9.93-1.18.23-2.86.56-4.62.9-1.63,1.1-3.25,2.21-4.9,3.3Z"
                />
                <path
                  class="cls-1"
                  d="M2879.33,1648.58c-1.68.92-5.08,2.77-6.76,3.69-8.81,12.15-15.85,25.48-24.08,37.95-4.05,9.32,12.57,2.89,15.85,7.16l-5.41-6.57c9.21-11.34,16.08-24.27,23.61-36.72.89.99,2.71,2.95,3.61,3.96-7.41-7.67,2.62-15.55,1.95-24.2-2.86.93-8.55,2.76-11.4,3.69.6,3.7,1.47,7.39,2.63,11.04Z"
                />
                <path
                  class="cls-1"
                  d="M2211.47,1870.01c.62-1.18,1.89-3.58,2.55-4.76-1.64-1.92-3.26-3.81-4.86-5.71-2.3,1.69-4.54,3.4-6.73,5.12,2.97,1.79,5.94,3.57,9.04,5.35Z"
                />
                <path
                  class="cls-1"
                  d="M3283.95,1508.77c-3.26,3.39-2.61,5.39,2,6.04,3.26-3.52,2.59-5.55-2-6.04Z"
                />
                <path
                  class="cls-1"
                  d="M4059.28,1267.38c-.14-1.57-.54-3.13-1.21-4.55-3.68,2.37-10.95,6.15-11.3,10.76,3.72-2.94,7.95-5.11,12.51-6.22Z"
                />
                <path
                  class="cls-1"
                  d="M2166.43,1888.95c-3.47-2.3-9.57-5.41-10.06,1.1,6.77.14,9.45,6.29,13.02,10.94,3.43-3.2,5.43-7.05,2.68-11.66.53-3.43,1.07-6.8,1.58-10.2-4.22,1.91-6.61,5.18-7.22,9.82Z"
                />
                <path
                  class="cls-1"
                  d="M3392.54,1490.8c.97,1.94,2.86,5.79,3.82,7.69.43-5.38-2.62-9.97-4.53-14.69-.89.76-2.69,2.36-3.58,3.15-2.09-.33-6.31-.9-8.4-1.22,3.09,4.54,6.11,9.03,7.96,14.31,1.17-2.3,3.52-6.93,4.72-9.24Z"
                />
                <path
                  class="cls-1"
                  d="M2212.49,1881.37c-1.59,5.33,6.88,5.62,8.45,1.58,2.26-5.54-7.31-6.32-8.45-1.58Z"
                />
                <path
                  class="cls-1"
                  d="M3531.22,1456.66c-4.51.6-9.27,2.59-10.34,7.44.47,4.04,1.86,7.8,3.48,11.5,1.52-5.87,4.52-11.34,9.22-15.81-.83-1.11-1.78-2.37-2.36-3.13Z"
                />
                <path
                  class="cls-1"
                  d="M3401.83,1511.94c-1.17-3.69-2.89-6.99-5.17-9.98-3.6,2.55-6.81,5.72-9.96,8.73,5.04,0,10.2-.47,15.13,1.25Z"
                />
                <path
                  class="cls-1"
                  d="M1925.86,1992.25c-1.81,5.67,7.44,7.05,8.8,1.83,2.54-6.21-7.67-7.34-8.8-1.83Z"
                />
                <path
                  class="cls-1"
                  d="M3473.72,1485.75c-.05,5.29,2.2,6.54,6.79,3.7-.09-5.42-2.33-6.63-6.79-3.7Z"
                />
                <path
                  class="cls-1"
                  d="M2837.92,1709.62c4.5-1.23,2.14-8.9-2.25-7.4-4.34,1.32-2.13,8.6,2.25,7.4Z"
                />
                <path
                  class="cls-1"
                  d="M3409.4,1524.22c-1.42-1.89-4.31-5.69-5.73-7.57-4.11,3.26-8.1,6.61-11.99,10.03,2.71,6.65,7.85,11.69,12.85,16.71,3.76-5.77,5.96-12.23,4.87-19.17Z"
                />
                <path
                  class="cls-1"
                  d="M3490.2,1491.33c.04,4.56,2.05,5.65,6.02,3.31-.14-4.66-2.15-5.75-6.02-3.31Z"
                />
                <path
                  class="cls-1"
                  d="M2589.19,1804.83c-1.75,4.3-6.36,11.09.37,13.8,2.42-.12,7.23-.41,9.64-.53-.1-5.25.3-10.42.68-15.62,1.08-.72,3.27-2.24,4.33-2.99-4.93,1.48-12.86-.57-15.03,5.34Z"
                />
                <path
                  class="cls-1"
                  d="M2577.84,1816.91c-2.86,6.28,6.94,7.65,8.22,1.92,2.43-6.04-7.3-7.94-8.22-1.92Z"
                />
                <path
                  class="cls-1"
                  d="M2805.18,1748.55c-2.23,4.9-6.79,9.58-5.27,15.37,11.37,4.76,14.68-10.94,5.27-15.37Z"
                />
                <path
                  class="cls-1"
                  d="M3450.46,1550.62c6.07-2.92-.29-11.5-5.15-7.73-5.68,3.4-.21,11.6,5.15,7.73Z"
                />
                <path
                  class="cls-1"
                  d="M2790.97,1770.33c-.35,5.53,1.72,6.5,6.2,2.92.26-5.6-1.81-6.57-6.2-2.92Z"
                />
                <path
                  class="cls-1"
                  d="M2429.83,1895.24c-7.39-2.06-20.98.6-18.51,10.24,8.05,1.27,14.38-3.92,18.51-10.24Z"
                />
                <path
                  class="cls-1"
                  d="M1667.35,2164.16c4.29,4.55,9.33-.19,13.83-2.03-.39-.95-.78-1.9-1.18-2.85-4.11-2.44-8.96,2.46-12.65,4.87Z"
                />
                <path
                  class="cls-1"
                  d="M2219.16,1995.2c5.67-.14,9.14-5.47,13.46-8.39,1.67,1.3,5.03,3.87,6.7,5.18,5.21-2.17,6.16-9.24,10.54-12.72,4.81-3.89-1.46-10.55-6.2-8.09-7.76.42-7.41,13.65-16.66,9.61-12.57,10.62-29.76,16.34-46.18,14.74-.03,1.05-.1,3.19-.16,4.25,5.23,1.08,10.37,2.93,15.76,3.59,7.46-2.9,14.47-7.88,22.75-8.16Z"
                />
                <path
                  class="cls-1"
                  d="M3253.27,1647.19c-.56-4.69-2.66-5.69-6.3-3.02.46,4.59,2.56,5.58,6.3,3.02Z"
                />
                <path
                  class="cls-1"
                  d="M3420.91,1609.94c1.92-1.03,5.74-3.02,7.63-4-2.58-5.54-3.26-11.54-3.83-17.51-5.74,5.91-5.16,13.95-3.8,21.51Z"
                />
                <path
                  class="cls-1"
                  d="M1485.92,2252.67c-2,.53-4.02,1-6.05,1.39-1.28,4.98.37,10.67.38,15.85,2.86-3.49,5.81-6.91,8.57-10.5-.54-2.46-1.53-4.71-2.9-6.75Z"
                />
                <path
                  class="cls-1"
                  d="M3638,1550.95c-.37-2.27-1.1-6.77-1.47-9.03,4.87-2.06,6.34-6.84,3-10.89-4.24,1.85-8.3,3.72-12.4,5.56,1.48,6.17,5.74,10.8,10.87,14.37Z"
                />
                <path
                  class="cls-1"
                  d="M3666.77,1529.96c5.46-3.66-4.38-12.89-7.76-6.98-.99,4.09,3.88,7.67,7.76,6.98Z"
                />
                <path
                  class="cls-1"
                  d="M4126.35,1383.88c-.02-.11-.03-.23-.05-.34-.24-.6-.5-1.2-.73-1.81-.85-2.24-1.54-4.51-2.09-6.8-1.32-.31-2.85-.67-3.77-.9,1.22,1.58,3.69,4.71,4.94,6.29-5.57,7.97-14.41,6.72-22.45,4.34.31,4.36,4.46,5.87,7.64,8.1,4.6-4.31,10.35-7.32,16.5-8.88Z"
                />
                <path
                  class="cls-1"
                  d="M1578.37,2212.44c5.56,4.47,8.64-2.25,12.13-5.67-4.84-3.4-14.52-2.05-12.13,5.67Z"
                />
                <path
                  class="cls-1"
                  d="M1607.25,2200.82c2.1-5.42-6.94-6.64-8.03-1.65-2.13,5.53,6.67,6.12,8.03,1.65Z"
                />
                <path
                  class="cls-1"
                  d="M3330.83,1646.61c-3.53-2.78-7.25-5.43-10.74-8.09-1.24,1.25-3.77,3.79-5.01,5.03,4.7,2.97,10.23,3.65,15.75,3.06Z"
                />
                <path
                  class="cls-1"
                  d="M3433.62,1619.41c4.23-4.04-5.55-12.78-9.84-8.82-.17,4.73,6.14,7.07,9.84,8.82Z"
                />
                <path
                  class="cls-1"
                  d="M1570.29,2219.11c-7.32.44-5.99,10.8-8.66,15.8,4.93-.77,9.68-2.49,14.11-4.77-1.7-3.78-3.53-7.42-5.45-11.03Z"
                />
                <path
                  class="cls-1"
                  d="M1799.68,2143.02c-.35,3.14-5.46,7.26-1.79,9.86,10.28-.13,20.14,2.3,29.79,5.6,1.46-.58,4.32-1.71,5.74-2.28-2.84-14.67-22.52-11.1-33.75-13.19Z"
                />
                <path
                  class="cls-1"
                  d="M3460.29,1610.6c-5.76,2.22-11.85,3.97-16.99,7.36-1.61,4.12-1.19,7.99,1.27,11.62l-.57.32c-1.36-1.91-4.07-5.66-5.43-7.57-1.53,1.27-4.61,3.79-6.15,5.06,4.47,2.88,9.99,5.07,11.56,10.92,4.12-6.72,9.86-12.13,15.92-17.13-1.87-3.66-1.74-7.2.38-10.58Z"
                />
                <path
                  class="cls-1"
                  d="M3737.76,1529.81c-2.59-1.04-5.04-2.33-7.32-3.84-3.85.92-7.57,2.27-11.01,4.35,5.24,2.23,13.01,2.5,18.33-.51Z"
                />
                <path
                  class="cls-1"
                  d="M3659.56,1566.46c-1.31-2.46-4-7.4-5.33-9.86-1.84.64-5.49,1.93-7.32,2.59-4.29-5.83-9.33-6.54-15.07-2.1,2.56,1.86,5.19,3.65,7.95,5.41-2.45.33-7.34.98-9.8,1.28l.02,5.61c4.51-.4,9.07-.74,13.71-1.05.2,3.5.6,10.49.79,13.96,3.93-6.39,10.91-1.38,16.33-4.35,2.45-3.82,4.56-7.87,6.74-11.88-2.72.11-5.4.25-8.01.39Z"
                />
                <path
                  class="cls-1"
                  d="M3606.71,1573.02c-1.54,8.47,14.9,3.1,13.85-2.17-4.52-.04-10.43-1.37-13.85,2.17Z"
                />
                <path
                  class="cls-1"
                  d="M2481.88,1948.84c3.32-3.44,2.74-5.5-1.73-6.23-3.38,3.35-2.8,5.42,1.73,6.23Z"
                />
                <path
                  class="cls-1"
                  d="M1847.8,2160.29c3.36-4.63-3.66-8.32-7.14-5.4-7.49,4.03,3.8,12.57,7.14,5.4Z"
                />
                <path
                  class="cls-1"
                  d="M3420.32,1642.2c.75,3.62.03,8.33,3.74,10.64,7.12.1,13.29-4.17,17.9-9.31-7.14-1.7-14.45-1.64-21.65-1.34Z"
                />
                <path
                  class="cls-1"
                  d="M2404.18,1978.33c-2.26,3.49.9,10.36,5.54,8.95,4.63-3.02-.89-13.32-5.54-8.95Z"
                />
                <path
                  class="cls-1"
                  d="M3576.93,1594.93c-.25,2.79-.81,5.53-1.68,8.18,5.4-1.19,10.86-3.04,14.75-7.26-.37-8.93-7.55-3.56-13.07-.92Z"
                />
                <path
                  class="cls-1"
                  d="M3611.1,1599.32c.83-6.93,8.25-13.75,2.71-20.42-11.39,3.11-10.47,16.73-11.51,25.91,2.18-1.35,6.58-4.13,8.8-5.49Z"
                />
                <path
                  class="cls-1"
                  d="M3786.25,1542.15l-.49-2.26c-4.74-1.67-9.51-3.13-14.27-4.27,1.75,4.49,9.3,5.67,14.76,6.53Z"
                />
                <path
                  class="cls-1"
                  d="M1501.61,2290.23c3.4-1.51,6.78-3.22,10.13-4.92.54-4.85,1.24-9.68,1.57-14.56-2.44,2.51-4.61,5.24-6.61,8.07-3.28,2.92-10.3,6.45-5.08,11.41Z"
                />
                <path
                  class="cls-1"
                  d="M3451.23,1637.53c2.46,7.84-6.25,5.97-8.68,10.5,2.54,5.22,7.73,3.49,12.32,2.43-.39-4.58,1.05-10.06-3.65-12.93Z"
                />
                <path
                  class="cls-1"
                  d="M3123.08,1756.84c-.68-1.66-2.1-5-2.81-6.65-7.15,4.76-6.19,12.54-5.25,19.76,6.61-1.48,7.21-7.46,8.05-13.12Z"
                />
                <path
                  class="cls-1"
                  d="M1553.24,2272.2c2.4-5.52-6.75-6.87-7.88-1.8-2.23,5.43,6.43,6.31,7.88,1.8Z"
                />
                <path
                  class="cls-1"
                  d="M3462.34,1644.89c-2.37,4.27,2.46,13.11,7.53,10.52-2.05-3.09-2.04-15.4-7.53-10.52Z"
                />
                <path
                  class="cls-1"
                  d="M3480.53,1640.37c-1.49,4.49,0,6.15,4.48,5.06,1.35-4.51-.13-6.17-4.48-5.06Z"
                />
                <path
                  class="cls-1"
                  d="M3661.84,1597.11c3.36-3.18,7.06-6.27,9.32-10.47-1-3.78-3.33-5.37-7.04-4.79.87,2.37,2.6,7.15,3.45,9.53-1.77.55-5.36,1.61-7.14,2.13l1.41,3.61Z"
                />
                <path
                  class="cls-1"
                  d="M3512.96,1635.63c-3.1,4.31,4.25,10.65,7.73,6.18,2.62-4.42-4.22-10.86-7.73-6.18Z"
                />
                <path
                  class="cls-1"
                  d="M3127.51,1800.98c1.47,1.4,4.39,4.18,5.85,5.55,4.63-3.43,10.1-5.21,15.83-6.08,7.02,1.34,14.1,2.42,21.28,3.1-6.33-3.75-11.65-8.4-10.54-16.43-4.91-.11-9.87-.27-14.71-.37l1.22-5.11c-3.87.59-7.72,1.28-11.52,1.98-1.74-3.37-4.47-5.67-8.26-6.88,1.31-4.63,2.78-9.21,4.43-13.72-5.27,3.74-10.53,7.07-15.65,10.86-.81,6.28,4.16,12.96,10.75,8.73l.67,3.71c1.87-.54,5.6-1.69,7.47-2.24-3.48,2.72-7.39,4.66-11.86,3.94l-2.1-.56c-3.35.96-6.57,2.11-9.64,3.42,1.19,3.44,2.39,6.92,3.63,10.41,1.47-2.9,1.91-7.11,5.55-8.13.5,2.66,1.5,7.98,2,10.64,3.4,3.09,6.83,6.31,10.71,8.91-2.36-4.04-9.59-6.42-5.11-11.74Z"
                />
                <path
                  class="cls-1"
                  d="M3463.99,1666.94c-.21-5.68-8.48-3.95-8.56.85-.64,6.8,10.21,5.74,8.56-.85Z"
                />
                <path
                  class="cls-1"
                  d="M1490.72,2308.55c-.07,5.57,2.02,6.6,6.3,3.12.04-5.63-2.05-6.69-6.3-3.12Z"
                />
                <path
                  class="cls-1"
                  d="M1935.68,2167.33c-3.51,3.36-2.93,5.33,1.7,5.93,3.52-3.43,2.97-5.41-1.7-5.93Z"
                />
                <path
                  class="cls-1"
                  d="M1483.25,2317.5c-.49,1.17-1.45,3.5-1.95,4.64,5.47,10.05,12.95-9.64,1.95-4.64Z"
                />
                <path
                  class="cls-1"
                  d="M1947.48,2170.61c1.22,5.69,9.09,4.77,13.44,7.08.06-6.2-2-11.89-7.54-15.15-2.16,2.55-4.14,5.25-5.9,8.08Z"
                />
                <path
                  class="cls-1"
                  d="M3100.91,1822.17c-2.1-4.16-4.23-8.33-6.27-12.41-2.91-.82-5.75-1.85-8.54-2.94.09,2.44-.08,4.88-.48,7.32,1.11,2.29,1.09,5.46,1.42,8.05,4.46,1.84,9.36,2.32,13.87-.02Z"
                />
                <path
                  class="cls-1"
                  d="M3468.68,1672.87c1.59,1.77,4.81,5.25,6.42,7.01-.04-3.21.09-6.42.07-9.57-6.81-1-11.77,5.02-13.85,10.81,6.89,1.75,9.63-.99,7.36-8.25Z"
                />
                <path
                  class="cls-1"
                  d="M3541.72,1650c-3.35,4.15,3.5,11.53,7.11,6.45,2.65-4.13-3.62-11.39-7.11-6.45Z"
                />
                <path
                  class="cls-1"
                  d="M1503.65,2321.6c7.39,7.81,20.59,4.47,30.08,3.39-7.09-9.35-20.67-7.71-30.08-3.39Z"
                />
                <path
                  class="cls-1"
                  d="M1978.37,2174.24c-5.43,1.7.09,8.91,2.32,11.44,8.67-.41,4.71-14.11-2.32-11.44Z"
                />
                <path
                  class="cls-1"
                  d="M3479.08,1690.11c-1.78.62-5.37,1.89-7.18,2.51.54.83,1.57,2.44,2.07,3.26-4.08,8.29,3.78,9.22,10,9.01-1.47-5.03-3.17-9.92-4.89-14.77Z"
                />
                <path
                  class="cls-1"
                  d="M3511.07,1683.67c2.13-5.74-7.67-5.67-8.78-1.17-1.38,5.36,7.21,5.01,8.78,1.17Z"
                />
                <path
                  class="cls-1"
                  d="M3486.6,1695.53c4.78,1.46,9.65,2.9,14.58,4.18-1.8-5.83-12.1-14-14.58-4.18Z"
                />
                <path
                  class="cls-1"
                  d="M3186.36,1816.32l-4.6.63,1.09,4.15c-8.17.11-15.84,5.44-23.9,2.05-8.06,1.35-15.18,6.23-22.82,8.86-4.98-.93-9.95-1.56-14.86-2.17,1.81-4.46-.55-8.06-3.54-11.15-1.33,3.12-2.59,6.29-3.8,9.48l6.11-2.2c.07,4.25-4.18,9.53-.67,13.29,3.72,1.41,7.62,2.02,11.57,2.91l-2.69-5.37c6.74,1.19,13.64,2.44,20.4,4-1.48,1.43-4.48,4.29-6,5.72,4.19,2.73,7.78,6.13,10.99,10.09,1.33.27,4,.81,5.37,1.1,4.03,8.23,7.44,16.83,11.73,25.01,5.24-6.62-4.1-13.69-2.5-21.24-2.57-2.22-5.09-4.46-7.22-6.99-1.2-.38-3.54-1.16-4.71-1.56,2.34-.66,6.98-2.01,9.27-2.69-.72-4.98-3.41-9.31-5.45-13.72-1.88,3.1-3.71,6.25-5.43,9.4-3.2-3.22-6.41-6.45-9.51-9.67,5.54-2.28,11.42-4.47,17.11-6.59,10.13,5.4,21.47-3.31,24.07-13.37Z"
                />
                <path
                  class="cls-1"
                  d="M3112.43,1829.03c-1.46-4.47-8.84-5.35-11.64-1.88-2.12,6.68,10.68,8.01,11.64,1.88Z"
                />
                <path
                  class="cls-1"
                  d="M2401.71,2063.55c-1.97-.57-5.89-1.67-7.85-2.21,1.83,5.39,4.72,10.43,9.18,14.11l-3.95,2.53c1.58-.21,4.74-.61,6.32-.82-1.6-4.18-3.06-8.35-4.46-12.53l8.68,1.97c-1.06-2.61-3.16-7.81-4.21-10.42-.94,1.85-2.77,5.51-3.71,7.36Z"
                />
                <path
                  class="cls-1"
                  d="M3180.83,1813.69c-.48-1.16-1.42-3.43-1.9-4.59-4.51.4-8.85-.34-12.99-2.21-.04,3.07-.15,6.13-.04,9.26,4.68-2.03,9.73-2.94,14.93-2.45Z"
                />
                <path
                  class="cls-1"
                  d="M2335.74,2091.8c6.12-2.47.71-10.48-4.16-6.67-6.14,2.51-.85,10.56,4.16,6.67Z"
                />
                <path
                  class="cls-1"
                  d="M2433.31,2060.46c5.81-2.8.38-10.38-4.38-6.64-6.33,2.44-.6,10.62,4.38,6.64Z"
                />
                <path
                  class="cls-1"
                  d="M3498.72,1717.72c-3.21-2.41-6.43-4.86-9.53-7.27,1.43-1.27,4.28-3.78,5.71-5.06-11.14-.13-5.03,11.66-7.93,18.35-2.51,4.89,3.22,7.92,5.65,11.53,1.33-3.12,2.8-6.26,4.23-9.38-1.57-.7-4.75-2.08-6.31-2.75,2.04-1.37,6.14-4.05,8.18-5.43Z"
                />
                <path
                  class="cls-1"
                  d="M2413.98,2067.57c4.33,8.43,7.01-3.33,8.84-6.89-3.82.04-13.39.67-8.84,6.89Z"
                />
                <path
                  class="cls-1"
                  d="M3374.43,1752.07c1.74,4.81.86,13.23,8.24,12.87-1.32-4.55-2.37-21.48-8.24-12.87Z"
                />
                <path
                  class="cls-1"
                  d="M3086.97,1859.79c8.42-7.05,21.07-9.8,26.02-20.39-10.96,2.97-24.37,7.32-26.02,20.39Z"
                />
                <path
                  class="cls-1"
                  d="M2915.08,1918.02c-.12,4.78,1.76,5.61,5.58,2.58-.01-4.67-1.87-5.51-5.58-2.58Z"
                />
                <path
                  class="cls-1"
                  d="M3193.59,1825.09c-2.4,4.58-9.48,8.04-7.97,13.79,4.17,4.12,8.84,2.16,11.18-2.91,1.63,4.27,5.2,6.57,9.76,7.03-1.76-7.56-8-12.55-12.97-17.92Z"
                />
                <path
                  class="cls-1"
                  d="M3521.03,1726.44c.68,1.28,1.68,3.18,2.69,5.09,1.61-.45,3.24-.86,4.85-1.29.79-1.01,1.67-1.99,2.43-2.99-1.6-1.39-3.08-2.76-4.53-4.1-4.32,2.52-9.11,4.42-14.13,4.07-.92,1.51-1.77,3.03-2.54,4.56l-2.64-3.24c-3.33,2.93-6.33,6.1-5.58,9.97,4.12-1.44,8.26-2.82,12.42-4.11,1.58-3.15,4.08-5.75,7.03-7.96Z"
                />
                <path
                  class="cls-1"
                  d="M2254.88,2150.64c-4.74,4.1-3.83,11.03-5.2,16.52-1.83-.88-5.48-2.68-7.28-3.57-2,.65-5.97,1.98-7.98,2.64-.19.42-.38.84-.57,1.26.56-4.81-7.65-6.02-8.99-1.05-.86,1.88-.45,3.31.56,4.22-4.55,2.29-1.68,7.86-.42,12.45,5.99.84,7.56-3.11,6.77-8.93,1.9.93,3.84,1.91,5.78,2.9.71,3.86,3.02,4.52,6.88,1.93-.13-2.52-.74-4.11-1.84-4.78.74-1.86,1.5-3.75,1.98-5,5.2,4.69,8.93,3.27,10.48-3.42,9.19-3.17,15.54-10.79,14.95-20.71-5.13,1.47-11.32,1.37-15.13,5.54ZM2229.87,2176.28l-1.44-4.47c1.48.09,3.04-.34,4.08-1.36-.87,1.95-1.74,3.9-2.65,5.83Z"
                />
                <path
                  class="cls-1"
                  d="M3877.25,1620.31c-3.05,5.5,6.05,10.6,8.83,4.81,2.57-5.11-6.07-10.25-8.83-4.81Z"
                />
                <path
                  class="cls-1"
                  d="M2433.76,2094.29c-.04,4.62,1.91,5.86,5.86,3.74.02-4.78-1.93-6.03-5.86-3.74Z"
                />
                <path
                  class="cls-1"
                  d="M2963.8,1937.71c-5.14-2.26-10.19-.1-14.78,2.1,1.84,5.95,7.14,4.46,11.94,3.53,6.04,2.33,12.13,1.32,16.65-3.69-4.07-3.21-9.2-2.04-13.81-1.95Z"
                />
                <path
                  class="cls-1"
                  d="M3225.83,1881.22c-.81-1.85-2.49-5.57-3.33-7.42l3.24-.48c1.48,1.87,4.52,5.62,6.05,7.51,6.54-7.25-3.84-28.23-11.79-13.87-1.2-6.57-2.75-13.05-4.8-19.34-9.79,5.01,4.55,11.05-1.26,17.05,7.65,3.15,3.11,14.68,11.89,16.56Z"
                />
                <path
                  class="cls-1"
                  d="M2937.74,1942.62c-1.63,2.62-3.24,5.22-4.77,7.84,4.46,2.24,9.01,4.42,13.65,6.5.5-3.22,1.14-6.49,1.08-9.77-3.01-2.21-6.63-3.32-9.97-4.58Z"
                />
                <path
                  class="cls-1"
                  d="M3563.67,1824.12c-1.93-.98-5.75-3-7.7-4.01.19-4.97,2-10.03.54-14.93-.16-1.38-.56-2.85-.99-4.35-5.24,1.11-10.45,2.38-15.61,3.82,10.71,2.66.67,23.27,13.21,22.88.67,3.91,1.38,7.82,2.13,11.78l2.69-.81c-.6-1.95-1.83-5.92-2.44-7.88,1.7-.86,5.1-2.61,6.8-3.46l1.36-3.03Z"
                />
                <path
                  class="cls-1"
                  d="M2202.32,2187.78c.45-.26.94-.58,1.45-.99-.28-4.58-2.32-5.46-6.05-2.56.28,3.33,1.43,4.68,3.43,4.07-14,6.22-27.39,14.09-41.83,19.24-6.11,2.8-13.86-1.89-19.07,2.86-1.53,6.95,8.3,6.37,12.4,8.86,6.75-3.62,13.71-6.93,20.93-9.62,7.77,2.37,15.81,1.69,18.57-7.17,14.52,4.94,21.16-10.13,29.55-18.62l-3.76-1.83c-5.35,1.55-10.54,3.54-15.64,5.77Z"
                />
                <path
                  class="cls-1"
                  d="M2441.6,2116.74c-4.89-1.5-6.93,4.11-9.4,7.04,4.35,2.21,8.81,4.35,13.32,6.41.97-4.85,1.25-10.9-3.92-13.44Z"
                />
                <path
                  class="cls-1"
                  d="M4120.85,1568.63c-1.67,3.64-2.88,7.46-3.58,11.39,8.92,4.35,11.7-22.14,3.58-11.39Z"
                />
                <path
                  class="cls-1"
                  d="M3378.98,1813.05c-.22,4.48,1.74,5.75,5.99,3.83.14-4.52-1.86-5.81-5.99-3.83Z"
                />
                <path
                  class="cls-1"
                  d="M4099.85,1579.38c.18.85.53,2.55.71,3.4l6.58-.84c-1,1.77-3,5.32-4.01,7.09,1.17.69,3.51,2.11,4.69,2.84-1.41.63-4.27,1.96-5.7,2.63,2.73,4.45,5.43,8.92,8.3,13.39,3.11-5.82,1.22-10.78-4.11-14.56,1.4-.66,4.19-2.01,5.58-2.66-2.23-4.05-3.38-8.31-3.45-12.83-2.93.49-5.79,1.02-8.61,1.53Z"
                />
                <path
                  class="cls-1"
                  d="M1914.09,2308.47c-5.54,17.31-17.62,33.95-12.34,53.04,2.51-1.16,7.51-3.46,10.02-4.62-4.37-11.01,6.66-20.9,1.24-31.63,2.67-8.6,9.47-17.21,6.65-26.47-2.45,2.88-4.39,6.11-5.58,9.69Z"
                />
                <path
                  class="cls-1"
                  d="M4048.1,1605.68c-1.04,3.5,3.99,8.82,7.26,5.66,1.78-3.81-4.28-8.59-7.26-5.66Z"
                />
                <path
                  class="cls-1"
                  d="M3878.23,1670.18c3.88,1.99,7.7-4.83,4.61-7.49-3.87-1.26-7.97,4.62-4.61,7.49Z"
                />
                <path
                  class="cls-1"
                  d="M2569.91,2221.41c-5.24-3.2-12.22-13.02-14.75-2.04-6.93-.63-13.73.88-20.22,3.04-3.3-3.73-9.93-5.9-10.21-11.39,1.28-4.92-1.91-6.77-6.05-7.51-4.19,6.11-8,13.4-15.47,15.94-9.59,6.26-18.9-3.01-27.89-5.85-7.62-17.98-17.16-35.17-24.19-53.31.87-9.7.63-19.7-8.12-26.02-2.36,4.5-4.52,9.11-6.45,13.8,2.75,11.81,14.52,22.25,10.62,35.02,1.27.9,3.76,2.77,5,3.68.49,12.51,5.17,25.61,15.64,33.18-.38,3.79-1.01,7.52-.75,11.4,3.41,1.91,6.95,3.68,10.62,5.34,4.12,7.67,7.89,15.51,11.9,23.28,10.26-8.42-5.58-19.99-4.67-30.58,4.68,3.11,7.09,8.14,9.61,13.07,5.46-.77,11.16-1.12,16.42,1.09,9.73,3.75,20.16,1.12,30.28,1.21,1.77,2.55,3.61,5.08,5.46,7.66,9.46-3.76,19.58-4.27,29.63-3.45,2.35,4.21,4.84,8.44,7.32,12.64,5.44-1.88,10.76-3.91,16.22-5.9-.81-12.17-12.32-22.1-7.52-34.69-7.24-4.66-15.56-5.54-22.43.4Z"
                />
                <path
                  class="cls-1"
                  d="M2537.38,2119.8c2.6-4.28-4.57-9.06-7.57-5.16-2.72,4.22,4.5,8.85,7.57,5.16Z"
                />
                <path
                  class="cls-1"
                  d="M3074.23,1935.99c-1.62,4.63,5.68,5.77,7.1,1.78,2.15-4.84-6.16-6.42-7.1-1.78Z"
                />
                <path
                  class="cls-1"
                  d="M3241.58,1894.03c2.47.37,7.42,1.11,9.9,1.51-2.45-4.11-4.17-8.76-8.4-11.31-2.6-4.87-9.04,1.03-3.42,3.43l1.92,1.26c1.65,4.34-3.6,5.95-5.92,8.42-1.24-1.85-3.69-5.55-4.93-7.37-3.73,5.76,1.17,11.42,4.17,16.18,2.24-3.96,2.76-9.57,6.66-12.12Z"
                />
                <path
                  class="cls-1"
                  d="M2155.27,2257.3c9.55-2.78,1.8-10.64-1.88-15.02-1.85,5.14-.42,10.25,1.88,15.02Z"
                />
                <path
                  class="cls-1"
                  d="M3979.97,1672.43c1.55-5.75-3.52-8.93-6.81-12.53-4.02,5.28-.83,17.85,6.81,12.53Z"
                />
                <path
                  class="cls-1"
                  d="M3092.78,1955.95c-1.49.33-2.95.76-4.41,1.24,3.52-.13,7.05-.21,10.57-.24-1.58-1.4-3.63-1.75-6.16-1.01Z"
                />
                <path
                  class="cls-1"
                  d="M3256.81,1907.01c0-5.55-2.15-6.89-6.45-4.11-.16,5.7,1.97,7.06,6.45,4.11Z"
                />
                <path
                  class="cls-1"
                  d="M3143.91,1941.34c-4.2,3.52-8.43,6.92-12.63,10.31-8.96-2.49-24.75-5.36-28.1,5.3,2.38.01,4.76.05,7.13.11,3.94-1.44,7.95-2.67,12.24-2.3,6.86-.93,16.74,2.57,19.15-6.62,2.54.78,5.11,1.56,7.76,2.34-1.85-3.09-3.78-6.13-5.54-9.15Z"
                />
                <path
                  class="cls-1"
                  d="M3955.8,1684.89c4.99-1.49,2.28-10.22-2.67-8.27-4.55,1.72-2.14,9.71,2.67,8.27Z"
                />
                <path
                  class="cls-1"
                  d="M3200.36,1934.58c-.84-2.28-1.72-4.55-2.47-6.76-4.1,1.64-8.26,3.23-12.29,4.78l1.56,4.87c-2.04-.68-6.09-1.98-8.16-2.65,1.76,5.38,6.95,6.98,11.7,8.96.75-5.22,4.34-8.64,9.67-9.21Z"
                />
                <path
                  class="cls-1"
                  d="M3943.03,1680.66c-4.14,5.45-1.72,11.42,2.93,15.58,5.16-5.08,2.64-12.09-2.93-15.58Z"
                />
                <path
                  class="cls-1"
                  d="M2567.35,2135.6c-1.05,3.47-1.84,7.02-2.41,10.64,2.17-1.18,6.56-3.49,8.76-4.67-.72-3.53-1.76-8.37-6.35-5.96Z"
                />
                <path
                  class="cls-1"
                  d="M3174.62,1937.27c-4.36,1.59-3.07,10.15,2.09,8.46,4.49-1.5,3.16-10.51-2.09-8.46Z"
                />
                <path
                  class="cls-1"
                  d="M3261.62,1919.89c3.31,3.56,6.45,7.41,9.33,11.48.59-1.07,1.79-3.17,2.38-4.24-1.03-3.87-1.94-7.7-2.77-11.57-1.23.13-3.69.33-4.93.43-.58-2.6-1.74-7.8-2.32-10.4-1.36,1.39-4.05,4.18-5.38,5.55-3-.63-5.88-.4-8.58.68,2.07,4.9,4.49,9.73,7.01,14.48,1.68-2.16,3.44-4.28,5.26-6.42Z"
                />
                <path
                  class="cls-1"
                  d="M3929.06,1689.25c-5.75,4.84-10.32,10.8-14.75,16.81,1.21,1.65,3.61,4.97,4.83,6.66,6.66-2.58,9.59-10.36,14.37-15.38-1.56-2.72-3.04-5.39-4.46-8.09Z"
                />
                <path
                  class="cls-1"
                  d="M2577.38,2139.65c.7,2.16,2.05,6.49,2.75,8.62,3.33-3.61,7.45-5.39,12.34-5.34-.81-1.96-2.39-5.88-3.2-7.83-3.6,2.45-7.41,4.6-11.89,4.55Z"
                />
                <path
                  class="cls-1"
                  d="M2648.61,2115.99c-2.02,5.67,7.33,7.02,8.88,1.97,2.54-6.11-7.61-7.36-8.88-1.97Z"
                />
                <path
                  class="cls-1"
                  d="M3569.95,1825.43c-3.86.32-8.09,4.05-7.88,8.09,3.72,4.5,11.06-4.42,7.88-8.09Z"
                />
                <path
                  class="cls-1"
                  d="M3841.32,1743.4c-.28,5.54,1.82,6.8,6.28,3.8.18-5.64-1.92-6.9-6.28-3.8Z"
                />
                <path
                  class="cls-1"
                  d="M2543.69,2178.78c5.23,1.59,9.59-.81,13.47-4.26-1.09-1.29-3.22-3.89-4.27-5.16-4.61,1.54-7.87,4.82-9.19,9.42Z"
                />
                <path
                  class="cls-1"
                  d="M3976.22,1714.49c4.63-1.38,1.52-9.14-2.73-7.55-4.05,1.69-1.27,8.38,2.73,7.55Z"
                />
                <path
                  class="cls-1"
                  d="M3371.66,1925.95c-4.11,8.94-24.53,3.94-19.38,16.61,15.79-3.84,30.96-13.9,38.67-28.49-7.12,3-11.57,10.06-19.28,11.87Z"
                />
                <path
                  class="cls-1"
                  d="M2534.8,2199.73c-1.51,4.63,6,5.4,7.58,1.8,1.92-4.83-6.33-6-7.58-1.8Z"
                />
                <path
                  class="cls-1"
                  d="M3256.63,1973.52c4.59-1.6,2.74-10.74-2.38-8.94-3.86,1.97-2.52,10,2.38,8.94Z"
                />
                <path
                  class="cls-1"
                  d="M3556.75,1870.28c1.79,9.2,5.61,18.1,12.23,24.91-.69-2.33-2.05-7-2.71-9.33-.61-4.64-1.14-9.24-1.27-13.87,2.06,3.83,5.37,6.55,9.63,7.58-2.06-3.83-3.73-7.82-6.24-11.28-4.01-2.93-8.01.6-11.65,1.99Z"
                />
                <path
                  class="cls-1"
                  d="M3343.66,1941.48c-6.28,5.07-25.35,3.8-19.88,15.6-2.08.95-6.19,2.86-8.27,3.81,2.77.64,8.3,1.96,11.08,2.64l-2.05,4.84,2.4-.99c3.51-5.92,6.11-12.28,7.31-19.09,1.97.9,5.97,2.73,7.94,3.63.44-3.5.95-6.97,1.47-10.43Z"
                />
                <path
                  class="cls-1"
                  d="M2978.98,2068.4c-1.74,1.65-3.64,3.14-5.69,4.43-.08,2.93,3.58,5.86,6.89,3.3,4.92-2.05,2.44-7.4-1.2-7.73Z"
                />
                <path
                  class="cls-1"
                  d="M3291.91,1969.77c5.21,4.12,11.05,7.59,17,10.69,5.79-2.86,12.14-5.34,15.32-11.56-4.3-2.06-10.26-.95-13.15-5.15-3.2,6.46-12.83,8.59-19.18,6.02Z"
                />
                <path
                  class="cls-1"
                  d="M3073.58,2047.79c-1.89,4.92,6.05,5.05,7.34,1.27,2.18-5.05-6.39-5.48-7.34-1.27Z"
                />
                <path
                  class="cls-1"
                  d="M4020.04,1738.85c-2.59,3.4,2.85,8.95,5.95,5.35,2.46-3.39-2.97-8.98-5.95-5.35Z"
                />
                <path
                  class="cls-1"
                  d="M3283.43,1987.53c1.85-.94,5.58-2.79,7.42-3.73,2.56,2.59,5.98,4.1,9.55,5.25.41-4.91-.38-9.49-2.43-13.83-5.09,3.88-10.1,7.77-14.54,12.31Z"
                />
                <path
                  class="cls-1"
                  d="M2433.43,2264.32c-3.37,3.89,3.62,10.58,6.65,5.66,2.05-3.8-3.33-9.67-6.65-5.66Z"
                />
                <path
                  class="cls-1"
                  d="M4049.54,1745.28c3.16-3.82,2.49-5.96-1.91-6.37-3.11,3.77-2.44,5.91,1.91,6.37Z"
                />
                <path
                  class="cls-1"
                  d="M3568.98,1901.78c1.16,1.5,3.53,4.53,4.7,6.06,2.17-1.38,6.51-4.14,8.71-5.53-4.24-3.32-8.99-3.75-13.42-.53Z"
                />
                <path
                  class="cls-1"
                  d="M4072.16,1754.97c.09-6.01-3.61-11.36-9.98-11.33,1.55,5.07,1.87,16.63,9.98,11.33Z"
                />
                <path
                  class="cls-1"
                  d="M2509.42,2276.32c.71-9.88-9.2-11.92-16.44-14.13.73,4.3-.11,9.95,4.58,12.39,3.6,1.04,8.82,6.33,11.86,1.74Z"
                />
                <path
                  class="cls-1"
                  d="M3577.23,1910.78c-2.81,2.83-5.64,5.67-8.34,8.54,1.56.97,4.61,2.9,6.13,3.85-3.01,4.18-1.27,6.93,2.59,9.07-.88,1.33-2.64,4.06-3.52,5.38,8.4-1.46,4.51-10.99,3.07-16.13,4.59,1.9,8.31,4.95,11.27,9.19.37-.09,1.17-.21,1.58-.31-4.33-6.79-13.46-10.43-12.78-19.59Z"
                />
                <path
                  class="cls-1"
                  d="M3503.22,1957.97c5.87-6.42,3.47-15.22,3.19-22.99-2.98,3.96-5.94,7.85-8.45,12.1,1.4,3.78,3.33,7.32,5.27,10.89Z"
                />
                <path
                  class="cls-1"
                  d="M3596.36,1911.4c.1,5.25,2.45,6.36,7.08,3.27-.21-5.18-2.59-6.28-7.08-3.27Z"
                />
                <path
                  class="cls-1"
                  d="M4050.27,1772.34c-.3-3.5-3.96-10.57-8.02-6.96-1.66,3.87,7.85,16.63,8.02,6.96Z"
                />
                <path
                  class="cls-1"
                  d="M3419.16,1987.93c2.71-5.89,5.81-11.95,4.93-18.68-4.37,2.06-8.91,3.71-12.51,6.87.94,4.74,4.29,8.41,7.59,11.81Z"
                />
                <path
                  class="cls-1"
                  d="M3884.56,1829.54c-.61.24-1.21.48-1.84.7-1.19.64-2.35,1.63-3.44,3.16,4.34,2.28,8.89,4.59,13.5,6.65l7.11-2.32c-4.06-3.86-9.93-9.35-15.32-8.19Z"
                />
                <path
                  class="cls-1"
                  d="M3991.36,1800.01c1.94-5.81-7.64-6.92-8.98-1.88-2.28,5.99,7.68,7.24,8.98,1.88Z"
                />
                <path
                  class="cls-1"
                  d="M2517.36,2278.3c-6.14,2.51-11.03,6.36-9.2,13.73l15.37-5.02c-2.15-2.89-4.21-5.79-6.17-8.71Z"
                />
                <path
                  class="cls-1"
                  d="M3405.1,1999.24l1.97-.64c2.03-2.54,7.51-6.96,3.48-10.14-6.46-2.8-7.76,6.7-5.45,10.79Z"
                />
                <path
                  class="cls-1"
                  d="M3372.32,2009.94c1.49-7.68-10.81-3.66-5.32,1.74l5.32-1.74Z"
                />
                <path
                  class="cls-1"
                  d="M11.8,390.25c-3.23-6.81-11.26-4.02-17.11-4.94-.08,9.54,12.8,14.71,17.11,4.94Z"
                />
                <path
                  class="cls-1"
                  d="M25.18,382.52c-6.98-4.38-14,.17-11.32,8.17,5.74.81,9.18-3.5,11.32-8.17Z"
                />
                <path
                  class="cls-1"
                  d="M32.47,383.43c.24-4.72-1.57-5.74-5.48-3.09-.32,4.68,1.49,5.7,5.48,3.09Z"
                />
                <path
                  class="cls-1"
                  d="M9.39,396.95c-.63,4.14.44,8.76,4.01,11.36,9.04,8.24,18.78,15.72,28.89,22.6,1.1,1.42,3.37,4.24,4.5,5.66,8.07,3.21,17.39,4.27,24.06,10.37,6.01,5.84,15.08,6.77,20.7,13.17,5.13,5.62,12.82,4.56,19.05,1.61-1.42,8.73-.85,17.59-.7,26.38,5.84-7.75,12.6-16.69,9.95-27.08-14.31-3.57-21.41-18.83-35.71-22.7-14.12-3.93-24.94-14.31-38.53-19.29-8.36-3.15-14.83-10.22-23.84-11.75-3.8-3.5-5.92-15.68-12.38-10.34Z"
                />
                <path
                  class="cls-1"
                  d="M145.51,464.99c2.78-4.27-4.35-9.4-7.24-5.1-2.49,4.11,4.25,9.2,7.24,5.1Z"
                />
                <path
                  class="cls-1"
                  d="M91.44,490.67c-1.56,4.58,5.62,5.59,7.26,1.97,2.43-4.83-6.07-6.45-7.26-1.97Z"
                />
                <path
                  class="cls-1"
                  d="M107.85,494.9c.22,5.41,2.5,6.61,6.88,3.67-.31-5.48-2.6-6.72-6.88-3.67Z"
                />
                <path
                  class="cls-1"
                  d="M704.04,98.68c-5.41,1.87-10.8,3.89-16.07,6.05-.15,1.5-.38,4.49-.53,5.99,5.93,1.19,11.91,2.2,17.94,2.95,1.49-5.12,1.18-10.3-1.33-14.99Z"
                />
                <path
                  class="cls-1"
                  d="M716.23,114.7c4.27,1.97,8.6,3.88,12.95,5.79.86-1.89,2.56-5.64,3.4-7.5-3.43-3.08-7.39-4.71-11.86-4.83,1.08-3.18,2.19-6.36,3.32-9.49-1.96-.13-5.91-.39-7.87-.52-8.51,2.98-.71,10.79,2.56,14.73l-2.5,1.82Z"
                />
                <path
                  class="cls-1"
                  d="M738.1,101.78c.74,2.68,2.29,8.06,3.04,10.74,10.93.23,5.97-15.9-3.04-10.74Z"
                />
                <path
                  class="cls-1"
                  d="M1288.37,28.61c2.55-6.21-7.67-7.34-8.8-1.83-1.81,5.67,7.44,7.05,8.8,1.83Z"
                />
                <path
                  class="cls-1"
                  d="M237.81,390.23c.83-.51,1.63-.96,2.37-1.25-1.07-1.94-3.26-5.86-4.36-7.79-2.13,1.43-5.96,2.42-8.33,4.12,1.56.56,3.12,1.11,4.68,1.67,1.95,1,3.81,2.1,5.63,3.25Z"
                />
                <path
                  class="cls-1"
                  d="M289.19,426.67c-5.3-9.23-15.03-13.41-24.27-17.52-.78,1.1-2.31,3.31-3.07,4.4,6.77,8.08,17.5,10.76,27.34,13.13Z"
                />
                <path
                  class="cls-1"
                  d="M1034.89,196.67c-.39-.95-.78-1.9-1.18-2.84-4.11-2.44-8.96,2.46-12.65,4.87,4.29,4.55,9.33-.19,13.83-2.03Z"
                />
                <path
                  class="cls-1"
                  d="M1572.87,29.73c5.67-.14,9.14-5.47,13.46-8.39,1.67,1.3,5.03,3.87,6.7,5.18,5.21-2.17,6.16-9.24,10.54-12.72,4.81-3.89-1.46-10.55-6.2-8.09-7.76.42-7.41,13.65-16.66,9.61-12.57,10.62-29.76,16.34-46.18,14.74-.03,1.05-.1,3.19-.16,4.25,5.23,1.08,10.37,2.93,15.76,3.59,7.46-2.9,14.47-7.88,22.75-8.16Z"
                />
                <path
                  class="cls-1"
                  d="M839.64,287.2c-2,.53-4.02,1-6.05,1.39-1.28,4.98.37,10.67.38,15.85,2.86-3.49,5.81-6.91,8.57-10.5-.54-2.46-1.53-4.71-2.9-6.75Z"
                />
                <path
                  class="cls-1"
                  d="M944.21,241.29c-4.84-3.39-14.52-2.05-12.13,5.67,5.56,4.47,8.64-2.25,12.13-5.67Z"
                />
                <path
                  class="cls-1"
                  d="M960.96,235.35c2.1-5.42-6.94-6.64-8.03-1.65-2.13,5.53,6.67,6.12,8.03,1.65Z"
                />
                <path
                  class="cls-1"
                  d="M929.46,264.66c-1.7-3.78-3.53-7.42-5.45-11.03-7.32.44-5.99,10.8-8.66,15.8,4.93-.77,9.68-2.49,14.11-4.77Z"
                />
                <path
                  class="cls-1"
                  d="M1181.4,193.01c1.46-.58,4.32-1.71,5.74-2.28-2.84-14.67-22.52-11.1-33.75-13.19-.35,3.14-5.46,7.26-1.79,9.86,10.28-.13,20.15,2.3,29.8,5.6Z"
                />
                <path
                  class="cls-1"
                  d="M1201.52,194.82c3.36-4.63-3.66-8.32-7.14-5.4-7.49,4.03,3.8,12.57,7.14,5.4Z"
                />
                <path
                  class="cls-1"
                  d="M1763.44,21.81c4.63-3.02-.89-13.32-5.54-8.95-2.26,3.49.9,10.36,5.54,8.95Z"
                />
                <path
                  class="cls-1"
                  d="M865.45,319.84c.54-4.85,1.24-9.68,1.57-14.56-2.44,2.51-4.61,5.24-6.61,8.07-3.28,2.92-10.3,6.45-5.08,11.41,3.41-1.51,6.78-3.22,10.13-4.92Z"
                />
                <path
                  class="cls-1"
                  d="M446.89,454.96c-.07-5.36-2.38-6.35-6.9-3.02.06,5.22,2.34,6.23,6.9,3.02Z"
                />
                <path
                  class="cls-1"
                  d="M906.95,306.73c2.4-5.52-6.75-6.87-7.88-1.8-2.23,5.43,6.43,6.3,7.88,1.8Z"
                />
                <path
                  class="cls-1"
                  d="M332.26,503.44c4.85-1.72,2.06-10.59-2.94-8.49-4.28,1.93-1.66,9.55,2.94,8.49Z"
                />
                <path
                  class="cls-1"
                  d="M850.72,346.2c.04-5.63-2.05-6.69-6.3-3.12-.07,5.57,2.02,6.6,6.3,3.12Z"
                />
                <path
                  class="cls-1"
                  d="M1291.1,207.79c3.52-3.43,2.97-5.41-1.7-5.93-3.51,3.36-2.93,5.33,1.7,5.93Z"
                />
                <path
                  class="cls-1"
                  d="M836.96,352.03c-.49,1.17-1.45,3.5-1.95,4.64,5.46,10.05,12.95-9.64,1.95-4.64Z"
                />
                <path
                  class="cls-1"
                  d="M1301.19,205.14c1.22,5.69,9.09,4.77,13.44,7.08.06-6.2-2-11.89-7.54-15.15-2.16,2.55-4.14,5.25-5.9,8.08Z"
                />
                <path
                  class="cls-1"
                  d="M290.51,554.61c7.92-4.37,17.38-1.54,25.44-5.38,7.77-3.78,20.59-5.31,20.73-16.41-9.3,1.69-16.67,9.58-26.36,9.14-9.19-.76-18.01,5.48-27.01,1.19-4.26,2.3-8.49,4.69-12.61,7.21,4.14,6.72,13.2,8.1,19.81,4.26Z"
                />
                <path
                  class="cls-1"
                  d="M857.36,356.13c7.39,7.81,20.59,4.47,30.08,3.39-7.09-9.35-20.67-7.71-30.08-3.39Z"
                />
                <path
                  class="cls-1"
                  d="M365.1,531.74c-4.79-3.24-10.38-4.81-15.95-6.02.01,3.22-2.18,8.04,1.58,10.1,4.84,4.23,10.5-1.21,14.36-4.08Z"
                />
                <path
                  class="cls-1"
                  d="M443.21,515.15c3.23-4.32,6.38-8.67,9.49-13.05-7.12.21-14.28.12-21.24-1.23-3.86,8.55,4.6,12.65,11.75,14.28Z"
                />
                <path
                  class="cls-1"
                  d="M1332.09,208.77c-5.43,1.7.09,8.91,2.32,11.44,8.67-.41,4.71-14.11-2.32-11.44Z"
                />
                <path
                  class="cls-1"
                  d="M399.1,528.81c10.68-3.82,21.52-7.6,33.06-7.16-2.05-5.05-3.6-11.23-9.84-12.12-8.55-3.73-13.03,6.31-18.65,10.52-10.07-1.08-26.95.23-28.08,12.93,7.57-2.67,15.47-4.21,23.51-4.18Z"
                />
                <path
                  class="cls-1"
                  d="M522.09,492.03c.59-.4,1.03-.86,1.36-1.35.68.6,1.34,1.21,1.92,1.87-.31-.89-.8-2.29-1.26-3.61.12-.86-.02-1.76-.35-2.63,8.58-4.33,10.37,4.12,13.03,10.44.14-5.66-1.84-11-2.49-16.6-4.39.51-8.76,1.37-13.02,2.77-1.26-1.04-2.79-1.72-4.34-1.72-4.9,3.31-1.12,13.98,5.15,10.82Z"
                />
                <path
                  class="cls-1"
                  d="M481.12,505.64c-3.29-.61-6.98-6.26-10.08-2.36-1.15,4.41,2.04,7.7,4.69,10.77,2.78-2.08,4.57-4.85,5.39-8.41Z"
                />
                <path
                  class="cls-1"
                  d="M1752.81,112.51c1.58-.21,4.74-.61,6.32-.82-1.6-4.18-3.06-8.35-4.46-12.53l8.68,1.97c-1.05-2.61-3.15-7.81-4.21-10.42-.94,1.85-2.77,5.51-3.71,7.36-1.97-.57-5.89-1.67-7.85-2.21,1.83,5.39,4.72,10.43,9.18,14.11l-3.95,2.53Z"
                />
                <path
                  class="cls-1"
                  d="M243.61,596.68c-.09-1.82-.28-5.49-.37-7.31-5.65,2.15-12.95,2.75-16.28,8.51,2.74,8.92,11.23.33,16.65-1.2Z"
                />
                <path
                  class="cls-1"
                  d="M1689.45,126.33c6.12-2.47.71-10.48-4.16-6.67-6.14,2.51-.85,10.56,4.16,6.67Z"
                />
                <path
                  class="cls-1"
                  d="M1787.02,94.99c5.81-2.8.38-10.38-4.39-6.64-6.33,2.44-.6,10.62,4.39,6.64Z"
                />
                <path
                  class="cls-1"
                  d="M1776.54,95.22c-3.82.04-13.39.67-8.84,6.89,4.33,8.43,7.01-3.33,8.84-6.89Z"
                />
                <path
                  class="cls-1"
                  d="M1585.48,208.71c1.9.93,3.84,1.91,5.78,2.9.71,3.86,3.02,4.52,6.88,1.93-.13-2.52-.74-4.11-1.84-4.78.74-1.86,1.5-3.75,1.98-5,5.2,4.69,8.93,3.27,10.48-3.42,9.18-3.17,15.54-10.79,14.95-20.71-5.13,1.47-11.32,1.37-15.13,5.54-4.74,4.1-3.83,11.03-5.2,16.52-1.83-.88-5.48-2.68-7.28-3.57-2,.65-5.97,1.98-7.98,2.64-.19.42-.38.84-.57,1.26.56-4.81-7.65-6.02-8.99-1.05-.86,1.88-.45,3.31.56,4.22-4.55,2.29-1.68,7.86-.42,12.46,5.99.84,7.56-3.11,6.77-8.93ZM1586.23,204.98c-.87,1.95-1.74,3.9-2.65,5.83l-1.44-4.47c1.48.09,3.04-.34,4.08-1.36Z"
                />
                <path
                  class="cls-1"
                  d="M1787.48,128.82c-.04,4.62,1.91,5.86,5.86,3.73.02-4.78-1.93-6.02-5.86-3.73Z"
                />
                <path
                  class="cls-1"
                  d="M1506.38,253.79c6.75-3.62,13.71-6.93,20.93-9.62,7.77,2.37,15.81,1.69,18.57-7.17,14.52,4.94,21.16-10.13,29.55-18.62l-3.76-1.83c-5.35,1.55-10.54,3.54-15.64,5.77.45-.26.94-.58,1.45-.99-.29-4.58-2.32-5.46-6.05-2.56.28,3.33,1.43,4.68,3.43,4.07-14,6.22-27.39,14.09-41.83,19.24-6.11,2.8-13.86-1.9-19.07,2.86-1.53,6.95,8.3,6.37,12.4,8.86Z"
                />
                <path
                  class="cls-1"
                  d="M1785.91,158.31c4.35,2.21,8.81,4.35,13.32,6.41.97-4.85,1.25-10.9-3.92-13.44-4.89-1.5-6.93,4.11-9.4,7.04Z"
                />
                <path
                  class="cls-1"
                  d="M764.3,505.4c-.25-5.5-2.49-6.72-6.76-3.61.16,5.43,2.4,6.64,6.76,3.61Z"
                />
                <path
                  class="cls-1"
                  d="M1266.73,359.78c2.67-8.6,9.48-17.21,6.65-26.47-2.45,2.88-4.39,6.11-5.58,9.69-5.54,17.31-17.62,33.95-12.34,53.04,2.51-1.16,7.51-3.46,10.02-4.62-4.37-11.01,6.66-20.9,1.24-31.63Z"
                />
                <path
                  class="cls-1"
                  d="M1805.9,221.3c.49,12.51,5.17,25.61,15.64,33.18-.38,3.79-1.01,7.52-.75,11.4,3.41,1.91,6.95,3.68,10.62,5.34,4.12,7.66,7.89,15.51,11.9,23.28,10.26-8.42-5.59-19.99-4.67-30.58,4.68,3.11,7.09,8.14,9.61,13.07,5.46-.77,11.16-1.12,16.42,1.09,9.73,3.75,20.16,1.12,30.28,1.21,1.77,2.55,3.61,5.07,5.46,7.66,9.46-3.76,19.58-4.27,29.63-3.45,2.35,4.21,4.84,8.44,7.32,12.64,5.44-1.88,10.76-3.91,16.22-5.9-.81-12.17-12.32-22.1-7.52-34.69-7.24-4.66-15.56-5.54-22.43.4-5.25-3.2-12.22-13.02-14.75-2.04-6.93-.63-13.73.88-20.22,3.04-3.3-3.73-9.93-5.9-10.21-11.39,1.28-4.92-1.91-6.77-6.05-7.51-4.19,6.11-8,13.4-15.47,15.94-9.59,6.26-18.9-3.01-27.89-5.85-7.62-17.98-17.16-35.17-24.19-53.31.87-9.7.63-19.7-8.12-26.02-2.36,4.5-4.52,9.11-6.45,13.8,2.75,11.81,14.52,22.25,10.62,35.02,1.27.9,3.76,2.77,5,3.68Z"
                />
                <path
                  class="cls-1"
                  d="M1891.1,154.33c2.6-4.28-4.57-9.06-7.57-5.16-2.72,4.22,4.5,8.85,7.57,5.16Z"
                />
                <path
                  class="cls-1"
                  d="M1507.11,276.81c-1.85,5.14-.42,10.25,1.88,15.02,9.55-2.78,1.8-10.64-1.88-15.02Z"
                />
                <path
                  class="cls-1"
                  d="M329.36,695.44c3.28-5.71-1.26-11.18-6.39-13.41-1.48,3.41-2.73,6.87-3.74,10.47-1.43,7.46,6.13,5.6,10.14,2.94Z"
                />
                <path
                  class="cls-1"
                  d="M1921.06,170.13c-1.05,3.47-1.84,7.02-2.41,10.64,2.17-1.18,6.56-3.49,8.76-4.67-.72-3.53-1.76-8.37-6.35-5.96Z"
                />
                <path
                  class="cls-1"
                  d="M1933.83,182.8c3.33-3.61,7.45-5.39,12.34-5.34-.81-1.96-2.39-5.88-3.2-7.83-3.6,2.45-7.41,4.6-11.89,4.55.7,2.16,2.05,6.49,2.75,8.62Z"
                />
                <path
                  class="cls-1"
                  d="M2011.21,152.5c2.54-6.11-7.61-7.36-8.88-1.97-2.02,5.67,7.33,7.02,8.88,1.97Z"
                />
                <path
                  class="cls-1"
                  d="M317.46,706.05c.3,5.25,2.68,6.45,7.11,3.66-.29-5.42-2.68-6.66-7.11-3.66Z"
                />
                <path
                  class="cls-1"
                  d="M168.41,784.08c4.25-6.97,8.84-19.36-2.59-21.94-4.13,7.63-6.5,17.05,2.59,21.94Z"
                />
                <path
                  class="cls-1"
                  d="M338.75,722.36c9.32-.79,1.74-9.17-1.23-12.94-4.8,3.92-4.63,10.12,1.23,12.94Z"
                />
                <path
                  class="cls-1"
                  d="M1897.41,213.31c5.22,1.59,9.58-.81,13.47-4.26-1.09-1.29-3.22-3.89-4.27-5.16-4.61,1.54-7.87,4.82-9.19,9.42Z"
                />
                <path
                  class="cls-1"
                  d="M1241.01,450.2c3-5.42,7.4-11.22,5.4-17.76-5.41,3.61-9.74,11.75-5.4,17.76Z"
                />
                <path
                  class="cls-1"
                  d="M1348.03,404.54c-.04,1.32-.13,4.04-.16,5.36,8.16,8.13,8.68-13.05.16-5.36Z"
                />
                <path
                  class="cls-1"
                  d="M1888.52,234.26c-1.51,4.63,6,5.4,7.58,1.8,1.92-4.83-6.33-6-7.58-1.8Z"
                />
                <path
                  class="cls-1"
                  d="M2607.97-.89c-3.86,1.97-2.52,10,2.38,8.94,4.59-1.6,2.74-10.74-2.38-8.94Z"
                />
                <path
                  class="cls-1"
                  d="M162.6,803.26c1.32,4.24,2.77,8.47,4.38,12.69,4.86-1.89,12.92-2.74,10.41-10.02-1.64-8.1-9.63-4.18-14.79-2.67Z"
                />
                <path
                  class="cls-1"
                  d="M483.77,698.39c-2.47,1.28-7.42,3.83-9.9,5.08,2,1,4.02,1.96,6.07,2.91,1.71-.41,3.41-.7,5.11-.86-.39-2.39-.8-4.77-1.27-7.13Z"
                />
                <path
                  class="cls-1"
                  d="M2680.3-1.94l-2.05,4.84,2.4-.99c3.51-5.92,6.11-12.28,7.31-19.09,1.97.9,5.96,2.72,7.94,3.63.44-3.5.95-6.97,1.47-10.43-6.28,5.07-25.35,3.8-19.88,15.6-2.08.95-6.19,2.86-8.27,3.81,2.76.64,8.3,1.96,11.08,2.64Z"
                />
                <path
                  class="cls-1"
                  d="M1236.79,491.54c1.41-4.23,2.93-8.42,4.38-12.62-.64-1.97-1.9-5.93-2.52-7.92,3.28-4.57,4.58-10.07,5.46-15.5-2.86.5-8.64,1.54-11.5,2.04.63,3.89,1.32,7.74,2.13,11.67-5.06,6.73-10.13,20.05,2.04,22.32Z"
                />
                <path
                  class="cls-1"
                  d="M827.36,594.36c-5.12,1.91-9.9,4.98-5.84,10.85,7.09.41,5.85-5.98,5.84-10.85Z"
                />
                <path
                  class="cls-1"
                  d="M2327,107.36c-.08,2.93,3.58,5.87,6.89,3.3,4.92-2.05,2.44-7.4-1.2-7.73-1.74,1.65-3.64,3.14-5.69,4.43Z"
                />
                <path
                  class="cls-1"
                  d="M265.56,781.31c-1.32,7.89,12,5.06,10.16-1.63-1.9-4.59-9.15-2.59-10.16,1.63Z"
                />
                <path
                  class="cls-1"
                  d="M2677.95,3.43c-4.3-2.06-10.26-.95-13.14-5.15-3.2,6.46-12.83,8.59-19.18,6.02,5.21,4.11,11.05,7.59,17,10.69,5.79-2.86,12.14-5.34,15.32-11.56Z"
                />
                <path
                  class="cls-1"
                  d="M1279.87,464.4c2.57-4.37-4.77-9.06-7.55-4.8-2.63,4.29,4.68,8.79,7.55,4.8Z"
                />
                <path
                  class="cls-1"
                  d="M2434.63,83.59c2.18-5.05-6.39-5.48-7.34-1.27-1.89,4.92,6.05,5.05,7.34,1.27Z"
                />
                <path
                  class="cls-1"
                  d="M735.72,639.33c-1.91.2-3.82.2-5.72.07-3.71,3.62-1.68,12.29-6.81,16.03,2.69,1.85,5.4,3.68,8.18,5.5,2.69-5.99,9.41-15.65,4.34-21.6Z"
                />
                <path
                  class="cls-1"
                  d="M2651.68,9.75c-5.09,3.88-10.1,7.77-14.54,12.31,1.85-.94,5.57-2.79,7.42-3.73,2.56,2.59,5.98,4.1,9.55,5.25.41-4.91-.38-9.49-2.43-13.83Z"
                />
                <path
                  class="cls-1"
                  d="M1793.8,304.51c2.05-3.8-3.33-9.67-6.65-5.66-3.37,3.89,3.62,10.58,6.65,5.66Z"
                />
                <path
                  class="cls-1"
                  d="M394.47,756.31c.08,5.29,2.38,6.35,6.89,3.2-.13-5.34-2.43-6.4-6.89-3.2Z"
                />
                <path
                  class="cls-1"
                  d="M379.07,763.92c.05,4.99,1.85,5.98,5.4,2.94-.1-4.94-1.93-5.92-5.4-2.94Z"
                />
                <path
                  class="cls-1"
                  d="M726.86,663.88c-.19,5.31,1.97,6.46,6.48,3.48.03,3.61,4.89,7.42,7.35,3.41,2.44-3.75-3.03-9.8-6.52-5.77-.32.38-.53.8-.66,1.23-.13-4.54-2.35-5.32-6.65-2.35Z"
                />
                <path
                  class="cls-1"
                  d="M1230.68,499.38c.19,5.32,2.53,6.4,7.01,3.26-.33-5.34-2.67-6.42-7.01-3.26Z"
                />
                <path
                  class="cls-1"
                  d="M1851.27,309.11c3.6,1.04,8.82,6.33,11.86,1.74.71-9.88-9.2-11.92-16.44-14.13.73,4.3-.11,9.95,4.58,12.39Z"
                />
                <path
                  class="cls-1"
                  d="M244.12,828.72c-1.25,7.8,11.87,4.86,10.12-1.76-1.76-4.87-9.2-2.44-10.12,1.76Z"
                />
                <path
                  class="cls-1"
                  d="M2777.79,3.78c-4.37,2.06-8.91,3.71-12.51,6.87.94,4.74,4.29,8.41,7.59,11.81,2.71-5.89,5.81-11.95,4.93-18.68Z"
                />
                <path
                  class="cls-1"
                  d="M1231.66,518.46c-.26-5.63-2.4-6.75-6.4-3.32.19,5.72,2.33,6.84,6.4,3.32Z"
                />
                <path
                  class="cls-1"
                  d="M324.82,820.56c-.04,1.93-.09,5.81-.09,7.76l16.77-5.47c-4.99-4.49-10.78-6.06-16.68-2.29Z"
                />
                <path
                  class="cls-1"
                  d="M2764.27,22.98c-6.46-2.8-7.76,6.7-5.45,10.79l1.97-.64c2.03-2.54,7.51-6.96,3.48-10.14Z"
                />
                <path
                  class="cls-1"
                  d="M2720.72,46.21l5.32-1.74c1.49-7.68-10.81-3.66-5.32,1.74Z"
                />
                <path
                  class="cls-1"
                  d="M786.13,677.71l5.56-1.81c-3.45-4.18-5.3-3.58-5.56,1.81Z"
                />
                <path
                  class="cls-1"
                  d="M4012.04,1456.52c-.07.28-.08.55-.13.82l24.27-7.92c-3.77-.39-7.54-.79-11.31-1.16-5.03,1.29-9.58,3.63-12.84,8.26Z"
                />
                <path
                  class="cls-1"
                  d="M3533.58,1613.48c-4.22-7.74-9.82-14.67-17.26-19.55.47,4.22.9,8.41,1.33,12.61,4.61,1.76,7.35,5.16,9.61,9.01l6.33-2.06Z"
                />
                <path
                  class="cls-1"
                  d="M3493.16,1626.68c-3.79-2.77-7.73-5.39-11.1-8.66-3.43-5.16-4.82-11.37-7.69-16.85-4.54-3.26-9.06-7.11-12.79-11.54,2.46-1.09,5.71-2.55,7.54-3.36-.97-1.23-2.99-3.7-4-4.95-3.18.85-3.6,4.27-4.5,7.1-3.33-4.22-5.91-8.93-7.08-14.14-4.23-2.65-9.13-3.98-13.79-5.79-3.16-5.96-6.52-11.85-9.91-17.71-2.84.77-5.47,1.92-7.93,3.45-3.09-3.45-6.4-7.12-10.53-1.87l.27-3.48c-3.39-.3-6.7-.64-9.96-.95.14.83.42,2.42.55,3.22,2.04-.53,6.11-1.56,8.13-2.08-.97,2.17-2.96,6.48-3.93,8.65,6.47,4.68,4.76,13.03,6.4,19.83,7.94-1.11,12.2,6.07,19.26,7.53,3.6-6.99-8.12-6.66-12.11-9.09-8.5-.72-4.92-10.73-5.59-16.29,1.82-.39,4.83-1.03,7.42-1.58,8.43,4.6,9.19,16.35,17.29,21.39,8.87,5.04,9.02,18.06,19.53,21.22,3.76,12.79,15.1,20,23.38,29.59l11.14-3.64Z"
                />
                <path
                  class="cls-1"
                  d="M2549.56,1934.69l7.55-2.47c-.78-2.65-1.62-5.28-2.57-7.88-2.73.99-8.19,3.01-10.93,4,1.08,3.16,3.3,5.03,5.94,6.34Z"
                />
                <path
                  class="cls-1"
                  d="M3936.56,1473.16c-3.93,1.35-7.6,3.19-11.04,5.52-.18,9.44,16.22,2.1,11.04-5.52Z"
                />
                <path
                  class="cls-1"
                  d="M2207.16,2041.57c-.85-8.06-3.94-16.09-11.15-20.46,1.29,7.88,4.07,15.98,11.15,20.46Z"
                />
                <path
                  class="cls-1"
                  d="M2828.27,1831.06c4.14-1.62,1.43-8.6-2.7-7.45-4.52,1.41-1.58,8.95,2.7,7.45Z"
                />
                <path
                  class="cls-1"
                  d="M3888.49,1475.4c-5.73-1.39-11.38-3.24-16.75-5.79-3.81-2.82-5.5,3.24-6.88,5.5,1.99.12,5.98.4,7.97.52-.89,3.75-2.63,7.68-.53,11.37,1.33-1.78,3.98-5.3,5.29-7.07,4.23,7.49,8.78-1.22,10.89-4.53Z"
                />
                <path
                  class="cls-1"
                  d="M2423.37,1954.16c-5.44-.41-10.42,1.55-14.6,5,5.05,7.63,13.96,2.91,14.6-5Z"
                />
                <path
                  class="cls-1"
                  d="M2480.13,1931.97c-1.47-1.1-4.38-3.31-5.84-4.41-16.2,6.6-31.36,15.45-47.21,22.81.51,1.35,1.52,4.04,2.03,5.39,16.37-6.39,31.6-15.43,48.04-21.6,1.13,1.08,3.45,3.24,4.61,4.34,6.43-1.73,12.69-4.38,16.5-10.09-6.45-2.97-12.48.28-18.13,3.57Z"
                />
                <path
                  class="cls-1"
                  d="M3936.49,1445.85c1.95,3.9,8.23.61,8.24-2.96-1.52-4.45-9.19-1.27-8.24,2.96Z"
                />
                <path
                  class="cls-1"
                  d="M3089.37,1725.16c2.54-2.41,4.16-8.05.9-10.51-6.89-1.75-7.82,11.36-.9,10.51Z"
                />
                <path
                  class="cls-1"
                  d="M2039.86,2014.27c-.63.36-1.36.74-2.12,1.14,1.22.92,2.46,1.82,3.67,2.75,1.37.32,2.75.63,4.13.94-.14.48-.33,1.15-.53,1.84.5.39,1,.79,1.51,1.19l4.31-3.11c-2.16-.24-4.35-.46-6.59-.74,3.86-4.02,5.54-9.27,7.78-14.17-.32-.36-.63-.73-.95-1.09-2.77,4.63-6.51,8.59-11.2,11.25Z"
                />
                <path
                  class="cls-1"
                  d="M1539.27,2234.18c.63-1.78,1.88-5.35,2.51-7.14-3.38-4-7.9-1.47-11.73,1.16.92,1.24,1.76,2.54,2.54,3.88,2.23.7,4.47,1.41,6.68,2.1Z"
                />
                <path
                  class="cls-1"
                  d="M3904.85,1458.5c3.15-4.76,1.22-10.38.71-15.53-5.65,3.9-4,10.62-.71,15.53Z"
                />
                <path
                  class="cls-1"
                  d="M3891.33,1448.49c-5.01,4.32-13.04,3.62-16.83,9.39,5.23,4.68,13.04,1.86,19.41,2.71-.18-4.14.83-8.88-2.57-12.1Z"
                />
                <path
                  class="cls-1"
                  d="M2105.7,2035.77c4.23-7.53-10.12-8.56-9.54-1.12.39,5.01,7.62,4.91,9.54,1.12Z"
                />
                <path
                  class="cls-1"
                  d="M3584.24,1549.31c-3.68-3.34-6-2.95-7.01,1.18,3.68,3.34,6,2.95,7.01-1.18Z"
                />
                <path
                  class="cls-1"
                  d="M4089.16,1360.79c.2,4.54,2.24,5.62,6.07,3.26-.11-4.57-2.15-5.65-6.07-3.26Z"
                />
                <path
                  class="cls-1"
                  d="M3739.23,1480.12c2.12-5.87-7.75-7.15-9.09-1.91-1.99,5.86,7.62,6.96,9.09,1.91Z"
                />
                <path
                  class="cls-1"
                  d="M1484.71,2203.28c6,2.51,11.36,6.07,16.8,9.44-1.39-9.09-8.85-11.16-16.8-9.44Z"
                />
                <path
                  class="cls-1"
                  d="M1475.99,2207.88c6.69-4.23,4.9-10.84,1.94-16.6-2.06,5.21-4.2,10.92-1.94,16.6Z"
                />
                <path
                  class="cls-1"
                  d="M3944.97,1364.96c-1.67.95-5.06,2.83-6.74,3.75-2.23,5.74-5.21,11.21-10.4,14.79-2.16,3.46-4.3,6.92-6.55,10.31.54,1.24,1.6,3.68,2.13,4.88,4.5-6.31,11.61-7.89,19-7.92-5.16-8.1-7.26-20.49,2.57-25.81Z"
                />
                <path
                  class="cls-1"
                  d="M888.73,2384.18c-.45-2.31-1.37-6.88-1.81-9.16,1.67-5.69,3.19-11.43,4.85-17.08-2.1-1.13-4.26-2.17-6.46-2.94.4-.22.79-.4,1.17-.55-1.07-1.94-3.26-5.86-4.36-7.79-2.13,1.43-5.96,2.42-8.33,4.12,1.56.56,3.12,1.11,4.68,1.67.94.48,1.85.98,2.75,1.5-3.26-.51-6.61-.21-9.99,1.51,1.74,7.7,5.7,15.82,1.89,23.62-2.65,5.17-2.66,11.93,3.19,14.92,6.23.15,8.98-5.86,12.42-9.84Z"
                />
                <path
                  class="cls-1"
                  d="M1081.47,2324.76c5.9-1.09,10.97-3.68,13.97-9-4.77-.6-9.47.13-14.05,1.66.03,1.84.05,5.5.08,7.34Z"
                />
                <path
                  class="cls-1"
                  d="M988.71,2344.28c2.01-5.9-7.48-6.97-8.88-1.77-2.52,6.07,7.73,6.99,8.88,1.77Z"
                />
                <path
                  class="cls-1"
                  d="M2112.55,1958c-3.41.68-7.3,1.11-10.54,2.73.8,2.36,2.43,7.04,3.27,9.39,2.77-3.86,5.26-7.87,7.27-12.12Z"
                />
                <path
                  class="cls-1"
                  d="M986.04,2329.79c.19,5.42,2.47,6.76,6.85,3.98-.06-5.43-2.34-6.76-6.85-3.98Z"
                />
                <path
                  class="cls-1"
                  d="M4087.43,1317.18c-2.45-10.7-18.57-14.14-26.14-6.46,2.76,5.79,6.5,10.95,11.82,14.59,1.1-1.27,3.29-3.73,4.36-4.99,3.2-.81,8.68,1.06,9.96-3.15Z"
                />
                <path
                  class="cls-1"
                  d="M2078.72,1967.33c-4.2.33-7.31,3.46-10.65,5.79,2.87,1.69,5.74,3.37,8.62,4.98,1.59-2.84,7.87-8.32,2.03-10.78Z"
                />
                <path
                  class="cls-1"
                  d="M3572.69,1445.44c5.64,4.81,11.76,2.35,15.89-3-5.53-5.19-11.48-1.6-15.89,3Z"
                />
                <path
                  class="cls-1"
                  d="M1403.63,2158.05c2.97-1.33,3.13-4.98,1.77-7.76-1.44-.89-2.79-1.91-4.08-3-4.58,1.16-2.7,11.34,2.3,10.77Z"
                />
                <path
                  class="cls-1"
                  d="M4101.96,1264.37c-1.46-7.56-7.79-1.02-10.9,1.31,3.83,2.38,7.79,1.63,10.9-1.31Z"
                />
                <path
                  class="cls-1"
                  d="M3659.31,1410.46c-1.13-4.7-1.48-9.57-.95-14.31-5.29,2.69-3.73,10.5.95,14.31Z"
                />
                <path
                  class="cls-1"
                  d="M1624.93,2058.15c-4.11,1.51-2.03,9.44,2.47,7.67,3.75-1.8,1.86-8.91-2.47-7.67Z"
                />
                <path
                  class="cls-1"
                  d="M1943.41,1949.45c2.9.33,5.55-.1,7.97-1.32,4.1-1.74,4.59-4.46,1.49-8.12-4.67.82-9.95,3.92-9.46,9.44Z"
                />
                <path
                  class="cls-1"
                  d="M710.37,2347.91c2.48-4.04-3.59-11.4-7.16-6.5-2.78,4.14,3.92,12.33,7.16,6.5Z"
                />
                <path
                  class="cls-1"
                  d="M2444.78,1759.33c-9.16-.98-5.66,8.5-.98,11.82,1.4-.86,4.21-2.55,5.61-3.41-1.16-2.11-3.47-6.3-4.63-8.41Z"
                />
                <path
                  class="cls-1"
                  d="M769.38,2305.66c-2.78-.37-7.63-4.13-9.56-.24-3.75,5.09-2.55,11.86,1.14,16.57,7.51-1.61,6.81-10.56,8.42-16.33Z"
                />
                <path
                  class="cls-1"
                  d="M3482.67,1423.3c.31,5.07,2.76,5.99,7.26,2.77-.25-5.2-2.67-6.12-7.26-2.77Z"
                />
                <path
                  class="cls-1"
                  d="M2375.04,1787.38c4.91.01,9.64-.86,13.76-3.55-1.04-1.54-3.12-4.63-4.17-6.17-4.74,1.55-7.85,5.18-9.6,9.72Z"
                />
                <path
                  class="cls-1"
                  d="M3635.01,1375.75c-.29-4.71-2.33-5.8-6.1-3.25.34,4.66,2.38,5.74,6.1,3.25Z"
                />
                <path
                  class="cls-1"
                  d="M2746.76,1667.05c.23-4.75-1.57-5.84-5.41-3.28-.25,4.79,1.55,5.88,5.41,3.28Z"
                />
                <path
                  class="cls-1"
                  d="M2426.92,1769.27c2.07,5.11,9.89.64,8.27-3.91-2.22-4.42-9.57-.37-8.27,3.91Z"
                />
                <path
                  class="cls-1"
                  d="M1499.27,2072.61c3.24-4.08-3.55-9.93-6.62-5.24-2.87,3.96,3.58,9.52,6.62,5.24Z"
                />
                <path
                  class="cls-1"
                  d="M3648.07,1369.11c2.75-1.67,5.44-10.31-.03-9.37-5.34,1.44-8.11,14.92.03,9.37Z"
                />
                <path
                  class="cls-1"
                  d="M943.11,2235.06c.9-4.16,3.7-9.68-.44-13.1-3.29-3.8-8.02-.17-12.13.23.1,5.24,2.67,11.9-2.96,15.35-7.47,5.23-7.08,14.98-2.7,22.19,7.96-6.6,14.53-15,18.23-24.67Z"
                />
                <path
                  class="cls-1"
                  d="M985.09,2215.18c-2.91-4.6-8.18.48-11.86,1.45.6,1.95,1.81,5.86,2.41,7.79-.67,2.57-2.02,7.72-2.69,10.29,2.48.9,4.91,1.86,7.28,2.83,3.99-6.41,11.76-15.17,4.87-22.36Z"
                />
                <path
                  class="cls-1"
                  d="M2470.49,1739.24c-4.21,2.45.12,8.6,3.81,5.38,4.99-2.33.16-9.3-3.81-5.38Z"
                />
                <path
                  class="cls-1"
                  d="M1509.55,2050.26c-4.46,1.99-11.18,2.51-11.03,8.84,4.74,0,9.43.15,14.08-.23-.88-2.91-1.88-5.77-3.05-8.62Z"
                />
                <path
                  class="cls-1"
                  d="M2680.35,1664.29c-8.42,1.6,3.95,15.38,6.78,6.56,3.68-4.39-2.83-9.9-6.78-6.56Z"
                />
                <path
                  class="cls-1"
                  d="M1681.14,1960.84c3.16,1.96,6.36,3.84,9.59,5.58,2.38,4.2,4.6,8.42,6.85,12.65,2.01-.57,5.38-1.53,8.27-2.36.98-2.42,2.1-4.79,3.34-7.1-7.73-6.72-17.77-11.08-28.05-8.77Z"
                />
                <path
                  class="cls-1"
                  d="M1482.02,2058.38c.37,4.62,2.4,5.5,6.09,2.69-.39-4.58-2.42-5.46-6.09-2.69Z"
                />
                <path
                  class="cls-1"
                  d="M1016.06,2197.6c-3.98-.45-6.9,7.09-1.72,7.29,4.22.57,7.32-7.23,1.72-7.29Z"
                />
                <path
                  class="cls-1"
                  d="M3651.63,1308.24c.5,1.52,1.47,4.5,1.99,6.01-2.53,2.24-5.06,4.48-7.59,6.71-1.98,4.14-4.19,8.16-6.33,12.22-3.16-.72-6.35-1.42-9.54-2.13,3.66,5.33,5.46,17.04,14.34,13.03-3.21-7.76,5.99-13.05,1.86-20.57,4.28-2.14,8.5-4.35,12.69-6.63-2.45-2.86-4.91-5.76-7.42-8.64Z"
                />
                <path
                  class="cls-1"
                  d="M3466.41,1401.31c1.81-.73,5.4-2.2,7.2-2.96,4.17-12.15-11.98-3.95-7.2,2.96Z"
                />
                <path
                  class="cls-1"
                  d="M967.85,2188.1c-11.68,1.49-16.67,14.01-26.73,18.91.89,2.43,2.64,7.27,3.54,9.7,9.79-7.4,23.5-14.5,23.2-28.61Z"
                />
                <path
                  class="cls-1"
                  d="M1278.81,2085.85c-6.38,3.12.03,11.52,5.14,7.5,5.69-3.07-.14-11.45-5.14-7.5Z"
                />
                <path
                  class="cls-1"
                  d="M3631.19,1308.03c-6.8-5.38-14.02-10.31-22.09-13.73.97,11.11,3.26,23.37-2.95,33.5,1.71.62,5.11,1.86,6.83,2.48-.17-1.15-.52-3.46-.7-4.61,6.44-.35,12.83-.46,19.24-.36-.86-5.74-.46-11.51-.33-17.27Z"
                />
                <path
                  class="cls-1"
                  d="M1673.02,1963.99c7.93-1.75-.1-11.03-4.46-12.12-1.14,3.4-1.84,15.46,4.46,12.12Z"
                />
                <path
                  class="cls-1"
                  d="M3059.88,1498.48c.15,4.79,2.12,5.96,5.97,3.56-.17-4.65-2.14-5.82-5.97-3.56Z"
                />
                <path
                  class="cls-1"
                  d="M2111.07,1814.35c3.36-6.27,5.75-13.07,7.55-19.91-1.22-6.32-4.59-12.01-7.03-17.94-8.76-1.61-16.96.76-24.87,4.55-3.8-1.11-7.64-2.11-11.47-3.14l5.81,17.78c1.46,4.47,1.97,8.94,1.76,13.27.79,2.55,1.97,4.95,3.89,7.04,2.31-.85,6.92-2.59,9.26-3.46,4.63,1.51,11.02,7.29,15.11,1.79Z"
                />
                <path
                  class="cls-1"
                  d="M1923.59,1867.95c1.07-.14,2.01-.42,2.88-.76,1.01-3.75,2.33-7.42,3.94-10.97-.11-.23-.16-.45-.29-.68-6.21,1.46-6.32,7.21-6.53,12.42Z"
                />
                <path
                  class="cls-1"
                  d="M2688.04,1608.47c-3.11,3.67-2.37,5.71,2.24,6.13,3-3.57,2.26-5.65-2.24-6.13Z"
                />
                <path
                  class="cls-1"
                  d="M2930,1520.74c-.22,5.41,5.86,6.52,9.89,4.97,2.71-6.73-5.85-10.29-9.89-4.97Z"
                />
                <path
                  class="cls-1"
                  d="M1644.23,1939.31c2.37,3.26,4.79,6.44,7.24,9.6,2.53-2.74,6.22-8.85,1.08-11.31-2.97-1.89-5.69.58-8.32,1.71Z"
                />
                <path
                  class="cls-1"
                  d="M3566.8,1274.59c-1,5.67-2.17,11.36-2.39,17.18-2.22,1.13-4.51,2.25-6.81,3.33l-.85-7.25c-5.46.47-14.79,3.28-11.16,10.8,2.46,7.43,10.8,2.39,16.02,2.03-1.39,9.03,9.71,9.17,15.51,11.17,7.13-13.05-.93-27.76-10.32-37.27Z"
                />
                <path
                  class="cls-1"
                  d="M2769.15,1574.06c-1.78-13.7-24.01-15.16-30.59-4.84,5.36,3.86,11.83,3.8,17.88,2.06,4.27,1.03,8.5,1.93,12.71,2.78Z"
                />
                <path
                  class="cls-1"
                  d="M2947.01,1503.46c2.53-3.78-3.39-10.79-6.66-6.09-2.41,3.74,3.34,10.34,6.66,6.09Z"
                />
                <path
                  class="cls-1"
                  d="M3535.43,1277.97c-.16-6.37-2.45-13.99,2.72-19.07,5.92-6.47,11.81-14.38,8.12-23.63,2.63-2.14,5.25-4.3,7.85-6.43-6.2-11.26-4.81-24.01-8.38-35.85-5.42,8.42-11.94,16.03-18.43,23.66,2.35,4.01,4.38,8.15,6.05,12.45-2.56,7.01-4.55,15.25-10.57,20.01-.75-.87-1.53-1.69-2.31-2.47-.59-1.19-1.77-3.56-2.36-4.74,8.67-3.5,4.03-14.12,6.09-21.18-2.29.21-6.86.62-9.15.8-5.06,8.91-11.02,17.51-19.91,22.94-5.23,3.02-7.75,9.12-7.97,14.91,3.69,2.02,7.53,3.83,11.1,6.29.71-2.65,1.48-5.26,2.33-7.89,3.31-4.68,6.47-9.44,10.08-13.91,2.4.66,4.81,1.35,7.28,2.13-.37,4.11.47,7.92,1.96,11.52.09,3.25.08,6.49-1.09,9.51-4.12,5.82-8.88,11.2-13.62,16.55-2.92-.29-8.78-.93-11.66-1.23-2.82,1.88-4.6,5.82-7.64,7.32-2.15-3-4.22-6.05-6.11-9.22,2.35-.73,7.01-2.12,9.32-2.84-2.79-.84-5.56-.97-8.3-.42-1.45-4.13-5.19-5.1-8.94-5.75,1.04,1.24,3.15,3.68,4.21,4.88-.32,2.93-.45,6.03,1.19,8.69-1.1,2.02-1.39,4.05-1.18,6.06-2.47.46-4.38,1.59-4.03,4.89.28,5.89-1.87,13.22,3.7,17.31,2.4,2.71,1.66,6.82,2.56,10.12,14.88-1.56,25.16-12.21,35.19-22.04,5.56-.58,10.61,5.15,15.94,4.92,1.64,1.76,4.43,2.46,6.21.18,1.5-2.08.49-4.54-1.26-5.91-2.37-6.11-4.79-12.2-6.96-18.4,2.02-1.03,5.97-3.13,7.96-4.14Z"
                />
                <path
                  class="cls-1"
                  d="M2768.35,1554.72c2.91-4.18-3.95-11.28-7.51-6.52-2.57,4.27,3.9,11.23,7.51,6.52Z"
                />
                <path
                  class="cls-1"
                  d="M2193.42,1736.28c0,5.07,2.35,6.06,7.01,2.95.12-5.18-2.22-6.17-7.01-2.95Z"
                />
                <path
                  class="cls-1"
                  d="M1432.42,1973.26c-2.18,1.86-4.47,3.71-6.78,5.58-4.11-2.59-8.41-5.05-12.95-7.03-.73,3.04-1.56,6.06-2.43,9.08.3.1.61.2.91.31,1.44-.9,3.29-2.06,4.34-2.71,1.27,2.07,2.5,4.14,3.74,6.22,1.66.84,3.28,1.76,4.86,2.73,4.62-.4,9.23-.6,13.83-.67-1.8-4.49-3.67-8.99-5.51-13.49Z"
                />
                <path
                  class="cls-1"
                  d="M3025.48,1455.83c-7.77-.12-15.06,3.6-17.75,11.21,7.36,1.23,20.47-1.44,17.75-11.21Z"
                />
                <path
                  class="cls-1"
                  d="M3029.98,1456.75c5.3.89,12.3.09,13.15-6.38-5.21-6.6-11.54.91-13.15,6.38Z"
                />
                <path
                  class="cls-1"
                  d="M3039.84,1441.12c-2.24,5.2,6.49,6.89,7.94,2.18,2.51-5.39-6.45-7-7.94-2.18Z"
                />
                <path
                  class="cls-1"
                  d="M4033.47,1112.03c.45-3.65.75-7.31.24-10.99-1.88,2.26-3.74,4.62-5.38,7.1,1.83,1.14,3.55,2.44,5.13,3.89Z"
                />
                <path
                  class="cls-1"
                  d="M3452.65,1289.23c-7.54,3.47-15.46,4.34-23.69,3.83,6.19,5.17,13.82,8.77,22.04,6.45,2.91,3.35,6.03,6.54,10.5,7.56.01-6.56-1.49-16.29-8.85-17.85Z"
                />
                <path
                  class="cls-1"
                  d="M3088.73,1418.31c-2.61,4.05,4.15,9.3,7.1,5.18,2.92-4.15-4.1-9.59-7.1-5.18Z"
                />
                <path
                  class="cls-1"
                  d="M1397.98,1966.92c-.5,5.37,3.87,7.44,7.99,9.33.83-2.09,2.53-6.27,3.37-8.33-3.42-1.3-7.99-5.02-11.35-1Z"
                />
                <path
                  class="cls-1"
                  d="M1725.22,1866.65c-1.42-4.24-5.7-6.54-8.6-9.76-3.45,4.56-7.91,7.99-12.82,10.98,5.82,7.31,15.87,5.27,21.42-1.21Z"
                />
                <path
                  class="cls-1"
                  d="M1327.81,1986.53c-.02,5.08,4.78,5.9,8.44,4.03.88-.69,2.69-2.06,3.6-2.76.26-7.65-8.49-4.69-12.05-1.28Z"
                />
                <path
                  class="cls-1"
                  d="M3363.56,1325.13c-.04-1.67-.17-4.95-.2-6.59-6.13.28-10.88,2.91-12.68,8.95.69.03,1.37.05,2.06.06-2.78,1.32-4.68,4.49-.54,7.75,1.45-.51,4.3-1.54,5.75-2.05,1.32-3.33.68-5.17-.69-5.93,2.2-.3,4.33-.93,6.3-2.19Z"
                />
                <path
                  class="cls-1"
                  d="M3393.34,1304.12c-7.59,2.38-15.33,4.1-23.4,3.27,1.98,4.33,4.43,8.33,7.41,12,6.96-3.48,13.8-7.16,20.35-11.28-1.06-1-3.27-3-4.36-3.99Z"
                />
                <path
                  class="cls-1"
                  d="M1342.99,1973.15s0,0,0,0c.13-.92.06-1.95-.33-3.14-5.11-6.8-13.61-4.1-19.39.01,2.05,4.21,4.17,8.45,6.29,12.67,3.65-2.62,10.86-3.87,12.93-7.92-.91,3.5-.56,7,3.34,9.2,3.54-1.96,5.52-5.45,7.41-8.93-3.48-.36-6.9-1-10.25-1.89Z"
                />
                <path
                  class="cls-1"
                  d="M3423.12,1296.99c3.95-8.92-9.17-6.89-11.45-.67,1.86,4.57,9.24,5.35,11.45.67Z"
                />
                <path
                  class="cls-1"
                  d="M2119.89,1711.81c-7.64-1.47-11.75,6.22-12.46,12.6,3.41,1.38,6.51,1,9.3-1.05,2.88-2.82,7.81-8.2,3.15-11.55Z"
                />
                <path
                  class="cls-1"
                  d="M3301.67,1327.69c-5.14.2-9.83,2.23-13.99,5.14,4.23,8.03,14.69,3.2,13.99-5.14Z"
                />
                <path
                  class="cls-1"
                  d="M2290.52,1653.65c-2.87,3.36-1.94,8.16-2.89,12.14,2.09-.62,4.14-1.34,6.17-2.11,3.2-2.38,6.98-4.36,11.43-5.82.55-.18,1.08-.29,1.63-.44.49-.28.99-.54,1.47-.83-5.73-1.79-11.69-3.38-17.8-2.93Z"
                />
                <path
                  class="cls-1"
                  d="M3926.25,1121.53c.36,5.43,2.67,6.63,6.94,3.65-.26-5.43-2.58-6.66-6.94-3.65Z"
                />
                <path
                  class="cls-1"
                  d="M3320.8,1317.92c-.2-5.65-2.43-6.94-6.7-3.83.31,5.48,2.54,6.77,6.7,3.83Z"
                />
                <path
                  class="cls-1"
                  d="M1096.06,2043.22c4.36-1.69,1-8.36-3.02-7.28-4.71,1.44-1.09,8.83,3.02,7.28Z"
                />
                <path
                  class="cls-1"
                  d="M2126.38,1694.93c-2.74-7.78-12.53,2.61-18.15,2.36,1.8,1.4,5.44,4.21,7.24,5.6l.42-6.53c4.3,1.32,13.53,8.19,10.49-1.44Z"
                />
                <path
                  class="cls-1"
                  d="M2070.38,1710.59c-1.35.76-2.73,1.38-4.14,1.96.44,1.95.67,3.89.79,5.81,5.34-2.49,12.25-.06,16.61-4.74-3.54-3.32-8.67-6.78-13.26-3.03Z"
                />
                <path
                  class="cls-1"
                  d="M3901.46,1105.01c2.18.9,9.72,8.26,10.27,1.79,1.59-4.49-3.13-6.91-5.59-9.71-1.59,2.64-3.13,5.26-4.68,7.91Z"
                />
                <path
                  class="cls-1"
                  d="M3562.76,1205.39c-.27-5.56-2.54-6.87-6.88-3.97.37,5.46,2.66,6.8,6.88,3.97Z"
                />
                <path
                  class="cls-1"
                  d="M3924.26,1076.6c3.14,2.61,6.47,8.07,11.17,4.66-1.97-3.46-3.53-7.12-4.65-10.95-2.14,2.11-4.31,4.2-6.52,6.3Z"
                />
                <path
                  class="cls-1"
                  d="M3918.34,1084.64c-1.21-5.05-8.77-7.93-12.6-3.69-1.69,7.17,9.5,9.03,12.6,3.69Z"
                />
                <path
                  class="cls-1"
                  d="M2743.86,1451.89c-.75,4.08-1.49,8.22-2.2,12.31,4.41-1.64,8.78-3.37,13.05-5.34-2.83-3.41-6.58-5.75-10.85-6.98Z"
                />
                <path
                  class="cls-1"
                  d="M584.99,2167.29c-2.16-2.49-6.45-7.41-8.6-9.87.6,0,1.21,0,1.81-.01-1.31-2.34-2.41-4.79-3.27-7.34-3.17,1.8-6.31,3.66-9.46,5.51.22.97.69,2.93.9,3.91,1.56-1.82,4.61-5.44,6.14-7.25,1.59,4.56,2.98,9.14,4.25,13.74,2.86.41,5.51.82,8.23,1.31Z"
                />
                <path
                  class="cls-1"
                  d="M199.87,2290.35c-2.16-3.93-9.91-1.54-8.68,3.17,1.99,4.66,10.55,1.73,8.68-3.17Z"
                />
                <path
                  class="cls-1"
                  d="M1193.21,1956.55c-2.54,4.26,4.7,8.85,7.44,4.77,2.84-4.39-4.54-9.07-7.44-4.77Z"
                />
                <path
                  class="cls-1"
                  d="M173.33,2292.42c.06,5.63,2.17,6.85,6.37,3.67.04-5.63-2.07-6.85-6.37-3.67Z"
                />
                <path
                  class="cls-1"
                  d="M921.64,2043.15c-3.16,3.49-2.58,5.68,1.76,6.52,3.27-3.49,2.69-5.65-1.76-6.52Z"
                />
                <path
                  class="cls-1"
                  d="M153.31,2295.16c-.12-5.1-2.51-6.14-7.16-3.08.16,5.23,2.55,6.26,7.16,3.08Z"
                />
                <path
                  class="cls-1"
                  d="M3896.6,1029.96c-1.32,8.1-1.74,16.3-1.95,24.5,5.42,3.54,10.26,7.84,15.38,11.79.28-13.24-8.94-24.31-13.43-36.29Z"
                />
                <path
                  class="cls-1"
                  d="M979.59,2014.31c-7.28-.99-8.17-4.83-4.35-10.24-1.45.91-4.31,2.75-5.75,3.69.79.99,2.37,3.03,3.14,4.05-1.63,1.4-4.86,4.17-6.48,5.58,4.31,5.69,11.67,3.42,13.45-3.08Z"
                />
                <path
                  class="cls-1"
                  d="M2744.98,1426.48c-2.76,4.1,4.18,9.19,7.18,5.22,2.88-4.17-4.11-9.41-7.18-5.22Z"
                />
                <path
                  class="cls-1"
                  d="M2071.81,1655.13c.56-1.16,1.68-3.51,2.23-4.7-5.14-10.09-13.25,9.57-2.23,4.7Z"
                />
                <path
                  class="cls-1"
                  d="M1039.67,1989.42c-.18-.52-.37-1.04-.55-1.56-3.09-.45-6.18-.92-9.29-1.4-1.46,1.52-2.21,3.52-1.4,6.49,3.87-1.13,7.51-2.32,11.25-3.54Z"
                />
                <path
                  class="cls-1"
                  d="M1007.45,2002.63c1.38-4.62-5.88-5.14-7.41-1.58-2.4,5.02,6.4,6.01,7.41,1.58Z"
                />
                <path
                  class="cls-1"
                  d="M918.82,2025.11c-.11.54-.16,1.04-.17,1.49-3.51,1.23-7.75,3.75-10.31,4.45.31-.94.62-1.88.91-2.81-3.15.96-6.38,1.98-9.68,2.99,3.34,3.11,5.69,6.92,6.61,11.39,1.33.17,3.96.49,5.28.63-1.22-1.69-3.71-5.08-4.97-6.78.5-1.39.99-2.79,1.45-4.19.49,9.4,11.57,1.87,16.46-1.02.06-.32.1-.62.13-.91,1.95-.43,3.98-1.44,5.4-2.7,1.04-8.88-6.69-6.19-11.11-2.52Z"
                />
                <path
                  class="cls-1"
                  d="M2203.97,1599.72c.89-2.41,2.67-7.26,3.6-9.68-4.79-3.85-10.58-4.31-15.89-1.1,1.78,5.97,6.91,8.8,12.29,10.78Z"
                />
                <path
                  class="cls-1"
                  d="M3385.33,1199.14c-5.66-1.48-5.22,7.59-10.01,9.08.34.73,1.01,2.16,1.32,2.9,2.43-4.59,7.17-5.53,11.97-5.96-.83-1.51-2.45-4.51-3.28-6.02Z"
                />
                <path
                  class="cls-1"
                  d="M3566.97,1146.3c.87-6-.8-11.4-5.96-14.96-4.66,6.12-1.92,13.67,5.96,14.96Z"
                />
                <path
                  class="cls-1"
                  d="M3334.79,1218.86c.13-5.69-1.98-6.88-6.24-3.58-.04,5.66,2.04,6.86,6.24,3.58Z"
                />
                <path
                  class="cls-1"
                  d="M3968.08,1004.17c-.25,5.53,1.92,6.7,6.45,3.58.19-5.41-1.95-6.59-6.45-3.58Z"
                />
                <path
                  class="cls-1"
                  d="M3688.58,1088.42c0,3.16-2.82,5.36-4.33,7.94,3.7-2.15,7.56-4.01,11.58-5.39-.73-.6-2.18-1.74-2.92-2.34-1.57-4.09.1-7.33,4.93-9.71-4.83-.91-9.74-1.63-14.72-1.45-1.64,4.97,2.87,7.67,5.46,10.96Z"
                />
                <path
                  class="cls-1"
                  d="M3646.22,1098.58c-.23,4.14.26,8.32,3.05,11.61,1.3-3.42,2.65-6.81,3.92-10.22-2.31-.49-4.64-.94-6.97-1.39Z"
                />
                <path
                  class="cls-1"
                  d="M1259.75,1879.57c10.96.22,17.11-9.89,16.63-19.78,6.82-3.5,13.95-6.37,21.02-9.25.16-1.57.52-4.68.7-6.21,7.88-4.59,16.08-10.36,14.45-20.72,1.83-.87,5.53-2.61,7.4-3.49.2-1.85.69-5.5.89-7.35-5.24.94-12.83,2.41-11.66,9.89-11.32,3.02-15.28,15.61-25.7,20.12-9.43,11.38-16.32,25.06-28.12,34.32-2.27,5.31-1.33,10.65,1.47,15.62,1.24-4.34,2.09-8.75,2.93-13.16Z"
                />
                <path
                  class="cls-1"
                  d="M1248.94,1889.62c-3.69-6.46-10.2-.27-13.98,2.68,5.07,4.63,11.7,4.85,13.98-2.68Z"
                />
                <path
                  class="cls-1"
                  d="M837.46,2013.16c6.82,4.75,20.15-1.92,17.07-10.13-7.11.37-13.3,4.24-18.9,8.42.02.02.04.03.05.05.62.53,1.2,1.09,1.78,1.65Z"
                />
                <path
                  class="cls-1"
                  d="M3738.99,1055.93c-7.96.85-13.15,8.63-21.29,8.29l1.01,2.69c5.03-1.47,9.35,1.35,13.67,3.27-7.09-7.7,3.23-9.05,6.61-14.26Z"
                />
                <path
                  class="cls-1"
                  d="M3365.6,1182.25c2.93-1.22,6.58-6.21,2.98-8.67-5.3-2.74-9.55,9.27-2.98,8.67Z"
                />
                <path
                  class="cls-1"
                  d="M3998.02,943.71c-.41-.95-.8-1.9-1.12-2.89-.36-1.11-.74-2.22-1.1-3.33-1.34.48-2.64.94-3.53,1.24-.57,4.86-1.24,9.68-1.99,14.5-1.77.55-5.31,1.66-7.08,2.21,1.11,4.54.23,12.33,6.79,11.83-.75-8.89,4.69-15.85,8.03-23.57Z"
                />
                <path
                  class="cls-1"
                  d="M3369.78,1169.42c6.96-4.93,15.05-7.74,23.16-10.18-.82-1.38-2.47-4.17-3.3-5.58,5.4-2.5,10.74-5.29,14.51-10.12l1.13,6.05c1.2-5.6,2.24-11.25,2.93-16.96-7.6,6.48-13.76,14.68-23.22,18.67-1.76,9.01-14.17,9.73-15.23,18.11Z"
                />
                <path
                  class="cls-1"
                  d="M3735.47,1036.81c-.14,4.01-.04,8.01.25,11.99,4.31-1.31,8.47-3,12.41-5.13-1.1-6.06-8.18-5.09-12.66-6.86Z"
                />
                <path
                  class="cls-1"
                  d="M3540.67,1056.06c-11.89,11.04-6.81,28.47-12.9,41.93,4.45,4.87,8.84,9.79,13.17,14.8-.7-19.44-.45-39.79,8.67-57.48-2.22.19-6.7.58-8.93.76Z"
                />
                <path
                  class="cls-1"
                  d="M1444.42,1792.13c-4.84-3.6-11.17-6-17.05-3.21,4.91,2.06,13.72,10.62,17.05,3.21Z"
                />
                <path
                  class="cls-1"
                  d="M487.85,2104.91c-1.44-.71-4.3-2.16-5.71-2.87-2.34,1.27-4.74,2.56-7.18,3.86.03,1.54.11,4.67.14,6.21,5.31-.62,9.84-2.71,12.75-7.19Z"
                />
                <path
                  class="cls-1"
                  d="M3321.37,1165.8c1.68,5.77,3.1,12.8,10.78,12.11-2.71-4.8-2.9-14.04-10.78-12.11Z"
                />
                <path
                  class="cls-1"
                  d="M1516.96,1767.44c2.99-3.4-2.59-9.58-5.45-4.95-2.48,3.33,2.63,9.19,5.45,4.95Z"
                />
                <path
                  class="cls-1"
                  d="M3714.26,1028.98c-.23-.81-.39-1.77-.57-2.76-2.97,1.98-5.9,4.02-8.8,6.11.03,1.02.06,2.04.03,3.03-1.72.53-4.68,1.48-7.02,2.22-.79.61-1.56,1.24-2.34,1.86-.83,5.42,5.23,6.24,8.57,1.76.77.62,2.26,1.88,3.01,2.51-.69-1.09-2.1-3.25-2.8-4.36,3.76-2.91,9.56-4.8,9.93-10.37Z"
                />
                <path
                  class="cls-1"
                  d="M833.41,1972.62c.13,5.64,2.24,6.87,6.36,3.74,0-5.75-2.11-6.98-6.36-3.74Z"
                />
                <path
                  class="cls-1"
                  d="M1823.51,1645.16c1.5,7.88,10.52,2.78,13.29-1.31-3.54-5.4-10.33-3.95-13.29,1.31Z"
                />
                <path
                  class="cls-1"
                  d="M1892.81,1615.07c8.69,2.94,13.05-9.44,18.47-14.47-7.41,1.61-25.19,3.45-18.47,14.47Z"
                />
                <path
                  class="cls-1"
                  d="M1790.81,1646.22c.31,5.38,2.64,6.64,7,3.73-.22-5.41-2.57-6.62-7-3.73Z"
                />
                <path
                  class="cls-1"
                  d="M883.24,1938.59c-.14-.36-.29-.71-.43-1.07-.34-.91-.64-1.82-.94-2.73-2.86-1.32-6.04-2.13-9.05-2.6-2.74,2.11-10.82,2.89-7.32,7.97,5.24,2.81,10.98,4.15,16.8,4.52.13-2.07.47-4.09.93-6.09Z"
                />
                <path
                  class="cls-1"
                  d="M1758.93,1653.7c4.51-.5,9.22-1.2,12.3-4.85-.61-6.82-6.94-3.65-11.45-3.25-.21,2.02-.63,6.09-.85,8.11Z"
                />
                <path
                  class="cls-1"
                  d="M124.46,2190.09c.02-5.28-2.22-6.4-6.72-3.29.02,5.41,2.26,6.52,6.72,3.29Z"
                />
                <path
                  class="cls-1"
                  d="M4060.53,881.46c3.73,8.53,16.63,3.58,11.91-4.9-4.37.42-8.11,2.85-11.91,4.9Z"
                />
                <path
                  class="cls-1"
                  d="M1696.48,1642.18c-5.38-4.33-11.2-.85-15.43,3.39,3.11,1.4,6.24,2.74,9.31,4.02,1.52-1.84,4.6-5.57,6.12-7.41Z"
                />
                <path
                  class="cls-1"
                  d="M1451.02,1721.23c-4.5-3.17-8.44,1.65-12.39,3.34,2.09,7.85,14.73,4.03,12.39-3.34Z"
                />
                <path
                  class="cls-1"
                  d="M3371.12,1091.57c-1.07-1-3.17-3.03-4.24-4.03-2.12,1.23-6.35,3.72-8.47,4.95,1.53,2.02,3.03,4.02,4.49,6.03,2.07-3.13,4.84-5.45,8.22-6.95Z"
                />
                <path
                  class="cls-1"
                  d="M3387.39,1076.75c7.2-1.74,19.81-8.21,16.75-17.06-4.55,6.26-11.02,10.22-17.66,13.97-3.37-2.7-6.66-.31-9.94,1.16.86,2.44,2.57,7.36,3.45,9.83,2.5-2.63,4.94-5.24,7.41-7.9Z"
                />
                <path
                  class="cls-1"
                  d="M3375.34,1081.73c-3.84-3.62-6.38-2.76-7.6,2.58,3.8,3.5,6.34,2.64,7.6-2.58Z"
                />
                <path
                  class="cls-1"
                  d="M1679.05,1633.99c6.48-3.02,14.67-5.33,16.78-13.07-7.3,1.84-14.87,5.02-16.78,13.07Z"
                />
                <path
                  class="cls-1"
                  d="M3426.71,1044.13c-2.76-1.68-5.18-3.65-7.28-5.84-.09.02-.18.05-.26.07-.29-.73-.66-1.45-1.1-2.17-1.47.95-4.4,2.78-5.88,3.7l-1.81-3.48-.97.62c.43,1.45.86,2.91,1.28,4.38-.52.33-1.01.68-1.45,1.1-.42,6.53-1.04,13.08-1.61,19.58,3.39-2.53,6.51-5.4,9.31-8.58,0,.16.01.32.02.46.21-.39.41-.78.61-1.17,1.07-1.26,2.1-2.57,3.06-3.92,2.55,1.12,5.11,2.27,7.6,3.4,1.22-3.26.39-5.95-1.5-8.14Z"
                />
                <path
                  class="cls-1"
                  d="M3386.78,1060.78c4.95-.17,10.6.34,13.78-4.43-1.37-10.07-13.34-2.37-13.78,4.43Z"
                />
                <path
                  class="cls-1"
                  d="M3346.81,1079.41c1.3-4.26,2.56-8.53,3.34-12.92-4.31.3-9,.95-12.09,4.35-1.73,5.91,4.69,7.48,8.75,8.57Z"
                />
                <path
                  class="cls-1"
                  d="M1064.52,1821.58c1.32-1.51,2.54-3.02,3.74-4.51-.76-1-2.27-2.92-3.06-3.91-2.16.6-6.44,1.8-8.59,2.4,3.17,1.38,5.81,3.38,7.92,6.02Z"
                />
                <path
                  class="cls-1"
                  d="M141.13,2115.13c-4.18,1.4-2.06,9.34,2.35,7.81,3.87-1.73,1.98-8.75-2.35-7.81Z"
                />
                <path
                  class="cls-1"
                  d="M2914.72,1203.85c-2.63,5.63,6.77,6.93,7.76,1.74,2.05-5.34-6.41-6.35-7.76-1.74Z"
                />
                <path
                  class="cls-1"
                  d="M4146,805.25c-1.33-5.41-1.84-11-1.85-16.57-1.84-2.76-3.77-5.46-5.69-8.16-.94,8.44.42,19.32,7.54,24.73Z"
                />
                <path
                  class="cls-1"
                  d="M2710.64,1263.35c-1.76.39-3.52.69-5.27.93-2.05,3.25-3.92,6.61-4.54,10.49,4.68-2.03,9.12-4.39,13.43-7.04-1.2-1.46-2.42-2.92-3.63-4.38Z"
                />
                <path
                  class="cls-1"
                  d="M1084.08,1798.42c1.17-4.55-.53-6.55-4.99-6.03-.96,4.58.73,6.55,4.99,6.03Z"
                />
                <path
                  class="cls-1"
                  d="M1116.59,1765.89c-1.62-1.81-3.29-3.62-4.96-5.44-1.58-.44-3.16-.89-4.74-1.34-5.66,4.02-1.38,13.37-9.53,15.85.64-1.75,1.91-5.26,2.58-7.03-5.26-7.46-13.88-4.21-19.01,1.5-1.58-.42-4.81-1.25-6.39-1.65-2.62,5.87-5.59,11.61-8.64,17.31,5-2.91,10.03-5.83,15.53-7.52-5.29,3.78-10.16,8.02-8.29,15.48,8.94-2.38,10.06-13.27,19.24-15.09,5.37,3.68,10.85,7.2,16.34,10.68,2.67-2.76,5.35-5.5,8.09-8.21.24-.58.51-1.16.75-1.74-.96-1.81-2.89-5.45-3.81-7.26.69-1.4,2.11-4.15,2.83-5.53Z"
                />
                <path
                  class="cls-1"
                  d="M1051.92,1788.85c-1.7-1.19-5.08-3.62-6.75-4.82-2.24,2.82-3.24,5.93-3.03,9.36,5.27,1.31,10.71.77,15.99,1.1.45-1.39,1.36-4.18,1.82-5.54-2.64-.05-5.29-.05-8.03-.1Z"
                />
                <path
                  class="cls-1"
                  d="M2919.06,1183.14c2.28-5.68-7.19-7.91-8.75-2.49-2.04,5.61,7.26,7.92,8.75,2.49Z"
                />
                <path
                  class="cls-1"
                  d="M3524.61,960.49c-1.64.74-4.98,2.16-6.63,2.87.05-4.69,1.62-13.17-6.05-10.5.52,1.71,1.51,5.15,2.01,6.87-11.98-5.8-9.55,8.93-12.43,15.99,8.13-1.88,15.13,3.2,17.37,10.9,5.16-2.32,10.28-4.66,15.46-6.9-4.86-5.71-11.27-10.74-9.74-19.24ZM3519.11,970.02c-3.69,2.58-5.74,1.57-6.12-3.01,3.81-2.65,5.85-1.64,6.12,3.01Z"
                />
                <path
                  class="cls-1"
                  d="M2577.87,1291.05c5.19-2.84-.47-9.46-4.58-5.8-5.49,2.84.56,9.97,4.58,5.8Z"
                />
                <path
                  class="cls-1"
                  d="M846.4,1847.13c1.18,4.22,7.69,5.52,10.57,2.53,1.65-5.45-10.23-9.1-10.57-2.53Z"
                />
                <path
                  class="cls-1"
                  d="M4135.62,755.43c-3.93,3.4-.28,9.34,1.71,12.85,4.26-1.26,5-13.93-1.71-12.85Z"
                />
                <path
                  class="cls-1"
                  d="M222.11,2019.69c-12.47,7.83-21.63,20.64-24.92,35.06.99-.05,2.94-.15,3.91-.17,7.63-12.14,18.25-22.76,31.81-27.96-3.54-2.31-7.19-4.61-10.8-6.93Z"
                />
                <path
                  class="cls-1"
                  d="M456.65,1957.11c-1-6.06-6.65-4.52-11.01-3.77.38,4.75.71,9.48,1.38,14.21,5.53,1.69,14.71-4.16,9.63-10.44Z"
                />
                <path
                  class="cls-1"
                  d="M4076.19,771.17c3.19-4.03-3.78-9.72-6.88-5.42-2.5,3.98,3.67,9.59,6.88,5.42Z"
                />
                <path
                  class="cls-1"
                  d="M3549.87,943.57c.45-4.92-1.2-5.83-4.92-2.73-.44,5.05,1.21,5.96,4.92,2.73Z"
                />
                <path
                  class="cls-1"
                  d="M1269.27,1656.46c-3.93,3.15.72,10-3.16,12.1,1.57-.01,3.15.03,4.72.13-.47-4.07-1-8.14-1.57-12.23Z"
                />
                <path
                  class="cls-1"
                  d="M468.48,1933.32c3.44,4.66,12.91-.52,9.33-5.7-3.49-4-11.73.63-9.33,5.7Z"
                />
                <path
                  class="cls-1"
                  d="M1593.62,1544.87c-1.38-.02-4.16-.09-5.55-.11.45.96,1.35,2.89,1.79,3.85-.34,4.62.65,9.2,2.51,13.36.99-.89,3.01-2.63,3.99-3.52-.84-4.53-1.75-9.08-2.76-13.59Z"
                />
                <path
                  class="cls-1"
                  d="M3530,916.28c4.24,5.57,11.09,5.05,17.18,4.95-3.72-6.05-10.65-7.28-17.18-4.95Z"
                />
                <path
                  class="cls-1"
                  d="M1274.24,1637.7l-4.39-13.45c-6.83-2.49-13.69-4.96-18.34-11.07-1.97.68-5.91,2.07-7.87,2.77-5.63-14.16-24.54-7.72-31.6-19.87-5.11-5.76-13.93-5.2-20.79-7.77-.45,1.09-1.34,3.3-1.8,4.38,1.79.63,5.34,1.85,7.12,2.45,4.21,8.27,13.08,10.42,21.51,11.63,8.42,3.97,12.79,14.99,23.71,12.7,2.61,6.98,9.42,9.6,15.83,11.94l-4.26,4.45c1.91-1.36,3.77-2.78,5.55-4.2,5.86.67,10.78,3.01,15.31,6.03Z"
                />
                <path
                  class="cls-1"
                  d="M3615.66,887.48c-8.72-5.39-14.78,4.25-11.6,11.92,5.27-2.49,9.04-6.81,11.6-11.92Z"
                />
                <path
                  class="cls-1"
                  d="M3411.29,959.77c5.46-2.83,11.27-5.53,14.22-11.23-6.13.89-12.28,1.82-18.54,1.08,1.14,3.49,2.62,6.91,4.32,10.15Z"
                />
                <path
                  class="cls-1"
                  d="M3636.1,874.29c-4.01-1.38-8.07-2.78-12.14-4.14.66,1.8,1.95,5.45,2.6,7.25-5.86.37-10.94,2.33-12.13,8.67,9.26,1.48,15.45-6.42,21.67-11.78Z"
                />
                <path
                  class="cls-1"
                  d="M2775.58,1152.68c-.57-.62-1.19-1.21-1.8-1.78-1.85,3.7-3.42,7.54-4.95,11.4,3.2-.61,6.36-1.3,9.25-2.75.06-.28.06-.55.08-.82-.92-1.94-1.78-3.93-2.55-5.97,0-.02-.02-.05-.03-.08Z"
                />
                <path
                  class="cls-1"
                  d="M2942.43,1091.44c.27-1.97.73-5.89,1-7.86-8.31-2.29-11.48,9.63-7.55,15.47,5.58-1.96,10.81.57,16.05,1.99,1.13-5.71-6.19-6.52-9.49-9.61Z"
                />
                <path
                  class="cls-1"
                  d="M2919.28,1106.9c-2.39,5.65,7.36,7.82,8.82,2.5,2.4-5.72-7.01-7.56-8.82-2.5Z"
                />
                <path
                  class="cls-1"
                  d="M2594.17,1205.35c-2.2,3.88-4.02,7.87-6.17,11.79,7.18,3.27,9.81-7.13,6.17-11.79Z"
                />
                <path
                  class="cls-1"
                  d="M1600.24,1537.33c.05,5.5,2.19,6.51,6.53,3.01.03-5.46-2.11-6.47-6.53-3.01Z"
                />
                <path
                  class="cls-1"
                  d="M3647.44,868.87l2.4.46c-.53-1.1-1.6-3.35-2.16-4.44,2-.05,5.97-.13,7.97-.18.03-1.25.11-3.77.14-5.02,7.38,1.69,11.71-5,17.05-8.42-3.27-.34-6.49-.64-9.8-.97-4.39,6.54-11.59,9.9-17.32,15-4.37,1.23-8.6-1.33-12.89-2.01,1.63,3.03,3.26,6.06,4.84,9.07,2.44-.86,7.31-2.62,9.75-3.49Z"
                />
                <path
                  class="cls-1"
                  d="M3398.81,940.89c-4.69-.35-8.78,1.72-11.16,5.76-.88,4.32,3.7,6.19,7.06,6.3,3.43-2.87,6.5-7.57,4.1-12.06Z"
                />
                <path
                  class="cls-1"
                  d="M3533.94,894.46c-2.02,3.69,3.47,10.53,6.55,5.66,2.78-3.93-3.57-10.83-6.55-5.66Z"
                />
                <path
                  class="cls-1"
                  d="M1876.98,1434.56c-4.36.55-4.55,8.61.59,7.07,4.47-.52,4.64-8.64-.59-7.07Z"
                />
                <path
                  class="cls-1"
                  d="M30.51,2034.2c-2.43.19-7.25.55-9.66.77,1.51,4.31,2.89,8.74,5.2,12.72,5.44-1.77,6.79-8.87,4.47-13.49Z"
                />
                <path
                  class="cls-1"
                  d="M3734.18,813.02c8.3-3.83,14.95-10.1,22.46-15.11.46-.59.92-1.18,1.38-1.76.56-1.95,1.05-3.91,1.42-5.93-3.8,1.24-7.58,2.41-11.42,3.53.57,1.53,1.72,4.55,2.32,6.07-2.72.32-8.14.91-10.83,1.22-1.17,3-2.33,6.04-3.51,9.01-1.96,1.01-5.83,3.05-7.75,4.07-2.11-.79-6.33-2.4-8.44-3.19.58,2.2,1.75,6.59,2.33,8.79-5.98.84-9.61-2.68-12.27-7.62.04,4.66.59,9.32.97,13.9-2.78-.6-5.6-1.2-8.43-1.82.28,1.49.86,4.49,1.18,5.97-5.42,3.18-18.28,1.77-15.1,11.11-4.66,2.6-9.23,5.7-14.83,5.85.63,1,1.83,3.03,2.43,4.05.89-.66,2.71-1.99,3.6-2.66,20.16-3.22,32.75-21.68,51.3-28.91.81-1.64,2.39-4.92,3.17-6.55Z"
                />
                <path
                  class="cls-1"
                  d="M3424.14,924.78c3.34-9.63-9.97-9.75-15.7-12.56-3.61,1.51-7.18,3.12-10.74,4.78-3.12,5.59-3.27,12.33-4.66,18.46,10.84,2.51,27.49,2.35,31.1-10.69Z"
                />
                <path
                  class="cls-1"
                  d="M4138.52,689.54c2.19-.71,6.55-2.07,8.74-2.79-4.48-7.85-8.95-17.55-18.29-20.52,1.91,5.23,3.84,10.41,5.76,15.6-2.56-1.55-7.68-4.69-10.25-6.27-4.27,10.91,10.2,9.61,10.85,19.25.82-1.31,2.4-3.98,3.19-5.28Z"
                />
                <path
                  class="cls-1"
                  d="M751.82,1789.4c-4.45,2.53,1.27,8.53,4.84,6.39,4.24-2.56-1.38-7.92-4.84-6.39Z"
                />
                <path
                  class="cls-1"
                  d="M3375.04,918.12c-5.95.93-1.3,13.84,4.31,9.08,5.75-2.58,1.32-12.43-4.31-9.08Z"
                />
                <path
                  class="cls-1"
                  d="M1622.59,1496.15c-.07,4.63,1.81,5.56,5.6,2.74.19-4.67-1.69-5.6-5.6-2.74Z"
                />
                <path
                  class="cls-1"
                  d="M353.32,1905.33c-1.36,4.78,6.48,10.99,8.73,4.61,2.15-4.94-5.88-8.43-8.73-4.61Z"
                />
                <path
                  class="cls-1"
                  d="M1953.27,1381.79c4.11,3.94,9.33.89,13.77-.36-1.31-3.91-1.08-9.29-5.4-11.48-6.49-1.34-12.92,5.73-8.37,11.84Z"
                />
                <path
                  class="cls-1"
                  d="M795.07,1724.79c3.37,2.39,6.86,4.54,10.59,6.14,2.29-1.3,4.82-2.42,7.62-3.34.62-.2,1.22-.33,1.83-.5-.27-.67-.56-1.34-.82-2.02,1.28.42,2.48.85,3.73,1.28,1.72-.35,3.39-.56,5.03-.68-.24-3.84-.78-7.67-2.11-11.31-.85,2.43-2.56,7.29-3.42,9.72-2.11-1.53-4.27-3.11-6.47-4.68-4.95,2.56-9.99,4.3-15.19.72,1.35-1.31,4.03-3.94,5.38-5.25-1.58-.42-4.77-1.23-6.35-1.63.44,4.02-1.22,6.35-4.92,6.95-2.35-2.97-4.56-6.14-6.82-9.27,2.72-.82,8.14-2.46,10.86-3.28-1.66-1.58-4.98-4.76-6.64-6.34-3.06-6.9,5.62-19.14-6.32-19.25-8.79,11.76-5.56,26.97-2.01,40.22.35.38.69.77,1.03,1.16.14-2.66.33-6.1.44-8.03,4.64,3.6,8.62,8.18,14.55,9.37Z"
                />
                <path
                  class="cls-1"
                  d="M3414.8,897.11c1.34,1.44,4.04,4.33,5.39,5.8,2.51-.95,7.57-2.87,10.09-3.8-1.04-3.19-2.11-6.37-3.21-9.54-4.56,1.69-8.85,4-12.26,7.53Z"
                />
                <path
                  class="cls-1"
                  d="M3150.78,979.12c3.23,6.81,11.26,4.02,17.11,4.94.08-9.54-12.8-14.71-17.11-4.94Z"
                />
                <path
                  class="cls-1"
                  d="M3137.41,986.85c6.98,4.38,14-.17,11.32-8.17-5.75-.81-9.18,3.5-11.32,8.17Z"
                />
                <path
                  class="cls-1"
                  d="M4100.13,613.42c-11.98.78-23.01,7.67-34.16,11.59,1.95.41,5.87,1.21,7.81,1.58-1.48,1.66-4.41,4.93-5.88,6.59,10.91-2.09,20.96-6.81,30.08-13.02-.03,6.26-.88,12.51-1.55,18.7,8.34,2.39,16.99,3.86,24.64,8.13-5.02,3.79-10.25,4.96-15.63,3.49-1.14,1.65-2.29,3.27-3.49,4.87-3.98.89-6.5,3.36-6.47,7.56,4.87-1.76,9.7-4.07,15.01-2.92,1.57-1.38,4.76-4.17,6.32-5.56-.55,8.62,7.65,8.19,13.75,9.16-1.52-11.57-9.48-20.4-15.7-29.77-1.69-.86-5.12-2.6-6.82-3.49-.39-2.23-.78-4.45-1.22-6.73-1.83-1.88-4.1-3.65-5.38-5.9,1.78-1.32,3.52-2.68,5.22-4.1-2.09-.29-4.14-.33-6.17-.22,0-.06,0-.12.01-.19-.1.06-.23.13-.36.21Z"
                />
                <path
                  class="cls-1"
                  d="M3130.12,985.94c-.24,4.72,1.57,5.74,5.48,3.09.32-4.68-1.49-5.7-5.48-3.09Z"
                />
                <path
                  class="cls-1"
                  d="M3390,887.02c-.85,2.76,2.79,11.83,5.15,5.58,2.2-3.24-3.53-12.46-5.15-5.58Z"
                />
                <path
                  class="cls-1"
                  d="M3387.26,895.82c2.09-4.21-.84-11.73-6.25-11-4.91,2.98,1.59,14.04,6.25,11Z"
                />
                <path
                  class="cls-1"
                  d="M3357.32,902.46c3.6-2.25,7.13-4.51,10.57-6.95,2.73.96,5.35,1.98,8.07,2.78.13-1.96.47-5.87.6-7.83-5.96.16-11.94.4-17.88,1.13-.43,3.63-.89,7.25-1.36,10.86Z"
                />
                <path
                  class="cls-1"
                  d="M521.52,1828.38c3.82-1.78,1.6-8.69-2.56-7.63-4.28,1.5-1.88,9.39,2.56,7.63Z"
                />
                <path
                  class="cls-1"
                  d="M1201.59,1580.5c-2.26,7.9,9.86,9.82,13.99,14.96,2.7.38,5.35.69,8.03,1.02-7.57-3.51-14-8.92-19.06-15.49-.95-.07-1.94-.22-2.97-.49Z"
                />
                <path
                  class="cls-1"
                  d="M792.51,1733.83c-.08-4.58-2.05-5.55-5.91-2.88.11,4.67,2.07,5.61,5.91,2.88Z"
                />
                <path
                  class="cls-1"
                  d="M3462.28,855.43c-.77-2.47-2.3-7.45-3.07-9.92-3.57,2.65-7.17,5.33-10.72,8.04,2.46,1.78,4.91,3.61,7.33,5.37,2.18-1.15,4.32-2.32,6.46-3.49Z"
                />
                <path
                  class="cls-1"
                  d="M873.57,1703.41c-.09-5.52-2.27-6.65-6.56-3.41.15,5.6,2.33,6.73,6.56,3.41Z"
                />
                <path
                  class="cls-1"
                  d="M625.13,1774.35l-6.66,2.58c.71.84,2.18,2.55,2.92,3.38,2.35-1.74,4.66-3.44,6.96-5.13.94-5.75,2.38-11.67.68-17.47-4.45,2.02-9,3.95-13.61,5.79l1,3.07c-2.88,1.17-8.61,3.48-11.49,4.66-.71-1.75-2.06-5.28-2.74-7.07-2.81,4.28-4.08,9.84-8.52,12.93,2.3,1.27,4.5,2.56,6.64,3.85,4.02-6.32,9.04-11.76,16.7-13.32l-1.24,5.98c2.34.18,7.01.57,9.35.75Z"
                />
                <path
                  class="cls-1"
                  d="M3470.44,844.7c-.13-5.44-2.34-6.56-6.64-3.35.08,5.49,2.31,6.57,6.64,3.35Z"
                />
                <path
                  class="cls-1"
                  d="M3742.88,744.1c-2.29,3.81,3.63,9.98,6.81,5.81,2.57-3.86-3.66-10.81-6.81-5.81Z"
                />
                <path
                  class="cls-1"
                  d="M1166.19,1592.66c13.61.8,21.31-16.8,17.83-27.87-3.23,3.48-4.78,11.41-11,10.38-3.61-.23-7.26-.42-10.99-.51-4.56,7.34-18.08,15.55-8.67,24.51,4.8-1.47,7.42-6.93,12.83-6.51Z"
                />
                <path
                  class="cls-1"
                  d="M873.95,1678.21c3.69-1.67,7.2-3.49,10.59-5.44,3.08-12.6-11.86-1.1-17.87-1.09,1.87-4.37,9.2-7.04,7.51-12.3-3.54-2-7.49-3.27-11.37-4.76-2.76,7.09-8.07,12.05-15.32,14.45-.39,10.85-1.02,22.52-7.26,31.82,8.17-4.62,17.78-7.72,22.78-16.21,5.68,2.58,9.7-1.08,10.93-6.46Z"
                />
                <path
                  class="cls-1"
                  d="M886.22,1682.44c-1.77-3.89-4.16-3.99-7.15-.29,1.87,3.96,4.22,4.07,7.15.29Z"
                />
                <path
                  class="cls-1"
                  d="M299.39,1864.51c.43-3.2-2.42-5.46-3.79-8.11-1.91,4.45-8.48,7.91-6.95,13.3,4.03-.31,8.94-1.24,10.74-5.19Z"
                />
                <path
                  class="cls-1"
                  d="M620.9,1757.18c-3.68-3.34-6.05-2.36-7.16,2.98,3.45,1.7,5.85.71,7.16-2.98Z"
                />
                <path
                  class="cls-1"
                  d="M3751.67,717.9c1.51,5.02,2.95,10.06,4.59,14.97,3.43-5.66,2.02-13.47-1.26-18.99-.81,1.01-2.48,3-3.33,4.01Z"
                />
                <path
                  class="cls-1"
                  d="M626.86,1730.66c1.73,6.63,2.54,13.46.12,20.03-1.9-4.08-4.12-8.1-6.53-11.98-1.78,4.95-3.67,9.87-5.71,14.74l5.72-3.68c.72,2.22,2.15,6.69,2.89,8.94,1.84-1.78,5.5-5.29,7.34-7.07.58-1.73,1.65-5.24,2.2-6.97-1.95-4.64-4.01-9.31-6.02-14Z"
                />
                <path
                  class="cls-1"
                  d="M2461.41,1137.73c1.54,4.91,6.49,11.73,11.51,5.72-.6-5.75-6.93-6.31-11.51-5.72Z"
                />
                <path
                  class="cls-1"
                  d="M-1.29,1945.32c.26,5.53,2.51,6.78,6.73,3.72-.18-5.49-2.43-6.74-6.73-3.72Z"
                />
                <path
                  class="cls-1"
                  d="M4078.2,612.76c-3.03-2.17-6.25-4.11-9.57-5.85.2,1.48.53,3.86.84,6.07.74,1.02,1.45,2.06,2.12,3.12,2.15-1.08,5.01-2.52,6.62-3.34Z"
                />
                <path
                  class="cls-1"
                  d="M2858.41,996.41c1.37,4.09,3.1,8.06,4.69,12.01,3.71-1.61,7.03-4.01,9.22-7.48-4.22-1.92-8.84-7.6-13.92-4.53Z"
                />
                <path
                  class="cls-1"
                  d="M2793.77,1030.28c2.18,3.79,4.65,3.73,7.36-.22-2.11-3.68-4.58-3.62-7.36.22Z"
                />
                <path
                  class="cls-1"
                  d="M2374.01,1170.16c3.05-4.15-3.55-10.77-7.01-6.02-3.6,4.3,3.6,11.53,7.01,6.02Z"
                />
                <path
                  class="cls-1"
                  d="M3731.36,720.87c1.87,4.4,8.88,2.48,10.56-1.13.67-6.2-11.43-4.64-10.56,1.13Z"
                />
                <path
                  class="cls-1"
                  d="M4078.77,589.92c1.5-2.91,2.97-5.84,4.43-8.77-2.05-4.11-4.08-8.18-6.29-12.27-5.76-.04-9.18-3.52-10.86-8.96-3.26,7.72,1.88,14.82,3.82,22.11-3.41,2.83-4.04,6.46-1.91,10.94,2.18-.74,6.52-2.26,8.69-3.04,2.57,3.87,5.26,7.56,8.34,11.03,1-2.51,5.55-5.64,3.08-8.27-2.34-.68-6.97-2.09-9.31-2.78Z"
                />
                <path
                  class="cls-1"
                  d="M3349.16,824.52c.21,1.27.63,3.89.85,5.17,2.35,1.75,4.69,3.45,6.99,5.15,3.21-4.98,6.09-10.09-3.73-7.32.82-1.61,2.46-4.84,3.28-6.42-.51-5.28-2.45-12.14-9.05-11.23-1.67,6.73,13.06,10.66,1.66,14.65Z"
                />
                <path
                  class="cls-1"
                  d="M634.34,1722.06s-.06.02-.09.03l.05.16c.01-.06.03-.13.04-.19Z"
                />
                <path
                  class="cls-1"
                  d="M631.16,1703.75c1.42-3.29,2.62-6.6,3.86-9.9-2.46-.11-7.33-.33-9.79-.44-1.48,4.75-.19,9.61.67,14.3,3.55,1.6,7.02,3.19,10.46,4.75-.51,2.37-1.49,7.08-2.01,9.59,3.97-1.17,7.39-3.6,9.63-8.08-3.98-3.64-6.87-9.32-12.82-10.24Z"
                />
                <path
                  class="cls-1"
                  d="M632.45,1716.16c-.95.91-2.9,2.76-3.84,3.67-1.38-.02-4.13-.1-5.5-.16-.09.77-.27,2.27-.35,3.04,4,.43,7.96.38,11.49-.64l-1.8-5.92Z"
                />
                <path
                  class="cls-1"
                  d="M604.32,1719.56c3.39.3,6.72.6,10,.87-1.86-3.12-3.75-6.24-5.77-9.34-1.4,2.81-2.8,5.62-4.23,8.47Z"
                />
                <path
                  class="cls-1"
                  d="M846.1,1637.08c2.55-1.97,4.11-7.09,7.62-3.13,3.03-2.37,6.69-2.69,10.28-2.79-3.44-2.1-6.62-4.43-10.01-6.78-.95,1.92-2.77,5.81-3.72,7.77-3.19-2.81-5.4-6.3-6.95-10.13-2.6.07-5.2.14-7.79.19-.02.02-.03.03-.05.05-.05-.01-.12-.03-.17-.04-1.74.03-3.47.06-5.21.08,1.18,3.13,2.34,6.27,3.39,9.42,4.23,1.85,8.33,3.9,12.61,5.36Z"
                />
                <path
                  class="cls-1"
                  d="M593.17,1714.97c.49,5.32,2.9,6.52,7.23,3.62-.36-5.33-2.77-6.53-7.23-3.62Z"
                />
                <path
                  class="cls-1"
                  d="M2589.15,1064.03c-.98-2.6-2.9-7.76-3.88-10.33-10.81.97-21.72,8.43-18.51,20.73,8.07-2.06,15.75-5.41,22.39-10.4Z"
                />
                <path
                  class="cls-1"
                  d="M1932.27,1277.62c-.09-5.52-2.28-6.68-6.63-3.52.19,5.52,2.39,6.71,6.63,3.52Z"
                />
                <path
                  class="cls-1"
                  d="M3024.32,909.48c2.49-4.11-4.25-9.2-7.24-5.1-2.77,4.27,4.35,9.41,7.24,5.1Z"
                />
                <path
                  class="cls-1"
                  d="M2663.59,1011.87c5.12,2.8,10.28,5.65,14.59,9.59-.46-4.69,1.46-11.8-2.63-14.84-8.62.26-17.97-2.44-25.77,2.7,2.84,6.13,8.84,3.4,13.81,2.55Z"
                />
                <path
                  class="cls-1"
                  d="M245.07,1801.57c-2.72,4.22,3.74,11.76,7.24,6.41,3.1-4.1-3.71-11.06-7.24-6.41Z"
                />
                <path
                  class="cls-1"
                  d="M4066.85,556.6c-4.13-6.99-10.23-12.39-15.59-18.41-2.72,4.12-5.57,8.17-8.76,11.97,1.09,1.59,3.26,4.75,4.33,6.35,6.14-4.86,13.11,3.28,20.03.08Z"
                />
                <path
                  class="cls-1"
                  d="M3332.69,777.26c1.84-.03,5.48-.11,7.28-.16l3.15,3.07-4.67,3.41.28,1.49c1.42-.4,4.26-1.26,5.7-1.69.13,2.35.39,7.07.53,9.44,1.01-.5,3.11-1.49,4.13-1.99l-3.77-3.71c3.08-2.42,6.13-4.79,9.17-7.23-1.09-1.19-3.26-3.61-4.34-4.84-.38,2.34-1.14,7-1.53,9.31-4.64-5.14-7.67-11.45-11.02-17.48,9.85,5.36,9.67-4.67,10.33-11.1-2.09-2.18-4.21-4.34-6.34-6.54.17,3,.47,9.06.65,12.09-3.56-6.07-6.3-12.6-9.53-18.91l5.55-1.11c-4.06-2.84-3.58-8.28-7.65-11.08,10-5.41,2.93-20.48-2.69-25.95-.43-3.05-.85-6.11-1.29-9.19.76-3.54,1.48-7.1,2.2-10.67,2.15.81,6.42,2.48,8.57,3.29-2.18-3.79-5.84-6.16-9.64-8.21-1.5-3.58-4.11-7.13-2.82-11.32-3.71-1.58-8.7-7.61-10.45,1.26.98,4.78,2.37,9.5,3.43,14.26-1.83-1.32-3.96-.62-6.37,2.12,1.89,3.06,4.23,3.41,7.01,1.02.72,3.94,1.12,7.92.76,12.01-1.19-.47-3.35-1.3-4.97-1.93.9.88,1.76,1.81,2.57,2.77,1.41-.41,2.76-.8,3.71-1.07.17,2.12.15,4.24.05,6.35,5.81,9.72,7.71,21.9,4.55,32.66.71,3.02,1.07,6.13,1.09,9.24,1.83,5.02,4.26,9.78,7.89,14.04-3.44,4.82-1.31,10.92-1.53,16.33Z"
                />
                <path
                  class="cls-1"
                  d="M654.76,1652.81c1.04-.51,3.06-1.54,4.1-2.08-1.91-.08-5.77-.27-7.68-.35-.48,7.28-9.39,5.52-14.24,8.08-1.59,1.73-4.79,5.19-6.38,6.92,4.63,3.57,8.67-.95,12.02-3.96-1.59,8.01,3.16,10.8,10.02,11.12-1.32-1.69-3.98-5.09-5.3-6.77,7.41-1.08,9.14-6.71,7.47-12.96Z"
                />
                <path
                  class="cls-1"
                  d="M298.53,1785.75c-2.77-.45-5.53-.92-8.3-1.34-.8-.12-1.56-.33-2.33-.51-.05.38-.04.79.07,1.24,3.48,2.02,7.38,1.69,11.11,1.59-.17-.33-.37-.65-.55-.98Z"
                />
                <path
                  class="cls-1"
                  d="M229.39,1799.06c1.96,4.97,5.92,10.51,11.21,5.52,3.67-8.12-6.57-8.91-11.21-5.52Z"
                />
                <path
                  class="cls-1"
                  d="M3063.88,876.73c-2.43,4.83,6.07,6.45,7.26,1.97,1.56-4.58-5.62-5.59-7.26-1.97Z"
                />
                <path
                  class="cls-1"
                  d="M2168.34,1167.76c-1.54-5.7-4.03-11.11-6.74-16.36-2.01,3.01-.87,6.3-.07,9.47.02.05.04.12.06.17,2.53,1.93,4.78,4.21,6.75,6.73Z"
                />
                <path
                  class="cls-1"
                  d="M1914.75,1250.8c-.43-1.41-1.22-4.24-1.64-5.65-3.92-2.22-10.55,2.5-7.42,6.93,3.34,2.41,6.36,1.99,9.06-1.28Z"
                />
                <path
                  class="cls-1"
                  d="M1417.13,1411.65c3.02-3.61,2.31-5.8-2.13-6.53-3.03,3.68-2.33,5.84,2.13,6.53Z"
                />
                <path
                  class="cls-1"
                  d="M3054.74,874.47c-.22-5.41-2.5-6.61-6.88-3.67.31,5.48,2.6,6.72,6.88,3.67Z"
                />
                <path
                  class="cls-1"
                  d="M3478.12-5.74c-5.74-.81-9.18,3.5-11.32,8.17,6.98,4.38,14-.17,11.32-8.17Z"
                />
                <path
                  class="cls-1"
                  d="M3464.99,4.6c.32-4.68-1.49-5.7-5.48-3.09-.24,4.72,1.57,5.74,5.48,3.09Z"
                />
                <path
                  class="cls-1"
                  d="M1970.7,1223.59c1.77-.6,3.5-1.24,5.22-1.92,1.28-2.24,2.73-4.46,4.3-6.67-.78-1.84-2.18-3.61-2.94-5.33-3.48,2.01-7.03,4.01-10.56,6.07,1.01,1.96,2.99,5.88,3.97,7.85Z"
                />
                <path
                  class="cls-1"
                  d="M4029.25,503.9c-4.68-1.26-9.38-2.58-14.11-3.9.83,3.87,1.57,7.69,2.44,11.5,1.12-1.61,3.44-4.82,4.6-6.41,2.82,3.48,6.04,6.46,9.32,9.5-1.83,1.2-3.68,2.41-5.52,3.58-2.53.29-7.59.83-10.12,1.12.02-1.79.05-5.4.06-7.21-.96,1.59-2.84,4.69-3.78,6.24,7.07,3.84,14.03,7.86,21.17,11.51.43-1.65,1.27-4.95,1.72-6.58,5.01-2.98,4.74,3.29,1.88,5.97,1.52,5.18,2.01,11.31,8.06,12.86,2.01-1.36,6.04-4.06,8.02-5.41-.93-2.86-2.81-8.6-3.75-11.48l-5.55.4c1.13-.44,3.36-1.33,4.5-1.77-4.46-11.18-11.36-20.8-19.03-29.99l-3.95.99c1.01,2.26,3.03,6.81,4.04,9.07Z"
                />
                <path
                  class="cls-1"
                  d="M664.28,1600.93c-4.71-3.49-8.13-7.95-10.4-12.9-6.38-.15-12.79-2.53-19.03-4.38.06,2.13.14,6.41.19,8.51-5.07-.4-15.11-.48-12.92,7.38,1.54-1.04,4.65-3.06,6.2-4.07,4,8.64.04,17.94-1.91,26.57,1.92-4.22,4.49-8.19,7.36-11.75.5,2.05,1.58,6.17,2.12,8.25l4.76,1.4c-.61,1.64-1.83,4.9-2.44,6.54,5.41-2.47,8.39-7.14,6.42-13.49,11.59,3.78,6.56,21.02-3.5,22.32-1.01-1.75-3.06-5.25-4.1-7-.62,2.93-1.32,5.84-2.08,8.78-.74,1.55-2.22,4.62-2.96,6.18l-9.75,3.18c4.09,1.52,8.06,3.49,9.03,8.21l1.32-.06c-.8-1.62-2.39-4.86-3.22-6.48,6.16-8.94,9.8.67,12.85,5.49,3.36-2.27,6.68-4.57,9.97-6.85,1.6-10.03-2.44-23.24,6.51-30.19-3.7-1.75-7.26-3.51-11.09-5.35,1.74-1.68,5.19-5.02,6.92-6.7-3.71-2.42-6.73-7.65-11.89-7.18l-1.53,1.61c-1.8.76-5.35,2.25-7.12,3,3.89-4.06,8.02-7.86,11.94-11.83.03,1.64.11,4.87.14,6.51,2.48-1.05,7.46-3.21,9.94-4.25-.28,5.74,4.01,7.23,8.27,8.56Z"
                />
                <path
                  class="cls-1"
                  d="M1328.33,1419.8c2.6-3.98-3.42-11.49-7.11-6.65-2.86,4.13,3.63,12.06,7.11,6.65Z"
                />
                <path
                  class="cls-1"
                  d="M606.51,1643.59c.37,5.26,2.67,5.92,6.88,2.02-.18-5.29-2.48-5.95-6.88-2.02Z"
                />
                <path
                  class="cls-1"
                  d="M2351.22,1078.31c3.63-4.44,6.79-9.58,5.14-15.56-4.21,4.4-9.52,9.03-5.14,15.56Z"
                />
                <path
                  class="cls-1"
                  d="M2138.62,1118.39c2.94,5.7,6.78,11.7,13.57,12.75-1.77-1.91-3.57-3.84-5.41-5.76,1.94-6.52-2.94-12.08-8.16-6.98Z"
                />
                <path
                  class="cls-1"
                  d="M1319.9,1398.42c2.93-4.22-4.23-9.55-7.16-5.06-2.39,4.11,4.24,9.17,7.16,5.06Z"
                />
                <path
                  class="cls-1"
                  d="M1921.73,1200.32c-1.73-4.58-6.6-7.05-11.24-5.2-1.51,7.22,6.46,9.19,11.24,5.2Z"
                />
                <path
                  class="cls-1"
                  d="M2367.85,1046.66c3.22-2.29,6.43-4.62,9.55-6.98-.71-1.96-2.13-5.89-2.84-7.88-2.41,4.89-4.62,9.84-6.71,14.86Z"
                />
                <path
                  class="cls-1"
                  d="M3248.6,721.78c-.76,3.37-1.22,6.78-1.59,10.21.74-.55,1.48-1.1,2.22-1.64-.04-.79-.1-1.59-.27-2.43.93.18,1.73.46,2.45.79.64-.48,1.28-.96,1.92-1.45,1.46,2.03,4.14,3.07,6.06.65,2.75-3.62-2.73-9.93-5.94-6.54.03-.69.07-1.37.14-2.05-1.88.12-3.62.71-4.98,2.47Z"
                />
                <path
                  class="cls-1"
                  d="M2820.57,884.83c-.13,5.46,1.99,6.41,6.44,2.84.09-5.51-2.07-6.45-6.44-2.84Z"
                />
                <path
                  class="cls-1"
                  d="M2139.73,1103.68c1.39-8.62-20.25-6.73-4.39-10.57-.88-1.36-2.61-4.09-3.48-5.42-1.88,3.71-3.71,7.46-5.58,11.23,1.99,4.13,3.55,8.39,4.65,12.8,5.32-1.1,15.72-.12,8.8-8.05Z"
                />
                <path
                  class="cls-1"
                  d="M2379.53,1020.26c.19,5.32,2.48,6.35,6.83,3.11-.1-5.35-2.39-6.38-6.83-3.11Z"
                />
                <path
                  class="cls-1"
                  d="M3360.52,699.9c3.66-2.57,7.18-5.3,10.49-8.33-5.44-3.07-17.01,1.75-10.49,8.33Z"
                />
                <path
                  class="cls-1"
                  d="M661.28,1511.29c5.7,1.3,11.39,2.47,17.07,3.37,3.14-3.78,9.29-6.36,7.11-12.3l-1.53,6.22c-3.44-2.04-7.15-3.57-10.96-4.32-.47-.32-1.05-.41-1.74-.28-4.18-.54-8.46-.11-12.65,1.68-.52-4.17-.74-8.33-1-12.55-2.01,3.72-2.94,7.88-4.03,11.97l-3.27-.45c.19,2.43.52,7.26.68,9.7,2.77,2.42,5.49,4.86,8.09,7.38-2.05.3-6.21.85-8.26,1.15-4.66,10.73-3.77,25.73-15.06,32.11,2.22,2.07,4.37,4.12,6.46,6.19-3.26,5.77-5.73,11.89-5.55,18.72,1.91-1.46,5.75-4.33,7.66-5.79-.92,2.32-2.79,6.89-3.72,9.21,3.88-.42,7.74-1.27,10.73-3.07-.48-2.28-.76-4.61-.84-6.95-2.65-.69-4.3-3.5-1.57-7.52.54.05,1.22.1,1.96.16.05-.37.13-.74.19-1.11-.29.06-.61.14-.85.19.3-.43.68-1,1.1-1.61.46-2.29,1.1-4.54,1.91-6.73-.4-.77-.79-1.53-1.06-2.05l2.07-1.18.12.5c.82-1.79,1.75-3.52,2.81-5.16.12-4.17,2.43-7.96,6.44-10.8-2.54-3.44-5.15-6.92-7.68-10.44,5.33-3.86,4.52-10.55,5.39-16.25Z"
                />
                <path
                  class="cls-1"
                  d="M3162.4,753.68c.28-5.43-1.88-6.48-6.53-3.11-.15,5.4,2,6.44,6.53,3.11Z"
                />
                <path
                  class="cls-1"
                  d="M3986.45,438.91c1.57,5.74,3.12,11.52,4.46,17.27-3.07.9-6.16,1.71-9.31,2.47,12.14,4.04,24.57,7.61,36.03,13.38-7.2-8.27-13.79-17.75-24.72-21.37,1.6.15,4.75.43,6.31.59-1.44-4.71-3.62-9.54-3.17-14.66-3.19.74-6.4,1.52-9.59,2.32Z"
                />
                <path
                  class="cls-1"
                  d="M3230.15,725.72c-1.86-5.48-4.36-10.78-8.74-14.73.92,6.12.28,14.77,8.74,14.73Z"
                />
                <path
                  class="cls-1"
                  d="M2409.31,956.32c3.42-3,2.62-7.21-.48-10.23-3.65,3.14-6.45,7.11-9.68,10.72-2.11,5.26-4.07,10.6-6.24,15.89-.64-2.58-1.94-7.7-2.61-10.27-6.98,5.3,3.31,12.6,3.1,19.19-1.32.9-3.9,2.68-5.22,3.58,2.19,1.97,4.38,3.95,6.51,5.94,10.86-2.87,7.76-16.18,14.79-22.75,6.95-3.95-7.42-7.9-.18-12.08Z"
                />
                <path
                  class="cls-1"
                  d="M611.36,1555.14c5.14,4.29,7.41,10.4,9.01,16.7l-.55-4.06c4.46-1.59,8.89-3.04,13.26-4.6-1.39-1.57-4.15-4.69-5.51-6.27l-.16,7.95c-6.43-3.42-6.66-11.34,2.15-11.53-.93-.77-2.76-2.39-3.69-3.17-3.42-.6-6.88-1.22-10.4-1.88l1.95,5.98c-1.55.12-4.47.32-6.17.45.03.14.07.27.11.41Z"
                />
                <path
                  class="cls-1"
                  d="M2603.91,909.16c-7.25,1.16-2.45,7.62-1.73,11.99,2.17-1.08,6.57-3.25,8.77-4.34-1.91-2.87-2.54-7.98-7.04-7.65Z"
                />
                <path
                  class="cls-1"
                  d="M2054.19,1083.09c-.15,3.61-.33,7.2-.51,10.79,4.43-.64,8.61-.5,12.47.35,2.61-1.96,4.69-4.64,5.88-8.26-4.26-6.47-11.52-4.2-17.85-2.88Z"
                />
                <path
                  class="cls-1"
                  d="M2086.33,1085.78c-.1-2.25-.3-6.79-.4-9.05l5.62.22c-1.04-3.29-5.45-6.29-3.93-9.98.36-3.01,5.55-10.69-1.89-9.3-2.15,5.24-3.96,10.64-5.91,15.98-2.31,1.06-6.89,3.19-9.16,4.27,5.2,2.74,10.42,5.34,15.67,7.86Z"
                />
                <path
                  class="cls-1"
                  d="M11.95,1750.47c.49-1.27,1.5-3.75,2-4.99-2.47,2.22-4.95,4.51-7.47,6.77-6.14,1.67-10.01,11.87-16.64,9.16.8,1.82,2.44,5.42,3.24,7.25,4.65-8.51,17.2-8.37,24.38-14.68-1.4-.89-4.13-2.65-5.52-3.51Z"
                />
                <path
                  class="cls-1"
                  d="M2047.18,1095.3c.21-5.01.75-10.16-1.4-14.9-1.02.9-3.08,2.72-4.14,3.6,1.36,1.61,4.04,4.76,5.4,6.34-4.34,1.32-8.74,2.68-13.12,4.08,4.43.5,8.9.69,13.26.88Z"
                />
                <path
                  class="cls-1"
                  d="M1389.02,1305.37c2.52-4.52-.46-8.62-3.36-12.05-2.28,4.85-5.68,9.79-5.52,15.32,1.78,5.87,8.85.94,8.88-3.27Z"
                />
                <path
                  class="cls-1"
                  d="M4011.19,450.73c3.78-1.7,1.99-8.95-2.34-7.78-4.07,1.53-2.15,9.37,2.34,7.78Z"
                />
                <path
                  class="cls-1"
                  d="M747.17,1494c-2.01-.55-3.99-1.1-5.33-1.48-1.46,8.32,4.99,9.76,10.15,13.05-1.7-3.84-3.31-7.7-4.82-11.58Z"
                />
                <path
                  class="cls-1"
                  d="M694.43,1521.94c2.9-3.28,6.36-5.91,9.75-8.59,1.06,3.49,5.48,6.3,7.89,2.36,1.55-2.42-.06-5.66-2.34-7.08.14-.13.29-.26.42-.39-2.62-9.57-16.46-.07-11.75,7.16-8.81,2.88-18.48,5.06-25.03,12.2-3.59-.71-7.31-2.42-11.12-1.21,4.06,2.76,8.18,5.42,12.05,8.35,3.35-1.2,7.01-1.88,10.96-1.94,3.42-3.1,5.95-7.55,9.15-10.86Z"
                />
                <path
                  class="cls-1"
                  d="M1897.35,1133.45c1.89-5.53-7.2-7.63-9.21-2.78-1.91,5.47,7.6,8.04,9.21,2.78Z"
                />
                <path
                  class="cls-1"
                  d="M1788.72,1169.21c4.48-2.97-.26-11.01-5.09-8.69-4.17,2.98.35,11.38,5.09,8.69Z"
                />
                <path
                  class="cls-1"
                  d="M1391.04,1287.03c.9,1.82,2.72,5.46,3.62,7.29,6.75-4.15,14.4-7.79,18.24-15.06-7.61,1.51-14.8,4.5-21.87,7.78Z"
                />
                <path
                  class="cls-1"
                  d="M3316.23,664.01c4.21-.4,8.43-.84,12.62-1.3-.49-5.4-4.27-8.92-8.07-12.36l-9.56,3.12c.89,3.6,4.42,7.1,5.01,10.53Z"
                />
                <path
                  class="cls-1"
                  d="M155.34,1682.09c-.16,7.45,7.87,7.21,12.9,9.34-2.53-4.75-3.39-9.98-3.86-15.31-3.01,1.79-6.27,3.56-9.04,5.98Z"
                />
                <path
                  class="cls-1"
                  d="M122.6,1704.64c3.59.28,9.82-3.58,7.74-7.6-3.72-1.1-9.31,3.71-7.74,7.6Z"
                />
                <path
                  class="cls-1"
                  d="M2207.92,1004.65c-.91.27-1.82.66-2.72,1.25-4.26-1-8.31-.34-12.17,1.96,4.03,3.21,9.08,2.66,14,2.88.3-2.03.59-4.06.89-6.09Z"
                />
                <path
                  class="cls-1"
                  d="M195.84,1675.79c-1.91-3.68-4.44-3.63-7.58.15,2.08,3.69,4.59,3.65,7.58-.15Z"
                />
                <path
                  class="cls-1"
                  d="M142.77,1679.84c-2.92,3.1-5.69,6.26-8.64,9.48,3.78,1.29,7.51,2.52,11.19,3.71-.03-4.53-1.22-8.88-2.56-13.18Z"
                />
                <path
                  class="cls-1"
                  d="M1960.87,1076c1,.97,1.95,2,2.84,3.08.12-.06.25-.12.37-.18,5.57-.44,10.87,2.2,16.27,2.99,5.06-1.59,10.16-2.95,15.2-4.19,2.19-1.11,4.35-2.18,6.52-3.26-.93-.07-1.87-.13-2.81-.29-4.46,0-8.69-1.05-12.71-3.06-8.47,2.2-16.86,5.01-25.68,4.92Z"
                />
                <path
                  class="cls-1"
                  d="M1877.08,1098.96c7.72,3.28,16.75,1.21,23.54-3.4.23-1.32.52-2.62.89-3.9-7.33,2.48-14.78,4.59-22.14.64-1.05,2.13-1.81,4.35-2.29,6.67Z"
                />
                <path
                  class="cls-1"
                  d="M150.31,1645.24c-3,2.22-6.45,4.33-8.25,7.87-5.98,9.79-15.86,16.3-23.2,25.02-1.05-1.57-3.13-4.76-4.18-6.33,2.07,5.11.58,10.03-3.64,13.36-6.16.16-12.45.06-18.67.88,4.5,4.11,9.17,8.33,9.93,14.77,0-1.75.04-5.22.04-6.97l4.07-1.93c.39,1.39,1.18,4.12,1.56,5.51,1.02-1.41,3.04-4.18,4.03-5.58,14.78-4.46,20.18-19.43,28.15-30.94,6.29-2.86,11.64-7.06,16.52-11.78l-1.51-1.12c3.91-3.66,7.58-7.48,11.11-11.39-5.83-8.38-11.63,4.54-15.97,8.64Z"
                />
                <path
                  class="cls-1"
                  d="M2515.51,900.44c-1.51,4.63-.12,6.53,4.14,5.67,1.53-4.57.14-6.47-4.14-5.67Z"
                />
                <path
                  class="cls-1"
                  d="M130.56,1684.43c-7.97-2.47-3.18,9.81.85,2.31l-.85-2.31Z"
                />
                <path
                  class="cls-1"
                  d="M3205.95,668.88c3.08,3.16,6.07,6.35,9.14,9.45l-3.4-9.08c3,1.27,5.97,2.52,8.94,3.81,2.3-3.24,4.65-6.46,7.08-9.61-1.76-.03-5.31-.11-7.1-.13-4.03,3.6-9.1,5.89-14.66,5.56Z"
                />
                <path
                  class="cls-1"
                  d="M1405.24,1258.26c-.04,1.53-.16,4.56-.23,6.09,6.11.09,14.02-2.26,9.68-10.09-2.36,1.01-7.09,2.99-9.45,3.99Z"
                />
                <path
                  class="cls-1"
                  d="M3251.59,653.71c-3.92.64-7.9,1.03-11.92,1.17-5.41.72-10.77,1.6-16.08,3.16,4.17,1.66,8.43,1.42,12.43-.43,2.01-.32,6.02-.92,8.04-1.21.09,2.12.28,6.33.37,8.45,6.96.52,6.55-6.71,7.15-11.14Z"
                />
                <path
                  class="cls-1"
                  d="M2118.81,1022.17c-6.15,2.78-.6,10.82,4.37,6.81,5.67-2.62.41-10.39-4.37-6.81Z"
                />
                <path
                  class="cls-1"
                  d="M3984.01,415.87c.14-5.86-1.92-7.21-6.14-4.08-.07,5.77,1.99,7.12,6.14,4.08Z"
                />
                <path
                  class="cls-1"
                  d="M1517.57,1214.66c2.21-.22,6.61-.65,8.83-.86,5.98,7.93,5.69-6.87,7.65-10.53,6.32.93,12.56,2.02,18.78,3.25-.51-2.23-.98-4.46-1.42-6.7-3.09-1.49-6.07-3.2-8.92-5.13-5.51.31-11.04.56-16.52,1.84-5.23,4.46-6.6,11.8-8.4,18.14Z"
                />
                <path
                  class="cls-1"
                  d="M1850.56,1100.72c2.05-3.7-4.23-8.64-7.04-5.1-1.19,3.55,4.21,8.58,7.04,5.1Z"
                />
                <path
                  class="cls-1"
                  d="M600.98,1500.25c2.08-.05,4.26-.1,5.65-.13.23,1.64.73,4.91.99,6.53l5.68-1.85c-.6-4.51-1.65-8.97-3.08-13.35-.42.14-.86.26-1.31.37-2.37,3.11-5.04,5.91-7.94,8.44Z"
                />
                <path
                  class="cls-1"
                  d="M110.03,1660.78c-5.25,4.1-10.55,8.25-15.07,13.25,6.05-1.84,11.84-4.2,17.73-6.23-.68-1.76-1.99-5.27-2.66-7.03Z"
                />
                <path
                  class="cls-1"
                  d="M673.64,1477.5l-5.71,1.16c-.85-5.6-3.59-10.59-6.26-15.57-1.44,2.18-2.91,4.38-4.42,6.55,4.6,4.82,9.11,9.7,13.81,14.38.9-2.18,1.78-4.34,2.58-6.52Z"
                />
                <path
                  class="cls-1"
                  d="M44.09,1676.76c-3.52.34-7.06.93-10.67,1.8.11,3.02.12,6.04.04,9.09,2-.05,6-.14,8-.19,1.11-3.49,4.03-6.9,2.62-10.71Z"
                />
                <path
                  class="cls-1"
                  d="M462.24,1535.49c.9,2,2.02,4.37,2.83,6.11,4.1,3.65,9.45,5.4,14.55,1.59-2.02-4.12-7.34-3.45-11.06-4.96,1.37-1.46,4.13-4.34,5.5-5.8.93,1.21,2.74,3.64,3.67,4.85,1.77-2.29,3.47-4.6,5.11-6.91-.47-2.87-.97-5.77-1.51-8.65,2.41,1.2,7.26,3.61,9.68,4.84-.76-2.01-2.26-5.99-3-7.96-4.56-.39-9.75-5.05-13.91-1.01,1.35,1.24,4.09,3.67,5.44,4.92-4.19,2.11-8.77,4.34-6.37,10.04-3.46.4-7.02.78-10.57,1.19-.08.59-.24,1.16-.35,1.75Z"
                />
                <path
                  class="cls-1"
                  d="M3265.89,552.84c8.11,8.88,10.49,20.57,14.84,31.32l10.23-3.34c-1.15-4.49-1.72-9.49-5.4-12.22-9.98-3.4-8.78-16.8-18.52-21.32-1.42-3.94-3.16-7.71-5.2-11.41-1.74-2.66-5.26-7.97-7-10.62,7.82,1.31,14.63,5.48,21.61,8.95.68-6.27-4.68-9.3-9.2-12.02-3.77.49-7.48-.68-11.16-1.54l2.87,4.47c-1.87-.06-5.67-.17-7.54-.23,2.36,4.24,3.07,9.08,3.8,13.79,4.15,4.16,10.84,7.35,10.67,14.16Z"
                />
                <path
                  class="cls-1"
                  d="M1945.18,1026.18c2.83,2.26,6.06,3.93,10.25,4.28.34-1.21.95-3.46,1.34-4.87-3.98.72-7.74.75-11.28.26-.09.11-.2.22-.3.33Z"
                />
                <path
                  class="cls-1"
                  d="M1837.57,1057.2c2.17-1.08,4.31-2.15,6.42-3.2,3.98.95,7.81,1.69,11.75,2.32-3.1-3.02-6.29-5.98-9.51-8.96-4.72-.54-9.46-1.08-14.22-1.64.2-1.54.59-4.66.8-6.21-6.39-5.04-7.86-13.06-2.97-19.7-.84-1.12-1.83-2.22-2.84-3.33-.53-.08-1.05-.15-1.58-.23-20.21-2.96-32.94-25.94-28.84-44.81.96-4.44,2.67-8.39,4.9-11.89-1.57-1.16-3.11-2.38-4.55-3.68.26-9.8-7.54-17.34-11.21-25.99,1.21-1.74,3.64-5.22,4.85-6.96-.21-4.34-.35-8.79,2.19-12.55l2.57,5.31c-.06-3.68-.02-7.36.12-11.06-4,4.94-9.68,7.63-15.36,10.29-2.14-5.32-4.5-10.6-6.92-15.86-5.57,5.79.17,13.89,1.18,20.39,3.96,9.77,2.59,20.6,6.4,30.42-4.96-3.46-12.07-2.68-14,3.96,10.55-3.51,14.74,6.85,21.81,11.74-.45,1.59-1.35,4.81-1.81,6.41.63,2.15,1.93,6.43,2.56,8.57,2.07,1.71,4,3.5,5.79,5.37-2.45,6.61-2.43,15.62,6.14,17.16-.51,8.23,7.53,12.06,12.24,17.42,7.74,5.81,8.77,17.4,18.51,20.78l-5.59,2.33c1.86,4.47,3.65,8.93,5.5,13.36.81,5.25,1.76,10.45,2.81,15.62,6.56-3.28,4.81-9.77,2.85-15.35Z"
                />
                <path
                  class="cls-1"
                  d="M3966.6,363.67c-3.25,3.65-2.66,5.74,1.81,6.27,3.24-3.58,2.62-5.66-1.81-6.27Z"
                />
                <path
                  class="cls-1"
                  d="M3496.65,513.68c-.09-4.51-.2-9.02-.36-13.53-4.02-1.61-8.1-3.2-12.17-4.84.8,8.9-2.63,16.67-6.13,24.45l18.66-6.09Z"
                />
                <path
                  class="cls-1"
                  d="M1280.91,1239.54c-5.83-2.73-12.28-4.87-16.14,1.94,5.83,2.94,13.11,5.97,16.14-1.94Z"
                />
                <path
                  class="cls-1"
                  d="M646.2,1427.84l-3.04,4.59c-2.98-4.64-5-10.32-9.41-13.87-.06.34-.11.67-.17,1.01,3.01,5.42,4.37,11.49,5.84,17.45,2.58,5.01,7.01,8.8,10.33,13.2-2.12-5.66-4.31-11.23-6.61-16.87,2.18-.11,6.6-.27,8.79-.35-1.43-1.28-4.29-3.88-5.72-5.16Z"
                />
                <path
                  class="cls-1"
                  d="M691.71,1427.1c4.43,3.7,11.15,3.79,12.93-2.51-1.84-8.21-9.69-1.07-12.93,2.51Z"
                />
                <path
                  class="cls-1"
                  d="M682.47,1435.66c.66-3.74-4.64-8.77-8.16-5.94-.92,3.76,5.01,8.25,8.16,5.94Z"
                />
                <path
                  class="cls-1"
                  d="M2214.38,925.39c-5.78-1.04-10.64,10.56-2.24,7.25,3.17-.39,8.14-7.09,2.24-7.25Z"
                />
                <path
                  class="cls-1"
                  d="M2029.05,989.82c4.48-1.53,2.98-9.81-2.05-8.54-4.79,1.29-3.11,10.26,2.05,8.54Z"
                />
                <path
                  class="cls-1"
                  d="M686.06,1427.3c.23-4.95-1.58-5.97-5.38-3.09-.18,5,1.63,6.02,5.38,3.09Z"
                />
                <path
                  class="cls-1"
                  d="M2133.57,941.96c-2.7,2.33-5.47,4.68-8.26,7.03,4.07,1.36,8.09,2.74,12.06,4.1-.94-2.78-2.83-8.35-3.8-11.13Z"
                />
                <path
                  class="cls-1"
                  d="M1159.26,1267.42c0-5.14-2.35-6.16-7.02-2.98.05,5.19,2.43,6.2,7.02,2.98Z"
                />
                <path
                  class="cls-1"
                  d="M673.86,1428.53c1.53-4.06,2.74-8.19,3.94-12.34-3.55-1.09-6.77-5.08-10.86-4.76-.53,6.42-1.36,15.3,6.93,17.1Z"
                />
                <path
                  class="cls-1"
                  d="M202.49,1572.17c-.83-1.35-2.37-3.83-3.39-5.47-.58,1.49-1.22,2.97-1.89,4.42.18.04.36.06.54.11-.5,2.08-1.49,6.24-1.99,8.31,3.13-1.93,5.36-4.37,6.74-7.37Z"
                />
                <path
                  class="cls-1"
                  d="M3697.54,423.23c-6.41,2.7-.58,10.98,4.45,6.75,5.27-2.7.18-10.28-4.45-6.75Z"
                />
                <path
                  class="cls-1"
                  d="M3567.32,452.7c-5.7-3.65-8.56,4.88-10.82,8.44,4.78,1.36,17.23-1.89,10.82-8.44Z"
                />
                <path
                  class="cls-1"
                  d="M675.03,1399.07c2.71,1.1,5.34,2.16,7.94,3.22,1.91-1.26,5.79-3.77,7.73-5.05-5.28-2.48-10.55-.29-15.67,1.82Z"
                />
                <path
                  class="cls-1"
                  d="M668.29,1406.01c5.5,2.14,4.55-6.86,1.36-8.61-5.77-2.65-6.13,7.48-1.36,8.61Z"
                />
                <path
                  class="cls-1"
                  d="M3854.39,364.67c1.59-4.28-5.96-9.08-7.82-3.87-1.57,4.45,5.85,9.18,7.82,3.87Z"
                />
                <path
                  class="cls-1"
                  d="M4096.01,132.99c-.82,19.93,4.58,39.98-1.64,59.53,3.14-1.09,9.39-3.27,12.5-4.35,2.2,6.64-6,7.37-8.46,11.97,2.46,7.74,7.92,14.89,5.92,23.38-.48,2.25-.23,4.35.41,6.36-7.86,2.79-2.04,13.33,3.05,11.8-5.19,2.52-3.18,9.5,2.89,10.25.49,1.29,1.44,3.8,1.89,5.06l.03-3.81c4.76-1.59,7.11-5.92,9.46-10.05,1.86,1.68,3.72,3.36,5.56,4.98-3.17,2.55-6.39,5.04-9.64,7.45,2.16,5.28,4.6,10.4,7.19,15.43,1.5-.66,4.46-1.99,5.96-2.65-.28-4.98,4.49-7.45,7.47-10.57-2.48-6.89-3.71-14.15-3.22-21.5-12.63-7.61-19.45-24.47-16.94-38.81-3.88-.98-7.81-1.99-11.72-2.96,1.34-1.55,3.97-4.62,5.28-6.16-1.4-.89-4.23-2.65-5.66-3.53,4-5.78,7.89-11.65,11.63-17.61-5.71-8.73-7.76-18.41-5.68-28.63-4.01-4.77-10.7-4.27-16.27-5.58ZM4108.41,241.43c.61-.31,1.2-.82,1.74-1.55.19.33.38.66.57.99-.88.1-1.63.31-2.31.57Z"
                />
                <path
                  class="cls-1"
                  d="M1505.62,1122.56c-.18,4.8,1.66,5.91,5.46,3.33.23-4.75-1.61-5.86-5.46-3.33Z"
                />
                <path
                  class="cls-1"
                  d="M3472.35,459.06c-.57.93-1.66,2.83-2.2,3.78,1.52,6.19,1.97,12.53,1.85,18.86,2.39-7.5,8.81-16.36.34-22.63Z"
                />
                <path
                  class="cls-1"
                  d="M3643.23,417.7c-.41,4.81,1.33,5.82,5.24,3.06.48-4.7-1.3-5.73-5.24-3.06Z"
                />
                <path
                  class="cls-1"
                  d="M1808.95,1021.63l.42-2.62c-4.72-7.16-7.4,6.68-.42,2.62Z"
                />
                <path
                  class="cls-1"
                  d="M3842.96,341.31c-1.34,5.18,1.12,9.08,5.31,11.85,1.7-5.29-.85-9.2-5.31-11.85Z"
                />
                <path
                  class="cls-1"
                  d="M3575.31,441.12c-.09-4.61-2.14-5.72-6.07-3.36.2,4.54,2.22,5.66,6.07,3.36Z"
                />
                <path
                  class="cls-1"
                  d="M3534.16,447.29c-4.13,2.79.81,8.54,4.32,5.31,4.63-2.59-.68-8.99-4.32-5.31Z"
                />
                <path
                  class="cls-1"
                  d="M3357.8,504.48c.31,5.28,2.72,6.27,7.19,2.97-.36-5.13-2.74-6.13-7.19-2.97Z"
                />
                <path
                  class="cls-1"
                  d="M638.18,1384.63c-.37,4.19-.79,8.37-1.28,12.54,1.15.13,2.32.05,3.5-.41,3.46-4.2,1.43-9.01-2.21-12.13Z"
                />
                <path
                  class="cls-1"
                  d="M3529.04,426.47c-2.63-1.06-5.27-2.14-7.92-3.26,4.21-3.79,9.83,2.2,14.08-1.87,6.86-1.84-.51-9.71-1.11-13.59-16.23,1.47-16.74,20.09-28.52,27.66,1.68,3.39,3.78,6.43,6.35,9.15.16,2.34.31,4.67.4,7,.97-.12,2.87-.37,3.8-.5.86-3.14,2.62-9.39,3.47-12.53l1.5,7.58c1.05-.38,3.15-1.06,4.21-1.41-7.56-6.27-.4-12.54,3.73-18.23Z"
                />
                <path
                  class="cls-1"
                  d="M676.27,1364.14c.86,4.69,1.73,9.42,2.18,14.18,4.16-3.54,8.23-7.12,12.45-10.45-2.43-2.4-4.81-4.85-7.36-7.31-2.36,1.21-4.76,2.4-7.27,3.58Z"
                />
                <path
                  class="cls-1"
                  d="M3297.03,517.87c.19-1.37.54-4.11.71-5.44-7.93-7.29-9.33,14.47-.71,5.44Z"
                />
                <path
                  class="cls-1"
                  d="M2098.51,896.36c.4,1.11,1.19,3.34,1.62,4.45-2.4,2.63-4.16,5.69-5,9.19,4.77-1.46,9.33-3.35,13.06-6.65-3.2-2.28-6.45-4.62-9.68-6.99Z"
                />
                <path
                  class="cls-1"
                  d="M2488.66,737.44c-4.31,2.35-8.55,4.81-12.84,7.22-.58,3.68-1.23,7.36-1.92,11.01.04,2.17.1,6.59.14,8.76l5.86-6.05c-1.69,6.37-3.12,12.78-4.26,19.27,2.33.55,4.6,1.12,6.86,1.66,1.04-14.32,5.23-28.26,9.09-42.06.83-5.18,1.62-10.38,1.82-15.65-6.87,2.85-6.48,9.71-4.75,15.84Z"
                />
                <path
                  class="cls-1"
                  d="M2108.92,886.19c-3.21,2.05-6.44,4.14-9.7,6.24,4.69,2,9.71,2.88,14.63,3.73-1.09-2.46-3.23-7.25-4.4-9.89-.17-.03-.35-.05-.53-.08Z"
                />
                <path
                  class="cls-1"
                  d="M3238.32,512.87c-.71,6.79,5.76,7.87,10.76,9.29-.63-4.4-2.76-7.84-6.38-10.39-1.99-4.76-5.76-8.47-9.76-11.67-3.68,5.61,1.88,9.17,5.38,12.77Z"
                />
                <path
                  class="cls-1"
                  d="M680.31,1343.26c3.03-.08,6.03-.15,9.01-.22,0-1.41.08-4.19.1-5.58-.7-2.76-1.44-5.55-2.21-8.32-3.02.85-6.11,1.66-9.28,2.46.93,3.87,1.72,7.74,2.39,11.66Z"
                />
                <path
                  class="cls-1"
                  d="M1777.21,984.73c1.47-4.55,2.88-9.11,4.05-13.76-8.25,1.18-7.98,7.98-4.05,13.76Z"
                />
                <path
                  class="cls-1"
                  d="M2447.82,761.96c2.51-3.84-3.39-9.55-6.76-5.66-3.2,4,3.59,10.09,6.76,5.66Z"
                />
                <path
                  class="cls-1"
                  d="M664.49,1340.63c-.24,4.72,1.6,5.73,5.49,3.02.33-4.65-1.51-5.66-5.49-3.02Z"
                />
                <path
                  class="cls-1"
                  d="M3572.68,377.47c-10-1.71-11.62,8.16-7.2,14.72,8.66,1.41,16.78-9.04,7.2-14.72Z"
                />
                <path
                  class="cls-1"
                  d="M327.79,1445.05c1.11-4.03,2.62-7.95,4.82-11.49-3.41-.39-6.87-.83-10.36-1.25.43,2.1.74,4.21.94,6.33,2.89.87,5.04,2.47,4.6,6.41Z"
                />
                <path
                  class="cls-1"
                  d="M3538.69,364.16c-2.29,4.61-1.95,9.78-1.81,14.74-3.19,2.49-6.53,5.02-6.67,9.44,2.51-.35,7.47-1.1,9.98-1.44,3.42.9,6.79,1.75,10.21,2.55-.82-9.62-5.09-18.27-11.72-25.29Z"
                />
                <path
                  class="cls-1"
                  d="M3581.88,366.2c-.29,5.4,1.86,6.42,6.4,3.02.35-5.42-1.77-6.45-6.4-3.02Z"
                />
                <path
                  class="cls-1"
                  d="M2501.93,716.4c5.56,1.68,11.36,2.27,17.09,2.12-4.5-5.22-11.59-8.22-17.09-2.12Z"
                />
                <path
                  class="cls-1"
                  d="M2577.25,693.33c1.54-4.64-5.99-5.68-7.45-1.8-1.82,4.73,6.25,6.06,7.45,1.8Z"
                />
                <path
                  class="cls-1"
                  d="M3561.58,315.34c-5.9,9.52-8.62,20.56-12.47,31,4.5,2.97,9.1,5.74,13.29,9.11.07,4.75-.37,9.47-.27,14.21,3.97-3.58,6.3-8.51,7.44-13.66-1.81-6.06-4.24-11.96-6.49-17.92,3.18-8.4,6.82-16.68,7.96-25.66-2.35.73-7.12,2.19-9.47,2.92Z"
                />
                <path
                  class="cls-1"
                  d="M3593,347.77c1.33-.87,3.92-2.62,5.24-3.52-1.1-2.23-3.24-6.74-4.35-9-9.57-1.72-4.95,9.14-.89,12.52Z"
                />
                <path
                  class="cls-1"
                  d="M839.27,1154.4c2.89,11.63-13.59,7.29-19.56,4.74-.42.91-1.15,2.47-1.73,3.73,1.88.17,3.75.37,5.58.68,6.06,1.04,11.57,2.96,16.64,5.46-.42-2.62-.95-5.94-1.24-7.85,1.75-.2,5.22-.59,6.97-.8-2.16-1.98-4.35-3.96-6.65-5.96Z"
                />
                <path
                  class="cls-1"
                  d="M2862.97,574.48c-3.76,4.76,4.4,9.76,7.42,4.91,4.13-4.74-4.32-9.75-7.42-4.91Z"
                />
                <path
                  class="cls-1"
                  d="M161.88,1456.76c-.31-.19-.6-.39-.92-.58.34-.22.69-.35,1.03-.52.19-1.5.43-3,.79-4.48-3.16-1.04-6.37-2.11-9.38-3.42.37-2.68.8-5.37,1.28-8.02l2.26,8.77c10.75-8.68-3.57-12.18-4.89-20.02-3.66,1.87-7.4,3.69-11.21,5.51-.42-1.81-1.22-5.48-1.62-7.34-6.8.07-13.78-2.56-20.5-.1-1.33-2.63-2.69-5.24-4.15-7.89-3.11,2.32-6.07,4.87-8.93,7.65-4.25-4.36-8.28-9.8-9.51-15.85l2.65-.43c-.71-.94-2.07-2.85-2.79-3.8.31-.16.6-.22.91-.33-1-.2-2-.38-3.01-.64-1.68,1.05-3.31,2.16-4.76,3.55l5.03.58c.32,4.88-4.71,8.75-5.85,13.35,5.59,2.17,10.7,5.27,13.93,10.57-2.08.41-6.21,1.25-8.3,1.67,4.03,7.39,9.13-1.57,13.25-3.79.06,1.43.14,4.26.21,5.68,1.76.44,5.34,1.32,7.1,1.78,9.52,10.74,4.81-1.13,4.97-5.59,1.71,5.56,3.91,10.96,6.2,16.23,1.55-.71,4.65-2.12,6.18-2.79,11.07,2.34,21.37,6.84,29.86,14.26-.02-1.34.04-2.67.17-4.02Z"
                />
                <path
                  class="cls-1"
                  d="M82.31,1414.9c-1.01-2.06-3.01-6.14-4.01-8.17-1.41-1.86-4.21-5.58-5.62-7.44l-2.68,5.08c-3.03-1.46-6.13-2.91-9.31-4.32-.94-1.04-2.83-3.11-3.74-4.16-1.68,3.61-3.36,7.21-5.11,10.81,1.49-.28,4.5-.83,5.99-1.11l2.68-.03c-2.5,1.62-7.52,4.87-10.03,6.54,10.44-4.05,15.94,6.5,25.41,7,4.07,1.01,8.36,2.11,12.41,3.67-.23-2.67-.72-7.95-.99-10.59-1.23.67-3.73,2.06-4.99,2.74Z"
                />
                <path
                  class="cls-1"
                  d="M3716.76,296.25c-.19,5.51,1.96,6.72,6.51,3.66.15-5.4-2.02-6.6-6.51-3.66Z"
                />
                <path
                  class="cls-1"
                  d="M4085.17,161.78c-3.53-3.92-8.36-3.05-12.88-2.38.13,2.24.38,4.45.69,6.63,4.58,1.06,8.41-2.34,12.19-4.25Z"
                />
                <path
                  class="cls-1"
                  d="M3875.5,215.34c2.55,3.31,4.86,6.84,6.86,10.6.71-.61,1.41-1.25,2.09-1.91-2.2-3.04-4.42-6.12-6.63-9.2-.84.08-1.6.27-2.32.5Z"
                />
                <path
                  class="cls-1"
                  d="M712.4,1262.9c-3.43-2.78-7.12-5.44-10.82-8.03-1.13,3.63-2.38,7.23-3.61,10.86,1.05-.71,3.16-2.07,4.21-2.75,2.55-.02,7.68-.05,10.23-.08Z"
                />
                <path
                  class="cls-1"
                  d="M172.33,1432.81c-1.01-4.72-1.78-9.5-2.71-14.28-1.72,7.18-4.17,14.2-5.74,21.44,2.6-2.01,5.1-4.07,7.55-6.14.29-.35.6-.68.9-1.02Z"
                />
                <path
                  class="cls-1"
                  d="M3590.56,315.67c10.03-3.14,20.39-7.56,26.63-16.46-9.26,3.86-25.49,3.68-26.63,16.46Z"
                />
                <path
                  class="cls-1"
                  d="M53.01,1460.66c-1.08,2.14-3.17,6.45-4.22,8.6-5.65-8.34-14.31-.81-12.47,7.1,5.4-5.29,19.72-5.7,16.69-15.7Z"
                />
                <path
                  class="cls-1"
                  d="M20.51,1472.62c.27,4.65,2.29,5.77,6,3.35-.12-4.6-2.14-5.72-6-3.35Z"
                />
                <path
                  class="cls-1"
                  d="M2881.63,536.62c2.47,4.27,9.22,2.4,11.22-1.34,2.6-7.78-12.18-4.66-11.22,1.34Z"
                />
                <path
                  class="cls-1"
                  d="M4070.85,148.5c1.97-5.38-6.87-6.33-8.14-1.68-2.19,5.45,6.88,6.36,8.14,1.68Z"
                />
                <path
                  class="cls-1"
                  d="M3571.72,283.8c1.39,9.09-2.63,20.79,5.97,27.26,3.66-8.56,6.8-17.48,7.72-26.82-3.29-5.45-9.35-2.19-13.69-.44Z"
                />
                <path
                  class="cls-1"
                  d="M2877.28,532.13c-5.53,3.15-12.06,5.38-16.43,10.31,5.23-3.86,19.37-.51,16.43-10.31Z"
                />
                <path
                  class="cls-1"
                  d="M4113.11,115.98c-1.69-4.76-3.39-9.55-5.12-14.33-4.1,2.38-11.82,2.21-11.5,8.63-1.29,6.24,7.26,6.7,10.9,9.39-2.29,1.62-6.87,4.9-9.17,6.52,2.83,1.56,5.67,3.06,8.51,4.55,2.81-4.58,4.58-9.66,6.38-14.75Z"
                />
                <path
                  class="cls-1"
                  d="M3614.23,264.54c-1.64-1.19-3.17-2.52-4.6-3.96-.63-.22-1.31-.41-2.08-.55.5,4.11,1.22,8.17,1.96,12.17-2,3.24-11.15,4.88-7.92,10.02,1.12,7.03,10.1,7.97,13.47,2.23-.88-6.03,1.82-14.6-.82-19.91Z"
                />
                <path
                  class="cls-1"
                  d="M3366.16,367.6c2.9-3.47-2.87-9.31-5.67-4.91-2.42,3.41,2.82,8.96,5.67,4.91Z"
                />
                <path
                  class="cls-1"
                  d="M1826.66,860.46c-3.92-.77-7.72,7.26-2.14,6.95,3.93.3,8.39-7.04,2.14-6.95Z"
                />
                <path
                  class="cls-1"
                  d="M1758.32,823.17c-2.14,3.42-4.49,6.74-6.93,9.96,3.18,10.05,4.49,20.55,7.66,30.57,4.71,7,12.45,11.47,20.61,13-.13-1-.36-3.04-.49-4.08-2.17.04-6.54.15-8.71.19.98-15.21-10.35-27.48-9.85-42.33,6.53-3.91,13.25-7.63,20.67-9.2-.81-1.86-1.47-3.78-2.01-5.74-2.04-.46-4.33-.36-6.91.38,1.62-1.69,3.3-3.47,4.39-5.26,1.44.96,3.29,1.03,4.51-.88,1.9-3.04-1.98-7.58-4.9-5.9-.63-.63-1.47-1.25-2.58-1.84-2.91,4.18-5.85,8.33-8.84,12.47-4.95-3.22-3.79-6.87.64-10.09.9-2.48,1.74-4.97,2.5-7.47-5.6,2.2-11.25,4.45-17.04,6.4,1.23,4.07,2.49,8.13,3.67,12.18-4.04,5.76-9.72,8.72-15.95,3.76.7,2.06,2.08,6.18,2.79,8.23-6.81,2.93-9.91,10.43-15.99,14.46.36,1.3,1.05,3.93,1.4,5.22-6.14,6.21-9.96,14.18-4.65,22.32,7.5-13.47,15.77-26.46,24.25-39.28,2.7-3.97,7.9-4.83,11.74-7.09Z"
                />
                <path
                  class="cls-1"
                  d="M917.73,1156.99c4.19-1.47,1.67-8.58-2.5-7.45-4.6,1.37-1.83,8.9,2.5,7.45Z"
                />
                <path
                  class="cls-1"
                  d="M3737.14,210.2c-3.58,4.8-5.2,10.54-6.74,16.22,1.07,2.54,3.24,7.65,4.31,10.22,8.46-6.42,9.31-18.43,2.43-26.44Z"
                />
                <path
                  class="cls-1"
                  d="M3999.38,145.68c-.26-5.43-2.52-6.71-6.81-3.86.21,5.58,2.47,6.86,6.81,3.86Z"
                />
                <path
                  class="cls-1"
                  d="M3582.61,265.15c-.38,6.04,3.51,14.65,10.47,10.23,10.39-4.43-4.78-12.99-10.47-10.23Z"
                />
                <path
                  class="cls-1"
                  d="M1235.27,1031.85c.15,3.14,1.85,5.25,4.98,6.31,4.63,1.82,9.13-5.8,3.71-7.7-3.23-1.03-6.1-.56-8.69,1.39Z"
                />
                <path
                  class="cls-1"
                  d="M1404.77,969.1c-1.93,1.87-2.05,3.72-1.3,5.47.95,1.21,1.87,2.46,2.75,3.73,1.14,1.15,2.38,2.21,3.36,3.15,3.02-8.45,10.9-12.74,17.81-17.51-6.9-7.03-16.19,1.28-22.62,5.16Z"
                />
                <path
                  class="cls-1"
                  d="M1186.15,1053.43c8.73-2.92,18.82-5.27,24.24-13.36-9.12,1.3-21.31,2.89-24.24,13.36Z"
                />
                <path
                  class="cls-1"
                  d="M946.84,1124.46c-2.88,3.73-2.12,5.87,2.37,6.45,2.87-3.66,2.07-5.82-2.37-6.45Z"
                />
                <path
                  class="cls-1"
                  d="M873.72,1157.07c3.87-3.79,11.17-11.51,5.69-16.65-5.51,2.91-5.9,11.07-5.69,16.65Z"
                />
                <path
                  class="cls-1"
                  d="M38.88,1396.97c-3.71-6.32-8.28-11.68-16.34-11.04-1.73.06-5.26.17-7.02.21-.41,1.21-1.23,3.66-1.63,4.9l4.26-1.79c2.39.83,7.23,2.48,9.65,3.3-.08,2.01-.23,5.99-.31,8,1.94,1.21,3.77,2.4,5.54,3.57l-3.54-7.75c5.8,1.1,9.29,4.57,10.39,10.42-4.85,2.86-6.48,7.96-4.76,13.22-3.42-3.49-6.98-6.97-10.67-10.33l2,3.95c-2.96,1.23-5.16,3.23-6.64,6.03,6.47,1.28,15.54,9.08,19.45-.57,3.25,2.44,6.45,5.02,9.58,7.43-2.25-5.15-4.91-10.6-10.08-13.48,1.86-5.62,4.43-11.26,10.75-12.79,1.49-3.42,2.86-6.86,4.13-10.34-.12-.04-.23-.08-.34-.12-5.26,1.24-11.58,1.4-14.41,7.17Z"
                />
                <path
                  class="cls-1"
                  d="M4099.57,100.23c8.54-6.59,7.67-17.19,2.01-25.36,1.73-4.06,4.49-9.83-2.52-10.1.64,11.76-8.39,25.36.52,35.46Z"
                />
                <path
                  class="cls-1"
                  d="M2542.99,596.51c-4.79,1.8-1.93,10.35,2.95,8.92,4.25-1.92,1.55-9.58-2.95-8.92Z"
                />
                <path
                  class="cls-1"
                  d="M1430.29,958.51c1.25,3.93,3.72,7.29,5.91,10.68,4.05-4.68,5.75-10.62,7.2-16.47-4.64.91-10.95.45-13.1,5.79Z"
                />
                <path
                  class="cls-1"
                  d="M3257.78,366.95c5.6-2.6.99-10.57-3.98-6.84-6.33,2.34-1.18,11.01,3.98,6.84Z"
                />
                <path
                  class="cls-1"
                  d="M4077.08,95.61c4.14-1.95,4.29-9.2-.27-10.8-7.16-1.56-6.35,12.26.27,10.8Z"
                />
                <path
                  class="cls-1"
                  d="M296.36,1323.75c1.77-5.28-6.64-6.13-8.32-1.92-2.24,5.4,7.05,6.67,8.32,1.92Z"
                />
                <path
                  class="cls-1"
                  d="M4125.34,61.37c-2.75,4.66-6.58,6.92-11.43,6.79.42-1.82,1.21-5.47,1.62-7.29-2.49.11-5.24-.3-7.06,1.87,2.04,2.86,4.1,5.65,6.22,8.35,3.94-2.76,9.81-4.14,10.64-9.73Z"
                />
                <path
                  class="cls-1"
                  d="M1387.47,955.11c2.35,0,7.07.04,9.44.08,1.29-3.25,2.53-6.47,3.69-9.71.9-.41,1.79-.83,2.68-1.24-2.24-.48-4.47-.98-6.7-1.49-.47.64-.96,1.25-1.37,1.97-3.34,2.84-7.17,5.63-7.73,10.39Z"
                />
                <path
                  class="cls-1"
                  d="M2.07,1392.85c.4,2.26,1.13,6.76,1.5,9.02l5.54-2.18c.41,1.98,1.27,5.94,1.72,7.94,2.25-1.98,4.24-4.11,5.93-6.44-3.88-4.28-9.34-6.36-14.69-8.35Z"
                />
                <path
                  class="cls-1"
                  d="M353.48,1286.31c.21,5.38,2.47,6.42,6.78,3.16-.05-5.4-2.3-6.44-6.78-3.16Z"
                />
                <path
                  class="cls-1"
                  d="M2531.25,578.66c-1.74-4.91-4.56-9.34-8.33-12.95l2.41-.85c-3.19-1.65-6.38-3.36-9.55-5.15-2.13,2.01-4.39,3.95-6.54,6,4.45.77,8.89,1.4,13.31,1.94-.24,6.06.92,12.51,8.7,11.01Z"
                />
                <path
                  class="cls-1"
                  d="M3224.06,347.47c.16-5.5-1.97-6.75-6.35-3.81-.14,5.66,1.99,6.91,6.35,3.81Z"
                />
                <path
                  class="cls-1"
                  d="M2821.59,480.36c2.67-3.56,5.22-7.18,7.77-10.8,0-1.23.01-3.03.02-4.87-1.09.56-2.19,1.11-3.28,1.67.09.21.16.4.26.61-2.07.98-6.19,2.96-8.25,3.97-.05,3.45,2.41,6.34,3.48,9.42Z"
                />
                <path
                  class="cls-1"
                  d="M1801.75,748.68c.21,1.01.43,2.02.63,3.03-2.58,6.21-.86,12.41.97,18.48,3.38-1.05,6.63-1.61,9.74-1.78-4.28-6.11-6.25-13.22-8.4-20.26-.98.18-1.96.35-2.94.53Z"
                />
                <path
                  class="cls-1"
                  d="M261.2,1313.48c3.56-5.36-1.22-10.22-3.24-15.08-4.9,1.06-7.66,4.95-10.04,9.09,4.14,2.58,7.94,7.63,13.28,5.98Z"
                />
                <path
                  class="cls-1"
                  d="M4094.51,48.91c2.75,3.57,3.97,11.04,9.96,8.48,1.9-4.48,3-9.25,3.96-14.03-4.91,1.13-9.54,3.11-13.92,5.55Z"
                />
                <path
                  class="cls-1"
                  d="M209.71,1282.49c-5.84,4.66-12.71,7.21-19.58,10.05,1.16,3.45,3.65,5.63,7.47,6.5-8.77-1.54-7.06,7.21-8.91,12.05,7.72,5.01,9.65,16.28,18.31,19.33-9.27-5.55-7.85-17.87-11.66-26.75,1.42-.39,4.26-1.16,5.69-1.52-1.26-3.66-2.56-7.33-3.93-11.02,6.29.43,9.55-4.09,12.6-8.65Z"
                />
                <path
                  class="cls-1"
                  d="M895.05,1100.69c2.62-4.12-3.91-11.26-7.38-6.33-2.67,4.27,4.03,11.73,7.38,6.33Z"
                />
                <path
                  class="cls-1"
                  d="M-.36,1381.18c-1.69,6.57,10.75,13.26,6.65,2.67,4.42.37,8.41-1.08,12.24-2.85-10.61-2.25-21.28-4.3-31.92-6.41,4.49,2.8,6.48,10.74,13.02,6.59Z"
                />
                <path
                  class="cls-1"
                  d="M844.4,1101.41c-.71-.38-1.42-.77-2.1-1.19-3.97.95-7.94,1.93-11.93,3.03l-1.04-7.29c-2.92,5.36-5.8,10.77-8.74,16.16,4.26-.25,9.61,1.53,11.78-3.34,3.84-8.01,10.96-.08,15.78,2.41l-4.63,2.92,3.34.15c1.95-2.69,3.9-5.34,5.8-7.98,4.02,6.35,4.1,2.89,5.07-1.1-2.54-.16-4.97-.6-7.28-1.29-.12.57-.2,1.14-.32,1.71-3.33.45-5.25-.94-5.73-4.19Z"
                />
                <path
                  class="cls-1"
                  d="M2525.44,553.13c3.96,9.67,13.78,1.02,19.71-1.73-5.13-8.81-13.16-1.18-19.71,1.73Z"
                />
                <path
                  class="cls-1"
                  d="M1692.38,827.85c1.11-4.63,2.43-9.23,3.62-13.82-3.71-1.68-7.57-3.01-11.49-4.32,1.02,1.48,3.06,4.44,4.09,5.93l5.87-.03c-1.25,1.01-3.71,3.06-4.96,4.07.7,2.06,2.13,6.13,2.87,8.17Z"
                />
                <path
                  class="cls-1"
                  d="M2563.22,536.16c.13-5.46-2.08-6.78-6.56-4.04-.14,5.46,2.06,6.82,6.56,4.04Z"
                />
                <path
                  class="cls-1"
                  d="M1684.62,823.12c5.17-1.79.52-9.62-3.83-8.63-4.66,2.3-.6,9.61,3.83,8.63Z"
                />
                <path
                  class="cls-1"
                  d="M3961.31,73.97c-.11-4.67-2.05-5.75-5.79-3.22.1,4.74,2.04,5.82,5.79,3.22Z"
                />
                <path
                  class="cls-1"
                  d="M3807.79,123.38c3.06-3.92-3.49-10.49-6.44-5.43-2.41,3.85,3.34,10.24,6.44,5.43Z"
                />
                <path
                  class="cls-1"
                  d="M2568,528.04c10.86-5.23,21.96-9.86,32.79-15.07,4.28-2.64,11.27-3.98,10.37-10.85-11.08,4.15-22.36,7.9-33.22,12.73-4.93,2.62-12.14,6.38-9.94,13.2Z"
                />
                <path
                  class="cls-1"
                  d="M1760.54,774.27c-2.44,3.45,2.97,9.08,5.81,4.93,2.64-3.45-3.07-9.18-5.81-4.93Z"
                />
                <path
                  class="cls-1"
                  d="M2622.78,488.55c.66,5.53,3.05,6.67,7.12,3.39-.64-5.37-3-6.52-7.12-3.39Z"
                />
                <path
                  class="cls-1"
                  d="M1317.26,918.4c3.2-4.2-3.99-9.15-7.08-5.02-2.98,4.16,4.17,9.06,7.08,5.02Z"
                />
                <path
                  class="cls-1"
                  d="M3825.87,85.17c-4.38,2.03-3.53,9.05.41,11.03,6.67.98,6.7-12.94-.41-11.03Z"
                />
                <path
                  class="cls-1"
                  d="M3452.59,215.42c-.65,4.82,1.11,5.76,5.23,2.83.53-4.64-1.22-5.59-5.23-2.83Z"
                />
                <path
                  class="cls-1"
                  d="M185.68,1285.69c-1.94-4.81-4.07-9.59-6.44-14.27-1.58,4.01-3.05,8.05-4.65,12.11,3.78.78,7.42,1.51,11.09,2.16Z"
                />
                <path
                  class="cls-1"
                  d="M3666.17,99.15c-1.81-.08-5.4-.29-7.21-.37,3.17,12.39-2.67,24.14-9.12,34.75,5.21.05,10.33.7,15.28,1.92,2.08-2.09,3.65-4.62,4.29-7.87,1.89-5.32-2.11-10.07-3.7-14.93,1.83-4.39,1.78-8.95.47-13.5Z"
                />
                <path
                  class="cls-1"
                  d="M1786.53,756.28c2.63,3.64,9.27,2.86,11.4-.9,1.53-7.26-12.87-5.75-11.4.9Z"
                />
                <path
                  class="cls-1"
                  d="M197.33,1275.77c.01-5.32-2.25-6.49-6.8-3.53.11,5.38,2.37,6.55,6.8,3.53Z"
                />
                <path
                  class="cls-1"
                  d="M212.83,1266c3.34-1.29,4.93-3.53,4.77-6.7-2.27-4.17-7.28-.38-9.57,1.88-4.45,3.37,1.38,8.15,4.8,4.82Z"
                />
                <path
                  class="cls-1"
                  d="M4025.17,19.17c4.92-3.05-1.1-9.15-4.97-5.74-5.53,3.05,1.03,9.85,4.97,5.74Z"
                />
                <path
                  class="cls-1"
                  d="M1732.6,761.48c-.12-.04-.23-.11-.35-.16-3.49.81-6.93,1.7-10.34,2.65,2.85,2.89,8.1,2.03,10.68-2.49Z"
                />
                <path
                  class="cls-1"
                  d="M2185.47,603.5c-7.02,0-10.39,5.14-10.72,11.63,8.19,3.58,10.31-5.48,10.72-11.63Z"
                />
                <path
                  class="cls-1"
                  d="M1339.84,879.77c1.21.93,2.42,1.85,3.63,2.77,1.48-2.92,3.32-5.68,5.51-8.19-.15-.1-.32-.22-.45-.31-2.84,1.9-5.78,3.8-8.69,5.73Z"
                />
                <path
                  class="cls-1"
                  d="M1180.52,934.46c-.05,4.69,1.83,5.82,5.66,3.43.13-4.75-1.72-5.89-5.66-3.43Z"
                />
                <path
                  class="cls-1"
                  d="M3709.61,108.87c-5.15-8.67-13.23-.39-19.75,2.01,4.52,10.05,13.25.85,19.75-2.01Z"
                />
                <path
                  class="cls-1"
                  d="M3672.18,112.72c-2.36,3.39,2.87,9.01,5.69,4.97,2.73-3.48-2.93-9.5-5.69-4.97Z"
                />
                <path
                  class="cls-1"
                  d="M3111.45,295.55c-6.44,2.51-.7,11.45,4.39,6.87,4.96-2.73.16-10.1-4.39-6.87Z"
                />
                <path
                  class="cls-1"
                  d="M661.6,1096.99c.31,5.48,2.52,6.57,6.67,3.34-.15-5.6-2.36-6.72-6.67-3.34Z"
                />
                <path
                  class="cls-1"
                  d="M179.77,1254.51c.44-5.56-1.6-6.64-6.15-3.2-.46,5.6,1.6,6.64,6.15,3.2Z"
                />
                <path
                  class="cls-1"
                  d="M662.95,1084.35c-1.43,4.47-.02,6.33,4.23,5.54,1.6-4.56.19-6.42-4.23-5.54Z"
                />
                <path
                  class="cls-1"
                  d="M3701.48,94.99c4.42,5.41,11.03-.81,16.04-2.14,1.23-3.26,1.46-6.78,1.65-10.34-4.12-.7-8.13-1.76-12.02-3.19-2.22,5.18-4.8,10.23-5.67,15.67Z"
                />
                <path
                  class="cls-1"
                  d="M241.14,1226.48c3.74-3.27,3.27-5.23-1.47-5.94-3.6,3.29-3.11,5.29,1.47,5.94Z"
                />
                <path
                  class="cls-1"
                  d="M860.68,1021.46c3.53-1.35,3.81-7.26,1.34-9.78-1.24.44-3.76,1.36-4.99,1.8-.39,3.55.82,6.22,3.65,7.99Z"
                />
                <path
                  class="cls-1"
                  d="M735.58,1062.69c1.71-5.16-1.94-13.45-8.34-9.98-1.11,5.04,2.39,12.16,8.34,9.98Z"
                />
                <path
                  class="cls-1"
                  d="M3418.17,174.66c-3.26,4.53,4.07,10.81,7.32,5.64,3.56-4.42-4.05-10.34-7.32-5.64Z"
                />
                <path
                  class="cls-1"
                  d="M3685.75,87.15c-1.35-3.73-2.67-7.36-4.12-11.06-4.95,3.9-8.34,9.25-11.39,14.64,5.53.58,11.03.13,15.5-3.58Z"
                />
                <path
                  class="cls-1"
                  d="M895.61,992.94c1.46-9.75,2.74-19.62,5.52-29.13-3.15,2.2-6.24,4.36-9.61,6.4-.14,7.81-.78,16.05,4.09,22.73Z"
                />
                <path
                  class="cls-1"
                  d="M3683.57,68.63c.33,4.83,4.92,13.52,9.92,7.32.25-1.14.09-2.37-.24-3.57-2.24-1.45-4.4-3.03-6.47-4.72-.76,0-1.52-.02-2.28-.02-.31.28-.62.61-.92.99Z"
                />
                <path
                  class="cls-1"
                  d="M2360.81,490.87c1.99,9.5,11.76,15.22,20.98,14.23-4.92-7.34-12.28-12.39-20.98-14.23Z"
                />
                <path
                  class="cls-1"
                  d="M173.47,1217.27c-.17-.22-.36-.45-.53-.67,1.11-.24,2.3-1.28,3.57-3.15-1.95-3.58-4.23-3.5-6.9.18-.57-.33-1.15-.65-1.72-1-1.15,4.92-.28,9.9,1.43,14.67,1.36-3.34,2.9-6.66,4.15-10.03Z"
                />
                <path
                  class="cls-1"
                  d="M882.32,994.36c1.31-4.33,2.43-8.73,3.52-13.11-4.22-1.48-8.73-2.86-11.18-7.07-8.33,4.33-10.57,12.63-10.73,21.39,3.78-5.1,8.45-9.11,14.49-11.12.97,2.47,2.93,7.45,3.91,9.92Z"
                />
                <path
                  class="cls-1"
                  d="M281.93,1186.04c4.92-3.56-3.44-12.9-7.35-7.48-3.33,4.52,3,10.22,7.35,7.48Z"
                />
                <path
                  class="cls-1"
                  d="M2835.92,343.44c1.85-4.94-6.53-7.14-8.14-2.49-2.07,5.18,6.6,7.36,8.14,2.49Z"
                />
                <path
                  class="cls-1"
                  d="M1232.26,865.91c3.52-3.13,2.96-5.14-1.67-6.04-3.48,3.25-2.95,5.27,1.67,6.04Z"
                />
                <path
                  class="cls-1"
                  d="M2336.02,467.03c-2.39-.02-7.2-.14-9.61-.19.95,2.81,2.85,8.41,3.83,11.22-1.89-1.67-5.64-5.02-7.51-6.73-9.85,2.37-13.06,13.54-11.55,22.39,2.65,2.46,5.33,4.88,7.98,7.24,4.2-.63,8.32-1.27,12.42-1.9-.03-1.64-.05-4.89-.08-6.53,3.39-3.42,6.96-6.68,9.97-10.45-2.91-4.6-5.62-9.39-5.45-15.06Z"
                />
                <path
                  class="cls-1"
                  d="M875.56,960.18c.51,2.34,1.01,4.69,1.52,7.02,3.29-3.09,6.28-6.52,9.24-9.91-.18-.36-.4-.78-.62-1.23l-6.17,2.97c-1.32.49-2.64.86-3.97,1.15Z"
                />
                <path
                  class="cls-1"
                  d="M2782.35,321.43c-4.7,1.37-1.4,8.79,2.76,7.43,4.33-1.55,1.27-8.38-2.76-7.43Z"
                />
                <path
                  class="cls-1"
                  d="M606.44,1037.05c6.26-3.89,2.31-10.03-2.65-12.85-3.06,3.59-4.42,10.25-10.52,9.79v.68c4.47-.05,11.08-4.12,13.17,2.39Z"
                />
                <path
                  class="cls-1"
                  d="M918.29,926.82c.19-1.98.6-5.88.78-7.82-3.69-.71-7.46-1.43-11.31-2.12,2,5.6,3.86,11.21,5.54,16.88,1.7-2.3,3.36-4.63,4.99-6.94Z"
                />
                <path
                  class="cls-1"
                  d="M641.92,1015.08c1.6,2.03,3.17,4.04,4.65,6.01,2.11-1.97,4.13-3.94,6.13-5.93-1.59-2.51-3.31-5-5.12-7.44-1.86,2.42-3.75,4.89-5.66,7.36Z"
                />
                <path
                  class="cls-1"
                  d="M769.41,965.73c-5.97,2.42-.45,10.77,4.24,6.82,5.41-2.98.88-11.21-4.24-6.82Z"
                />
                <path
                  class="cls-1"
                  d="M2332.16,455.11c-5.19.48-6.47,2.95-3.89,7.45,5.19-.38,6.49-2.86,3.89-7.45Z"
                />
                <path
                  class="cls-1"
                  d="M1358.09,768.73c.18,4.68,2.1,5.7,5.82,3.11-.02-4.7-1.97-5.71-5.82-3.11Z"
                />
                <path
                  class="cls-1"
                  d="M2783.84,301.92c.27,4.75,2.3,5.8,6.03,3.14-.22-4.6-2.25-5.65-6.03-3.14Z"
                />
                <path
                  class="cls-1"
                  d="M633.74,998.66l6.54-.96-3.09,6.08c1.21.31,3.62.9,4.82,1.18-.61-5.78,1.92-11.01,4.8-15.78-.69-2.42-1.45-4.83-2.24-7.23-1.89,1.37-3.76,2.75-5.62,4.15.56,1,1.18,1.98,1.94,2.86-5.68.11-8.31,4.5-7.15,9.7Z"
                />
                <path
                  class="cls-1"
                  d="M2341.65,442.67c3.58-4.26-3.82-11.59-7.11-5.92-2.82,4.25,3.77,10.84,7.11,5.92Z"
                />
                <path
                  class="cls-1"
                  d="M2266.37,461.05c-2.74,3.75,3.46,8.22,6.08,4.3,3.01-3.74-3.43-8.26-6.08-4.3Z"
                />
                <path
                  class="cls-1"
                  d="M2804.55,274.22c-5.93-1.19-11.91-2.2-17.94-2.95-1.49,5.12-1.18,10.3,1.33,14.99,5.41-1.87,10.8-3.89,16.07-6.05.15-1.49.38-4.49.53-5.99Z"
                />
                <path
                  class="cls-1"
                  d="M773.12,939.82c-7.28-2.23-14.59.5-10.89,9.17,3.93-2.69,9.21-4.12,10.89-9.17Z"
                />
                <path
                  class="cls-1"
                  d="M2762.81,264.45c-.86,1.89-2.56,5.64-3.4,7.5,3.43,3.08,7.39,4.71,11.86,4.83-1.08,3.18-2.19,6.36-3.32,9.49,1.96.13,5.91.39,7.87.52,8.51-2.98.71-10.79-2.56-14.73l2.5-1.82c-4.27-1.97-8.6-3.88-12.95-5.79Z"
                />
                <path
                  class="cls-1"
                  d="M1810.67,595.55c.3,5.45,2.65,6.67,7.02,3.59-.29-5.32-2.63-6.5-7.02-3.59Z"
                />
                <path
                  class="cls-1"
                  d="M2753.89,283.16c-.74-2.68-2.29-8.06-3.04-10.74-10.93-.23-5.97,15.9,3.04,10.74Z"
                />
                <path
                  class="cls-1"
                  d="M770.3,892.57c-2.37-1.18-7.09-3.5-9.45-4.65-3.7,1.64-7.52,3.33-11.29,5.06-2.49-2.38-5.51-3.58-9.06-3.56.89,2.1,2.6,6.31,3.45,8.42,6.93,1.67,16.77-.84,17.67,8.92-3.88,2.54-7.76,5.16-11.65,7.77-1.28-.22-3.85-.66-5.14-.91.05,4.99.52,9.95.96,14.88l2.4-.78c-7.28-11.07,9.27-6.09,12.05-14.46-.77,7.21,1.14,14.42,9,16.05-.92-1.28-2.76-3.84-3.68-5.09,1.82-4.09-.76-7.99-1.97-11.8l11.86,1.21-5.17-3.59-5.48.21c-.22-4.27-.48-8.58-.78-12.89,1.55-1.21,4.7-3.62,6.26-4.8Z"
                />
                <path
                  class="cls-1"
                  d="M7.24,1176.58c-.14-5.47-2.36-6.62-6.73-3.42.31,5.48,2.57,6.62,6.73,3.42Z"
                />
                <path
                  class="cls-1"
                  d="M1635.74,610.98c-.13-5.64-2.28-6.89-6.42-3.82.22,5.81,2.35,7.1,6.42,3.82Z"
                />
                <path
                  class="cls-1"
                  d="M623.9,904.78c-6.18-5.64-13.6,2.32-14.4,9.87,2.25-1.59,4.5-3.18,6.78-4.74-.6-.34-1.23-.65-1.9-.93,1.18-.23,2.86-.56,4.62-.9,1.63-1.1,3.25-2.21,4.9-3.3Z"
                />
                <path
                  class="cls-1"
                  d="M1258.94,701.84c1.68-.92,5.08-2.77,6.76-3.69,8.81-12.15,15.85-25.48,24.08-37.95,4.05-9.32-12.57-2.89-15.85-7.16l5.41,6.57c-9.21,11.34-16.08,24.27-23.61,36.72-.89-.99-2.71-2.95-3.61-3.96,7.41,7.67-2.62,15.55-1.95,24.2,2.86-.93,8.55-2.76,11.4-3.69-.6-3.7-1.47-7.39-2.63-11.04Z"
                />
                <path
                  class="cls-1"
                  d="M1935.84,485.75c-2.97-1.79-5.94-3.57-9.04-5.35-.62,1.18-1.89,3.58-2.55,4.76,1.64,1.92,3.26,3.81,4.86,5.71,2.3-1.69,4.54-3.4,6.73-5.12Z"
                />
                <path
                  class="cls-1"
                  d="M854.32,841.65c3.26-3.39,2.61-5.39-2-6.04-3.26,3.52-2.59,5.55,2,6.04Z"
                />
                <path
                  class="cls-1"
                  d="M79,1083.03c.14,1.57.54,3.13,1.21,4.55,3.68-2.37,10.95-6.15,11.3-10.76-3.72,2.94-7.95,5.11-12.51,6.22Z"
                />
                <path
                  class="cls-1"
                  d="M1971.85,461.46c3.47,2.3,9.57,5.41,10.06-1.1-6.77-.14-9.45-6.29-13.02-10.94-3.43,3.2-5.43,7.05-2.68,11.66-.53,3.43-1.07,6.8-1.58,10.2,4.22-1.91,6.61-5.18,7.22-9.82Z"
                />
                <path
                  class="cls-1"
                  d="M745.73,859.61c-.97-1.94-2.86-5.79-3.82-7.69-.43,5.38,2.62,9.97,4.53,14.69.89-.76,2.69-2.36,3.58-3.15,2.09.33,6.31.9,8.4,1.22-3.09-4.54-6.11-9.03-7.96-14.31-1.17,2.3-3.52,6.93-4.72,9.24Z"
                />
                <path
                  class="cls-1"
                  d="M1925.78,469.04c1.59-5.33-6.88-5.62-8.45-1.58-2.26,5.54,7.31,6.32,8.45,1.58Z"
                />
                <path
                  class="cls-1"
                  d="M607.06,893.75c4.51-.6,9.27-2.59,10.34-7.44-.47-4.04-1.86-7.8-3.48-11.5-1.52,5.87-4.52,11.34-9.22,15.81.83,1.11,1.78,2.37,2.36,3.13Z"
                />
                <path
                  class="cls-1"
                  d="M736.44,838.48c1.17,3.69,2.89,6.99,5.17,9.98,3.6-2.55,6.81-5.72,9.96-8.73-5.04,0-10.2.47-15.13-1.25Z"
                />
                <path
                  class="cls-1"
                  d="M2212.41,358.16c1.81-5.67-7.44-7.05-8.8-1.83-2.54,6.21,7.67,7.34,8.8,1.83Z"
                />
                <path
                  class="cls-1"
                  d="M664.56,864.67c.05-5.29-2.2-6.54-6.79-3.7.09,5.42,2.33,6.63,6.79,3.7Z"
                />
                <path
                  class="cls-1"
                  d="M1300.36,640.79c-4.5,1.23-2.14,8.9,2.25,7.4,4.34-1.32,2.13-8.6-2.25-7.4Z"
                />
                <path
                  class="cls-1"
                  d="M728.87,826.19c1.42,1.89,4.31,5.69,5.73,7.57,4.11-3.26,8.1-6.61,11.99-10.03-2.71-6.65-7.85-11.69-12.85-16.71-3.76,5.77-5.96,12.23-4.87,19.17Z"
                />
                <path
                  class="cls-1"
                  d="M648.08,859.09c-.04-4.56-2.05-5.65-6.02-3.31.14,4.66,2.15,5.75,6.02,3.31Z"
                />
                <path
                  class="cls-1"
                  d="M1549.08,545.58c1.75-4.3,6.36-11.09-.37-13.8-2.42.12-7.23.41-9.64.53.1,5.25-.3,10.42-.68,15.62-1.08.72-3.27,2.24-4.33,2.99,4.93-1.48,12.86.57,15.03-5.34Z"
                />
                <path
                  class="cls-1"
                  d="M1560.43,533.51c2.86-6.28-6.94-7.65-8.22-1.92-2.43,6.04,7.3,7.94,8.22,1.92Z"
                />
                <path
                  class="cls-1"
                  d="M1333.1,601.86c2.23-4.9,6.79-9.58,5.27-15.37-11.37-4.76-14.68,10.94-5.27,15.37Z"
                />
                <path
                  class="cls-1"
                  d="M687.82,799.79c-6.07,2.92.29,11.5,5.15,7.73,5.68-3.4.21-11.6-5.15-7.73Z"
                />
                <path
                  class="cls-1"
                  d="M1347.3,580.09c.35-5.53-1.72-6.5-6.2-2.92-.26,5.6,1.81,6.57,6.2,2.92Z"
                />
                <path
                  class="cls-1"
                  d="M1708.45,455.17c7.39,2.06,20.98-.6,18.51-10.24-8.05-1.27-14.38,3.92-18.51,10.24Z"
                />
                <path
                  class="cls-1"
                  d="M2470.92,186.25c-4.29-4.55-9.33.19-13.83,2.03.39.95.78,1.9,1.18,2.85,4.11,2.44,8.96-2.46,12.65-4.87Z"
                />
                <path
                  class="cls-1"
                  d="M1919.11,355.21c-5.67.14-9.14,5.47-13.46,8.39-1.67-1.3-5.03-3.87-6.7-5.18-5.21,2.17-6.16,9.24-10.54,12.72-4.81,3.89,1.46,10.55,6.2,8.09,7.76-.42,7.41-13.65,16.66-9.61,12.57-10.62,29.76-16.34,46.18-14.74.03-1.05.1-3.19.16-4.25-5.23-1.08-10.37-2.93-15.76-3.59-7.46,2.9-14.47,7.88-22.75,8.16Z"
                />
                <path
                  class="cls-1"
                  d="M885,703.23c.56,4.69,2.66,5.69,6.3,3.02-.46-4.59-2.56-5.58-6.3-3.02Z"
                />
                <path
                  class="cls-1"
                  d="M717.36,740.47c-1.92,1.03-5.74,3.02-7.63,4,2.58,5.54,3.26,11.54,3.83,17.51,5.74-5.91,5.16-13.95,3.8-21.51Z"
                />
                <path
                  class="cls-1"
                  d="M2652.35,97.74c2-.53,4.02-1,6.05-1.39,1.28-4.98-.37-10.67-.38-15.85-2.86,3.49-5.81,6.91-8.57,10.5.54,2.46,1.53,4.71,2.9,6.75Z"
                />
                <path
                  class="cls-1"
                  d="M500.28,799.46c.37,2.27,1.1,6.77,1.47,9.03-4.87,2.06-6.34,6.84-3,10.89,4.24-1.85,8.3-3.72,12.4-5.56-1.48-6.17-5.74-10.8-10.87-14.37Z"
                />
                <path
                  class="cls-1"
                  d="M471.5,820.46c-5.46,3.66,4.38,12.89,7.76,6.98.99-4.09-3.88-7.67-7.76-6.98Z"
                />
                <path
                  class="cls-1"
                  d="M11.92,966.53c.02.11.03.23.05.34.24.6.5,1.2.73,1.81.85,2.24,1.54,4.51,2.09,6.8,1.32.31,2.85.67,3.77.9-1.22-1.58-3.69-4.71-4.94-6.29,5.57-7.97,14.41-6.72,22.45-4.34-.31-4.36-4.46-5.87-7.64-8.1-4.6,4.31-10.35,7.32-16.5,8.88Z"
                />
                <path
                  class="cls-1"
                  d="M2559.91,137.97c-5.56-4.47-8.64,2.25-12.13,5.67,4.84,3.4,14.52,2.05,12.13-5.67Z"
                />
                <path
                  class="cls-1"
                  d="M2539.06,151.23c2.13-5.53-6.67-6.12-8.03-1.65-2.1,5.42,6.94,6.64,8.03,1.65Z"
                />
                <path
                  class="cls-1"
                  d="M807.44,703.8c3.53,2.78,7.25,5.43,10.74,8.09,1.24-1.25,3.77-3.79,5.01-5.03-4.7-2.97-10.23-3.65-15.75-3.06Z"
                />
                <path
                  class="cls-1"
                  d="M704.66,731c-4.23,4.04,5.55,12.78,9.84,8.82.17-4.73-6.14-7.07-9.84-8.82Z"
                />
                <path
                  class="cls-1"
                  d="M2567.98,131.3c7.32-.44,5.99-10.8,8.66-15.8-4.93.77-9.68,2.49-14.11,4.77,1.7,3.78,3.53,7.42,5.45,11.03Z"
                />
                <path
                  class="cls-1"
                  d="M2338.6,207.39c.35-3.14,5.46-7.26,1.79-9.86-10.28.13-20.14-2.3-29.79-5.6-1.46.58-4.32,1.71-5.74,2.28,2.84,14.67,22.52,11.1,33.75,13.19Z"
                />
                <path
                  class="cls-1"
                  d="M677.99,739.81c5.76-2.22,11.85-3.97,16.99-7.36,1.61-4.12,1.19-7.99-1.27-11.62l.57-.32c1.36,1.91,4.07,5.66,5.43,7.57,1.53-1.27,4.61-3.79,6.15-5.06-4.47-2.88-9.99-5.07-11.56-10.92-4.12,6.72-9.86,12.13-15.92,17.13,1.87,3.66,1.74,7.2-.38,10.58Z"
                />
                <path
                  class="cls-1"
                  d="M400.51,820.6c2.59,1.04,5.04,2.33,7.32,3.84,3.85-.92,7.57-2.27,11.01-4.35-5.24-2.23-13.01-2.5-18.33.51Z"
                />
                <path
                  class="cls-1"
                  d="M478.71,783.95c1.31,2.46,4,7.4,5.33,9.86,1.84-.64,5.49-1.93,7.32-2.59,4.29,5.83,9.33,6.54,15.07,2.1-2.56-1.86-5.19-3.65-7.95-5.41,2.45-.33,7.34-.98,9.8-1.28l-.02-5.61c-4.51.4-9.07.74-13.71,1.05-.2-3.5-.6-10.49-.79-13.96-3.93,6.39-10.91,1.38-16.33,4.35-2.45,3.82-4.56,7.87-6.74,11.88,2.72-.11,5.4-.25,8.01-.39Z"
                />
                <path
                  class="cls-1"
                  d="M531.56,777.39c1.54-8.47-14.9-3.1-13.85,2.17,4.52.04,10.43,1.37,13.85-2.17Z"
                />
                <path
                  class="cls-1"
                  d="M1656.39,401.58c-3.32,3.44-2.74,5.5,1.73,6.23,3.38-3.35,2.8-5.42-1.73-6.23Z"
                />
                <path
                  class="cls-1"
                  d="M2290.47,190.13c-3.36,4.63,3.66,8.32,7.14,5.4,7.49-4.03-3.8-12.57-7.14-5.4Z"
                />
                <path
                  class="cls-1"
                  d="M717.96,708.21c-.75-3.62-.03-8.33-3.74-10.64-7.12-.1-13.29,4.17-17.9,9.31,7.14,1.7,14.45,1.64,21.65,1.34Z"
                />
                <path
                  class="cls-1"
                  d="M1734.09,372.08c2.26-3.49-.9-10.36-5.54-8.95-4.63,3.02.89,13.32,5.54,8.95Z"
                />
                <path
                  class="cls-1"
                  d="M561.35,755.48c.25-2.79.81-5.53,1.68-8.18-5.4,1.19-10.86,3.04-14.75,7.26.37,8.93,7.55,3.56,13.07.92Z"
                />
                <path
                  class="cls-1"
                  d="M527.18,751.09c-.83,6.93-8.25,13.75-2.71,20.42,11.39-3.11,10.47-16.73,11.51-25.91-2.18,1.35-6.58,4.13-8.8,5.49Z"
                />
                <path
                  class="cls-1"
                  d="M352.02,808.26l.49,2.26c4.74,1.67,9.51,3.13,14.27,4.27-1.75-4.49-9.3-5.67-14.76-6.53Z"
                />
                <path
                  class="cls-1"
                  d="M2636.66,60.18c-3.4,1.51-6.78,3.22-10.13,4.92-.54,4.85-1.24,9.68-1.57,14.56,2.44-2.51,4.61-5.24,6.61-8.07,3.28-2.92,10.3-6.45,5.08-11.41Z"
                />
                <path
                  class="cls-1"
                  d="M687.05,712.89c-2.46-7.84,6.25-5.97,8.68-10.5-2.54-5.22-7.73-3.49-12.32-2.43.39,4.58-1.05,10.06,3.65,12.93Z"
                />
                <path
                  class="cls-1"
                  d="M1023.25,580.45c-6.61,1.48-7.21,7.46-8.05,13.12.68,1.66,2.1,5,2.81,6.65,7.15-4.76,6.19-12.54,5.25-19.76Z"
                />
                <path
                  class="cls-1"
                  d="M2585.03,78.21c-2.4,5.52,6.75,6.87,7.88,1.8,2.23-5.43-6.43-6.31-7.88-1.8Z"
                />
                <path
                  class="cls-1"
                  d="M675.94,705.52c2.37-4.27-2.46-13.11-7.53-10.52,2.05,3.09,2.04,15.4,7.53,10.52Z"
                />
                <path
                  class="cls-1"
                  d="M657.75,710.05c1.49-4.49,0-6.15-4.48-5.06-1.35,4.51.13,6.17,4.48,5.06Z"
                />
                <path
                  class="cls-1"
                  d="M476.44,753.3c-3.36,3.18-7.06,6.27-9.32,10.47,1,3.78,3.33,5.37,7.04,4.79-.87-2.37-2.6-7.15-3.45-9.53,1.77-.55,5.36-1.61,7.14-2.13l-1.41-3.61Z"
                />
                <path
                  class="cls-1"
                  d="M625.31,714.79c3.1-4.31-4.25-10.65-7.73-6.18-2.62,4.42,4.22,10.86,7.73,6.18Z"
                />
                <path
                  class="cls-1"
                  d="M1010.77,549.43c-1.47-1.4-4.39-4.18-5.85-5.55-4.63,3.43-10.1,5.21-15.83,6.08-7.02-1.34-14.1-2.42-21.28-3.1,6.33,3.75,11.65,8.4,10.54,16.43,4.91.11,9.87.27,14.71.37l-1.22,5.11c3.87-.59,7.72-1.28,11.52-1.98,1.74,3.37,4.47,5.67,8.26,6.88-1.31,4.63-2.78,9.21-4.43,13.72,5.27-3.74,10.53-7.07,15.65-10.86.81-6.28-4.16-12.96-10.75-8.73l-.67-3.71c-1.87.54-5.6,1.69-7.47,2.24,3.48-2.72,7.39-4.66,11.86-3.94l2.1.56c3.35-.96,6.57-2.11,9.64-3.42-1.19-3.44-2.39-6.92-3.63-10.41-1.47,2.9-1.91,7.11-5.55,8.13-.5-2.66-1.5-7.98-2-10.64-3.4-3.09-6.83-6.31-10.71-8.91,2.36,4.04,9.59,6.42,5.11,11.74Z"
                />
                <path
                  class="cls-1"
                  d="M674.28,683.47c.21,5.68,8.48,3.95,8.56-.85.64-6.8-10.21-5.74-8.56.85Z"
                />
                <path
                  class="cls-1"
                  d="M2647.56,41.87c.07-5.57-2.02-6.6-6.3-3.12-.04,5.63,2.05,6.69,6.3,3.12Z"
                />
                <path
                  class="cls-1"
                  d="M2202.59,183.08c3.51-3.36,2.93-5.33-1.7-5.93-3.52,3.43-2.97,5.41,1.7,5.93Z"
                />
                <path
                  class="cls-1"
                  d="M2655.02,32.91c.49-1.17,1.45-3.5,1.95-4.64-5.47-10.05-12.95,9.64-1.95,4.64Z"
                />
                <path
                  class="cls-1"
                  d="M2177.36,172.73c-.06,6.2,2,11.89,7.54,15.15,2.16-2.55,4.14-5.25,5.9-8.08-1.22-5.69-9.09-4.77-13.44-7.08Z"
                />
                <path
                  class="cls-1"
                  d="M1037.37,528.25c2.1,4.16,4.23,8.33,6.27,12.41,2.91.82,5.75,1.85,8.54,2.94-.09-2.44.08-4.88.48-7.32-1.11-2.29-1.09-5.46-1.42-8.05-4.46-1.84-9.36-2.32-13.87.02Z"
                />
                <path
                  class="cls-1"
                  d="M669.59,677.54c-1.59-1.77-4.81-5.25-6.42-7.01.04,3.21-.09,6.42-.07,9.57,6.81,1,11.77-5.02,13.85-10.81-6.89-1.75-9.63.99-7.36,8.25Z"
                />
                <path
                  class="cls-1"
                  d="M596.55,700.41c3.35-4.15-3.5-11.53-7.11-6.45-2.65,4.13,3.62,11.39,7.11,6.45Z"
                />
                <path
                  class="cls-1"
                  d="M2634.62,28.81c-7.39-7.81-20.59-4.47-30.08-3.39,7.09,9.35,20.67,7.71,30.08,3.39Z"
                />
                <path
                  class="cls-1"
                  d="M2159.9,176.18c5.43-1.7-.09-8.91-2.32-11.44-8.67.41-4.71,14.11,2.32,11.44Z"
                />
                <path
                  class="cls-1"
                  d="M659.19,660.3c1.78-.62,5.37-1.89,7.18-2.51-.54-.83-1.57-2.44-2.07-3.26,4.08-8.29-3.78-9.22-10-9.01,1.47,5.03,3.17,9.92,4.89,14.77Z"
                />
                <path
                  class="cls-1"
                  d="M627.21,666.74c-2.13,5.74,7.67,5.67,8.78,1.17,1.38-5.36-7.21-5.01-8.78-1.17Z"
                />
                <path
                  class="cls-1"
                  d="M651.68,654.89c-4.78-1.46-9.65-2.9-14.58-4.18,1.8,5.83,12.1,14,14.58,4.18Z"
                />
                <path
                  class="cls-1"
                  d="M951.91,534.09l4.6-.63-1.09-4.15c8.17-.11,15.84-5.44,23.9-2.05,8.06-1.35,15.18-6.23,22.82-8.86,4.98.93,9.95,1.56,14.86,2.17-1.81,4.46.55,8.06,3.54,11.15,1.33-3.12,2.59-6.29,3.8-9.48l-6.11,2.2c-.07-4.25,4.18-9.53.67-13.29-3.72-1.41-7.62-2.02-11.57-2.91l2.69,5.37c-6.74-1.19-13.64-2.44-20.4-4,1.48-1.43,4.48-4.29,6-5.72-4.19-2.73-7.78-6.13-10.99-10.09-1.33-.27-4-.81-5.37-1.1-4.03-8.23-7.44-16.83-11.73-25.01-5.24,6.62,4.1,13.69,2.5,21.24,2.57,2.22,5.09,4.46,7.22,6.99,1.2.38,3.54,1.16,4.71,1.56-2.34.66-6.98,2.01-9.27,2.69.72,4.98,3.41,9.31,5.45,13.72,1.88-3.1,3.71-6.25,5.43-9.4,3.2,3.22,6.41,6.45,9.51,9.67-5.54,2.28-11.42,4.47-17.11,6.59-10.13-5.4-21.47,3.31-24.07,13.37Z"
                />
                <path
                  class="cls-1"
                  d="M1025.85,521.38c1.46,4.47,8.84,5.35,11.64,1.88,2.12-6.68-10.68-8.01-11.64-1.88Z"
                />
                <path
                  class="cls-1"
                  d="M1736.57,286.87c1.97.57,5.89,1.67,7.85,2.21-1.83-5.39-4.72-10.43-9.18-14.11l3.95-2.53c-1.58.21-4.74.61-6.32.82,1.6,4.18,3.06,8.35,4.46,12.53l-8.68-1.97c1.06,2.61,3.16,7.81,4.21,10.42.94-1.85,2.77-5.51,3.71-7.36Z"
                />
                <path
                  class="cls-1"
                  d="M957.44,536.72c.48,1.16,1.42,3.43,1.9,4.59,4.51-.4,8.85.34,12.99,2.21.04-3.07.15-6.13.04-9.26-4.68,2.03-9.73,2.94-14.93,2.45Z"
                />
                <path
                  class="cls-1"
                  d="M1802.54,258.61c-6.12,2.47-.71,10.48,4.16,6.67,6.14-2.51.85-10.56-4.16-6.67Z"
                />
                <path
                  class="cls-1"
                  d="M1704.97,289.95c-5.81,2.8-.38,10.38,4.38,6.64,6.33-2.44.6-10.62-4.38-6.64Z"
                />
                <path
                  class="cls-1"
                  d="M639.56,632.69c3.21,2.41,6.43,4.86,9.53,7.27-1.43,1.27-4.28,3.78-5.71,5.06,11.14.13,5.03-11.66,7.93-18.35,2.51-4.89-3.22-7.92-5.65-11.53-1.33,3.12-2.8,6.26-4.23,9.38,1.57.7,4.75,2.08,6.31,2.75-2.04,1.37-6.14,4.05-8.18,5.43Z"
                />
                <path
                  class="cls-1"
                  d="M1724.29,282.84c-4.33-8.43-7.01,3.33-8.84,6.89,3.82-.04,13.39-.67,8.84-6.89Z"
                />
                <path
                  class="cls-1"
                  d="M763.84,598.34c-1.74-4.81-.86-13.23-8.24-12.87,1.32,4.55,2.37,21.48,8.24,12.87Z"
                />
                <path
                  class="cls-1"
                  d="M1051.3,490.62c-8.42,7.05-21.07,9.8-26.02,20.39,10.96-2.97,24.37-7.32,26.02-20.39Z"
                />
                <path
                  class="cls-1"
                  d="M1223.19,432.4c.12-4.78-1.76-5.61-5.58-2.58.01,4.67,1.87,5.51,5.58,2.58Z"
                />
                <path
                  class="cls-1"
                  d="M944.68,525.32c2.4-4.58,9.48-8.04,7.97-13.79-4.17-4.12-8.84-2.16-11.18,2.91-1.63-4.27-5.2-6.57-9.76-7.03,1.76,7.56,8,12.55,12.97,17.92Z"
                />
                <path
                  class="cls-1"
                  d="M617.25,623.97c-.68-1.28-1.68-3.18-2.69-5.09-1.61.45-3.24.86-4.85,1.29-.79,1.01-1.67,1.99-2.43,2.99,1.6,1.39,3.08,2.76,4.53,4.1,4.32-2.52,9.11-4.42,14.13-4.07.92-1.51,1.77-3.03,2.54-4.56l2.64,3.24c3.33-2.93,6.33-6.1,5.58-9.97-4.12,1.44-8.26,2.82-12.42,4.11-1.58,3.15-4.08,5.75-7.03,7.96Z"
                />
                <path
                  class="cls-1"
                  d="M1883.4,199.78c4.74-4.1,3.83-11.03,5.2-16.52,1.83.88,5.48,2.68,7.28,3.57,2-.65,5.97-1.98,7.98-2.64.19-.42.38-.84.57-1.26-.56,4.81,7.65,6.02,8.99,1.05.86-1.88.45-3.31-.56-4.22,4.55-2.29,1.68-7.86.42-12.45-5.99-.84-7.56,3.11-6.77,8.93-1.9-.93-3.84-1.91-5.78-2.9-.71-3.86-3.02-4.52-6.88-1.93.13,2.52.74,4.11,1.84,4.78-.74,1.86-1.5,3.75-1.98,5-5.2-4.69-8.93-3.27-10.48,3.42-9.19,3.17-15.54,10.79-14.95,20.71,5.13-1.47,11.32-1.37,15.13-5.54ZM1908.41,174.13l1.44,4.47c-1.48-.09-3.04.34-4.08,1.36.87-1.95,1.74-3.9,2.65-5.83Z"
                />
                <path
                  class="cls-1"
                  d="M261.03,730.1c3.05-5.5-6.05-10.6-8.83-4.81-2.57,5.11,6.07,10.25,8.83,4.81Z"
                />
                <path
                  class="cls-1"
                  d="M1704.51,256.12c.04-4.62-1.91-5.86-5.86-3.74-.02,4.78,1.93,6.03,5.86,3.74Z"
                />
                <path
                  class="cls-1"
                  d="M1174.47,412.7c5.14,2.26,10.19.1,14.78-2.1-1.84-5.95-7.14-4.46-11.94-3.53-6.04-2.33-12.13-1.32-16.65,3.69,4.07,3.21,9.2,2.04,13.81,1.95Z"
                />
                <path
                  class="cls-1"
                  d="M924.33,485.75c-7.65-3.15-3.11-14.68-11.89-16.56.81,1.85,2.49,5.57,3.33,7.42l-3.24.48c-1.48-1.87-4.52-5.62-6.05-7.51-6.54,7.25,3.84,28.23,11.79,13.87,1.2,6.57,2.75,13.05,4.8,19.34,9.79-5.01-4.55-11.05,1.26-17.05Z"
                />
                <path
                  class="cls-1"
                  d="M1200.54,407.79c1.63-2.62,3.24-5.22,4.77-7.84-4.46-2.24-9.01-4.42-13.65-6.5-.5,3.22-1.14,6.49-1.08,9.77,3.01,2.21,6.63,3.32,9.97,4.58Z"
                />
                <path
                  class="cls-1"
                  d="M574.61,526.29c1.93.98,5.75,3,7.7,4.01-.19,4.97-2,10.03-.54,14.93.16,1.38.56,2.85.99,4.35,5.24-1.11,10.45-2.38,15.61-3.82-10.71-2.66-.67-23.27-13.21-22.88-.67-3.91-1.38-7.82-2.13-11.78l-2.69.81c.6,1.95,1.83,5.92,2.44,7.88-1.7.86-5.1,2.61-6.8,3.46l-1.36,3.03Z"
                />
                <path
                  class="cls-1"
                  d="M1935.95,162.63c-.45.26-.94.58-1.45.99.28,4.58,2.32,5.46,6.05,2.56-.28-3.33-1.43-4.68-3.43-4.07,14-6.22,27.39-14.09,41.83-19.24,6.11-2.8,13.86,1.89,19.07-2.86,1.53-6.95-8.3-6.37-12.4-8.86-6.75,3.62-13.71,6.93-20.93,9.62-7.77-2.37-15.81-1.69-18.57,7.17-14.52-4.94-21.16,10.13-29.55,18.62l3.76,1.83c5.35-1.55,10.54-3.54,15.64-5.77Z"
                />
                <path
                  class="cls-1"
                  d="M1696.68,233.67c4.89,1.5,6.93-4.11,9.4-7.04-4.35-2.21-8.81-4.35-13.32-6.41-.97,4.85-1.25,10.9,3.92,13.44Z"
                />
                <path
                  class="cls-1"
                  d="M17.43,781.78c1.67-3.64,2.88-7.46,3.58-11.39-8.92-4.35-11.7,22.14-3.58,11.39Z"
                />
                <path
                  class="cls-1"
                  d="M759.3,537.37c.22-4.48-1.74-5.75-5.99-3.83-.14,4.52,1.86,5.81,5.99,3.83Z"
                />
                <path
                  class="cls-1"
                  d="M38.42,771.03c-.18-.85-.53-2.55-.71-3.4l-6.58.84c1-1.77,3-5.32,4.01-7.09-1.17-.69-3.51-2.11-4.69-2.84,1.41-.63,4.27-1.96,5.7-2.63-2.73-4.45-5.43-8.92-8.3-13.39-3.11,5.82-1.22,10.78,4.11,14.56-1.4.66-4.19,2.01-5.58,2.66,2.23,4.05,3.38,8.31,3.45,12.83,2.93-.49,5.79-1.02,8.61-1.53Z"
                />
                <path
                  class="cls-1"
                  d="M2224.19,41.95c5.54-17.31,17.62-33.95,12.34-53.04-2.51,1.16-7.51,3.46-10.02,4.62,4.37,11.01-6.66,20.9-1.24,31.63-2.67,8.6-9.47,17.21-6.65,26.47,2.45-2.88,4.39-6.11,5.58-9.69Z"
                />
                <path
                  class="cls-1"
                  d="M90.17,744.73c1.04-3.5-3.99-8.82-7.26-5.66-1.78,3.81,4.28,8.59,7.26,5.66Z"
                />
                <path
                  class="cls-1"
                  d="M260.05,680.23c-3.88-1.99-7.7,4.83-4.61,7.49,3.87,1.26,7.97-4.62,4.61-7.49Z"
                />
                <path
                  class="cls-1"
                  d="M1568.36,129c5.24,3.2,12.22,13.02,14.75,2.04,6.93.63,13.73-.88,20.22-3.04,3.3,3.73,9.93,5.9,10.21,11.39-1.28,4.92,1.91,6.77,6.05,7.51,4.19-6.11,8-13.4,15.47-15.94,9.59-6.26,18.9,3.01,27.89,5.85,7.62,17.98,17.16,35.17,24.19,53.31-.87,9.7-.63,19.7,8.12,26.02,2.36-4.5,4.52-9.11,6.45-13.8-2.75-11.81-14.52-22.25-10.62-35.02-1.27-.9-3.76-2.77-5-3.68-.49-12.51-5.17-25.61-15.64-33.18.38-3.79,1.01-7.52.75-11.4-3.41-1.91-6.95-3.68-10.62-5.34-4.12-7.67-7.89-15.51-11.9-23.28-10.26,8.42,5.58,19.99,4.67,30.58-4.68-3.11-7.09-8.14-9.61-13.07-5.46.77-11.16,1.12-16.42-1.09-9.73-3.75-20.16-1.12-30.28-1.21-1.77-2.55-3.61-5.08-5.46-7.66-9.46,3.76-19.58,4.27-29.63,3.45-2.35-4.21-4.84-8.44-7.32-12.64-5.44,1.88-10.76,3.91-16.22,5.9.81,12.17,12.32,22.1,7.52,34.69,7.24,4.66,15.56,5.54,22.43-.4Z"
                />
                <path
                  class="cls-1"
                  d="M1600.89,230.62c-2.6,4.28,4.57,9.06,7.57,5.16,2.72-4.22-4.5-8.85-7.57-5.16Z"
                />
                <path
                  class="cls-1"
                  d="M1064.05,414.43c1.62-4.63-5.68-5.77-7.1-1.78-2.15,4.84,6.16,6.42,7.1,1.78Z"
                />
                <path
                  class="cls-1"
                  d="M896.7,456.38c-2.47-.37-7.42-1.11-9.9-1.51,2.45,4.11,4.17,8.76,8.4,11.31,2.6,4.87,9.04-1.03,3.42-3.43l-1.92-1.26c-1.65-4.34,3.6-5.95,5.92-8.42,1.24,1.85,3.69,5.55,4.93,7.37,3.73-5.76-1.17-11.42-4.17-16.18-2.24,3.96-2.76,9.57-6.66,12.12Z"
                />
                <path
                  class="cls-1"
                  d="M1983,93.11c-9.55,2.78-1.8,10.64,1.88,15.02,1.85-5.14.42-10.25-1.88-15.02Z"
                />
                <path
                  class="cls-1"
                  d="M158.3,677.98c-1.55,5.75,3.52,8.93,6.81,12.53,4.02-5.28.83-17.85-6.81-12.53Z"
                />
                <path
                  class="cls-1"
                  d="M1045.5,394.46c1.49-.33,2.95-.76,4.41-1.24-3.52.13-7.05.21-10.57.24,1.58,1.4,3.63,1.75,6.16,1.01Z"
                />
                <path
                  class="cls-1"
                  d="M881.47,443.4c0,5.55,2.15,6.89,6.45,4.11.16-5.7-1.97-7.06-6.45-4.11Z"
                />
                <path
                  class="cls-1"
                  d="M994.36,409.07c4.2-3.52,8.43-6.92,12.63-10.31,8.96,2.49,24.75,5.36,28.1-5.3-2.38-.01-4.76-.05-7.13-.11-3.94,1.44-7.95,2.67-12.24,2.3-6.86.93-16.74-2.57-19.15,6.62-2.54-.78-5.11-1.56-7.76-2.34,1.85,3.09,3.78,6.13,5.54,9.15Z"
                />
                <path
                  class="cls-1"
                  d="M182.47,665.52c-4.99,1.49-2.28,10.22,2.67,8.27,4.55-1.72,2.14-9.71-2.67-8.27Z"
                />
                <path
                  class="cls-1"
                  d="M937.92,415.83c.84,2.28,1.72,4.55,2.47,6.76,4.1-1.64,8.26-3.23,12.29-4.78l-1.56-4.87c2.04.68,6.09,1.98,8.16,2.65-1.76-5.38-6.95-6.98-11.7-8.96-.75,5.22-4.34,8.64-9.67,9.21Z"
                />
                <path
                  class="cls-1"
                  d="M195.25,669.76c4.14-5.45,1.72-11.42-2.93-15.58-5.16,5.08-2.64,12.09,2.93,15.58Z"
                />
                <path
                  class="cls-1"
                  d="M1570.93,214.82c1.05-3.47,1.84-7.02,2.41-10.64-2.17,1.18-6.56,3.49-8.76,4.67.72,3.53,1.76,8.37,6.35,5.96Z"
                />
                <path
                  class="cls-1"
                  d="M963.66,413.14c4.36-1.59,3.07-10.15-2.09-8.46-4.49,1.5-3.16,10.51,2.09,8.46Z"
                />
                <path
                  class="cls-1"
                  d="M876.66,430.52c-3.31-3.56-6.45-7.41-9.33-11.48-.59,1.07-1.79,3.17-2.38,4.24,1.03,3.87,1.94,7.7,2.77,11.57,1.23-.13,3.69-.33,4.93-.43.58,2.6,1.74,7.8,2.32,10.4,1.36-1.39,4.05-4.18,5.38-5.55,3,.63,5.88.4,8.58-.68-2.07-4.9-4.49-9.73-7.01-14.48-1.68,2.16-3.44,4.28-5.26,6.42Z"
                />
                <path
                  class="cls-1"
                  d="M209.22,661.16c5.75-4.84,10.32-10.8,14.75-16.81-1.21-1.65-3.61-4.97-4.83-6.66-6.66,2.58-9.59,10.36-14.37,15.38,1.56,2.72,3.04,5.39,4.46,8.09Z"
                />
                <path
                  class="cls-1"
                  d="M1560.9,210.76c-.7-2.16-2.05-6.49-2.75-8.62-3.33,3.61-7.45,5.39-12.34,5.34.81,1.96,2.39,5.88,3.2,7.83,3.6-2.45,7.41-4.6,11.89-4.55Z"
                />
                <path
                  class="cls-1"
                  d="M1489.66,234.42c2.02-5.67-7.33-7.02-8.88-1.97-2.54,6.11,7.61,7.36,8.88,1.97Z"
                />
                <path
                  class="cls-1"
                  d="M568.33,524.98c3.86-.32,8.09-4.05,7.88-8.09-3.72-4.5-11.06,4.42-7.88,8.09Z"
                />
                <path
                  class="cls-1"
                  d="M296.95,607.01c.28-5.54-1.82-6.8-6.28-3.8-.18,5.64,1.92,6.9,6.28,3.8Z"
                />
                <path
                  class="cls-1"
                  d="M1594.58,171.63c-5.23-1.59-9.59.81-13.47,4.26,1.09,1.29,3.22,3.89,4.27,5.16,4.61-1.54,7.87-4.82,9.19-9.42Z"
                />
                <path
                  class="cls-1"
                  d="M162.05,635.92c-4.63,1.38-1.52,9.14,2.73,7.55,4.05-1.69,1.27-8.38-2.73-7.55Z"
                />
                <path
                  class="cls-1"
                  d="M766.61,424.46c4.11-8.94,24.53-3.94,19.38-16.61-15.79,3.84-30.96,13.9-38.67,28.49,7.12-3,11.57-10.06,19.28-11.87Z"
                />
                <path
                  class="cls-1"
                  d="M1603.47,150.68c1.51-4.63-6-5.4-7.58-1.8-1.92,4.83,6.33,6,7.58,1.8Z"
                />
                <path
                  class="cls-1"
                  d="M881.64,376.89c-4.59,1.6-2.74,10.74,2.38,8.94,3.86-1.97,2.52-10-2.38-8.94Z"
                />
                <path
                  class="cls-1"
                  d="M581.52,480.14c-1.79-9.2-5.61-18.1-12.23-24.91.69,2.33,2.05,7,2.71,9.33.61,4.64,1.14,9.24,1.27,13.87-2.06-3.83-5.37-6.55-9.63-7.58,2.06,3.83,3.73,7.82,6.24,11.28,4.01,2.93,8.01-.6,11.65-1.99Z"
                />
                <path
                  class="cls-1"
                  d="M794.62,408.93c6.28-5.07,25.35-3.8,19.88-15.6,2.08-.95,6.19-2.86,8.27-3.81-2.77-.64-8.3-1.96-11.08-2.64l2.05-4.84-2.4.99c-3.51,5.92-6.11,12.28-7.31,19.09-1.97-.9-5.97-2.73-7.94-3.63-.44,3.5-.95,6.97-1.47,10.43Z"
                />
                <path
                  class="cls-1"
                  d="M1159.29,282.01c1.74-1.65,3.64-3.14,5.69-4.43.08-2.93-3.58-5.86-6.89-3.3-4.92,2.05-2.44,7.4,1.2,7.73Z"
                />
                <path
                  class="cls-1"
                  d="M846.36,380.64c-5.21-4.12-11.05-7.59-17-10.69-5.79,2.86-12.14,5.34-15.32,11.56,4.3,2.06,10.26.95,13.15,5.15,3.2-6.46,12.83-8.59,19.18-6.02Z"
                />
                <path
                  class="cls-1"
                  d="M1064.69,302.62c1.89-4.92-6.05-5.05-7.34-1.27-2.18,5.05,6.39,5.48,7.34,1.27Z"
                />
                <path
                  class="cls-1"
                  d="M118.24,611.57c2.59-3.4-2.85-8.95-5.95-5.35-2.46,3.39,2.97,8.98,5.95,5.35Z"
                />
                <path
                  class="cls-1"
                  d="M854.85,362.88c-1.85.94-5.58,2.79-7.42,3.73-2.56-2.59-5.98-4.1-9.55-5.25-.41,4.91.38,9.49,2.43,13.83,5.09-3.88,10.1-7.77,14.54-12.31Z"
                />
                <path
                  class="cls-1"
                  d="M1704.84,86.09c3.37-3.89-3.62-10.58-6.65-5.66-2.05,3.8,3.33,9.67,6.65,5.66Z"
                />
                <path
                  class="cls-1"
                  d="M88.74,605.13c-3.16,3.82-2.49,5.96,1.91,6.37,3.11-3.77,2.44-5.91-1.91-6.37Z"
                />
                <path
                  class="cls-1"
                  d="M569.29,448.63c-1.16-1.5-3.53-4.53-4.7-6.06-2.17,1.38-6.51,4.14-8.71,5.53,4.24,3.32,8.99,3.75,13.42.53Z"
                />
                <path
                  class="cls-1"
                  d="M66.11,595.44c-.09,6.01,3.61,11.36,9.98,11.33-1.55-5.07-1.87-16.63-9.98-11.33Z"
                />
                <path
                  class="cls-1"
                  d="M1628.86,74.09c-.71,9.88,9.2,11.92,16.44,14.13-.73-4.3.11-9.95-4.58-12.39-3.6-1.04-8.82-6.33-11.86-1.74Z"
                />
                <path
                  class="cls-1"
                  d="M561.04,439.63c2.81-2.83,5.64-5.67,8.34-8.54-1.56-.97-4.61-2.9-6.13-3.85,3.01-4.18,1.27-6.93-2.59-9.07.88-1.33,2.64-4.06,3.52-5.38-8.4,1.46-4.51,10.99-3.07,16.13-4.59-1.9-8.31-4.95-11.27-9.19-.37.09-1.17.21-1.58.31,4.33,6.79,13.46,10.43,12.78,19.59Z"
                />
                <path
                  class="cls-1"
                  d="M635.05,392.44c-5.87,6.42-3.47,15.22-3.19,22.99,2.98-3.96,5.94-7.85,8.45-12.1-1.4-3.78-3.33-7.32-5.27-10.89Z"
                />
                <path
                  class="cls-1"
                  d="M541.91,439.01c-.1-5.25-2.45-6.36-7.08-3.27.21,5.18,2.59,6.28,7.08,3.27Z"
                />
                <path
                  class="cls-1"
                  d="M88.01,578.07c.3,3.5,3.96,10.57,8.02,6.96,1.66-3.87-7.85-16.63-8.02-6.96Z"
                />
                <path
                  class="cls-1"
                  d="M719.12,362.48c-2.71,5.89-5.81,11.95-4.93,18.68,4.37-2.06,8.91-3.71,12.51-6.87-.94-4.74-4.29-8.41-7.59-11.81Z"
                />
                <path
                  class="cls-1"
                  d="M253.72,520.87c.61-.24,1.21-.48,1.84-.7,1.19-.64,2.35-1.63,3.44-3.16-4.34-2.28-8.89-4.59-13.5-6.65l-7.11,2.32c4.06,3.86,9.93,9.35,15.32,8.19Z"
                />
                <path
                  class="cls-1"
                  d="M146.91,550.41c-1.94,5.81,7.64,6.92,8.98,1.88,2.28-5.99-7.68-7.24-8.98-1.88Z"
                />
                <path
                  class="cls-1"
                  d="M1620.92,72.11c6.14-2.51,11.03-6.36,9.2-13.73l-15.37,5.02c2.15,2.89,4.21,5.79,6.17,8.71Z"
                />
                <path
                  class="cls-1"
                  d="M733.17,351.17l-1.97.64c-2.03,2.54-7.51,6.96-3.48,10.14,6.46,2.8,7.76-6.7,5.45-10.79Z"
                />
                <path
                  class="cls-1"
                  d="M765.95,340.47c-1.49,7.68,10.81,3.66,5.32-1.74l-5.32,1.74Z"
                />
                <path
                  class="cls-1"
                  d="M4126.47,1960.17c3.23,6.81,11.26,4.02,17.11,4.94.08-9.54-12.8-14.71-17.11-4.94Z"
                />
                <path
                  class="cls-1"
                  d="M4113.09,1967.89c6.98,4.38,14-.17,11.32-8.17-5.74-.81-9.18,3.5-11.32,8.17Z"
                />
                <path
                  class="cls-1"
                  d="M4105.8,1966.98c-.24,4.72,1.57,5.74,5.48,3.09.32-4.68-1.49-5.7-5.48-3.09Z"
                />
                <path
                  class="cls-1"
                  d="M4128.89,1953.46c.63-4.14-.44-8.76-4.01-11.36-9.04-8.24-18.78-15.72-28.89-22.6-1.1-1.42-3.37-4.25-4.5-5.66-8.07-3.21-17.39-4.27-24.06-10.37-6.01-5.84-15.09-6.77-20.7-13.17-5.13-5.62-12.82-4.56-19.05-1.61,1.42-8.73.85-17.59.7-26.38-5.84,7.75-12.6,16.69-9.95,27.08,14.31,3.57,21.41,18.83,35.71,22.7,14.12,3.93,24.94,14.31,38.53,19.29,8.36,3.15,14.83,10.22,23.83,11.75,3.8,3.5,5.92,15.68,12.39,10.34Z"
                />
                <path
                  class="cls-1"
                  d="M3992.76,1885.43c-2.78,4.27,4.35,9.4,7.24,5.1,2.49-4.11-4.25-9.2-7.24-5.1Z"
                />
                <path
                  class="cls-1"
                  d="M4046.83,1859.74c1.56-4.58-5.62-5.59-7.26-1.97-2.43,4.83,6.07,6.45,7.26,1.97Z"
                />
                <path
                  class="cls-1"
                  d="M4030.43,1855.52c-.22-5.41-2.49-6.61-6.88-3.67.31,5.48,2.6,6.72,6.88,3.67Z"
                />
                <path
                  class="cls-1"
                  d="M3434.23,2251.73c5.41-1.87,10.8-3.89,16.07-6.05.15-1.5.38-4.49.53-5.99-5.93-1.19-11.91-2.2-17.94-2.95-1.49,5.12-1.18,10.3,1.33,14.99Z"
                />
                <path
                  class="cls-1"
                  d="M3422.04,2235.71c-4.27-1.97-8.6-3.88-12.95-5.79-.86,1.89-2.56,5.64-3.4,7.5,3.43,3.08,7.39,4.71,11.86,4.83-1.08,3.18-2.19,6.36-3.32,9.49,1.96.13,5.91.39,7.87.52,8.51-2.98.71-10.79-2.56-14.73l2.5-1.82Z"
                />
                <path
                  class="cls-1"
                  d="M3400.17,2248.63c-.74-2.68-2.29-8.06-3.04-10.74-10.93-.23-5.97,15.9,3.04,10.74Z"
                />
                <path
                  class="cls-1"
                  d="M2849.9,2321.8c-2.55,6.21,7.67,7.34,8.8,1.83,1.81-5.67-7.44-7.05-8.8-1.83Z"
                />
                <path
                  class="cls-1"
                  d="M3900.47,1960.18c-.83.51-1.63.96-2.37,1.24,1.07,1.94,3.26,5.86,4.36,7.79,2.13-1.43,5.96-2.42,8.33-4.12-1.56-.56-3.12-1.11-4.68-1.67-1.95-1-3.81-2.1-5.64-3.25Z"
                />
                <path
                  class="cls-1"
                  d="M3849.09,1923.74c5.3,9.23,15.03,13.41,24.27,17.52.78-1.1,2.31-3.31,3.07-4.4-6.77-8.08-17.5-10.76-27.34-13.13Z"
                />
                <path
                  class="cls-1"
                  d="M3103.38,2153.75c.39.95.78,1.9,1.18,2.84,4.11,2.44,8.96-2.46,12.65-4.87-4.29-4.55-9.33.19-13.83,2.03Z"
                />
                <path
                  class="cls-1"
                  d="M2565.4,2320.68c-5.67.14-9.14,5.47-13.46,8.39-1.67-1.3-5.03-3.87-6.7-5.18-5.21,2.17-6.16,9.24-10.54,12.72-4.81,3.89,1.46,10.55,6.2,8.09,7.76-.42,7.41-13.65,16.66-9.61,12.57-10.62,29.76-16.34,46.18-14.74.03-1.05.1-3.19.16-4.25-5.23-1.08-10.37-2.93-15.76-3.59-7.46,2.9-14.47,7.88-22.75,8.16Z"
                />
                <path
                  class="cls-1"
                  d="M3298.64,2063.22c2-.53,4.02-1,6.05-1.39,1.28-4.98-.37-10.67-.38-15.85-2.86,3.49-5.81,6.91-8.57,10.5.54,2.46,1.53,4.71,2.9,6.75Z"
                />
                <path
                  class="cls-1"
                  d="M3194.06,2109.12c4.84,3.39,14.52,2.05,12.13-5.67-5.56-4.47-8.64,2.25-12.13,5.67Z"
                />
                <path
                  class="cls-1"
                  d="M3177.31,2115.06c-2.1,5.42,6.94,6.64,8.03,1.65,2.13-5.53-6.67-6.12-8.03-1.65Z"
                />
                <path
                  class="cls-1"
                  d="M3208.82,2085.75c1.7,3.78,3.53,7.42,5.45,11.03,7.32-.44,5.99-10.8,8.66-15.8-4.93.77-9.68,2.49-14.11,4.77Z"
                />
                <path
                  class="cls-1"
                  d="M2956.88,2157.4c-1.46.58-4.32,1.71-5.74,2.28,2.84,14.67,22.52,11.1,33.75,13.19.35-3.14,5.46-7.26,1.79-9.86-10.28.13-20.15-2.3-29.8-5.6Z"
                />
                <path
                  class="cls-1"
                  d="M2936.76,2155.6c-3.36,4.63,3.66,8.32,7.14,5.4,7.49-4.03-3.8-12.57-7.14-5.4Z"
                />
                <path
                  class="cls-1"
                  d="M2374.84,2328.6c-4.63,3.02.89,13.32,5.54,8.95,2.26-3.49-.9-10.36-5.54-8.95Z"
                />
                <path
                  class="cls-1"
                  d="M3272.82,2030.57c-.54,4.85-1.24,9.68-1.57,14.56,2.44-2.51,4.61-5.24,6.61-8.07,3.28-2.92,10.3-6.45,5.08-11.41-3.41,1.51-6.78,3.22-10.13,4.92Z"
                />
                <path
                  class="cls-1"
                  d="M3691.38,1895.45c.07,5.36,2.38,6.35,6.9,3.02-.06-5.22-2.34-6.23-6.9-3.02Z"
                />
                <path
                  class="cls-1"
                  d="M3231.32,2043.68c-2.4,5.52,6.75,6.87,7.88,1.8,2.23-5.43-6.43-6.3-7.88-1.8Z"
                />
                <path
                  class="cls-1"
                  d="M3806.01,1846.98c-4.85,1.72-2.06,10.59,2.94,8.49,4.28-1.93,1.66-9.55-2.94-8.49Z"
                />
                <path
                  class="cls-1"
                  d="M3287.55,2004.21c-.04,5.63,2.05,6.69,6.3,3.12.07-5.57-2.02-6.6-6.3-3.12Z"
                />
                <path
                  class="cls-1"
                  d="M2847.18,2142.62c-3.52,3.43-2.97,5.41,1.7,5.93,3.51-3.36,2.93-5.33-1.7-5.93Z"
                />
                <path
                  class="cls-1"
                  d="M3301.31,1998.38c.49-1.17,1.45-3.5,1.95-4.64-5.46-10.05-12.95,9.64-1.95,4.64Z"
                />
                <path
                  class="cls-1"
                  d="M2823.65,2138.2c-.06,6.2,2,11.89,7.54,15.15,2.16-2.55,4.14-5.25,5.9-8.08-1.22-5.69-9.09-4.77-13.44-7.08Z"
                />
                <path
                  class="cls-1"
                  d="M3847.76,1795.8c-7.92,4.37-17.38,1.54-25.44,5.38-7.77,3.78-20.59,5.31-20.73,16.41,9.3-1.69,16.67-9.58,26.36-9.14,9.19.76,18.01-5.48,27.01-1.19,4.26-2.3,8.49-4.69,12.6-7.21-4.14-6.72-13.2-8.1-19.81-4.26Z"
                />
                <path
                  class="cls-1"
                  d="M3280.91,1994.28c-7.39-7.81-20.59-4.47-30.08-3.39,7.09,9.35,20.67,7.71,30.08,3.39Z"
                />
                <path
                  class="cls-1"
                  d="M3773.17,1818.67c4.79,3.24,10.38,4.81,15.95,6.02-.01-3.22,2.18-8.04-1.58-10.1-4.84-4.23-10.5,1.21-14.36,4.08Z"
                />
                <path
                  class="cls-1"
                  d="M3695.06,1835.26c-3.23,4.32-6.38,8.67-9.49,13.05,7.12-.21,14.28-.12,21.24,1.23,3.86-8.55-4.6-12.65-11.75-14.28Z"
                />
                <path
                  class="cls-1"
                  d="M2806.19,2141.65c5.43-1.7-.09-8.91-2.32-11.44-8.67.41-4.71,14.11,2.32,11.44Z"
                />
                <path
                  class="cls-1"
                  d="M3739.17,1821.6c-10.68,3.82-21.52,7.6-33.06,7.16,2.05,5.05,3.6,11.23,9.84,12.12,8.55,3.73,13.03-6.31,18.65-10.52,10.07,1.08,26.95-.23,28.08-12.93-7.57,2.67-15.47,4.21-23.51,4.18Z"
                />
                <path
                  class="cls-1"
                  d="M3616.19,1858.38c-.59.4-1.03.86-1.36,1.35-.68-.6-1.34-1.21-1.92-1.87.31.89.8,2.3,1.26,3.61-.12.86.02,1.76.35,2.63-8.58,4.33-10.37-4.12-13.03-10.44-.14,5.66,1.84,11,2.49,16.6,4.39-.51,8.76-1.37,13.02-2.77,1.26,1.04,2.79,1.72,4.34,1.72,4.9-3.31,1.12-13.98-5.15-10.82Z"
                />
                <path
                  class="cls-1"
                  d="M3657.16,1844.78c3.29.61,6.98,6.26,10.08,2.36,1.15-4.41-2.04-7.7-4.69-10.77-2.78,2.08-4.57,4.85-5.39,8.41Z"
                />
                <path
                  class="cls-1"
                  d="M2385.47,2237.9c-1.58.21-4.74.61-6.32.82,1.6,4.18,3.06,8.35,4.46,12.53l-8.68-1.97c1.05,2.61,3.15,7.81,4.21,10.42.94-1.85,2.77-5.51,3.71-7.36,1.97.57,5.89,1.67,7.85,2.21-1.83-5.39-4.72-10.43-9.18-14.11l3.95-2.53Z"
                />
                <path
                  class="cls-1"
                  d="M3894.67,1753.73c.09,1.82.28,5.49.37,7.31,5.65-2.15,12.95-2.75,16.28-8.51-2.74-8.92-11.23-.33-16.65,1.2Z"
                />
                <path
                  class="cls-1"
                  d="M2448.82,2224.08c-6.12,2.47-.71,10.48,4.16,6.67,6.14-2.51.85-10.56-4.16-6.67Z"
                />
                <path
                  class="cls-1"
                  d="M2351.26,2255.42c-5.81,2.8-.38,10.38,4.39,6.64,6.33-2.44.6-10.62-4.39-6.64Z"
                />
                <path
                  class="cls-1"
                  d="M2361.74,2255.2c3.82-.04,13.39-.67,8.84-6.89-4.33-8.43-7.01,3.33-8.84,6.89Z"
                />
                <path
                  class="cls-1"
                  d="M2552.79,2141.7c-1.9-.93-3.84-1.91-5.78-2.9-.71-3.86-3.02-4.52-6.88-1.93.13,2.52.74,4.11,1.84,4.78-.74,1.86-1.5,3.75-1.98,5-5.2-4.69-8.93-3.27-10.48,3.42-9.18,3.17-15.54,10.79-14.95,20.71,5.13-1.47,11.32-1.37,15.13-5.54,4.74-4.1,3.83-11.03,5.2-16.52,1.83.88,5.48,2.68,7.28,3.57,2-.65,5.97-1.98,7.98-2.64.19-.42.38-.84.57-1.26-.56,4.81,7.65,6.02,8.99,1.05.86-1.88.45-3.31-.56-4.22,4.55-2.29,1.68-7.86.42-12.46-5.99-.84-7.56,3.11-6.77,8.93ZM2552.05,2145.44c.87-1.95,1.74-3.9,2.65-5.83l1.44,4.47c-1.48-.09-3.04.34-4.08,1.36Z"
                />
                <path
                  class="cls-1"
                  d="M2350.8,2221.59c.04-4.62-1.91-5.86-5.86-3.73-.02,4.78,1.93,6.02,5.86,3.73Z"
                />
                <path
                  class="cls-1"
                  d="M2631.89,2096.62c-6.75,3.62-13.71,6.93-20.93,9.62-7.77-2.37-15.81-1.69-18.57,7.17-14.52-4.94-21.16,10.13-29.55,18.62l3.76,1.83c5.35-1.55,10.54-3.54,15.64-5.77-.45.26-.94.58-1.45.99.29,4.58,2.32,5.46,6.05,2.56-.28-3.33-1.43-4.68-3.43-4.07,14-6.22,27.39-14.09,41.83-19.24,6.11-2.8,13.86,1.9,19.07-2.86,1.53-6.95-8.3-6.37-12.4-8.86Z"
                />
                <path
                  class="cls-1"
                  d="M2352.37,2192.1c-4.35-2.21-8.81-4.35-13.32-6.41-.97,4.85-1.25,10.9,3.92,13.44,4.89,1.5,6.93-4.11,9.4-7.04Z"
                />
                <path
                  class="cls-1"
                  d="M3373.97,1845.01c.25,5.5,2.49,6.72,6.76,3.61-.16-5.43-2.4-6.64-6.76-3.61Z"
                />
                <path
                  class="cls-1"
                  d="M2871.55,1990.63c-2.67,8.6-9.48,17.21-6.65,26.47,2.45-2.88,4.39-6.11,5.58-9.69,5.54-17.31,17.62-33.95,12.34-53.04-2.51,1.16-7.51,3.46-10.02,4.62,4.37,11.01-6.66,20.9-1.24,31.63Z"
                />
                <path
                  class="cls-1"
                  d="M2332.38,2129.11c-.49-12.51-5.17-25.61-15.64-33.18.38-3.79,1.01-7.52.75-11.4-3.41-1.91-6.95-3.68-10.62-5.34-4.12-7.66-7.89-15.51-11.9-23.28-10.26,8.42,5.59,19.99,4.67,30.58-4.68-3.11-7.09-8.14-9.61-13.07-5.46.77-11.16,1.12-16.42-1.09-9.73-3.75-20.16-1.12-30.28-1.21-1.77-2.55-3.61-5.07-5.46-7.66-9.46,3.76-19.58,4.27-29.63,3.45-2.35-4.21-4.84-8.44-7.32-12.64-5.44,1.88-10.76,3.91-16.22,5.9.81,12.17,12.32,22.1,7.52,34.69,7.24,4.66,15.56,5.54,22.43-.4,5.25,3.2,12.22,13.02,14.75,2.04,6.93.63,13.73-.88,20.22-3.04,3.3,3.73,9.93,5.9,10.21,11.39-1.28,4.92,1.91,6.77,6.05,7.51,4.19-6.11,8-13.4,15.47-15.94,9.59-6.26,18.9,3.01,27.89,5.85,7.62,17.98,17.16,35.17,24.19,53.31-.87,9.7-.63,19.7,8.12,26.02,2.36-4.5,4.52-9.11,6.45-13.8-2.75-11.81-14.52-22.25-10.62-35.02-1.27-.9-3.76-2.77-5-3.68Z"
                />
                <path
                  class="cls-1"
                  d="M2247.18,2196.09c-2.6,4.28,4.57,9.06,7.57,5.16,2.72-4.22-4.5-8.85-7.57-5.16Z"
                />
                <path
                  class="cls-1"
                  d="M2629.29,2058.58c-9.55,2.78-1.8,10.64,1.88,15.02,1.85-5.14.42-10.25-1.88-15.02Z"
                />
                <path
                  class="cls-1"
                  d="M3808.91,1654.97c-3.28,5.71,1.26,11.18,6.39,13.41,1.48-3.41,2.73-6.87,3.74-10.47,1.43-7.46-6.13-5.6-10.14-2.94Z"
                />
                <path
                  class="cls-1"
                  d="M2217.21,2180.29c1.05-3.47,1.84-7.02,2.41-10.64-2.17,1.18-6.56,3.49-8.76,4.67.72,3.53,1.76,8.37,6.35,5.96Z"
                />
                <path
                  class="cls-1"
                  d="M2204.44,2167.62c-3.33,3.61-7.45,5.39-12.34,5.34.81,1.96,2.39,5.88,3.2,7.83,3.6-2.45,7.41-4.6,11.89-4.55-.7-2.16-2.05-6.49-2.75-8.62Z"
                />
                <path
                  class="cls-1"
                  d="M2127.07,2197.91c-2.54,6.11,7.61,7.36,8.88,1.97,2.02-5.67-7.33-7.02-8.88-1.97Z"
                />
                <path
                  class="cls-1"
                  d="M3820.81,1644.36c-.3-5.25-2.68-6.45-7.11-3.66.29,5.42,2.68,6.66,7.11,3.66Z"
                />
                <path
                  class="cls-1"
                  d="M3969.86,1566.33c-4.25,6.97-8.84,19.36,2.59,21.94,4.13-7.63,6.5-17.05-2.59-21.94Z"
                />
                <path
                  class="cls-1"
                  d="M3799.52,1628.05c-9.32.79-1.74,9.17,1.23,12.94,4.8-3.92,4.63-10.12-1.23-12.94Z"
                />
                <path
                  class="cls-1"
                  d="M2240.87,2137.1c-5.22-1.59-9.58.81-13.47,4.26,1.09,1.29,3.22,3.89,4.27,5.16,4.61-1.54,7.87-4.82,9.19-9.42Z"
                />
                <path
                  class="cls-1"
                  d="M2897.26,1900.22c-3,5.42-7.4,11.22-5.4,17.76,5.41-3.61,9.74-11.75,5.4-17.76Z"
                />
                <path
                  class="cls-1"
                  d="M2790.25,1945.87c.04-1.32.13-4.04.16-5.36-8.16-8.13-8.68,13.05-.16,5.36Z"
                />
                <path
                  class="cls-1"
                  d="M2249.76,2116.15c1.51-4.63-6-5.4-7.58-1.8-1.92,4.83,6.33,6,7.58,1.8Z"
                />
                <path
                  class="cls-1"
                  d="M1530.31,2351.3c3.86-1.97,2.52-10-2.38-8.94-4.59,1.6-2.74,10.74,2.38,8.94Z"
                />
                <path
                  class="cls-1"
                  d="M3975.67,1547.15c-1.32-4.24-2.77-8.47-4.38-12.69-4.86,1.89-12.92,2.74-10.41,10.02,1.64,8.1,9.63,4.18,14.79,2.67Z"
                />
                <path
                  class="cls-1"
                  d="M3654.51,1652.02c2.47-1.28,7.42-3.83,9.9-5.08-2-1-4.02-1.96-6.07-2.91-1.71.41-3.41.7-5.11.86.39,2.39.8,4.77,1.27,7.13Z"
                />
                <path
                  class="cls-1"
                  d="M1457.98,2352.36l2.05-4.84-2.4.99c-3.51,5.92-6.11,12.28-7.31,19.09-1.97-.9-5.96-2.72-7.94-3.63-.44,3.5-.95,6.97-1.47,10.43,6.28-5.07,25.35-3.8,19.88-15.6,2.08-.95,6.19-2.86,8.27-3.81-2.76-.64-8.3-1.96-11.08-2.64Z"
                />
                <path
                  class="cls-1"
                  d="M2901.48,1858.87c-1.41,4.23-2.93,8.42-4.38,12.62.64,1.97,1.9,5.93,2.52,7.92-3.28,4.57-4.58,10.07-5.46,15.5,2.86-.5,8.64-1.54,11.5-2.04-.63-3.89-1.32-7.74-2.13-11.67,5.06-6.73,10.13-20.05-2.04-22.32Z"
                />
                <path
                  class="cls-1"
                  d="M3316.75,1745.2c-7.09-.41-5.85,5.98-5.84,10.85,5.12-1.91,9.9-4.98,5.84-10.85Z"
                />
                <path
                  class="cls-1"
                  d="M1804.39,2239.75c-4.92,2.05-2.44,7.4,1.2,7.73,1.74-1.65,3.64-3.14,5.69-4.43.08-2.93-3.58-5.87-6.89-3.3Z"
                />
                <path
                  class="cls-1"
                  d="M3872.72,1569.1c1.32-7.89-12-5.06-10.16,1.63,1.9,4.59,9.15,2.59,10.16-1.63Z"
                />
                <path
                  class="cls-1"
                  d="M1460.33,2346.98c4.3,2.06,10.26.95,13.14,5.15,3.2-6.46,12.83-8.59,19.18-6.02-5.21-4.11-11.05-7.59-17-10.69-5.79,2.86-12.14,5.34-15.32,11.56Z"
                />
                <path
                  class="cls-1"
                  d="M2858.41,1886.01c-2.57,4.37,4.77,9.06,7.55,4.8,2.63-4.29-4.68-8.79-7.55-4.8Z"
                />
                <path
                  class="cls-1"
                  d="M1703.64,2266.82c-2.18,5.05,6.39,5.48,7.34,1.27,1.89-4.92-6.05-5.05-7.34-1.27Z"
                />
                <path
                  class="cls-1"
                  d="M3402.56,1711.08c1.91-.2,3.82-.2,5.72-.07,3.71-3.62,1.68-12.29,6.81-16.03-2.69-1.85-5.4-3.68-8.18-5.5-2.69,5.99-9.41,15.65-4.34,21.6Z"
                />
                <path
                  class="cls-1"
                  d="M1486.6,2340.66c5.09-3.88,10.1-7.77,14.54-12.31-1.85.94-5.57,2.79-7.42,3.73-2.56-2.59-5.98-4.1-9.55-5.25-.41,4.91.38,9.49,2.43,13.83Z"
                />
                <path
                  class="cls-1"
                  d="M2344.48,2045.9c-2.05,3.8,3.33,9.67,6.65,5.66,3.37-3.89-3.62-10.58-6.65-5.66Z"
                />
                <path
                  class="cls-1"
                  d="M3743.8,1594.1c-.08-5.29-2.38-6.35-6.89-3.2.13,5.34,2.43,6.4,6.89,3.2Z"
                />
                <path
                  class="cls-1"
                  d="M3759.2,1586.49c-.05-4.99-1.85-5.98-5.4-2.94.1,4.94,1.93,5.92,5.4,2.94Z"
                />
                <path
                  class="cls-1"
                  d="M3411.42,1686.53c.19-5.31-1.97-6.46-6.48-3.48-.03-3.61-4.88-7.42-7.35-3.41-2.44,3.75,3.03,9.8,6.52,5.77.32-.38.53-.8.66-1.23.13,4.54,2.35,5.32,6.65,2.35Z"
                />
                <path
                  class="cls-1"
                  d="M2907.59,1851.03c-.19-5.32-2.53-6.4-7.01-3.26.33,5.34,2.67,6.42,7.01,3.26Z"
                />
                <path
                  class="cls-1"
                  d="M2275.14,2039.56c-.71,9.88,9.2,11.92,16.44,14.13-.73-4.3.11-9.95-4.58-12.39-3.6-1.04-8.82-6.33-11.86-1.74Z"
                />
                <path
                  class="cls-1"
                  d="M3894.15,1521.7c1.25-7.8-11.87-4.86-10.12,1.76,1.76,4.87,9.2,2.44,10.12-1.76Z"
                />
                <path
                  class="cls-1"
                  d="M1360.48,2346.63c4.37-2.06,8.91-3.71,12.51-6.87-.94-4.74-4.29-8.41-7.59-11.81-2.71,5.89-5.81,11.95-4.93,18.68Z"
                />
                <path
                  class="cls-1"
                  d="M2906.61,1831.95c.26,5.63,2.4,6.75,6.4,3.32-.19-5.72-2.33-6.84-6.4-3.32Z"
                />
                <path
                  class="cls-1"
                  d="M3813.45,1529.85c.04-1.93.09-5.81.09-7.76l-16.77,5.47c4.99,4.49,10.78,6.06,16.68,2.29Z"
                />
                <path
                  class="cls-1"
                  d="M1374.01,2327.43c6.46,2.8,7.76-6.7,5.45-10.79l-1.97.64c-2.03,2.54-7.51,6.96-3.48,10.14Z"
                />
                <path
                  class="cls-1"
                  d="M1417.56,2304.21l-5.32,1.74c-1.49,7.68,10.81,3.66,5.32-1.74Z"
                />
                <path
                  class="cls-1"
                  d="M3352.15,1672.71l-5.56,1.81c3.45,4.18,5.3,3.58,5.56-1.81Z"
                />
                <path
                  class="cls-1"
                  d="M1251.33,2009.55c7.25.96,1.48,10.86,6.8,13.19.15.11.29.18.43.28,3.28-5.77,7.2-10.94,11.85-15.48-3.36-.97-8.52,3.24-12.42,2.36,1.41-6.49,11.49-6.89,15.88-11.62-2.59-6.04-4.24-13.19-10.94-15.97-4.64-1.97-5.8-6.68-6.39-11.23.54-.65,1.08-1.3,1.62-1.95,2.86.87,5.73,1.75,8.53,2.64,4.53,7.2,6.7,23.45,18.12,16.39v-.04c.01-.92.24-19.27-1.42-39.26-.64-1.1-1.28-2.2-1.9-3.3-.41.73-.87,1.44-1.4,2.09-.78.98-1.7,1.87-2.82,2.64-.26.02-.52.03-.79.02,0,0,0,0,0,0-.34-1.46-.02-2.94,1.55-4.43,4.57-4.75,4.8-11.16,6.28-17.13,1.35-2.29,3.1-4.35,4.78-6.43,1.03,1.61,2.2,3.11,3.56,4.49.12-.47.2-.94.31-1.41-.66-2-1.21-4.01-1.65-6.03,1.57-2.26,2.81-4.69,3.18-7.57,1.21-11.99,13.99-17.11,19.21-27.04.49-.93.93-1.86,1.35-2.81,1.85-.89,3.86-1.86,5.11-2.47.03-2.26-1.01-4.28-2.04-6.28,2.82-10.2,3.68-21.01,6.8-31.11,2.21-.68,6.66-2.07,8.85-2.77-1.56-14.17,19.99-20.49,13.87-34.14-.88,1.12-1.79,2.23-2.7,3.33-3.75-3.07-7.6,4.11-5.74,6.67-7.13,7.99-14.69,15.61-21.76,23.6-5.38,13.34-10.45,26.87-16.98,39.74-2.56,13.45-11.36,23.53-20.45,33.45-7.34-2.09-14.49-4.93-21.35-8.28,2.31,3.68,4.55,7.35,6.87,10.97,3.76-.09,7.46.4,11.15.96-4.48,4.91-8.85,9.87-12.39,15.28.14,2.85.26,5.68.34,8.55-3.23,3.02-5.65,6.44-7.56,10.1,0,0,0,.01-.01.02-8.49,9.9-16.34,20.37-24.19,30.81-4.44,6.76-13.63,9.05-17.21,16.54.12,6.31,2.19,12.35,3.65,18.43-1.76.7-5.29,2.1-7.05,2.8-.23-2.68-.66-8.01-.89-10.69-15.46,2.96-14.39,22.25-21.19,33.56-5.31-12.33.51-26.38-6.91-37.76-8.91-2.91-4.33,7.83-5.56,12.47-5.53,15.7-17.34,28.16-24.37,43.21-1.16.57-3.51,1.7-4.68,2.23-1.36.47-4.09,1.39-5.44,1.86,4.41-6.83,11.11-12.63,11.76-21.24-5.76-4.23-11.43-8.72-15.67-14.6-8.57,2.79-13.57,11.04-18.39,18.09-4.35,5.26,1.02,13.06-3.73,18.02-3.46,4.27-7.24,8.3-10.8,12.56-3.3-3.07-6.44-6.25-9.77-9.38-2.4,1.18-7.25,3.55-9.7,4.7.61,2.21,1.85,6.69,2.46,8.91-2.96,3.95-9.37,7.31-7.22,13.16,5.27,3.75,10.24,7.82,14.52,12.58,1.94-.34,5.79-1.08,7.71-1.47,4.91,4.81,17.18,7.4,14.99,15.59-4.92,3.83-10.54,7.12-14.03,12.54-.67-2-1.96-6.02-2.61-8.03-5.81-3.09-8.27-9.52-11.93-14.66-3.36.37-7.1.77-10.62,1.1.26-2.53.82-7.68,1.1-10.26-6.21,1.57-12.5,3.52-17.4,7.98,4.27,4.23,10.11,7.65,11.25,14.11-3.42-.91-6.91-1.74-10.47-2.48-.85,4.67,1.39,6.84,6.81,6.55-2.7,7.48-5.47,14.92-8.17,22.42,4.39,2.18,8.07,5.93,9.98,10.3-5.49,6.95-10.79,14.07-16.09,21.18-4.41,6.78-13.6,9.11-17.13,16.62.14,6.31,2.25,12.34,3.73,18.41-1.75.71-5.29,2.13-7.04,2.84-.24-2.68-.7-8.01-.93-10.69-15.45,3.03-14.3,22.31-21.05,33.66-5.36-12.3.4-26.38-7.07-37.73-8.94-2.87-4.29,7.85-5.5,12.49-5.45,15.73-17.2,28.24-24.18,43.32-1.16.58-3.51,1.72-4.67,2.26-1.36.48-4.08,1.4-5.44,1.88,4.39-6.84,11.05-12.68,11.67-21.29-5.77-4.2-11.47-8.66-15.73-14.53-8.56,2.83-13.52,11.1-18.3,18.18-4.33,5.28,1.07,13.06-3.66,18.04-3.44,4.28-7.2,8.33-10.74,12.61-3.32-3.05-6.47-6.22-9.8-9.34-2.4,1.19-7.24,3.57-9.68,4.74.62,2.22,1.88,6.68,2.5,8.9-2.94,3.95-9.33,7.35-7.16,13.19,5.28,3.72,10.27,7.77,14.57,12.52,1.93-.36,5.79-1.12,7.71-1.51,4.92,4.78,17.21,7.32,15.05,15.52-4.89,3.85-10.5,7.16-13.97,12.59-.68-1.99-1.99-6.01-2.65-8.01-5.81-3.08-8.31-9.49-11.99-14.61-3.37.39-7.1.8-10.62,1.15.25-2.54.79-7.69,1.05-10.26-6.2,1.59-12.48,3.57-17.37,8.06,4.3,4.21,10.15,7.61,11.31,14.06-3.42-.9-6.91-1.71-10.47-2.43-.83,4.67,1.42,6.83,6.83,6.51-2.66,7.49-5.41,14.94-8.06,22.46,8.6,4.22,14.55,14.41,9.71,23.66,8.38,5.6,12.81-5.56,17.24-10.84.42,4.33,2.37,9.46-1.58,12.61-.86-.38-1.71-.77-2.57-1.15-.78,1.1-2.31,3.31-3.07,4.4.5.6,1.03,1.16,1.57,1.7-1,3.27-.2,7.16-.11,10.74-2.71-3.15-5.39-6.31-8.19-9.43-3.47,5.44-19.28,15.5-6.29,18.73-.14,2.26-.4,6.72-.53,8.98,4.4,1.22,8.66,2.45,12.98,3.53,2.02-5.03,3.54-10.26,6.13-15.01,4.74-3.43,10.4-5.19,15.6-7.66,2.07.56,4.15,1.07,6.18,1.56-1.2-2.1-2.65-3.92-4.25-5.56,2.19-6.17,4.54-12.42,10.19-16.27.82-4.4-.22-9.44,2.09-13.36,6.45-.22,13.27,1.42,19.04-2.22-1.65-5.78-1.67-11.72-.02-17.47-3.39-1.95-6.85-3.88-10.34-5.83,4.1-10.41,7.45-21.15,12.52-31.15,1.69.32,5.03.98,6.7,1.27-3.64,7.27-7.41,14.49-10.96,21.83,2.12,4.12,4.34,8.13,6.66,12.08,3.39,4.61,8.26-.44,12.15-1.28-.58-3.74-1.26-7.46-2.02-11.14,4.48-2.74,8.74-5.54,12.95-8.53.13-3.81-.05-7.58-.07-11.34,7.16,6.07,8.45-1.41,11.15-5.79,7.27-4.09,8.09,4.92,9.67,9.65,1.63-1.4,4.85-4.2,6.47-5.61-.73-8.3,1.42-16.23,4.51-23.86-2.27-3.97-3.74-8.16-4.49-12.62,2.14-.76,6.38-2.28,8.52-3.05,2.47,4.98,4.31,10.53,9,13.87,2.12-7.01,2.18-14.43,3.97-21.5,3.09.5,6.15,1.02,9.17,1.51,2.03-5.2,4.04-10.39,5.97-15.6,5.76-2.75,11.38-5.6,16.96-8.49.81-7.1-1.15-15.77,4.22-21.34,1.17.33,2.34.64,3.51.95,2.42,3.09-.39,9.82,3.87,11.65.15.11.29.17.44.27,3.24-5.78,7.15-10.98,11.77-15.54-3.21-.91-8.02,2.89-11.84,2.5.43-1.13.85-2.26,1.27-3.39,3.45-3.54,10.52-4.59,13.99-8.37-.75-1.73-1.43-3.56-2.17-5.35,2.42-1.06,4.88-2.03,7.27-3.12,1.63.18,3.53-.3,5.8-1.72,4.1-6.38,8.43-12.64,12.56-18.99-1.7-2.14-3.36-4.31-4.97-6.51.14-2.36.45-4.66,1.65-6.67,6.45-.18,13.25,1.48,19.05-2.13-1.63-5.79-1.63-11.73.05-17.47-3.38-1.96-6.82-3.91-10.31-5.88,4.14-10.38,7.54-21.11,12.66-31.09,1.68.34,5.01,1.01,6.69,1.31-3.67,7.26-7.48,14.45-11.05,21.78,2.09,4.13,4.29,8.16,6.61,12.12,3.36,4.62,8.26-.41,12.15-1.23-.56-3.74-1.22-7.47-1.97-11.15,4.5-2.72,8.78-5.5,12.99-8.48.15-3.8-.02-7.57-.01-11.34,7.13,6.1,8.45-1.38,11.18-5.74,7.28-4.06,8.06,4.96,9.62,9.69,1.64-1.39,4.87-4.18,6.5-5.57-.7-8.3,1.5-16.22,4.62-23.84-2.25-3.98-3.7-8.18-4.43-12.65,2.14-.75,6.39-2.25,8.53-3.01,2.43,4.99,4.25,10.55,8.93,13.92,2.15-7,2.25-14.41,4.07-21.48,3.09.52,6.15,1.05,9.16,1.55,2.06-5.19,4.08-10.38,6.04-15.56,5.77-2.73,11.41-5.55,17-8.43.86-7.33-1.24-16.35,4.85-21.87ZM928.8,2354.43c-3.35,5.29-10.55-1.73-7.32-6.05,3.44-4.69,10.1,1.81,7.32,6.05ZM961.78,2274.95c-3.83,9.79-6.08,20.61-11.9,29.33-6.04-4.28-12.94-8.25-15.71-15.58,6.67-3.25,13.34-6.51,19.95-9.74-.5-4.51-3.15-9.56.17-13.6,5.77-1.88,10.53,4.46,7.5,9.59ZM992,2291.21c.78,1.16,2.38,3.49,3.2,4.67-.3,8.67-10.33-4.06-3.2-4.67ZM998.82,2282.26c-3.84-3.42-7.66-6.98-11.46-10.51,4.27-2.47,8.65-4.81,12.87-7.12-.13,5.89-.45,11.81-1.4,17.64ZM1000.71,2262.92c-.42-2.42-1.26-7.25-1.68-9.67,1.78-.62,5.37-1.89,7.14-2.53.05,4.79-2.21,8.79-5.46,12.2ZM1096.41,2147.42c2.18-2.94,5.62-1.44,7.16,1.14-.63.68-1.32,1.32-2.13,1.88-2.02.17-3.95-.23-5.85-.82.05-.76.3-1.51.82-2.19ZM1087.9,2175.26c-2.16,1.39-3.18,3.21-3.62,5.22-1.82-1.9-2.67-4.52-3.17-7.24,1.22-.82,2.34-1.97,3.39-3.26,2.07.62,4.12,1.25,6.14,1.88-.43,1.3-1.25,2.47-2.74,3.41ZM1137.04,2074.18c-3.88,9.77-6.18,20.58-12.04,29.28-6.02-4.32-12.9-8.31-15.64-15.66,6.69-3.22,13.38-6.44,20-9.64-.48-4.51-3.11-9.57.23-13.61,5.77-1.86,10.51,4.51,7.46,9.63ZM1167.17,2090.58c.78,1.15,2.37,3.5,3.18,4.68-.33,8.67-10.31-4.11-3.18-4.68ZM1174.04,2081.66c-3.82-3.44-7.62-7.02-11.41-10.57,4.28-2.45,8.68-4.76,12.9-7.06-.15,5.88-.49,11.8-1.48,17.63ZM1176.02,2062.32c-.41-2.43-1.22-7.26-1.64-9.68,1.79-.6,5.37-1.86,7.15-2.49.03,4.79-2.25,8.77-5.51,12.18Z"
                />
                <path
                  class="cls-1"
                  d="M2877.45,316.84c-1.22,7.28.42,16.39-5.93,21.6-7.2-1.32-.94-10.92-6.13-13.51-.14-.12-.28-.19-.42-.3-3.56,5.6-7.74,10.57-12.6,14.87,3.3,1.13,8.67-2.81,12.52-1.74-1.73,6.42-11.82,6.31-16.43,10.82,2.28,6.16,3.58,13.39,10.14,16.5,4.53,2.19,5.46,6.96,5.82,11.53-.57.63-1.14,1.25-1.72,1.87-2.81-1.01-5.64-2.03-8.39-3.06-4.17-7.42-5.53-23.76-17.29-17.27v.04c-.06.92-1.19,19.24-.53,39.28.59,1.13,1.17,2.26,1.73,3.39.45-.71.94-1.39,1.5-2.02.83-.94,1.79-1.79,2.95-2.49.26,0,.53,0,.79.02h0c.27,1.48-.12,2.94-1.77,4.35-4.8,4.52-5.35,10.91-7.13,16.8-3.66,5.56-9.79,9.54-11.02,16.43-1.8,11.92-14.82,16.4-20.52,26.06-7.59,12.87-8.3,28.27-13.33,42.06-2.24.57-6.75,1.74-8.98,2.33.85,14.23-20.98,19.47-15.55,33.41,9.89-11.39,21.33-21.33,31.83-32.06,6.04-13.06,11.77-26.32,18.93-38.85,4.1-16.95,18.05-27.93,29.88-40.2,1.11,3.7,1.86,7.44,2.23,11.2,1.13.92,2.24,1.83,3.38,2.76.82-.77,2.49-2.36,3.31-3.13,8.57,2.14,16.9,5.34,24.86,9.23-2.31-3.68-4.55-7.35-6.87-10.97-7,.17-13.82-1.67-20.69-2.22-1.28-3.01-2.85-5.79-4.89-8.26,2.69-2.86,5.25-5.8,7.52-8.92,0-2.86.02-5.69.08-8.56,3.37-2.86,5.96-6.15,8.05-9.72,0,0,.01-.01.02-.02,8.97-9.47,17.33-19.54,25.69-29.57,4.77-6.53,14.07-8.36,18.01-15.67.2-6.31-1.58-12.45-2.73-18.59,1.79-.61,5.39-1.84,7.18-2.45.09,2.69.26,8.03.36,10.72,15.59-2.19,15.47-21.51,22.83-32.47,4.7,12.57-1.82,26.32,5.03,38.06,8.76,3.35,4.71-7.61,6.17-12.18,6.3-15.41,18.71-27.26,26.49-41.95,1.18-.51,3.59-1.52,4.78-2,1.38-.41,4.15-1.18,5.53-1.59-4.74,6.6-11.72,12.07-12.8,20.63,5.54,4.51,10.98,9.27,14.93,15.36,8.7-2.36,14.1-10.35,19.26-17.16,4.61-5.04-.37-13.09,4.62-17.82,3.67-4.09,7.64-7.93,11.41-12.01,3.15,3.23,6.12,6.56,9.29,9.86,2.45-1.06,7.42-3.19,9.92-4.21-.5-2.24-1.51-6.77-2.02-9.02,3.15-3.8,9.72-6.84,7.86-12.79-5.08-4.01-9.84-8.32-13.88-13.29-1.95.25-5.84.79-7.78,1.08-4.66-5.04-16.79-8.25-14.2-16.31,5.1-3.59,10.88-6.58,14.64-11.83.57,2.03,1.66,6.11,2.2,8.15,5.65,3.38,7.79,9.92,11.19,15.23,3.38-.21,7.13-.42,10.66-.57-.38,2.52-1.2,7.63-1.61,10.19,6.28-1.26,12.66-2.89,17.77-7.11-4.06-4.44-9.72-8.14-10.53-14.65,3.37,1.08,6.81,2.08,10.33,3,1.08-4.62-1.05-6.9-6.47-6.88,3.07-7.34,6.21-14.63,9.27-21.99-3.55-1.98-6.55-5.02-8.43-8.54,8.15-9.68,15.71-19.86,23.28-30.02,4.41-6.78,13.6-9.11,17.13-16.62-.14-6.31-2.25-12.34-3.73-18.41,1.75-.71,5.29-2.13,7.04-2.84.24,2.68.7,8.01.93,10.69,15.45-3.03,14.3-22.31,21.05-33.66,5.36,12.3-.4,26.38,7.07,37.73,8.94,2.87,4.29-7.85,5.5-12.49,5.45-15.73,17.2-28.24,24.18-43.32,1.16-.58,3.51-1.72,4.67-2.26,1.36-.48,4.08-1.4,5.44-1.88-4.39,6.84-11.05,12.68-11.67,21.29,5.77,4.2,11.47,8.66,15.73,14.53,8.56-2.83,13.52-11.1,18.3-18.18,4.33-5.28-1.07-13.06,3.66-18.04,3.44-4.28,7.2-8.33,10.74-12.61,3.32,3.05,6.47,6.22,9.8,9.34,2.4-1.19,7.24-3.57,9.68-4.74-.62-2.22-1.88-6.68-2.5-8.9,2.94-3.95,9.33-7.35,7.16-13.19-5.28-3.72-10.27-7.77-14.57-12.52-1.93.36-5.79,1.12-7.71,1.51-4.92-4.78-17.21-7.32-15.05-15.52,4.89-3.85,10.5-7.16,13.97-12.59.68,1.99,1.99,6.01,2.65,8.01,5.81,3.08,8.31,9.49,11.99,14.61,3.37-.39,7.1-.8,10.62-1.15-.25,2.54-.79,7.69-1.05,10.26,6.2-1.59,12.48-3.57,17.37-8.06-4.3-4.21-10.15-7.61-11.31-14.06,3.42.9,6.91,1.71,10.47,2.43.83-4.67-1.42-6.83-6.83-6.51,2.66-7.49,5.41-14.94,8.06-22.46-8.6-4.22-14.55-14.41-9.71-23.66-8.38-5.6-12.81,5.56-17.24,10.84-.42-4.33-2.37-9.46,1.58-12.61.86.38,1.71.77,2.57,1.15.78-1.1,2.31-3.31,3.07-4.4-.5-.6-1.03-1.16-1.57-1.7,1-3.27.2-7.16.11-10.74,2.71,3.15,5.39,6.31,8.19,9.43,3.47-5.44,19.28-15.5,6.29-18.73.14-2.26.4-6.72.53-8.98-4.4-1.22-8.66-2.45-12.98-3.53-2.02,5.03-3.54,10.26-6.13,15.01-4.74,3.43-10.4,5.19-15.6,7.66-2.07-.56-4.15-1.07-6.18-1.56,1.2,2.1,2.65,3.92,4.25,5.56-2.19,6.17-4.54,12.42-10.19,16.27-.82,4.4.22,9.44-2.09,13.36-6.45.22-13.27-1.42-19.04,2.22,1.65,5.78,1.67,11.72.02,17.47,3.39,1.95,6.85,3.88,10.34,5.83-4.1,10.41-7.45,21.15-12.52,31.15-1.69-.32-5.03-.98-6.7-1.27,3.64-7.27,7.41-14.49,10.96-21.83-2.12-4.12-4.34-8.13-6.66-12.08-3.39-4.61-8.26.44-12.15,1.28.58,3.74,1.26,7.46,2.02,11.14-4.48,2.74-8.74,5.54-12.95,8.53-.13,3.81.05,7.58.07,11.34-7.16-6.07-8.45,1.41-11.15,5.79-7.27,4.09-8.09-4.92-9.67-9.65-1.63,1.4-4.85,4.2-6.47,5.61.73,8.3-1.42,16.23-4.51,23.86,2.27,3.97,3.74,8.16,4.49,12.62-2.14.76-6.38,2.28-8.52,3.05-2.47-4.98-4.31-10.53-9-13.87-2.12,7.01-2.18,14.43-3.97,21.5-3.09-.5-6.15-1.02-9.17-1.51-2.03,5.2-4.04,10.39-5.97,15.6-5.76,2.75-11.38,5.6-16.96,8.49-.83,7.33,1.3,16.35-4.75,21.89-7.26-.92-1.53-10.86-6.85-13.16-.15-.11-.29-.17-.44-.27-3.24,5.78-7.15,10.98-11.77,15.54,3.37.95,8.5-3.28,12.4-2.42-.44,2.07-1.76,3.52-3.5,4.69-.62-.2-1.23-.41-1.85-.6-.34.72-.66,1.45-.98,2.18-3.35,1.61-7.21,2.92-9.49,5.41,1.03,2.39,1.93,4.96,3.04,7.36-1.58.97-3.23,1.78-4.92,2.5-2.23-1.79-5.08-2.14-9.02.33-4.1,6.38-8.43,12.64-12.56,18.99.42.53.84,1.07,1.25,1.6-1.02,1-2.15,1.91-3.44,2.7-1.05,4.35-.28,9.44-2.81,13.23-6.45-.14-13.16-2.13-19.13,1.18,1.34,5.86,1.04,11.8-.91,17.45,3.28,2.12,6.62,4.24,10,6.39-4.65,10.16-8.58,20.71-14.19,30.42-1.66-.42-4.96-1.26-6.62-1.64,4.03-7.07,8.18-14.06,12.12-21.2-1.89-4.23-3.88-8.36-6-12.43-3.13-4.78-8.27,0-12.2.62.37,3.77.85,7.52,1.42,11.23-4.63,2.5-9.04,5.06-13.39,7.82-.34,3.79-.35,7.56-.55,11.32-6.82-6.45-8.51.96-11.45,5.18-7.48,3.69-7.81-5.35-9.13-10.15-1.7,1.31-5.07,3.94-6.77,5.25.28,8.33-2.3,16.13-5.79,23.58,2.05,4.08,3.29,8.35,3.8,12.85-2.17.64-6.49,1.93-8.67,2.58-2.18-5.11-3.73-10.74-8.23-14.34-2.49,6.89-2.96,14.29-5.13,21.25-3.06-.67-6.09-1.35-9.07-2-2.31,5.08-4.59,10.16-6.8,15.24-5.9,2.44-11.67,4.98-17.4,7.57ZM3209.48-4.01c3.35-5.29,10.55,1.73,7.32,6.05-3.44,4.69-10.1-1.81-7.32-6.05ZM3176.49,75.46c3.83-9.79,6.08-20.61,11.9-29.33,6.04,4.28,12.94,8.25,15.71,15.58-6.67,3.25-13.34,6.51-19.95,9.74.5,4.51,3.15,9.56-.17,13.6-5.77,1.88-10.53-4.46-7.5-9.59ZM3146.28,59.2c-.78-1.16-2.38-3.49-3.2-4.67.3-8.67,10.33,4.06,3.2,4.67ZM3139.45,68.15c3.84,3.42,7.66,6.98,11.46,10.51-4.27,2.47-8.65,4.81-12.87,7.12.13-5.89.45-11.81,1.4-17.64ZM3137.56,87.49c.42,2.42,1.26,7.25,1.68,9.67-1.78.62-5.37,1.89-7.14,2.53-.05-4.79,2.21-8.79,5.46-12.2ZM3047.29,166.05c2.54,3.29,5.04,6.6,7.67,9.86.38-.53.89-1.1,1.48-1.7.78,2.36,1.07,5,1.34,7.43-3.5-1.04-7.04-2.11-10.45-3.18-.28-.45-.56-.93-.83-1.43,1.31-3.25.67-7.31.79-10.98ZM3032.64,204.73c.25-.45.52-.89.81-1.32.79,1.6.89,3.52-.37,5.01-3.68,4.49-9.98-2.36-6.98-6.44,1.15-1.62,2.62-1.97,3.98-1.58.87,1.43,1.73,2.87,2.55,4.33ZM2988.87,279.55c4.36-9.57,7.19-20.24,13.48-28.65,5.79,4.61,12.48,8.94,14.85,16.41-6.84,2.89-13.68,5.77-20.45,8.64.25,4.53,2.64,9.72-.9,13.58-5.86,1.57-10.28-5.03-6.97-9.98ZM2959.59,261.68c-.73-1.19-2.19-3.62-2.95-4.83.76-8.64,10.09,4.61,2.95,4.83ZM2952.29,270.25c3.65,3.62,7.26,7.39,10.88,11.12-4.4,2.23-8.9,4.33-13.23,6.41.45-5.87,1.08-11.77,2.36-17.53ZM2949.35,289.47c.29,2.44.86,7.31,1.16,9.75-1.82.51-5.46,1.59-7.27,2.14.21-4.79,2.68-8.65,6.11-11.89Z"
                />
              </g>
            </g>
          </mask>
        </defs>
        <g class="cls-5">
          <g>
            <polygon
              class="cls-2"
              points="3614.98 0 172.38 1106.55 128.06 1120.8 0 1370.19 273.91 2222.36 523.3 2350.41 567.61 2336.17 4010.21 1229.62 4060.01 1132.64 4104.19 1046.62 4138.28 980.24 3864.36 128.06 3614.98 0"
            />
            <path
              class="cls-3"
              d="M3694.19,127.33h0s-86.02-44.17-86.02-44.17L254.55,1161.1l-72.51,23.31-98.89,192.58,254.37,791.37,192.58,98.89,72.51-23.31,3353.61-1077.95,44.17-86.02,54.72-106.56-254.37-791.37-106.56-54.72ZM3981.36,967.38l-73.02,142.19L581.69,2178.85l-45.55,14.64-17.24-8.85-124.95-64.16-237.04-737.45,73.02-142.19,45.55-14.64L3602.13,156.92l142.19,73.02,237.04,737.45Z"
            />
            <g>
              <path
                class="cls-3"
                d="M291.4,1333.79c21.01-46.75,63.39-80.39,127.16-100.88,63.77-20.5,117.81-17.85,162.14,7.89,44.32,25.77,77.38,72.52,99.16,140.26l8.45,26.3-124.33,39.96-11.15-34.68c-9.22-28.68-21.53-47.81-36.91-57.37-15.38-9.56-33.82-10.9-55.35-3.98-21.53,6.92-35.74,18.75-42.67,35.49-6.94,16.74-5.79,39.45,3.43,68.13,11.27,35.06,30.49,62.74,57.68,83.01,27.17,20.28,64.87,41.14,113.1,62.57,40.3,18.72,73.54,35.94,99.71,51.71,26.17,15.79,51.04,37.03,74.58,63.75,23.52,26.72,41.71,60.01,54.52,99.84,21.78,67.76,21.76,125.15-.06,172.15-21.82,47.03-64.61,80.78-128.36,101.27-63.77,20.5-118.21,18-163.34-7.51-45.13-25.49-78.56-72.12-100.34-139.88l-16.52-51.39,124.32-39.96,19.21,59.77c17.42,54.19,48.84,73.98,94.28,59.38,45.42-14.6,59.42-48.99,42.01-103.18-11.27-35.06-30.51-62.73-57.68-83.01-27.19-20.28-64.89-41.13-113.1-62.57-40.31-18.69-73.55-35.92-99.73-51.71-26.17-15.77-51.03-37.02-74.56-63.73-23.52-26.72-41.69-60.01-54.51-99.87-21.77-67.74-22.16-125-1.14-171.77Z"
              />
              <path
                class="cls-3"
                d="M759,1184.16c22.49-47.67,66.01-81.9,130.57-102.65,64.54-20.75,119.86-18.28,165.91,7.36,46.05,25.64,79.85,71.93,101.36,138.88l139.86,435.12c21.52,66.95,21.03,124.28-1.46,171.95-22.49,47.67-66.01,81.88-130.56,102.63-64.56,20.75-119.87,18.31-165.92-7.33-46.05-25.64-79.83-71.95-101.35-138.9l-139.86-435.12c-21.52-66.95-21.04-124.25,1.44-171.92ZM1126.27,1817.9c45.42-14.6,59.3-49.38,41.62-104.38l-145.25-451.88c-17.67-54.98-49.22-75.18-94.64-60.58-45.44,14.61-59.31,49.41-41.64,104.39l145.25,451.88c17.68,55,49.22,75.18,94.66,60.58Z"
              />
              <path
                class="cls-3"
                d="M1320.6,953.51l230.55,717.27,216.38-69.55,38.43,119.54-347.87,111.82-268.98-836.81,131.49-42.27Z"
              />
              <path
                class="cls-3"
                d="M1814.31,794.82c65.34-21,119.98-19.22,163.93,5.34,43.95,24.56,76.82,70.72,98.6,138.46l136.02,423.18c21.78,67.76,21.95,124.41.54,169.98-21.41,45.57-64.78,78.85-130.12,99.86l-208,66.86-268.98-836.81,208-66.86ZM1968.35,1536.68l74.12-23.83c21.51-6.91,36-18.59,43.45-35.07,7.46-16.46,6.59-39.05-2.64-67.75l-139.86-435.12c-9.23-28.7-21.67-47.56-37.33-56.6-15.65-9.03-34.24-10.09-55.75-3.18l-74.12,23.83,192.13,597.72Z"
              />
              <path
                class="cls-3"
                d="M2358.48,670.04c22.49-47.67,66.01-81.9,130.57-102.65,64.54-20.75,119.86-18.28,165.91,7.36,46.05,25.64,79.85,71.93,101.36,138.88l139.86,435.12c21.52,66.95,21.03,124.28-1.46,171.95-22.49,47.67-66.01,81.88-130.56,102.63-64.56,20.75-119.87,18.31-165.92-7.33-46.05-25.64-79.83-71.95-101.35-138.9l-139.86-435.12c-21.52-66.95-21.04-124.25,1.44-171.92ZM2725.74,1303.78c45.42-14.6,59.3-49.38,41.62-104.38l-145.25-451.88c-17.67-54.98-49.22-75.18-94.64-60.58-45.44,14.61-59.31,49.41-41.64,104.39l145.25,451.88c17.68,55,49.22,75.18,94.66,60.58Z"
              />
              <path
                class="cls-3"
                d="M3121.6,1086.86c17.42,54.19,48.84,73.98,94.26,59.38,45.42-14.6,59.44-49,42.02-103.19l-207.5-645.55,124.32-39.96,204.81,637.17c21.78,67.76,21.76,125.15-.06,172.15-21.82,47.03-64.59,80.77-128.36,101.27-63.77,20.5-118.19,17.99-163.33-7.51-45.13-25.49-78.58-72.11-100.36-139.88l-204.81-637.17,131.51-42.27,207.5,645.55Z"
              />
              <path
                class="cls-3"
                d="M3644.51,206.54l38.43,119.54-137.48,44.19,230.55,717.27-131.49,42.27-230.55-717.27-137.48,44.19-38.43-119.54,406.46-130.65Z"
              />
            </g>
          </g>
        </g>
      </svg>
    </>
  );
};

export default SoldOutsvg;
